/**
* @vue/shared v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Vs(e, t) {
  const n = new Set(e.split(","));
  return t ? (r) => n.has(r.toLowerCase()) : (r) => n.has(r);
}
const Le = {}, jr = [], St = () => {
}, cg = () => !1, La = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), qs = (e) => e.startsWith("onUpdate:"), Ke = Object.assign, Hs = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, ug = Object.prototype.hasOwnProperty, je = (e, t) => ug.call(e, t), ce = Array.isArray, wr = (e) => Na(e) === "[object Map]", xm = (e) => Na(e) === "[object Set]", pe = (e) => typeof e == "function", Ve = (e) => typeof e == "string", Ar = (e) => typeof e == "symbol", Ne = (e) => e !== null && typeof e == "object", km = (e) => (Ne(e) || pe(e)) && pe(e.then) && pe(e.catch), Sm = Object.prototype.toString, Na = (e) => Sm.call(e), mg = (e) => Na(e).slice(8, -1), Em = (e) => Na(e) === "[object Object]", Bs = (e) => Ve(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Xr = /* @__PURE__ */ Vs(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Ma = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, dg = /-(\w)/g, vt = Ma((e) => e.replace(dg, (t, n) => n ? n.toUpperCase() : "")), pg = /\B([A-Z])/g, $t = Ma(
  (e) => e.replace(pg, "-$1").toLowerCase()
), Ra = Ma((e) => e.charAt(0).toUpperCase() + e.slice(1)), wi = Ma((e) => e ? `on${Ra(e)}` : ""), Pn = (e, t) => !Object.is(e, t), xi = (e, t) => {
  for (let n = 0; n < e.length; n++)
    e[n](t);
}, ua = (e, t, n) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    value: n
  });
}, fg = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Gi = (e) => {
  const t = Ve(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let ic;
const Pm = () => ic || (ic = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Ut(e) {
  if (ce(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const r = e[n], o = Ve(r) ? vg(r) : Ut(r);
      if (o)
        for (const a in o)
          t[a] = o[a];
    }
    return t;
  } else if (Ve(e) || Ne(e))
    return e;
}
const _g = /;(?![^(]*\))/g, gg = /:([^]+)/, hg = /\/\*[^]*?\*\//g;
function vg(e) {
  const t = {};
  return e.replace(hg, "").split(_g).forEach((n) => {
    if (n) {
      const r = n.split(gg);
      r.length > 1 && (t[r[0].trim()] = r[1].trim());
    }
  }), t;
}
function Ce(e) {
  let t = "";
  if (Ve(e))
    t = e;
  else if (ce(e))
    for (let n = 0; n < e.length; n++) {
      const r = Ce(e[n]);
      r && (t += r + " ");
    }
  else if (Ne(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
function yg(e) {
  if (!e)
    return null;
  let { class: t, style: n } = e;
  return t && !Ve(t) && (e.class = Ce(t)), n && (e.style = Ut(n)), e;
}
const bg = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", zg = /* @__PURE__ */ Vs(bg);
function Tm(e) {
  return !!e || e === "";
}
const D = (e) => Ve(e) ? e : e == null ? "" : ce(e) || Ne(e) && (e.toString === Sm || !pe(e.toString)) ? JSON.stringify(e, Cm, 2) : String(e), Cm = (e, t) => t && t.__v_isRef ? Cm(e, t.value) : wr(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [r, o], a) => (n[ki(r, a) + " =>"] = o, n),
    {}
  )
} : xm(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => ki(n))
} : Ar(t) ? ki(t) : Ne(t) && !ce(t) && !Em(t) ? String(t) : t, ki = (e, t = "") => {
  var n;
  return Ar(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e;
};
/**
* @vue/reactivity v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Rt;
class Am {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this.parent = Rt, !t && Rt && (this.index = (Rt.scopes || (Rt.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  run(t) {
    if (this._active) {
      const n = Rt;
      try {
        return Rt = this, t();
      } finally {
        Rt = n;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Rt = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Rt = this.parent;
  }
  stop(t) {
    if (this._active) {
      let n, r;
      for (n = 0, r = this.effects.length; n < r; n++)
        this.effects[n].stop();
      for (n = 0, r = this.cleanups.length; n < r; n++)
        this.cleanups[n]();
      if (this.scopes)
        for (n = 0, r = this.scopes.length; n < r; n++)
          this.scopes[n].stop(!0);
      if (!this.detached && this.parent && !t) {
        const o = this.parent.scopes.pop();
        o && o !== this && (this.parent.scopes[this.index] = o, o.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function jg(e) {
  return new Am(e);
}
function wg(e, t = Rt) {
  t && t.active && t.effects.push(e);
}
function xg() {
  return Rt;
}
let Qn;
class Js {
  constructor(t, n, r, o) {
    this.fn = t, this.trigger = n, this.scheduler = r, this.active = !0, this.deps = [], this._dirtyLevel = 4, this._trackId = 0, this._runnings = 0, this._shouldSchedule = !1, this._depsLength = 0, wg(this, o);
  }
  get dirty() {
    if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
      this._dirtyLevel = 1, sr();
      for (let t = 0; t < this._depsLength; t++) {
        const n = this.deps[t];
        if (n.computed && (kg(n.computed), this._dirtyLevel >= 4))
          break;
      }
      this._dirtyLevel === 1 && (this._dirtyLevel = 0), lr();
    }
    return this._dirtyLevel >= 4;
  }
  set dirty(t) {
    this._dirtyLevel = t ? 4 : 0;
  }
  run() {
    if (this._dirtyLevel = 0, !this.active)
      return this.fn();
    let t = Sn, n = Qn;
    try {
      return Sn = !0, Qn = this, this._runnings++, sc(this), this.fn();
    } finally {
      lc(this), this._runnings--, Qn = n, Sn = t;
    }
  }
  stop() {
    var t;
    this.active && (sc(this), lc(this), (t = this.onStop) == null || t.call(this), this.active = !1);
  }
}
function kg(e) {
  return e.value;
}
function sc(e) {
  e._trackId++, e._depsLength = 0;
}
function lc(e) {
  if (e.deps.length > e._depsLength) {
    for (let t = e._depsLength; t < e.deps.length; t++)
      Om(e.deps[t], e);
    e.deps.length = e._depsLength;
  }
}
function Om(e, t) {
  const n = e.get(t);
  n !== void 0 && t._trackId !== n && (e.delete(t), e.size === 0 && e.cleanup());
}
let Sn = !0, Ki = 0;
const Im = [];
function sr() {
  Im.push(Sn), Sn = !1;
}
function lr() {
  const e = Im.pop();
  Sn = e === void 0 ? !0 : e;
}
function Ws() {
  Ki++;
}
function Ys() {
  for (Ki--; !Ki && Qi.length; )
    Qi.shift()();
}
function Lm(e, t, n) {
  if (t.get(e) !== e._trackId) {
    t.set(e, e._trackId);
    const r = e.deps[e._depsLength];
    r !== t ? (r && Om(r, e), e.deps[e._depsLength++] = t) : e._depsLength++;
  }
}
const Qi = [];
function Nm(e, t, n) {
  Ws();
  for (const r of e.keys()) {
    let o;
    r._dirtyLevel < t && (o ?? (o = e.get(r) === r._trackId)) && (r._shouldSchedule || (r._shouldSchedule = r._dirtyLevel === 0), r._dirtyLevel = t), r._shouldSchedule && (o ?? (o = e.get(r) === r._trackId)) && (r.trigger(), (!r._runnings || r.allowRecurse) && r._dirtyLevel !== 2 && (r._shouldSchedule = !1, r.scheduler && Qi.push(r.scheduler)));
  }
  Ys();
}
const Mm = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  return n.cleanup = e, n.computed = t, n;
}, Xi = /* @__PURE__ */ new WeakMap(), Xn = Symbol(""), Zi = Symbol("");
function _t(e, t, n) {
  if (Sn && Qn) {
    let r = Xi.get(e);
    r || Xi.set(e, r = /* @__PURE__ */ new Map());
    let o = r.get(n);
    o || r.set(n, o = Mm(() => r.delete(n))), Lm(
      Qn,
      o
    );
  }
}
function cn(e, t, n, r, o, a) {
  const i = Xi.get(e);
  if (!i)
    return;
  let s = [];
  if (t === "clear")
    s = [...i.values()];
  else if (n === "length" && ce(e)) {
    const l = Number(r);
    i.forEach((c, u) => {
      (u === "length" || !Ar(u) && u >= l) && s.push(c);
    });
  } else
    switch (n !== void 0 && s.push(i.get(n)), t) {
      case "add":
        ce(e) ? Bs(n) && s.push(i.get("length")) : (s.push(i.get(Xn)), wr(e) && s.push(i.get(Zi)));
        break;
      case "delete":
        ce(e) || (s.push(i.get(Xn)), wr(e) && s.push(i.get(Zi)));
        break;
      case "set":
        wr(e) && s.push(i.get(Xn));
        break;
    }
  Ws();
  for (const l of s)
    l && Nm(
      l,
      4
    );
  Ys();
}
const Sg = /* @__PURE__ */ Vs("__proto__,__v_isRef,__isVue"), Rm = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(Ar)
), cc = /* @__PURE__ */ Eg();
function Eg() {
  const e = {};
  return ["includes", "indexOf", "lastIndexOf"].forEach((t) => {
    e[t] = function(...n) {
      const r = Se(this);
      for (let a = 0, i = this.length; a < i; a++)
        _t(r, "get", a + "");
      const o = r[t](...n);
      return o === -1 || o === !1 ? r[t](...n.map(Se)) : o;
    };
  }), ["push", "pop", "shift", "unshift", "splice"].forEach((t) => {
    e[t] = function(...n) {
      sr(), Ws();
      const r = Se(this)[t].apply(this, n);
      return Ys(), lr(), r;
    };
  }), e;
}
function Pg(e) {
  const t = Se(this);
  return _t(t, "has", e), t.hasOwnProperty(e);
}
class $m {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, r) {
    const o = this._isReadonly, a = this._isShallow;
    if (n === "__v_isReactive")
      return !o;
    if (n === "__v_isReadonly")
      return o;
    if (n === "__v_isShallow")
      return a;
    if (n === "__v_raw")
      return r === (o ? a ? Ug : Vm : a ? Um : Fm).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the reciever is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(r) ? t : void 0;
    const i = ce(t);
    if (!o) {
      if (i && je(cc, n))
        return Reflect.get(cc, n, r);
      if (n === "hasOwnProperty")
        return Pg;
    }
    const s = Reflect.get(t, n, r);
    return (Ar(n) ? Rm.has(n) : Sg(n)) || (o || _t(t, "get", n), a) ? s : it(s) ? i && Bs(n) ? s : s.value : Ne(s) ? o ? qm(s) : Qs(s) : s;
  }
}
class Dm extends $m {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, r, o) {
    let a = t[n];
    if (!this._isShallow) {
      const l = Sr(a);
      if (!ma(r) && !Sr(r) && (a = Se(a), r = Se(r)), !ce(t) && it(a) && !it(r))
        return l ? !1 : (a.value = r, !0);
    }
    const i = ce(t) && Bs(n) ? Number(n) < t.length : je(t, n), s = Reflect.set(t, n, r, o);
    return t === Se(o) && (i ? Pn(r, a) && cn(t, "set", n, r) : cn(t, "add", n, r)), s;
  }
  deleteProperty(t, n) {
    const r = je(t, n);
    t[n];
    const o = Reflect.deleteProperty(t, n);
    return o && r && cn(t, "delete", n, void 0), o;
  }
  has(t, n) {
    const r = Reflect.has(t, n);
    return (!Ar(n) || !Rm.has(n)) && _t(t, "has", n), r;
  }
  ownKeys(t) {
    return _t(
      t,
      "iterate",
      ce(t) ? "length" : Xn
    ), Reflect.ownKeys(t);
  }
}
class Tg extends $m {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return !0;
  }
  deleteProperty(t, n) {
    return !0;
  }
}
const Cg = /* @__PURE__ */ new Dm(), Ag = /* @__PURE__ */ new Tg(), Og = /* @__PURE__ */ new Dm(
  !0
), Gs = (e) => e, $a = (e) => Reflect.getPrototypeOf(e);
function Uo(e, t, n = !1, r = !1) {
  e = e.__v_raw;
  const o = Se(e), a = Se(t);
  n || (Pn(t, a) && _t(o, "get", t), _t(o, "get", a));
  const { has: i } = $a(o), s = r ? Gs : n ? Zs : lo;
  if (i.call(o, t))
    return s(e.get(t));
  if (i.call(o, a))
    return s(e.get(a));
  e !== o && e.get(t);
}
function Vo(e, t = !1) {
  const n = this.__v_raw, r = Se(n), o = Se(e);
  return t || (Pn(e, o) && _t(r, "has", e), _t(r, "has", o)), e === o ? n.has(e) : n.has(e) || n.has(o);
}
function qo(e, t = !1) {
  return e = e.__v_raw, !t && _t(Se(e), "iterate", Xn), Reflect.get(e, "size", e);
}
function uc(e) {
  e = Se(e);
  const t = Se(this);
  return $a(t).has.call(t, e) || (t.add(e), cn(t, "add", e, e)), this;
}
function mc(e, t) {
  t = Se(t);
  const n = Se(this), { has: r, get: o } = $a(n);
  let a = r.call(n, e);
  a || (e = Se(e), a = r.call(n, e));
  const i = o.call(n, e);
  return n.set(e, t), a ? Pn(t, i) && cn(n, "set", e, t) : cn(n, "add", e, t), this;
}
function dc(e) {
  const t = Se(this), { has: n, get: r } = $a(t);
  let o = n.call(t, e);
  o || (e = Se(e), o = n.call(t, e)), r && r.call(t, e);
  const a = t.delete(e);
  return o && cn(t, "delete", e, void 0), a;
}
function pc() {
  const e = Se(this), t = e.size !== 0, n = e.clear();
  return t && cn(e, "clear", void 0, void 0), n;
}
function Ho(e, t) {
  return function(r, o) {
    const a = this, i = a.__v_raw, s = Se(i), l = t ? Gs : e ? Zs : lo;
    return !e && _t(s, "iterate", Xn), i.forEach((c, u) => r.call(o, l(c), l(u), a));
  };
}
function Bo(e, t, n) {
  return function(...r) {
    const o = this.__v_raw, a = Se(o), i = wr(a), s = e === "entries" || e === Symbol.iterator && i, l = e === "keys" && i, c = o[e](...r), u = n ? Gs : t ? Zs : lo;
    return !t && _t(
      a,
      "iterate",
      l ? Zi : Xn
    ), {
      // iterator protocol
      next() {
        const { value: d, done: p } = c.next();
        return p ? { value: d, done: p } : {
          value: s ? [u(d[0]), u(d[1])] : u(d),
          done: p
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function gn(e) {
  return function(...t) {
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function Ig() {
  const e = {
    get(a) {
      return Uo(this, a);
    },
    get size() {
      return qo(this);
    },
    has: Vo,
    add: uc,
    set: mc,
    delete: dc,
    clear: pc,
    forEach: Ho(!1, !1)
  }, t = {
    get(a) {
      return Uo(this, a, !1, !0);
    },
    get size() {
      return qo(this);
    },
    has: Vo,
    add: uc,
    set: mc,
    delete: dc,
    clear: pc,
    forEach: Ho(!1, !0)
  }, n = {
    get(a) {
      return Uo(this, a, !0);
    },
    get size() {
      return qo(this, !0);
    },
    has(a) {
      return Vo.call(this, a, !0);
    },
    add: gn("add"),
    set: gn("set"),
    delete: gn("delete"),
    clear: gn("clear"),
    forEach: Ho(!0, !1)
  }, r = {
    get(a) {
      return Uo(this, a, !0, !0);
    },
    get size() {
      return qo(this, !0);
    },
    has(a) {
      return Vo.call(this, a, !0);
    },
    add: gn("add"),
    set: gn("set"),
    delete: gn("delete"),
    clear: gn("clear"),
    forEach: Ho(!0, !0)
  };
  return ["keys", "values", "entries", Symbol.iterator].forEach((a) => {
    e[a] = Bo(
      a,
      !1,
      !1
    ), n[a] = Bo(
      a,
      !0,
      !1
    ), t[a] = Bo(
      a,
      !1,
      !0
    ), r[a] = Bo(
      a,
      !0,
      !0
    );
  }), [
    e,
    n,
    t,
    r
  ];
}
const [
  Lg,
  Ng,
  Mg,
  Rg
] = /* @__PURE__ */ Ig();
function Ks(e, t) {
  const n = t ? e ? Rg : Mg : e ? Ng : Lg;
  return (r, o, a) => o === "__v_isReactive" ? !e : o === "__v_isReadonly" ? e : o === "__v_raw" ? r : Reflect.get(
    je(n, o) && o in r ? n : r,
    o,
    a
  );
}
const $g = {
  get: /* @__PURE__ */ Ks(!1, !1)
}, Dg = {
  get: /* @__PURE__ */ Ks(!1, !0)
}, Fg = {
  get: /* @__PURE__ */ Ks(!0, !1)
}, Fm = /* @__PURE__ */ new WeakMap(), Um = /* @__PURE__ */ new WeakMap(), Vm = /* @__PURE__ */ new WeakMap(), Ug = /* @__PURE__ */ new WeakMap();
function Vg(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function qg(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : Vg(mg(e));
}
function Qs(e) {
  return Sr(e) ? e : Xs(
    e,
    !1,
    Cg,
    $g,
    Fm
  );
}
function Hg(e) {
  return Xs(
    e,
    !1,
    Og,
    Dg,
    Um
  );
}
function qm(e) {
  return Xs(
    e,
    !0,
    Ag,
    Fg,
    Vm
  );
}
function Xs(e, t, n, r, o) {
  if (!Ne(e) || e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const a = o.get(e);
  if (a)
    return a;
  const i = qg(e);
  if (i === 0)
    return e;
  const s = new Proxy(
    e,
    i === 2 ? r : n
  );
  return o.set(e, s), s;
}
function xr(e) {
  return Sr(e) ? xr(e.__v_raw) : !!(e && e.__v_isReactive);
}
function Sr(e) {
  return !!(e && e.__v_isReadonly);
}
function ma(e) {
  return !!(e && e.__v_isShallow);
}
function Hm(e) {
  return xr(e) || Sr(e);
}
function Se(e) {
  const t = e && e.__v_raw;
  return t ? Se(t) : e;
}
function Bm(e) {
  return Object.isExtensible(e) && ua(e, "__v_skip", !0), e;
}
const lo = (e) => Ne(e) ? Qs(e) : e, Zs = (e) => Ne(e) ? qm(e) : e;
class Jm {
  constructor(t, n, r, o) {
    this.getter = t, this._setter = n, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this.effect = new Js(
      () => t(this._value),
      () => ea(
        this,
        this.effect._dirtyLevel === 2 ? 2 : 3
      )
    ), this.effect.computed = this, this.effect.active = this._cacheable = !o, this.__v_isReadonly = r;
  }
  get value() {
    const t = Se(this);
    return (!t._cacheable || t.effect.dirty) && Pn(t._value, t._value = t.effect.run()) && ea(t, 4), Wm(t), t.effect._dirtyLevel >= 2 && ea(t, 2), t._value;
  }
  set value(t) {
    this._setter(t);
  }
  // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
  get _dirty() {
    return this.effect.dirty;
  }
  set _dirty(t) {
    this.effect.dirty = t;
  }
  // #endregion
}
function Bg(e, t, n = !1) {
  let r, o;
  const a = pe(e);
  return a ? (r = e, o = St) : (r = e.get, o = e.set), new Jm(r, o, a || !o, n);
}
function Wm(e) {
  var t;
  Sn && Qn && (e = Se(e), Lm(
    Qn,
    (t = e.dep) != null ? t : e.dep = Mm(
      () => e.dep = void 0,
      e instanceof Jm ? e : void 0
    )
  ));
}
function ea(e, t = 4, n) {
  e = Se(e);
  const r = e.dep;
  r && Nm(
    r,
    t
  );
}
function it(e) {
  return !!(e && e.__v_isRef === !0);
}
function ue(e) {
  return Ym(e, !1);
}
function Jg(e) {
  return Ym(e, !0);
}
function Ym(e, t) {
  return it(e) ? e : new Wg(e, t);
}
class Wg {
  constructor(t, n) {
    this.__v_isShallow = n, this.dep = void 0, this.__v_isRef = !0, this._rawValue = n ? t : Se(t), this._value = n ? t : lo(t);
  }
  get value() {
    return Wm(this), this._value;
  }
  set value(t) {
    const n = this.__v_isShallow || ma(t) || Sr(t);
    t = n ? t : Se(t), Pn(t, this._rawValue) && (this._rawValue = t, this._value = n ? t : lo(t), ea(this, 4));
  }
}
function X(e) {
  return it(e) ? e.value : e;
}
const Yg = {
  get: (e, t, n) => X(Reflect.get(e, t, n)),
  set: (e, t, n, r) => {
    const o = e[t];
    return it(o) && !it(n) ? (o.value = n, !0) : Reflect.set(e, t, n, r);
  }
};
function Gm(e) {
  return xr(e) ? e : new Proxy(e, Yg);
}
/**
* @vue/runtime-core v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function En(e, t, n, r) {
  try {
    return r ? e(...r) : e();
  } catch (o) {
    wo(o, t, n);
  }
}
function Pt(e, t, n, r) {
  if (pe(e)) {
    const a = En(e, t, n, r);
    return a && km(a) && a.catch((i) => {
      wo(i, t, n);
    }), a;
  }
  const o = [];
  for (let a = 0; a < e.length; a++)
    o.push(Pt(e[a], t, n, r));
  return o;
}
function wo(e, t, n, r = !0) {
  const o = t ? t.vnode : null;
  if (t) {
    let a = t.parent;
    const i = t.proxy, s = `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; a; ) {
      const c = a.ec;
      if (c) {
        for (let u = 0; u < c.length; u++)
          if (c[u](e, i, s) === !1)
            return;
      }
      a = a.parent;
    }
    const l = t.appContext.config.errorHandler;
    if (l) {
      En(
        l,
        null,
        10,
        [e, i, s]
      );
      return;
    }
  }
  Gg(e, n, o, r);
}
function Gg(e, t, n, r = !0) {
  console.error(e);
}
let co = !1, es = !1;
const Ze = [];
let Wt = 0;
const kr = [];
let zn = null, Jn = 0;
const Km = /* @__PURE__ */ Promise.resolve();
let el = null;
function Qm(e) {
  const t = el || Km;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Kg(e) {
  let t = Wt + 1, n = Ze.length;
  for (; t < n; ) {
    const r = t + n >>> 1, o = Ze[r], a = uo(o);
    a < e || a === e && o.pre ? t = r + 1 : n = r;
  }
  return t;
}
function Da(e) {
  (!Ze.length || !Ze.includes(
    e,
    co && e.allowRecurse ? Wt + 1 : Wt
  )) && (e.id == null ? Ze.push(e) : Ze.splice(Kg(e.id), 0, e), Xm());
}
function Xm() {
  !co && !es && (es = !0, el = Km.then(ed));
}
function Qg(e) {
  const t = Ze.indexOf(e);
  t > Wt && Ze.splice(t, 1);
}
function Xg(e) {
  ce(e) ? kr.push(...e) : (!zn || !zn.includes(
    e,
    e.allowRecurse ? Jn + 1 : Jn
  )) && kr.push(e), Xm();
}
function fc(e, t, n = co ? Wt + 1 : 0) {
  for (; n < Ze.length; n++) {
    const r = Ze[n];
    if (r && r.pre) {
      if (e && r.id !== e.uid)
        continue;
      Ze.splice(n, 1), n--, r();
    }
  }
}
function Zm(e) {
  if (kr.length) {
    const t = [...new Set(kr)].sort(
      (n, r) => uo(n) - uo(r)
    );
    if (kr.length = 0, zn) {
      zn.push(...t);
      return;
    }
    for (zn = t, Jn = 0; Jn < zn.length; Jn++)
      zn[Jn]();
    zn = null, Jn = 0;
  }
}
const uo = (e) => e.id == null ? 1 / 0 : e.id, Zg = (e, t) => {
  const n = uo(e) - uo(t);
  if (n === 0) {
    if (e.pre && !t.pre)
      return -1;
    if (t.pre && !e.pre)
      return 1;
  }
  return n;
};
function ed(e) {
  es = !1, co = !0, Ze.sort(Zg);
  try {
    for (Wt = 0; Wt < Ze.length; Wt++) {
      const t = Ze[Wt];
      t && t.active !== !1 && En(t, null, 14);
    }
  } finally {
    Wt = 0, Ze.length = 0, Zm(), co = !1, el = null, (Ze.length || kr.length) && ed();
  }
}
let eh = !1;
function th(e, t, ...n) {
  if (e.isUnmounted)
    return;
  const r = e.vnode.props || Le;
  let o = n;
  const a = t.startsWith("update:"), i = a && t.slice(7);
  if (i && i in r) {
    const u = `${i === "modelValue" ? "model" : i}Modifiers`, { number: d, trim: p } = r[u] || Le;
    p && (o = n.map((m) => Ve(m) ? m.trim() : m)), d && (o = n.map(fg));
  }
  let s, l = r[s = wi(t)] || // also try camelCase event handler (#2249)
  r[s = wi(vt(t))];
  !l && a && (l = r[s = wi($t(t))]), l && Pt(
    l,
    e,
    6,
    o
  );
  const c = r[s + "Once"];
  if (c) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[s])
      return;
    e.emitted[s] = !0, Pt(
      c,
      e,
      6,
      o
    );
  }
}
function td(e, t, n = !1) {
  const r = t.emitsCache, o = r.get(e);
  if (o !== void 0)
    return o;
  const a = e.emits;
  let i = {}, s = !1;
  if (!pe(e)) {
    const l = (c) => {
      const u = td(c, t, !0);
      u && (s = !0, Ke(i, u));
    };
    !n && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !a && !s ? (Ne(e) && r.set(e, null), null) : (ce(a) ? a.forEach((l) => i[l] = null) : Ke(i, a), Ne(e) && r.set(e, i), i);
}
function Fa(e, t) {
  return !e || !La(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), je(e, t[0].toLowerCase() + t.slice(1)) || je(e, $t(t)) || je(e, t));
}
let Je = null, Ua = null;
function da(e) {
  const t = Je;
  return Je = e, Ua = e && e.type.__scopeId || null, t;
}
function xo(e) {
  Ua = e;
}
function ko() {
  Ua = null;
}
function Oe(e, t = Je, n) {
  if (!t || e._n)
    return e;
  const r = (...o) => {
    r._d && Pc(-1);
    const a = da(t);
    let i;
    try {
      i = e(...o);
    } finally {
      da(a), r._d && Pc(1);
    }
    return i;
  };
  return r._n = !0, r._c = !0, r._d = !0, r;
}
function _c(e) {
  const {
    type: t,
    vnode: n,
    proxy: r,
    withProxy: o,
    props: a,
    propsOptions: [i],
    slots: s,
    attrs: l,
    emit: c,
    render: u,
    renderCache: d,
    data: p,
    setupState: m,
    ctx: f,
    inheritAttrs: _
  } = e;
  let y, A;
  const I = da(e);
  try {
    if (n.shapeFlag & 4) {
      const S = o || r, T = S;
      y = Jt(
        u.call(
          T,
          S,
          d,
          a,
          m,
          p,
          f
        )
      ), A = l;
    } else {
      const S = t;
      y = Jt(
        S.length > 1 ? S(
          a,
          { attrs: l, slots: s, emit: c }
        ) : S(
          a,
          null
          /* we know it doesn't need it */
        )
      ), A = t.props ? l : nh(l);
    }
  } catch (S) {
    ro.length = 0, wo(S, e, 1), y = B(Tt);
  }
  let j = y;
  if (A && _ !== !1) {
    const S = Object.keys(A), { shapeFlag: T } = j;
    S.length && T & 7 && (i && S.some(qs) && (A = rh(
      A,
      i
    )), j = mn(j, A));
  }
  return n.dirs && (j = mn(j), j.dirs = j.dirs ? j.dirs.concat(n.dirs) : n.dirs), n.transition && (j.transition = n.transition), y = j, da(I), y;
}
const nh = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || La(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, rh = (e, t) => {
  const n = {};
  for (const r in e)
    (!qs(r) || !(r.slice(9) in t)) && (n[r] = e[r]);
  return n;
};
function oh(e, t, n) {
  const { props: r, children: o, component: a } = e, { props: i, children: s, patchFlag: l } = t, c = a.emitsOptions;
  if (t.dirs || t.transition)
    return !0;
  if (n && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return r ? gc(r, i, c) : !!i;
    if (l & 8) {
      const u = t.dynamicProps;
      for (let d = 0; d < u.length; d++) {
        const p = u[d];
        if (i[p] !== r[p] && !Fa(c, p))
          return !0;
      }
    }
  } else
    return (o || s) && (!s || !s.$stable) ? !0 : r === i ? !1 : r ? i ? gc(r, i, c) : !0 : !!i;
  return !1;
}
function gc(e, t, n) {
  const r = Object.keys(t);
  if (r.length !== Object.keys(e).length)
    return !0;
  for (let o = 0; o < r.length; o++) {
    const a = r[o];
    if (t[a] !== e[a] && !Fa(n, a))
      return !0;
  }
  return !1;
}
function ah({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const r = t.subTree;
    if (r.suspense && r.suspense.activeBranch === e && (r.el = e.el), r === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const nd = "components";
function ih(e, t) {
  return od(nd, e, !0, t) || e;
}
const rd = Symbol.for("v-ndc");
function er(e) {
  return Ve(e) ? od(nd, e, !1) || e : e || rd;
}
function od(e, t, n = !0, r = !1) {
  const o = Je || Ge;
  if (o) {
    const a = o.type;
    {
      const s = ev(
        a,
        !1
      );
      if (s && (s === t || s === vt(t) || s === Ra(vt(t))))
        return a;
    }
    const i = (
      // local registration
      // check instance[type] first which is resolved for options API
      hc(o[e] || a[e], t) || // global registration
      hc(o.appContext[e], t)
    );
    return !i && r ? a : i;
  }
}
function hc(e, t) {
  return e && (e[t] || e[vt(t)] || e[Ra(vt(t))]);
}
const sh = (e) => e.__isSuspense;
function lh(e, t) {
  t && t.pendingBranch ? ce(e) ? t.effects.push(...e) : t.effects.push(e) : Xg(e);
}
const ch = Symbol.for("v-scx"), uh = () => Gt(ch);
function So(e, t) {
  return Va(e, null, t);
}
function mh(e, t) {
  return Va(
    e,
    null,
    { flush: "post" }
  );
}
const Jo = {};
function un(e, t, n) {
  return Va(e, t, n);
}
function Va(e, t, {
  immediate: n,
  deep: r,
  flush: o,
  once: a,
  onTrack: i,
  onTrigger: s
} = Le) {
  if (t && a) {
    const z = t;
    t = (...O) => {
      z(...O), T();
    };
  }
  const l = Ge, c = (z) => r === !0 ? z : (
    // for deep: false, only traverse root-level properties
    Yn(z, r === !1 ? 1 : void 0)
  );
  let u, d = !1, p = !1;
  if (it(e) ? (u = () => e.value, d = ma(e)) : xr(e) ? (u = () => c(e), d = !0) : ce(e) ? (p = !0, d = e.some((z) => xr(z) || ma(z)), u = () => e.map((z) => {
    if (it(z))
      return z.value;
    if (xr(z))
      return c(z);
    if (pe(z))
      return En(z, l, 2);
  })) : pe(e) ? t ? u = () => En(e, l, 2) : u = () => (m && m(), Pt(
    e,
    l,
    3,
    [f]
  )) : u = St, t && r) {
    const z = u;
    u = () => Yn(z());
  }
  let m, f = (z) => {
    m = j.onStop = () => {
      En(z, l, 4), m = j.onStop = void 0;
    };
  }, _;
  if (Co)
    if (f = St, t ? n && Pt(t, l, 3, [
      u(),
      p ? [] : void 0,
      f
    ]) : u(), o === "sync") {
      const z = uh();
      _ = z.__watcherHandles || (z.__watcherHandles = []);
    } else
      return St;
  let y = p ? new Array(e.length).fill(Jo) : Jo;
  const A = () => {
    if (!(!j.active || !j.dirty))
      if (t) {
        const z = j.run();
        (r || d || (p ? z.some((O, N) => Pn(O, y[N])) : Pn(z, y))) && (m && m(), Pt(t, l, 3, [
          z,
          // pass undefined as the old value when it's changed for the first time
          y === Jo ? void 0 : p && y[0] === Jo ? [] : y,
          f
        ]), y = z);
      } else
        j.run();
  };
  A.allowRecurse = !!t;
  let I;
  o === "sync" ? I = A : o === "post" ? I = () => mt(A, l && l.suspense) : (A.pre = !0, l && (A.id = l.uid), I = () => Da(A));
  const j = new Js(u, St, I), S = xg(), T = () => {
    j.stop(), S && Hs(S.effects, j);
  };
  return t ? n ? A() : y = j.run() : o === "post" ? mt(
    j.run.bind(j),
    l && l.suspense
  ) : j.run(), _ && _.push(T), T;
}
function dh(e, t, n) {
  const r = this.proxy, o = Ve(e) ? e.includes(".") ? ad(r, e) : () => r[e] : e.bind(r, r);
  let a;
  pe(t) ? a = t : (a = t.handler, n = t);
  const i = To(this), s = Va(o, a.bind(r), n);
  return i(), s;
}
function ad(e, t) {
  const n = t.split(".");
  return () => {
    let r = e;
    for (let o = 0; o < n.length && r; o++)
      r = r[n[o]];
    return r;
  };
}
function Yn(e, t, n = 0, r) {
  if (!Ne(e) || e.__v_skip)
    return e;
  if (t && t > 0) {
    if (n >= t)
      return e;
    n++;
  }
  if (r = r || /* @__PURE__ */ new Set(), r.has(e))
    return e;
  if (r.add(e), it(e))
    Yn(e.value, t, n, r);
  else if (ce(e))
    for (let o = 0; o < e.length; o++)
      Yn(e[o], t, n, r);
  else if (xm(e) || wr(e))
    e.forEach((o) => {
      Yn(o, t, n, r);
    });
  else if (Em(e))
    for (const o in e)
      Yn(e[o], t, n, r);
  return e;
}
function ph(e, t) {
  if (Je === null)
    return e;
  const n = Ja(Je) || Je.proxy, r = e.dirs || (e.dirs = []);
  for (let o = 0; o < t.length; o++) {
    let [a, i, s, l = Le] = t[o];
    a && (pe(a) && (a = {
      mounted: a,
      updated: a
    }), a.deep && Yn(i), r.push({
      dir: a,
      instance: n,
      value: i,
      oldValue: void 0,
      arg: s,
      modifiers: l
    }));
  }
  return e;
}
function Dn(e, t, n, r) {
  const o = e.dirs, a = t && t.dirs;
  for (let i = 0; i < o.length; i++) {
    const s = o[i];
    a && (s.oldValue = a[i].value);
    let l = s.dir[r];
    l && (sr(), Pt(l, n, 8, [
      e.el,
      s,
      e,
      t
    ]), lr());
  }
}
const jn = Symbol("_leaveCb"), Wo = Symbol("_enterCb");
function fh() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return Xt(() => {
    e.isMounted = !0;
  }), md(() => {
    e.isUnmounting = !0;
  }), e;
}
const xt = [Function, Array], id = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: xt,
  onEnter: xt,
  onAfterEnter: xt,
  onEnterCancelled: xt,
  // leave
  onBeforeLeave: xt,
  onLeave: xt,
  onAfterLeave: xt,
  onLeaveCancelled: xt,
  // appear
  onBeforeAppear: xt,
  onAppear: xt,
  onAfterAppear: xt,
  onAppearCancelled: xt
}, _h = {
  name: "BaseTransition",
  props: id,
  setup(e, { slots: t }) {
    const n = ur(), r = fh();
    return () => {
      const o = t.default && ld(t.default(), !0);
      if (!o || !o.length)
        return;
      let a = o[0];
      if (o.length > 1) {
        for (const p of o)
          if (p.type !== Tt) {
            a = p;
            break;
          }
      }
      const i = Se(e), { mode: s } = i;
      if (r.isLeaving)
        return Si(a);
      const l = vc(a);
      if (!l)
        return Si(a);
      const c = ts(
        l,
        i,
        r,
        n
      );
      ns(l, c);
      const u = n.subTree, d = u && vc(u);
      if (d && d.type !== Tt && !Wn(l, d)) {
        const p = ts(
          d,
          i,
          r,
          n
        );
        if (ns(d, p), s === "out-in")
          return r.isLeaving = !0, p.afterLeave = () => {
            r.isLeaving = !1, n.update.active !== !1 && (n.effect.dirty = !0, n.update());
          }, Si(a);
        s === "in-out" && l.type !== Tt && (p.delayLeave = (m, f, _) => {
          const y = sd(
            r,
            d
          );
          y[String(d.key)] = d, m[jn] = () => {
            f(), m[jn] = void 0, delete c.delayedLeave;
          }, c.delayedLeave = _;
        });
      }
      return a;
    };
  }
}, gh = _h;
function sd(e, t) {
  const { leavingVNodes: n } = e;
  let r = n.get(t.type);
  return r || (r = /* @__PURE__ */ Object.create(null), n.set(t.type, r)), r;
}
function ts(e, t, n, r) {
  const {
    appear: o,
    mode: a,
    persisted: i = !1,
    onBeforeEnter: s,
    onEnter: l,
    onAfterEnter: c,
    onEnterCancelled: u,
    onBeforeLeave: d,
    onLeave: p,
    onAfterLeave: m,
    onLeaveCancelled: f,
    onBeforeAppear: _,
    onAppear: y,
    onAfterAppear: A,
    onAppearCancelled: I
  } = t, j = String(e.key), S = sd(n, e), T = (N, F) => {
    N && Pt(
      N,
      r,
      9,
      F
    );
  }, z = (N, F) => {
    const te = F[1];
    T(N, F), ce(N) ? N.every((he) => he.length <= 1) && te() : N.length <= 1 && te();
  }, O = {
    mode: a,
    persisted: i,
    beforeEnter(N) {
      let F = s;
      if (!n.isMounted)
        if (o)
          F = _ || s;
        else
          return;
      N[jn] && N[jn](
        !0
        /* cancelled */
      );
      const te = S[j];
      te && Wn(e, te) && te.el[jn] && te.el[jn](), T(F, [N]);
    },
    enter(N) {
      let F = l, te = c, he = u;
      if (!n.isMounted)
        if (o)
          F = y || l, te = A || c, he = I || u;
        else
          return;
      let Y = !1;
      const me = N[Wo] = (qe) => {
        Y || (Y = !0, qe ? T(he, [N]) : T(te, [N]), O.delayedLeave && O.delayedLeave(), N[Wo] = void 0);
      };
      F ? z(F, [N, me]) : me();
    },
    leave(N, F) {
      const te = String(e.key);
      if (N[Wo] && N[Wo](
        !0
        /* cancelled */
      ), n.isUnmounting)
        return F();
      T(d, [N]);
      let he = !1;
      const Y = N[jn] = (me) => {
        he || (he = !0, F(), me ? T(f, [N]) : T(m, [N]), N[jn] = void 0, S[te] === e && delete S[te]);
      };
      S[te] = e, p ? z(p, [N, Y]) : Y();
    },
    clone(N) {
      return ts(N, t, n, r);
    }
  };
  return O;
}
function Si(e) {
  if (Eo(e))
    return e = mn(e), e.children = null, e;
}
function vc(e) {
  return Eo(e) ? (
    // #7121 ensure get the child component subtree in case
    // it's been replaced during HMR
    e.children ? e.children[0] : void 0
  ) : e;
}
function ns(e, t) {
  e.shapeFlag & 6 && e.component ? ns(e.component.subTree, t) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function ld(e, t = !1, n) {
  let r = [], o = 0;
  for (let a = 0; a < e.length; a++) {
    let i = e[a];
    const s = n == null ? i.key : String(n) + String(i.key != null ? i.key : a);
    i.type === se ? (i.patchFlag & 128 && o++, r = r.concat(
      ld(i.children, t, s)
    )) : (t || i.type !== Tt) && r.push(s != null ? mn(i, { key: s }) : i);
  }
  if (o > 1)
    for (let a = 0; a < r.length; a++)
      r[a].patchFlag = -2;
  return r;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Q(e, t) {
  return pe(e) ? (
    // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    Ke({ name: e.name }, t, { setup: e })
  ) : e;
}
const Zr = (e) => !!e.type.__asyncLoader;
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function cd(e) {
  pe(e) && (e = { loader: e });
  const {
    loader: t,
    loadingComponent: n,
    errorComponent: r,
    delay: o = 200,
    timeout: a,
    // undefined = never times out
    suspensible: i = !0,
    onError: s
  } = e;
  let l = null, c, u = 0;
  const d = () => (u++, l = null, p()), p = () => {
    let m;
    return l || (m = l = t().catch((f) => {
      if (f = f instanceof Error ? f : new Error(String(f)), s)
        return new Promise((_, y) => {
          s(f, () => _(d()), () => y(f), u + 1);
        });
      throw f;
    }).then((f) => m !== l && l ? l : (f && (f.__esModule || f[Symbol.toStringTag] === "Module") && (f = f.default), c = f, f)));
  };
  return /* @__PURE__ */ Q({
    name: "AsyncComponentWrapper",
    __asyncLoader: p,
    get __asyncResolved() {
      return c;
    },
    setup() {
      const m = Ge;
      if (c)
        return () => Ei(c, m);
      const f = (I) => {
        l = null, wo(
          I,
          m,
          13,
          !r
        );
      };
      if (i && m.suspense || Co)
        return p().then((I) => () => Ei(I, m)).catch((I) => (f(I), () => r ? B(r, {
          error: I
        }) : null));
      const _ = ue(!1), y = ue(), A = ue(!!o);
      return o && setTimeout(() => {
        A.value = !1;
      }, o), a != null && setTimeout(() => {
        if (!_.value && !y.value) {
          const I = new Error(
            `Async component timed out after ${a}ms.`
          );
          f(I), y.value = I;
        }
      }, a), p().then(() => {
        _.value = !0, m.parent && Eo(m.parent.vnode) && (m.parent.effect.dirty = !0, Da(m.parent.update));
      }).catch((I) => {
        f(I), y.value = I;
      }), () => {
        if (_.value && c)
          return Ei(c, m);
        if (y.value && r)
          return B(r, {
            error: y.value
          });
        if (n && !A.value)
          return B(n);
      };
    }
  });
}
function Ei(e, t) {
  const { ref: n, props: r, children: o, ce: a } = t.vnode, i = B(e, r, o);
  return i.ref = n, i.ce = a, delete t.vnode.ce, i;
}
const Eo = (e) => e.type.__isKeepAlive;
function hh(e, t) {
  ud(e, "a", t);
}
function vh(e, t) {
  ud(e, "da", t);
}
function ud(e, t, n = Ge) {
  const r = e.__wdc || (e.__wdc = () => {
    let o = n;
    for (; o; ) {
      if (o.isDeactivated)
        return;
      o = o.parent;
    }
    return e();
  });
  if (qa(t, r, n), n) {
    let o = n.parent;
    for (; o && o.parent; )
      Eo(o.parent.vnode) && yh(r, t, n, o), o = o.parent;
  }
}
function yh(e, t, n, r) {
  const o = qa(
    t,
    e,
    r,
    !0
    /* prepend */
  );
  cr(() => {
    Hs(r[t], o);
  }, n);
}
function qa(e, t, n = Ge, r = !1) {
  if (n) {
    const o = n[e] || (n[e] = []), a = t.__weh || (t.__weh = (...i) => {
      if (n.isUnmounted)
        return;
      sr();
      const s = To(n), l = Pt(t, n, e, i);
      return s(), lr(), l;
    });
    return r ? o.unshift(a) : o.push(a), a;
  }
}
const pn = (e) => (t, n = Ge) => (
  // post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
  (!Co || e === "sp") && qa(e, (...r) => t(...r), n)
), bh = pn("bm"), Xt = pn("m"), zh = pn("bu"), tl = pn("u"), md = pn("bum"), cr = pn("um"), jh = pn("sp"), wh = pn(
  "rtg"
), xh = pn(
  "rtc"
);
function kh(e, t = Ge) {
  qa("ec", e, t);
}
function De(e, t, n, r) {
  let o;
  const a = n;
  if (ce(e) || Ve(e)) {
    o = new Array(e.length);
    for (let i = 0, s = e.length; i < s; i++)
      o[i] = t(e[i], i, void 0, a);
  } else if (typeof e == "number") {
    o = new Array(e);
    for (let i = 0; i < e; i++)
      o[i] = t(i + 1, i, void 0, a);
  } else if (Ne(e))
    if (e[Symbol.iterator])
      o = Array.from(
        e,
        (i, s) => t(i, s, void 0, a)
      );
    else {
      const i = Object.keys(e);
      o = new Array(i.length);
      for (let s = 0, l = i.length; s < l; s++) {
        const c = i[s];
        o[s] = t(e[c], c, s, a);
      }
    }
  else
    o = [];
  return o;
}
function Ha(e, t, n = {}, r, o) {
  if (Je.isCE || Je.parent && Zr(Je.parent) && Je.parent.isCE)
    return B("slot", n, r);
  let a = e[t];
  a && a._c && (a._d = !1), w();
  const i = a && dd(a(n)), s = ge(
    se,
    {
      key: n.key || // slot content array of a dynamic conditional slot may have a branch
      // key attached in the `createSlots` helper, respect that
      i && i.key || `_${t}`
    },
    i || [],
    i && e._ === 1 ? 64 : -2
  );
  return a && a._c && (a._d = !0), s;
}
function dd(e) {
  return e.some((t) => fa(t) ? !(t.type === Tt || t.type === se && !dd(t.children)) : !0) ? e : null;
}
const rs = (e) => e ? Sd(e) ? Ja(e) || e.proxy : rs(e.parent) : null, eo = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ Ke(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => e.props,
    $attrs: (e) => e.attrs,
    $slots: (e) => e.slots,
    $refs: (e) => e.refs,
    $parent: (e) => rs(e.parent),
    $root: (e) => rs(e.root),
    $emit: (e) => e.emit,
    $options: (e) => fd(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      e.effect.dirty = !0, Da(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = Qm.bind(e.proxy)),
    $watch: (e) => dh.bind(e)
  })
), Pi = (e, t) => e !== Le && !e.__isScriptSetup && je(e, t), Sh = {
  get({ _: e }, t) {
    const { ctx: n, setupState: r, data: o, props: a, accessCache: i, type: s, appContext: l } = e;
    let c;
    if (t[0] !== "$") {
      const m = i[t];
      if (m !== void 0)
        switch (m) {
          case 1:
            return r[t];
          case 2:
            return o[t];
          case 4:
            return n[t];
          case 3:
            return a[t];
        }
      else {
        if (Pi(r, t))
          return i[t] = 1, r[t];
        if (o !== Le && je(o, t))
          return i[t] = 2, o[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (c = e.propsOptions[0]) && je(c, t)
        )
          return i[t] = 3, a[t];
        if (n !== Le && je(n, t))
          return i[t] = 4, n[t];
        os && (i[t] = 0);
      }
    }
    const u = eo[t];
    let d, p;
    if (u)
      return t === "$attrs" && _t(e, "get", t), u(e);
    if (
      // css module (injected by vue-loader)
      (d = s.__cssModules) && (d = d[t])
    )
      return d;
    if (n !== Le && je(n, t))
      return i[t] = 4, n[t];
    if (
      // global properties
      p = l.config.globalProperties, je(p, t)
    )
      return p[t];
  },
  set({ _: e }, t, n) {
    const { data: r, setupState: o, ctx: a } = e;
    return Pi(o, t) ? (o[t] = n, !0) : r !== Le && je(r, t) ? (r[t] = n, !0) : je(e.props, t) || t[0] === "$" && t.slice(1) in e ? !1 : (a[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: r, appContext: o, propsOptions: a }
  }, i) {
    let s;
    return !!n[i] || e !== Le && je(e, i) || Pi(t, i) || (s = a[0]) && je(s, i) || je(r, i) || je(eo, i) || je(o.config.globalProperties, i);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : je(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
function yc(e) {
  return ce(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
let os = !0;
function Eh(e) {
  const t = fd(e), n = e.proxy, r = e.ctx;
  os = !1, t.beforeCreate && zc(t.beforeCreate, e, "bc");
  const {
    // state
    data: o,
    computed: a,
    methods: i,
    watch: s,
    provide: l,
    inject: c,
    // lifecycle
    created: u,
    beforeMount: d,
    mounted: p,
    beforeUpdate: m,
    updated: f,
    activated: _,
    deactivated: y,
    beforeDestroy: A,
    beforeUnmount: I,
    destroyed: j,
    unmounted: S,
    render: T,
    renderTracked: z,
    renderTriggered: O,
    errorCaptured: N,
    serverPrefetch: F,
    // public API
    expose: te,
    inheritAttrs: he,
    // assets
    components: Y,
    directives: me,
    filters: qe
  } = t;
  if (c && Ph(c, r, null), i)
    for (const Pe in i) {
      const xe = i[Pe];
      pe(xe) && (r[Pe] = xe.bind(n));
    }
  if (o) {
    const Pe = o.call(n, n);
    Ne(Pe) && (e.data = Qs(Pe));
  }
  if (os = !0, a)
    for (const Pe in a) {
      const xe = a[Pe], gt = pe(xe) ? xe.bind(n, n) : pe(xe.get) ? xe.get.bind(n, n) : St, ye = !pe(xe) && pe(xe.set) ? xe.set.bind(n) : St, Be = ee({
        get: gt,
        set: ye
      });
      Object.defineProperty(r, Pe, {
        enumerable: !0,
        configurable: !0,
        get: () => Be.value,
        set: (Ye) => Be.value = Ye
      });
    }
  if (s)
    for (const Pe in s)
      pd(s[Pe], r, n, Pe);
  if (l) {
    const Pe = pe(l) ? l.call(n) : l;
    Reflect.ownKeys(Pe).forEach((xe) => {
      tr(xe, Pe[xe]);
    });
  }
  u && zc(u, e, "c");
  function Me(Pe, xe) {
    ce(xe) ? xe.forEach((gt) => Pe(gt.bind(n))) : xe && Pe(xe.bind(n));
  }
  if (Me(bh, d), Me(Xt, p), Me(zh, m), Me(tl, f), Me(hh, _), Me(vh, y), Me(kh, N), Me(xh, z), Me(wh, O), Me(md, I), Me(cr, S), Me(jh, F), ce(te))
    if (te.length) {
      const Pe = e.exposed || (e.exposed = {});
      te.forEach((xe) => {
        Object.defineProperty(Pe, xe, {
          get: () => n[xe],
          set: (gt) => n[xe] = gt
        });
      });
    } else e.exposed || (e.exposed = {});
  T && e.render === St && (e.render = T), he != null && (e.inheritAttrs = he), Y && (e.components = Y), me && (e.directives = me);
}
function Ph(e, t, n = St) {
  ce(e) && (e = as(e));
  for (const r in e) {
    const o = e[r];
    let a;
    Ne(o) ? "default" in o ? a = Gt(
      o.from || r,
      o.default,
      !0
    ) : a = Gt(o.from || r) : a = Gt(o), it(a) ? Object.defineProperty(t, r, {
      enumerable: !0,
      configurable: !0,
      get: () => a.value,
      set: (i) => a.value = i
    }) : t[r] = a;
  }
}
function zc(e, t, n) {
  Pt(
    ce(e) ? e.map((r) => r.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function pd(e, t, n, r) {
  const o = r.includes(".") ? ad(n, r) : () => n[r];
  if (Ve(e)) {
    const a = t[e];
    pe(a) && un(o, a);
  } else if (pe(e))
    un(o, e.bind(n));
  else if (Ne(e))
    if (ce(e))
      e.forEach((a) => pd(a, t, n, r));
    else {
      const a = pe(e.handler) ? e.handler.bind(n) : t[e.handler];
      pe(a) && un(o, a, e);
    }
}
function fd(e) {
  const t = e.type, { mixins: n, extends: r } = t, {
    mixins: o,
    optionsCache: a,
    config: { optionMergeStrategies: i }
  } = e.appContext, s = a.get(t);
  let l;
  return s ? l = s : !o.length && !n && !r ? l = t : (l = {}, o.length && o.forEach(
    (c) => pa(l, c, i, !0)
  ), pa(l, t, i)), Ne(t) && a.set(t, l), l;
}
function pa(e, t, n, r = !1) {
  const { mixins: o, extends: a } = t;
  a && pa(e, a, n, !0), o && o.forEach(
    (i) => pa(e, i, n, !0)
  );
  for (const i in t)
    if (!(r && i === "expose")) {
      const s = Th[i] || n && n[i];
      e[i] = s ? s(e[i], t[i]) : t[i];
    }
  return e;
}
const Th = {
  data: jc,
  props: wc,
  emits: wc,
  // objects
  methods: Gr,
  computed: Gr,
  // lifecycle
  beforeCreate: ot,
  created: ot,
  beforeMount: ot,
  mounted: ot,
  beforeUpdate: ot,
  updated: ot,
  beforeDestroy: ot,
  beforeUnmount: ot,
  destroyed: ot,
  unmounted: ot,
  activated: ot,
  deactivated: ot,
  errorCaptured: ot,
  serverPrefetch: ot,
  // assets
  components: Gr,
  directives: Gr,
  // watch
  watch: Ah,
  // provide / inject
  provide: jc,
  inject: Ch
};
function jc(e, t) {
  return t ? e ? function() {
    return Ke(
      pe(e) ? e.call(this, this) : e,
      pe(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function Ch(e, t) {
  return Gr(as(e), as(t));
}
function as(e) {
  if (ce(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function ot(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Gr(e, t) {
  return e ? Ke(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function wc(e, t) {
  return e ? ce(e) && ce(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : Ke(
    /* @__PURE__ */ Object.create(null),
    yc(e),
    yc(t ?? {})
  ) : t;
}
function Ah(e, t) {
  if (!e)
    return t;
  if (!t)
    return e;
  const n = Ke(/* @__PURE__ */ Object.create(null), e);
  for (const r in t)
    n[r] = ot(e[r], t[r]);
  return n;
}
function _d() {
  return {
    app: null,
    config: {
      isNativeTag: cg,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Oh = 0;
function Ih(e, t) {
  return function(r, o = null) {
    pe(r) || (r = Ke({}, r)), o != null && !Ne(o) && (o = null);
    const a = _d(), i = /* @__PURE__ */ new WeakSet();
    let s = !1;
    const l = a.app = {
      _uid: Oh++,
      _component: r,
      _props: o,
      _container: null,
      _context: a,
      _instance: null,
      version: nv,
      get config() {
        return a.config;
      },
      set config(c) {
      },
      use(c, ...u) {
        return i.has(c) || (c && pe(c.install) ? (i.add(c), c.install(l, ...u)) : pe(c) && (i.add(c), c(l, ...u))), l;
      },
      mixin(c) {
        return a.mixins.includes(c) || a.mixins.push(c), l;
      },
      component(c, u) {
        return u ? (a.components[c] = u, l) : a.components[c];
      },
      directive(c, u) {
        return u ? (a.directives[c] = u, l) : a.directives[c];
      },
      mount(c, u, d) {
        if (!s) {
          const p = B(r, o);
          return p.appContext = a, d === !0 ? d = "svg" : d === !1 && (d = void 0), e(p, c, d), s = !0, l._container = c, c.__vue_app__ = l, Ja(p.component) || p.component.proxy;
        }
      },
      unmount() {
        s && (e(null, l._container), delete l._container.__vue_app__);
      },
      provide(c, u) {
        return a.provides[c] = u, l;
      },
      runWithContext(c) {
        const u = to;
        to = l;
        try {
          return c();
        } finally {
          to = u;
        }
      }
    };
    return l;
  };
}
let to = null;
function tr(e, t) {
  if (Ge) {
    let n = Ge.provides;
    const r = Ge.parent && Ge.parent.provides;
    r === n && (n = Ge.provides = Object.create(r)), n[e] = t;
  }
}
function Gt(e, t, n = !1) {
  const r = Ge || Je;
  if (r || to) {
    const o = r ? r.parent == null ? r.vnode.appContext && r.vnode.appContext.provides : r.parent.provides : to._context.provides;
    if (o && e in o)
      return o[e];
    if (arguments.length > 1)
      return n && pe(t) ? t.call(r && r.proxy) : t;
  }
}
function Lh(e, t, n, r = !1) {
  const o = {}, a = {};
  ua(a, Ba, 1), e.propsDefaults = /* @__PURE__ */ Object.create(null), gd(e, t, o, a);
  for (const i in e.propsOptions[0])
    i in o || (o[i] = void 0);
  n ? e.props = r ? o : Hg(o) : e.type.props ? e.props = o : e.props = a, e.attrs = a;
}
function Nh(e, t, n, r) {
  const {
    props: o,
    attrs: a,
    vnode: { patchFlag: i }
  } = e, s = Se(o), [l] = e.propsOptions;
  let c = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (r || i > 0) && !(i & 16)
  ) {
    if (i & 8) {
      const u = e.vnode.dynamicProps;
      for (let d = 0; d < u.length; d++) {
        let p = u[d];
        if (Fa(e.emitsOptions, p))
          continue;
        const m = t[p];
        if (l)
          if (je(a, p))
            m !== a[p] && (a[p] = m, c = !0);
          else {
            const f = vt(p);
            o[f] = is(
              l,
              s,
              f,
              m,
              e,
              !1
            );
          }
        else
          m !== a[p] && (a[p] = m, c = !0);
      }
    }
  } else {
    gd(e, t, o, a) && (c = !0);
    let u;
    for (const d in s)
      (!t || // for camelCase
      !je(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((u = $t(d)) === d || !je(t, u))) && (l ? n && // for camelCase
      (n[d] !== void 0 || // for kebab-case
      n[u] !== void 0) && (o[d] = is(
        l,
        s,
        d,
        void 0,
        e,
        !0
      )) : delete o[d]);
    if (a !== s)
      for (const d in a)
        (!t || !je(t, d)) && (delete a[d], c = !0);
  }
  c && cn(e, "set", "$attrs");
}
function gd(e, t, n, r) {
  const [o, a] = e.propsOptions;
  let i = !1, s;
  if (t)
    for (let l in t) {
      if (Xr(l))
        continue;
      const c = t[l];
      let u;
      o && je(o, u = vt(l)) ? !a || !a.includes(u) ? n[u] = c : (s || (s = {}))[u] = c : Fa(e.emitsOptions, l) || (!(l in r) || c !== r[l]) && (r[l] = c, i = !0);
    }
  if (a) {
    const l = Se(n), c = s || Le;
    for (let u = 0; u < a.length; u++) {
      const d = a[u];
      n[d] = is(
        o,
        l,
        d,
        c[d],
        e,
        !je(c, d)
      );
    }
  }
  return i;
}
function is(e, t, n, r, o, a) {
  const i = e[n];
  if (i != null) {
    const s = je(i, "default");
    if (s && r === void 0) {
      const l = i.default;
      if (i.type !== Function && !i.skipFactory && pe(l)) {
        const { propsDefaults: c } = o;
        if (n in c)
          r = c[n];
        else {
          const u = To(o);
          r = c[n] = l.call(
            null,
            t
          ), u();
        }
      } else
        r = l;
    }
    i[
      0
      /* shouldCast */
    ] && (a && !s ? r = !1 : i[
      1
      /* shouldCastTrue */
    ] && (r === "" || r === $t(n)) && (r = !0));
  }
  return r;
}
function hd(e, t, n = !1) {
  const r = t.propsCache, o = r.get(e);
  if (o)
    return o;
  const a = e.props, i = {}, s = [];
  let l = !1;
  if (!pe(e)) {
    const u = (d) => {
      l = !0;
      const [p, m] = hd(d, t, !0);
      Ke(i, p), m && s.push(...m);
    };
    !n && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u);
  }
  if (!a && !l)
    return Ne(e) && r.set(e, jr), jr;
  if (ce(a))
    for (let u = 0; u < a.length; u++) {
      const d = vt(a[u]);
      xc(d) && (i[d] = Le);
    }
  else if (a)
    for (const u in a) {
      const d = vt(u);
      if (xc(d)) {
        const p = a[u], m = i[d] = ce(p) || pe(p) ? { type: p } : Ke({}, p);
        if (m) {
          const f = Ec(Boolean, m.type), _ = Ec(String, m.type);
          m[
            0
            /* shouldCast */
          ] = f > -1, m[
            1
            /* shouldCastTrue */
          ] = _ < 0 || f < _, (f > -1 || je(m, "default")) && s.push(d);
        }
      }
    }
  const c = [i, s];
  return Ne(e) && r.set(e, c), c;
}
function xc(e) {
  return e[0] !== "$" && !Xr(e);
}
function kc(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function Sc(e, t) {
  return kc(e) === kc(t);
}
function Ec(e, t) {
  return ce(t) ? t.findIndex((n) => Sc(n, e)) : pe(t) && Sc(t, e) ? 0 : -1;
}
const vd = (e) => e[0] === "_" || e === "$stable", nl = (e) => ce(e) ? e.map(Jt) : [Jt(e)], Mh = (e, t, n) => {
  if (t._n)
    return t;
  const r = Oe((...o) => nl(t(...o)), n);
  return r._c = !1, r;
}, yd = (e, t, n) => {
  const r = e._ctx;
  for (const o in e) {
    if (vd(o))
      continue;
    const a = e[o];
    if (pe(a))
      t[o] = Mh(o, a, r);
    else if (a != null) {
      const i = nl(a);
      t[o] = () => i;
    }
  }
}, bd = (e, t) => {
  const n = nl(t);
  e.slots.default = () => n;
}, Rh = (e, t) => {
  if (e.vnode.shapeFlag & 32) {
    const n = t._;
    n ? (e.slots = Se(t), ua(t, "_", n)) : yd(
      t,
      e.slots = {}
    );
  } else
    e.slots = {}, t && bd(e, t);
  ua(e.slots, Ba, 1);
}, $h = (e, t, n) => {
  const { vnode: r, slots: o } = e;
  let a = !0, i = Le;
  if (r.shapeFlag & 32) {
    const s = t._;
    s ? n && s === 1 ? a = !1 : (Ke(o, t), !n && s === 1 && delete o._) : (a = !t.$stable, yd(t, o)), i = t;
  } else t && (bd(e, t), i = { default: 1 });
  if (a)
    for (const s in o)
      !vd(s) && i[s] == null && delete o[s];
};
function ss(e, t, n, r, o = !1) {
  if (ce(e)) {
    e.forEach(
      (p, m) => ss(
        p,
        t && (ce(t) ? t[m] : t),
        n,
        r,
        o
      )
    );
    return;
  }
  if (Zr(r) && !o)
    return;
  const a = r.shapeFlag & 4 ? Ja(r.component) || r.component.proxy : r.el, i = o ? null : a, { i: s, r: l } = e, c = t && t.r, u = s.refs === Le ? s.refs = {} : s.refs, d = s.setupState;
  if (c != null && c !== l && (Ve(c) ? (u[c] = null, je(d, c) && (d[c] = null)) : it(c) && (c.value = null)), pe(l))
    En(l, s, 12, [i, u]);
  else {
    const p = Ve(l), m = it(l);
    if (p || m) {
      const f = () => {
        if (e.f) {
          const _ = p ? je(d, l) ? d[l] : u[l] : l.value;
          o ? ce(_) && Hs(_, a) : ce(_) ? _.includes(a) || _.push(a) : p ? (u[l] = [a], je(d, l) && (d[l] = u[l])) : (l.value = [a], e.k && (u[e.k] = l.value));
        } else p ? (u[l] = i, je(d, l) && (d[l] = i)) : m && (l.value = i, e.k && (u[e.k] = i));
      };
      i ? (f.id = -1, mt(f, n)) : f();
    }
  }
}
const mt = lh;
function Dh(e) {
  return Fh(e);
}
function Fh(e, t) {
  const n = Pm();
  n.__VUE__ = !0;
  const {
    insert: r,
    remove: o,
    patchProp: a,
    createElement: i,
    createText: s,
    createComment: l,
    setText: c,
    setElementText: u,
    parentNode: d,
    nextSibling: p,
    setScopeId: m = St,
    insertStaticContent: f
  } = e, _ = (b, k, R, U = null, V = null, W = null, Z = void 0, G = null, g = !!k.dynamicChildren) => {
    if (b === k)
      return;
    b && !Wn(b, k) && (U = en(b), Ye(b, V, W, !0), b = null), k.patchFlag === -2 && (g = !1, k.dynamicChildren = null);
    const { type: h, ref: E, shapeFlag: H } = k;
    switch (h) {
      case Po:
        y(b, k, R, U);
        break;
      case Tt:
        A(b, k, R, U);
        break;
      case no:
        b == null && I(k, R, U, Z);
        break;
      case se:
        Y(
          b,
          k,
          R,
          U,
          V,
          W,
          Z,
          G,
          g
        );
        break;
      default:
        H & 1 ? T(
          b,
          k,
          R,
          U,
          V,
          W,
          Z,
          G,
          g
        ) : H & 6 ? me(
          b,
          k,
          R,
          U,
          V,
          W,
          Z,
          G,
          g
        ) : (H & 64 || H & 128) && h.process(
          b,
          k,
          R,
          U,
          V,
          W,
          Z,
          G,
          g,
          jt
        );
    }
    E != null && V && ss(E, b && b.ref, W, k || b, !k);
  }, y = (b, k, R, U) => {
    if (b == null)
      r(
        k.el = s(k.children),
        R,
        U
      );
    else {
      const V = k.el = b.el;
      k.children !== b.children && c(V, k.children);
    }
  }, A = (b, k, R, U) => {
    b == null ? r(
      k.el = l(k.children || ""),
      R,
      U
    ) : k.el = b.el;
  }, I = (b, k, R, U) => {
    [b.el, b.anchor] = f(
      b.children,
      k,
      R,
      U,
      b.el,
      b.anchor
    );
  }, j = ({ el: b, anchor: k }, R, U) => {
    let V;
    for (; b && b !== k; )
      V = p(b), r(b, R, U), b = V;
    r(k, R, U);
  }, S = ({ el: b, anchor: k }) => {
    let R;
    for (; b && b !== k; )
      R = p(b), o(b), b = R;
    o(k);
  }, T = (b, k, R, U, V, W, Z, G, g) => {
    k.type === "svg" ? Z = "svg" : k.type === "math" && (Z = "mathml"), b == null ? z(
      k,
      R,
      U,
      V,
      W,
      Z,
      G,
      g
    ) : F(
      b,
      k,
      V,
      W,
      Z,
      G,
      g
    );
  }, z = (b, k, R, U, V, W, Z, G) => {
    let g, h;
    const { props: E, shapeFlag: H, transition: K, dirs: J } = b;
    if (g = b.el = i(
      b.type,
      W,
      E && E.is,
      E
    ), H & 8 ? u(g, b.children) : H & 16 && N(
      b.children,
      g,
      null,
      U,
      V,
      Ti(b, W),
      Z,
      G
    ), J && Dn(b, null, U, "created"), O(g, b, b.scopeId, Z, U), E) {
      for (const $ in E)
        $ !== "value" && !Xr($) && a(
          g,
          $,
          null,
          E[$],
          W,
          b.children,
          U,
          V,
          nt
        );
      "value" in E && a(g, "value", null, E.value, W), (h = E.onVnodeBeforeMount) && Ht(h, U, b);
    }
    J && Dn(b, null, U, "beforeMount");
    const C = Uh(V, K);
    C && K.beforeEnter(g), r(g, k, R), ((h = E && E.onVnodeMounted) || C || J) && mt(() => {
      h && Ht(h, U, b), C && K.enter(g), J && Dn(b, null, U, "mounted");
    }, V);
  }, O = (b, k, R, U, V) => {
    if (R && m(b, R), U)
      for (let W = 0; W < U.length; W++)
        m(b, U[W]);
    if (V) {
      let W = V.subTree;
      if (k === W) {
        const Z = V.vnode;
        O(
          b,
          Z,
          Z.scopeId,
          Z.slotScopeIds,
          V.parent
        );
      }
    }
  }, N = (b, k, R, U, V, W, Z, G, g = 0) => {
    for (let h = g; h < b.length; h++) {
      const E = b[h] = G ? wn(b[h]) : Jt(b[h]);
      _(
        null,
        E,
        k,
        R,
        U,
        V,
        W,
        Z,
        G
      );
    }
  }, F = (b, k, R, U, V, W, Z) => {
    const G = k.el = b.el;
    let { patchFlag: g, dynamicChildren: h, dirs: E } = k;
    g |= b.patchFlag & 16;
    const H = b.props || Le, K = k.props || Le;
    let J;
    if (R && Fn(R, !1), (J = K.onVnodeBeforeUpdate) && Ht(J, R, k, b), E && Dn(k, b, R, "beforeUpdate"), R && Fn(R, !0), h ? te(
      b.dynamicChildren,
      h,
      G,
      R,
      U,
      Ti(k, V),
      W
    ) : Z || xe(
      b,
      k,
      G,
      null,
      R,
      U,
      Ti(k, V),
      W,
      !1
    ), g > 0) {
      if (g & 16)
        he(
          G,
          k,
          H,
          K,
          R,
          U,
          V
        );
      else if (g & 2 && H.class !== K.class && a(G, "class", null, K.class, V), g & 4 && a(G, "style", H.style, K.style, V), g & 8) {
        const C = k.dynamicProps;
        for (let $ = 0; $ < C.length; $++) {
          const ie = C[$], _e = H[ie], Ie = K[ie];
          (Ie !== _e || ie === "value") && a(
            G,
            ie,
            _e,
            Ie,
            V,
            b.children,
            R,
            U,
            nt
          );
        }
      }
      g & 1 && b.children !== k.children && u(G, k.children);
    } else !Z && h == null && he(
      G,
      k,
      H,
      K,
      R,
      U,
      V
    );
    ((J = K.onVnodeUpdated) || E) && mt(() => {
      J && Ht(J, R, k, b), E && Dn(k, b, R, "updated");
    }, U);
  }, te = (b, k, R, U, V, W, Z) => {
    for (let G = 0; G < k.length; G++) {
      const g = b[G], h = k[G], E = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        g.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (g.type === se || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Wn(g, h) || // - In the case of a component, it could contain anything.
        g.shapeFlag & 70) ? d(g.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          R
        )
      );
      _(
        g,
        h,
        E,
        null,
        U,
        V,
        W,
        Z,
        !0
      );
    }
  }, he = (b, k, R, U, V, W, Z) => {
    if (R !== U) {
      if (R !== Le)
        for (const G in R)
          !Xr(G) && !(G in U) && a(
            b,
            G,
            R[G],
            null,
            Z,
            k.children,
            V,
            W,
            nt
          );
      for (const G in U) {
        if (Xr(G))
          continue;
        const g = U[G], h = R[G];
        g !== h && G !== "value" && a(
          b,
          G,
          h,
          g,
          Z,
          k.children,
          V,
          W,
          nt
        );
      }
      "value" in U && a(b, "value", R.value, U.value, Z);
    }
  }, Y = (b, k, R, U, V, W, Z, G, g) => {
    const h = k.el = b ? b.el : s(""), E = k.anchor = b ? b.anchor : s("");
    let { patchFlag: H, dynamicChildren: K, slotScopeIds: J } = k;
    J && (G = G ? G.concat(J) : J), b == null ? (r(h, R, U), r(E, R, U), N(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      k.children || [],
      R,
      E,
      V,
      W,
      Z,
      G,
      g
    )) : H > 0 && H & 64 && K && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    b.dynamicChildren ? (te(
      b.dynamicChildren,
      K,
      R,
      V,
      W,
      Z,
      G
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (k.key != null || V && k === V.subTree) && zd(
      b,
      k,
      !0
      /* shallow */
    )) : xe(
      b,
      k,
      R,
      E,
      V,
      W,
      Z,
      G,
      g
    );
  }, me = (b, k, R, U, V, W, Z, G, g) => {
    k.slotScopeIds = G, b == null ? k.shapeFlag & 512 ? V.ctx.activate(
      k,
      R,
      U,
      Z,
      g
    ) : qe(
      k,
      R,
      U,
      V,
      W,
      Z,
      g
    ) : zt(b, k, g);
  }, qe = (b, k, R, U, V, W, Z) => {
    const G = b.component = Gh(
      b,
      U,
      V
    );
    if (Eo(b) && (G.ctx.renderer = jt), Kh(G), G.asyncDep) {
      if (V && V.registerDep(G, Me), !b.el) {
        const g = G.subTree = B(Tt);
        A(null, g, k, R);
      }
    } else
      Me(
        G,
        b,
        k,
        R,
        V,
        W,
        Z
      );
  }, zt = (b, k, R) => {
    const U = k.component = b.component;
    if (oh(b, k, R))
      if (U.asyncDep && !U.asyncResolved) {
        Pe(U, k, R);
        return;
      } else
        U.next = k, Qg(U.update), U.effect.dirty = !0, U.update();
    else
      k.el = b.el, U.vnode = k;
  }, Me = (b, k, R, U, V, W, Z) => {
    const G = () => {
      if (b.isMounted) {
        let { next: E, bu: H, u: K, parent: J, vnode: C } = b;
        {
          const ht = jd(b);
          if (ht) {
            E && (E.el = C.el, Pe(b, E, Z)), ht.asyncDep.then(() => {
              b.isUnmounted || G();
            });
            return;
          }
        }
        let $ = E, ie;
        Fn(b, !1), E ? (E.el = C.el, Pe(b, E, Z)) : E = C, H && xi(H), (ie = E.props && E.props.onVnodeBeforeUpdate) && Ht(ie, J, E, C), Fn(b, !0);
        const _e = _c(b), Ie = b.subTree;
        b.subTree = _e, _(
          Ie,
          _e,
          // parent may have changed if it's in a teleport
          d(Ie.el),
          // anchor may have changed if it's in a fragment
          en(Ie),
          b,
          V,
          W
        ), E.el = _e.el, $ === null && ah(b, _e.el), K && mt(K, V), (ie = E.props && E.props.onVnodeUpdated) && mt(
          () => Ht(ie, J, E, C),
          V
        );
      } else {
        let E;
        const { el: H, props: K } = k, { bm: J, m: C, parent: $ } = b, ie = Zr(k);
        Fn(b, !1), J && xi(J), !ie && (E = K && K.onVnodeBeforeMount) && Ht(E, $, k), Fn(b, !0);
        {
          const _e = b.subTree = _c(b);
          if (b && b.parent && !(b.parent.type.__asyncLoader && b.parent.isCE)) {
            const Ie = b.ceContext && b.type.styles || null;
            b.ceContext && Ie && b.ceContext.addCEChildStyle(
              Ie,
              b.uid,
              b.hasStyleAttrs
            );
          }
          _(
            null,
            _e,
            R,
            U,
            b,
            V,
            W
          ), k.el = _e.el;
        }
        if (C && mt(C, V), !ie && (E = K && K.onVnodeMounted)) {
          const _e = k;
          mt(
            () => Ht(E, $, _e),
            V
          );
        }
        (k.shapeFlag & 256 || $ && Zr($.vnode) && $.vnode.shapeFlag & 256) && b.a && mt(b.a, V), b.isMounted = !0, k = R = U = null;
      }
    }, g = b.effect = new Js(
      G,
      St,
      () => Da(h),
      b.scope
      // track it in component's effect scope
    ), h = b.update = () => {
      g.dirty && g.run();
    };
    h.id = b.uid, Fn(b, !0), h();
  }, Pe = (b, k, R) => {
    k.component = b;
    const U = b.vnode.props;
    b.vnode = k, b.next = null, Nh(b, k.props, U, R), $h(b, k.children, R), sr(), fc(b), lr();
  }, xe = (b, k, R, U, V, W, Z, G, g = !1) => {
    const h = b && b.children, E = b ? b.shapeFlag : 0, H = k.children, { patchFlag: K, shapeFlag: J } = k;
    if (K > 0) {
      if (K & 128) {
        ye(
          h,
          H,
          R,
          U,
          V,
          W,
          Z,
          G,
          g
        );
        return;
      } else if (K & 256) {
        gt(
          h,
          H,
          R,
          U,
          V,
          W,
          Z,
          G,
          g
        );
        return;
      }
    }
    J & 8 ? (E & 16 && nt(h, V, W), H !== h && u(R, H)) : E & 16 ? J & 16 ? ye(
      h,
      H,
      R,
      U,
      V,
      W,
      Z,
      G,
      g
    ) : nt(h, V, W, !0) : (E & 8 && u(R, ""), J & 16 && N(
      H,
      R,
      U,
      V,
      W,
      Z,
      G,
      g
    ));
  }, gt = (b, k, R, U, V, W, Z, G, g) => {
    b = b || jr, k = k || jr;
    const h = b.length, E = k.length, H = Math.min(h, E);
    let K;
    for (K = 0; K < H; K++) {
      const J = k[K] = g ? wn(k[K]) : Jt(k[K]);
      _(
        b[K],
        J,
        R,
        null,
        V,
        W,
        Z,
        G,
        g
      );
    }
    h > E ? nt(
      b,
      V,
      W,
      !0,
      !1,
      H
    ) : N(
      k,
      R,
      U,
      V,
      W,
      Z,
      G,
      g,
      H
    );
  }, ye = (b, k, R, U, V, W, Z, G, g) => {
    let h = 0;
    const E = k.length;
    let H = b.length - 1, K = E - 1;
    for (; h <= H && h <= K; ) {
      const J = b[h], C = k[h] = g ? wn(k[h]) : Jt(k[h]);
      if (Wn(J, C))
        _(
          J,
          C,
          R,
          null,
          V,
          W,
          Z,
          G,
          g
        );
      else
        break;
      h++;
    }
    for (; h <= H && h <= K; ) {
      const J = b[H], C = k[K] = g ? wn(k[K]) : Jt(k[K]);
      if (Wn(J, C))
        _(
          J,
          C,
          R,
          null,
          V,
          W,
          Z,
          G,
          g
        );
      else
        break;
      H--, K--;
    }
    if (h > H) {
      if (h <= K) {
        const J = K + 1, C = J < E ? k[J].el : U;
        for (; h <= K; )
          _(
            null,
            k[h] = g ? wn(k[h]) : Jt(k[h]),
            R,
            C,
            V,
            W,
            Z,
            G,
            g
          ), h++;
      }
    } else if (h > K)
      for (; h <= H; )
        Ye(b[h], V, W, !0), h++;
    else {
      const J = h, C = h, $ = /* @__PURE__ */ new Map();
      for (h = C; h <= K; h++) {
        const rt = k[h] = g ? wn(k[h]) : Jt(k[h]);
        rt.key != null && $.set(rt.key, h);
      }
      let ie, _e = 0;
      const Ie = K - C + 1;
      let ht = !1, Nt = 0;
      const nn = new Array(Ie);
      for (h = 0; h < Ie; h++)
        nn[h] = 0;
      for (h = J; h <= H; h++) {
        const rt = b[h];
        if (_e >= Ie) {
          Ye(rt, V, W, !0);
          continue;
        }
        let wt;
        if (rt.key != null)
          wt = $.get(rt.key);
        else
          for (ie = C; ie <= K; ie++)
            if (nn[ie - C] === 0 && Wn(rt, k[ie])) {
              wt = ie;
              break;
            }
        wt === void 0 ? Ye(rt, V, W, !0) : (nn[wt - C] = h + 1, wt >= Nt ? Nt = wt : ht = !0, _(
          rt,
          k[wt],
          R,
          null,
          V,
          W,
          Z,
          G,
          g
        ), _e++);
      }
      const pr = ht ? Vh(nn) : jr;
      for (ie = pr.length - 1, h = Ie - 1; h >= 0; h--) {
        const rt = C + h, wt = k[rt], fr = rt + 1 < E ? k[rt + 1].el : U;
        nn[h] === 0 ? _(
          null,
          wt,
          R,
          fr,
          V,
          W,
          Z,
          G,
          g
        ) : ht && (ie < 0 || h !== pr[ie] ? Be(wt, R, fr, 2) : ie--);
      }
    }
  }, Be = (b, k, R, U, V = null) => {
    const { el: W, type: Z, transition: G, children: g, shapeFlag: h } = b;
    if (h & 6) {
      Be(b.component.subTree, k, R, U);
      return;
    }
    if (h & 128) {
      b.suspense.move(k, R, U);
      return;
    }
    if (h & 64) {
      Z.move(b, k, R, jt);
      return;
    }
    if (Z === se) {
      r(W, k, R);
      for (let H = 0; H < g.length; H++)
        Be(g[H], k, R, U);
      r(b.anchor, k, R);
      return;
    }
    if (Z === no) {
      j(b, k, R);
      return;
    }
    if (U !== 2 && h & 1 && G)
      if (U === 0)
        G.beforeEnter(W), r(W, k, R), mt(() => G.enter(W), V);
      else {
        const { leave: H, delayLeave: K, afterLeave: J } = G, C = () => r(W, k, R), $ = () => {
          H(W, () => {
            C(), J && J();
          });
        };
        K ? K(W, C, $) : $();
      }
    else
      r(W, k, R);
  }, Ye = (b, k, R, U = !1, V = !1) => {
    const {
      type: W,
      props: Z,
      ref: G,
      children: g,
      dynamicChildren: h,
      shapeFlag: E,
      patchFlag: H,
      dirs: K
    } = b;
    if (G != null && ss(G, null, R, b, !0), E & 256) {
      k.ctx.deactivate(b);
      return;
    }
    const J = E & 1 && K, C = !Zr(b);
    let $;
    if (C && ($ = Z && Z.onVnodeBeforeUnmount) && Ht($, k, b), E & 6)
      b.component.ceContext, fn(b.component, R, U);
    else {
      if (E & 128) {
        b.suspense.unmount(R, U);
        return;
      }
      J && Dn(b, null, k, "beforeUnmount"), E & 64 ? b.type.remove(
        b,
        k,
        R,
        V,
        jt,
        U
      ) : h && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (W !== se || H > 0 && H & 64) ? nt(
        h,
        k,
        R,
        !1,
        !0
      ) : (W === se && H & 384 || !V && E & 16) && nt(g, k, R), U && Xe(b);
    }
    (C && ($ = Z && Z.onVnodeUnmounted) || J) && mt(() => {
      $ && Ht($, k, b), J && Dn(b, null, k, "unmounted");
    }, R);
  }, Xe = (b) => {
    const { type: k, el: R, anchor: U, transition: V } = b;
    if (k === se) {
      Zt(R, U);
      return;
    }
    if (k === no) {
      S(b);
      return;
    }
    const W = () => {
      o(R), V && !V.persisted && V.afterLeave && V.afterLeave();
    };
    if (b.shapeFlag & 1 && V && !V.persisted) {
      const { leave: Z, delayLeave: G } = V, g = () => Z(R, W);
      G ? G(b.el, W, g) : g();
    } else
      W();
  }, Zt = (b, k) => {
    let R;
    for (; b !== k; )
      R = p(b), o(b), b = R;
    o(k);
  }, fn = (b, k, R) => {
    const { bum: U, scope: V, update: W, subTree: Z, um: G } = b;
    U && xi(U), V.stop(), W && (W.active = !1, Ye(Z, b, k, R)), G && mt(G, k), mt(() => {
      b.isUnmounted = !0;
    }, k), k && k.pendingBranch && !k.isUnmounted && b.asyncDep && !b.asyncResolved && b.suspenseId === k.pendingId && (k.deps--, k.deps === 0 && k.resolve());
  }, nt = (b, k, R, U = !1, V = !1, W = 0) => {
    for (let Z = W; Z < b.length; Z++)
      Ye(b[Z], k, R, U, V);
  }, en = (b) => b.shapeFlag & 6 ? en(b.component.subTree) : b.shapeFlag & 128 ? b.suspense.next() : p(b.anchor || b.el);
  let tn = !1;
  const _n = (b, k, R) => {
    b == null ? k._vnode && Ye(k._vnode, null, null, !0) : _(
      k._vnode || null,
      b,
      k,
      null,
      null,
      null,
      R
    ), tn || (tn = !0, fc(), Zm(), tn = !1), k._vnode = b;
  }, jt = {
    p: _,
    um: Ye,
    m: Be,
    r: Xe,
    mt: qe,
    mc: N,
    pc: xe,
    pbc: te,
    n: en,
    o: e
  };
  return {
    render: _n,
    hydrate: void 0,
    createApp: Ih(_n)
  };
}
function Ti({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function Fn({ effect: e, update: t }, n) {
  e.allowRecurse = t.allowRecurse = n;
}
function Uh(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function zd(e, t, n = !1) {
  const r = e.children, o = t.children;
  if (ce(r) && ce(o))
    for (let a = 0; a < r.length; a++) {
      const i = r[a];
      let s = o[a];
      s.shapeFlag & 1 && !s.dynamicChildren && ((s.patchFlag <= 0 || s.patchFlag === 32) && (s = o[a] = wn(o[a]), s.el = i.el), n || zd(i, s)), s.type === Po && (s.el = i.el);
    }
}
function Vh(e) {
  const t = e.slice(), n = [0];
  let r, o, a, i, s;
  const l = e.length;
  for (r = 0; r < l; r++) {
    const c = e[r];
    if (c !== 0) {
      if (o = n[n.length - 1], e[o] < c) {
        t[r] = o, n.push(r);
        continue;
      }
      for (a = 0, i = n.length - 1; a < i; )
        s = a + i >> 1, e[n[s]] < c ? a = s + 1 : i = s;
      c < e[n[a]] && (a > 0 && (t[r] = n[a - 1]), n[a] = r);
    }
  }
  for (a = n.length, i = n[a - 1]; a-- > 0; )
    n[a] = i, i = t[i];
  return n;
}
function jd(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : jd(t);
}
const qh = (e) => e.__isTeleport, se = Symbol.for("v-fgt"), Po = Symbol.for("v-txt"), Tt = Symbol.for("v-cmt"), no = Symbol.for("v-stc"), ro = [];
let Dt = null;
function w(e = !1) {
  ro.push(Dt = e ? null : []);
}
function Hh() {
  ro.pop(), Dt = ro[ro.length - 1] || null;
}
let mo = 1;
function Pc(e) {
  mo += e;
}
function wd(e) {
  return e.dynamicChildren = mo > 0 ? Dt || jr : null, Hh(), mo > 0 && Dt && Dt.push(e), e;
}
function P(e, t, n, r, o, a) {
  return wd(
    x(
      e,
      t,
      n,
      r,
      o,
      a,
      !0
    )
  );
}
function ge(e, t, n, r, o) {
  return wd(
    B(
      e,
      t,
      n,
      r,
      o,
      !0
    )
  );
}
function fa(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Wn(e, t) {
  return e.type === t.type && e.key === t.key;
}
const Ba = "__vInternal", xd = ({ key: e }) => e ?? null, ta = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? Ve(e) || it(e) || pe(e) ? { i: Je, r: e, k: t, f: !!n } : e : null);
function x(e, t = null, n = null, r = 0, o = null, a = e === se ? 0 : 1, i = !1, s = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && xd(t),
    ref: t && ta(t),
    scopeId: Ua,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: a,
    patchFlag: r,
    dynamicProps: o,
    dynamicChildren: null,
    appContext: null,
    ctx: Je
  };
  return s ? (rl(l, n), a & 128 && e.normalize(l)) : n && (l.shapeFlag |= Ve(n) ? 8 : 16), mo > 0 && // avoid a block node from tracking itself
  !i && // has current parent block
  Dt && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || a & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && Dt.push(l), l;
}
const B = Bh;
function Bh(e, t = null, n = null, r = 0, o = null, a = !1) {
  if ((!e || e === rd) && (e = Tt), fa(e)) {
    const s = mn(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && rl(s, n), mo > 0 && !a && Dt && (s.shapeFlag & 6 ? Dt[Dt.indexOf(e)] = s : Dt.push(s)), s.patchFlag |= -2, s;
  }
  if (tv(e) && (e = e.__vccOpts), t) {
    t = kd(t);
    let { class: s, style: l } = t;
    s && !Ve(s) && (t.class = Ce(s)), Ne(l) && (Hm(l) && !ce(l) && (l = Ke({}, l)), t.style = Ut(l));
  }
  const i = Ve(e) ? 1 : sh(e) ? 128 : qh(e) ? 64 : Ne(e) ? 4 : pe(e) ? 2 : 0;
  return x(
    e,
    t,
    n,
    r,
    o,
    i,
    a,
    !0
  );
}
function kd(e) {
  return e ? Hm(e) || Ba in e ? Ke({}, e) : e : null;
}
function mn(e, t, n = !1) {
  const { props: r, ref: o, patchFlag: a, children: i } = e, s = t ? Er(r || {}, t) : r;
  return {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: s,
    key: s && xd(s),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && o ? ce(o) ? o.concat(ta(t)) : [o, ta(t)] : ta(t)
    ) : o,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: i,
    target: e.target,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== se ? a === -1 ? 16 : a | 16 : a,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: e.transition,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && mn(e.ssContent),
    ssFallback: e.ssFallback && mn(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
}
function Ee(e = " ", t = 0) {
  return B(Po, null, e, t);
}
function Jh(e, t) {
  const n = B(no, null, e);
  return n.staticCount = t, n;
}
function re(e = "", t = !1) {
  return t ? (w(), ge(Tt, null, e)) : B(Tt, null, e);
}
function Jt(e) {
  return e == null || typeof e == "boolean" ? B(Tt) : ce(e) ? B(
    se,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : typeof e == "object" ? wn(e) : B(Po, null, String(e));
}
function wn(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : mn(e);
}
function rl(e, t) {
  let n = 0;
  const { shapeFlag: r } = e;
  if (t == null)
    t = null;
  else if (ce(t))
    n = 16;
  else if (typeof t == "object")
    if (r & 65) {
      const o = t.default;
      o && (o._c && (o._d = !1), rl(e, o()), o._c && (o._d = !0));
      return;
    } else {
      n = 32;
      const o = t._;
      !o && !(Ba in t) ? t._ctx = Je : o === 3 && Je && (Je.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else pe(t) ? (t = { default: t, _ctx: Je }, n = 32) : (t = String(t), r & 64 ? (n = 16, t = [Ee(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Er(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    for (const o in r)
      if (o === "class")
        t.class !== r.class && (t.class = Ce([t.class, r.class]));
      else if (o === "style")
        t.style = Ut([t.style, r.style]);
      else if (La(o)) {
        const a = t[o], i = r[o];
        i && a !== i && !(ce(a) && a.includes(i)) && (t[o] = a ? [].concat(a, i) : i);
      } else o !== "" && (t[o] = r[o]);
  }
  return t;
}
function Ht(e, t, n, r = null) {
  Pt(e, t, 7, [
    n,
    r
  ]);
}
const Wh = _d();
let Yh = 0;
function Gh(e, t, n) {
  const r = e.type, o = (t ? t.appContext : e.appContext) || Wh, a = {
    ceContext: t && (t.isCE || t.ceContext) ? t.ceContext : null,
    uid: Yh++,
    vnode: e,
    type: r,
    parent: t,
    appContext: o,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    scope: new Am(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(o.provides),
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: hd(r, o),
    emitsOptions: td(r, o),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Le,
    // inheritAttrs
    inheritAttrs: r.inheritAttrs,
    // state
    ctx: Le,
    data: Le,
    props: Le,
    attrs: Le,
    slots: Le,
    refs: Le,
    setupState: Le,
    setupContext: null,
    attrsProxy: null,
    slotsProxy: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return a.ctx = { _: a }, a.root = t ? t.root : a, a.emit = th.bind(null, a), e.ce && e.ce(a), a;
}
let Ge = null;
const ur = () => Ge || Je;
let _a, ls;
{
  const e = Pm(), t = (n, r) => {
    let o;
    return (o = e[n]) || (o = e[n] = []), o.push(r), (a) => {
      o.length > 1 ? o.forEach((i) => i(a)) : o[0](a);
    };
  };
  _a = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => Ge = n
  ), ls = t(
    "__VUE_SSR_SETTERS__",
    (n) => Co = n
  );
}
const To = (e) => {
  const t = Ge;
  return _a(e), e.scope.on(), () => {
    e.scope.off(), _a(t);
  };
}, Tc = () => {
  Ge && Ge.scope.off(), _a(null);
};
function Sd(e) {
  return e.vnode.shapeFlag & 4;
}
let Co = !1;
function Kh(e, t = !1) {
  t && ls(t);
  const { props: n, children: r } = e.vnode, o = Sd(e);
  Lh(e, n, o, t), Rh(e, r);
  const a = o ? Qh(e, t) : void 0;
  return t && ls(!1), a;
}
function Qh(e, t) {
  const n = e.type;
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = Bm(new Proxy(e.ctx, Sh));
  const { setup: r } = n;
  if (r) {
    const o = e.setupContext = r.length > 1 ? Zh(e) : null, a = To(e);
    sr();
    const i = En(
      r,
      e,
      0,
      [
        e.props,
        o
      ]
    );
    if (lr(), a(), km(i)) {
      if (i.then(Tc, Tc), t)
        return i.then((s) => {
          Cc(e, s);
        }).catch((s) => {
          wo(s, e, 0);
        });
      e.asyncDep = i;
    } else
      Cc(e, i);
  } else
    Ed(e);
}
function Cc(e, t, n) {
  pe(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : Ne(t) && (e.setupState = Gm(t)), Ed(e);
}
function Ed(e, t, n) {
  const r = e.type;
  e.render || (e.render = r.render || St);
  {
    const o = To(e);
    sr();
    try {
      Eh(e);
    } finally {
      lr(), o();
    }
  }
}
function Xh(e) {
  return e.attrsProxy || (e.attrsProxy = new Proxy(
    e.attrs,
    {
      get(t, n) {
        return _t(e, "get", "$attrs"), t[n];
      }
    }
  ));
}
function Zh(e) {
  const t = (n) => {
    e.exposed = n || {};
  };
  return {
    get attrs() {
      return Xh(e);
    },
    slots: e.slots,
    emit: e.emit,
    expose: t
  };
}
function Ja(e) {
  if (e.exposed)
    return e.exposeProxy || (e.exposeProxy = new Proxy(Gm(Bm(e.exposed)), {
      get(t, n) {
        if (n in t)
          return t[n];
        if (n in eo)
          return eo[n](e);
      },
      has(t, n) {
        return n in t || n in eo;
      }
    }));
}
function ev(e, t = !0) {
  return pe(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function tv(e) {
  return pe(e) && "__vccOpts" in e;
}
const ee = (e, t) => Bg(e, t, Co);
function pt(e, t, n) {
  const r = arguments.length;
  return r === 2 ? Ne(t) && !ce(t) ? fa(t) ? B(e, null, [t]) : B(e, t) : B(e, null, t) : (r > 3 ? n = Array.prototype.slice.call(arguments, 2) : r === 3 && fa(n) && (n = [n]), B(e, t, n));
}
const nv = "3.4.21";
/**
* @vue/runtime-dom v3.4.21
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const rv = "http://www.w3.org/2000/svg", ov = "http://www.w3.org/1998/Math/MathML", xn = typeof document < "u" ? document : null, Ac = xn && /* @__PURE__ */ xn.createElement("template"), av = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, r) => {
    const o = t === "svg" ? xn.createElementNS(rv, e) : t === "mathml" ? xn.createElementNS(ov, e) : xn.createElement(e, n ? { is: n } : void 0);
    return e === "select" && r && r.multiple != null && o.setAttribute("multiple", r.multiple), o;
  },
  createText: (e) => xn.createTextNode(e),
  createComment: (e) => xn.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => xn.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, r, o, a) {
    const i = n ? n.previousSibling : t.lastChild;
    if (o && (o === a || o.nextSibling))
      for (; t.insertBefore(o.cloneNode(!0), n), !(o === a || !(o = o.nextSibling)); )
        ;
    else {
      Ac.innerHTML = r === "svg" ? `<svg>${e}</svg>` : r === "mathml" ? `<math>${e}</math>` : e;
      const s = Ac.content;
      if (r === "svg" || r === "mathml") {
        const l = s.firstChild;
        for (; l.firstChild; )
          s.appendChild(l.firstChild);
        s.removeChild(l);
      }
      t.insertBefore(s, n);
    }
    return [
      // first
      i ? i.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, hn = "transition", Ur = "animation", po = Symbol("_vtc"), ol = (e, { slots: t }) => pt(gh, iv(e), t);
ol.displayName = "Transition";
const Pd = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
};
ol.props = /* @__PURE__ */ Ke(
  {},
  id,
  Pd
);
const Un = (e, t = []) => {
  ce(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, Oc = (e) => e ? ce(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function iv(e) {
  const t = {};
  for (const Y in e)
    Y in Pd || (t[Y] = e[Y]);
  if (e.css === !1)
    return t;
  const {
    name: n = "v",
    type: r,
    duration: o,
    enterFromClass: a = `${n}-enter-from`,
    enterActiveClass: i = `${n}-enter-active`,
    enterToClass: s = `${n}-enter-to`,
    appearFromClass: l = a,
    appearActiveClass: c = i,
    appearToClass: u = s,
    leaveFromClass: d = `${n}-leave-from`,
    leaveActiveClass: p = `${n}-leave-active`,
    leaveToClass: m = `${n}-leave-to`
  } = e, f = sv(o), _ = f && f[0], y = f && f[1], {
    onBeforeEnter: A,
    onEnter: I,
    onEnterCancelled: j,
    onLeave: S,
    onLeaveCancelled: T,
    onBeforeAppear: z = A,
    onAppear: O = I,
    onAppearCancelled: N = j
  } = t, F = (Y, me, qe) => {
    Vn(Y, me ? u : s), Vn(Y, me ? c : i), qe && qe();
  }, te = (Y, me) => {
    Y._isLeaving = !1, Vn(Y, d), Vn(Y, m), Vn(Y, p), me && me();
  }, he = (Y) => (me, qe) => {
    const zt = Y ? O : I, Me = () => F(me, Y, qe);
    Un(zt, [me, Me]), Ic(() => {
      Vn(me, Y ? l : a), vn(me, Y ? u : s), Oc(zt) || Lc(me, r, _, Me);
    });
  };
  return Ke(t, {
    onBeforeEnter(Y) {
      Un(A, [Y]), vn(Y, a), vn(Y, i);
    },
    onBeforeAppear(Y) {
      Un(z, [Y]), vn(Y, l), vn(Y, c);
    },
    onEnter: he(!1),
    onAppear: he(!0),
    onLeave(Y, me) {
      Y._isLeaving = !0;
      const qe = () => te(Y, me);
      vn(Y, d), uv(), vn(Y, p), Ic(() => {
        Y._isLeaving && (Vn(Y, d), vn(Y, m), Oc(S) || Lc(Y, r, y, qe));
      }), Un(S, [Y, qe]);
    },
    onEnterCancelled(Y) {
      F(Y, !1), Un(j, [Y]);
    },
    onAppearCancelled(Y) {
      F(Y, !0), Un(N, [Y]);
    },
    onLeaveCancelled(Y) {
      te(Y), Un(T, [Y]);
    }
  });
}
function sv(e) {
  if (e == null)
    return null;
  if (Ne(e))
    return [Ci(e.enter), Ci(e.leave)];
  {
    const t = Ci(e);
    return [t, t];
  }
}
function Ci(e) {
  return Gi(e);
}
function vn(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[po] || (e[po] = /* @__PURE__ */ new Set())).add(t);
}
function Vn(e, t) {
  t.split(/\s+/).forEach((r) => r && e.classList.remove(r));
  const n = e[po];
  n && (n.delete(t), n.size || (e[po] = void 0));
}
function Ic(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let lv = 0;
function Lc(e, t, n, r) {
  const o = e._endId = ++lv, a = () => {
    o === e._endId && r();
  };
  if (n)
    return setTimeout(a, n);
  const { type: i, timeout: s, propCount: l } = cv(e, t);
  if (!i)
    return r();
  const c = i + "end";
  let u = 0;
  const d = () => {
    e.removeEventListener(c, p), a();
  }, p = (m) => {
    m.target === e && ++u >= l && d();
  };
  setTimeout(() => {
    u < l && d();
  }, s + 1), e.addEventListener(c, p);
}
function cv(e, t) {
  const n = window.getComputedStyle(e), r = (f) => (n[f] || "").split(", "), o = r(`${hn}Delay`), a = r(`${hn}Duration`), i = Nc(o, a), s = r(`${Ur}Delay`), l = r(`${Ur}Duration`), c = Nc(s, l);
  let u = null, d = 0, p = 0;
  t === hn ? i > 0 && (u = hn, d = i, p = a.length) : t === Ur ? c > 0 && (u = Ur, d = c, p = l.length) : (d = Math.max(i, c), u = d > 0 ? i > c ? hn : Ur : null, p = u ? u === hn ? a.length : l.length : 0);
  const m = u === hn && /\b(transform|all)(,|$)/.test(
    r(`${hn}Property`).toString()
  );
  return {
    type: u,
    timeout: d,
    propCount: p,
    hasTransform: m
  };
}
function Nc(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, r) => Mc(n) + Mc(e[r])));
}
function Mc(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function uv() {
  return document.body.offsetHeight;
}
function mv(e, t, n) {
  const r = e[po];
  r && (t = (t ? [t, ...r] : [...r]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const ga = Symbol("_vod"), Td = Symbol("_vsh"), dv = {
  beforeMount(e, { value: t }, { transition: n }) {
    e[ga] = e.style.display === "none" ? "" : e.style.display, n && t ? n.beforeEnter(e) : Vr(e, t);
  },
  mounted(e, { value: t }, { transition: n }) {
    n && t && n.enter(e);
  },
  updated(e, { value: t, oldValue: n }, { transition: r }) {
    !t != !n && (r ? t ? (r.beforeEnter(e), Vr(e, !0), r.enter(e)) : r.leave(e, () => {
      Vr(e, !1);
    }) : Vr(e, t));
  },
  beforeUnmount(e, { value: t }) {
    Vr(e, t);
  }
};
function Vr(e, t) {
  e.style.display = t ? e[ga] : "none", e[Td] = !t;
}
const Cd = Symbol("");
function Ad(e) {
  const t = ur();
  if (!t)
    return;
  const n = t.ut = (o = e(t.proxy)) => {
    Array.from(
      document.querySelectorAll(`[data-v-owner="${t.uid}"]`)
    ).forEach((a) => us(a, o));
  }, r = () => {
    const o = e(t.proxy);
    cs(t.subTree, o), n(o);
  };
  mh(r), Xt(() => {
    const o = new MutationObserver(r);
    o.observe(t.subTree.el.parentNode, { childList: !0 }), cr(() => o.disconnect());
  });
}
function cs(e, t) {
  if (e.shapeFlag & 128) {
    const n = e.suspense;
    e = n.activeBranch, n.pendingBranch && !n.isHydrating && n.effects.push(() => {
      cs(n.activeBranch, t);
    });
  }
  for (; e.component; )
    e = e.component.subTree;
  if (e.shapeFlag & 1 && e.el)
    us(e.el, t);
  else if (e.type === se)
    e.children.forEach((n) => cs(n, t));
  else if (e.type === no) {
    let { el: n, anchor: r } = e;
    for (; n && (us(n, t), n !== r); )
      n = n.nextSibling;
  }
}
function us(e, t) {
  if (e.nodeType === 1) {
    const n = e.style;
    let r = "";
    for (const o in t)
      n.setProperty(`--${o}`, t[o]), r += `--${o}: ${t[o]};`;
    n[Cd] = r;
  }
}
const pv = /(^|;)\s*display\s*:/;
function fv(e, t, n) {
  const r = e.style, o = Ve(n);
  let a = !1;
  if (n && !o) {
    if (t)
      if (Ve(t))
        for (const i of t.split(";")) {
          const s = i.slice(0, i.indexOf(":")).trim();
          n[s] == null && na(r, s, "");
        }
      else
        for (const i in t)
          n[i] == null && na(r, i, "");
    for (const i in n)
      i === "display" && (a = !0), na(r, i, n[i]);
  } else if (o) {
    if (t !== n) {
      const i = r[Cd];
      i && (n += ";" + i), r.cssText = n, a = pv.test(n);
    }
  } else t && e.removeAttribute("style");
  ga in e && (e[ga] = a ? r.display : "", e[Td] && (r.display = "none"));
}
const Rc = /\s*!important$/;
function na(e, t, n) {
  if (ce(n))
    n.forEach((r) => na(e, t, r));
  else if (n == null && (n = ""), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const r = _v(e, t);
    Rc.test(n) ? e.setProperty(
      $t(r),
      n.replace(Rc, ""),
      "important"
    ) : e[r] = n;
  }
}
const $c = ["Webkit", "Moz", "ms"], Ai = {};
function _v(e, t) {
  const n = Ai[t];
  if (n)
    return n;
  let r = vt(t);
  if (r !== "filter" && r in e)
    return Ai[t] = r;
  r = Ra(r);
  for (let o = 0; o < $c.length; o++) {
    const a = $c[o] + r;
    if (a in e)
      return Ai[t] = a;
  }
  return t;
}
const Dc = "http://www.w3.org/1999/xlink";
function gv(e, t, n, r, o) {
  if (r && t.startsWith("xlink:"))
    n == null ? e.removeAttributeNS(Dc, t.slice(6, t.length)) : e.setAttributeNS(Dc, t, n);
  else {
    const a = zg(t);
    n == null || a && !Tm(n) ? e.removeAttribute(t) : e.setAttribute(t, a ? "" : n);
  }
}
function hv(e, t, n, r, o, a, i) {
  if (t === "innerHTML" || t === "textContent") {
    r && i(r, o, a), e[t] = n ?? "";
    return;
  }
  const s = e.tagName;
  if (t === "value" && s !== "PROGRESS" && // custom elements may use _value internally
  !s.includes("-")) {
    const c = s === "OPTION" ? e.getAttribute("value") || "" : e.value, u = n ?? "";
    (c !== u || !("_value" in e)) && (e.value = u), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let l = !1;
  if (n === "" || n == null) {
    const c = typeof e[t];
    c === "boolean" ? n = Tm(n) : n == null && c === "string" ? (n = "", l = !0) : c === "number" && (n = 0, l = !0);
  }
  try {
    e[t] = n;
  } catch {
  }
  l && e.removeAttribute(t);
}
function vv(e, t, n, r) {
  e.addEventListener(t, n, r);
}
function yv(e, t, n, r) {
  e.removeEventListener(t, n, r);
}
const Fc = Symbol("_vei");
function bv(e, t, n, r, o = null) {
  const a = e[Fc] || (e[Fc] = {}), i = a[t];
  if (r && i)
    i.value = r;
  else {
    const [s, l] = zv(t);
    if (r) {
      const c = a[t] = xv(r, o);
      vv(e, s, c, l);
    } else i && (yv(e, s, i, l), a[t] = void 0);
  }
}
const Uc = /(?:Once|Passive|Capture)$/;
function zv(e) {
  let t;
  if (Uc.test(e)) {
    t = {};
    let r;
    for (; r = e.match(Uc); )
      e = e.slice(0, e.length - r[0].length), t[r[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : $t(e.slice(2)), t];
}
let Oi = 0;
const jv = /* @__PURE__ */ Promise.resolve(), wv = () => Oi || (jv.then(() => Oi = 0), Oi = Date.now());
function xv(e, t) {
  const n = (r) => {
    if (!r._vts)
      r._vts = Date.now();
    else if (r._vts <= n.attached)
      return;
    Pt(
      kv(r, n.value),
      t,
      5,
      [r]
    );
  };
  return n.value = e, n.attached = wv(), n;
}
function kv(e, t) {
  if (ce(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map((r) => (o) => !o._stopped && r && r(o));
  } else
    return t;
}
const Vc = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Sv = (e, t, n, r, o, a, i, s, l) => {
  const c = o === "svg";
  t === "class" ? mv(e, r, c) : t === "style" ? fv(e, n, r) : La(t) ? qs(t) || bv(e, t, n, r, i) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Ev(e, t, r, c)) ? hv(
    e,
    t,
    r,
    a,
    i,
    s,
    l
  ) : (t === "true-value" ? e._trueValue = r : t === "false-value" && (e._falseValue = r), gv(e, t, r, c));
};
function Ev(e, t, n, r) {
  if (r)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Vc(t) && pe(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const o = e.tagName;
    if (o === "IMG" || o === "VIDEO" || o === "CANVAS" || o === "SOURCE")
      return !1;
  }
  return Vc(t) && Ve(n) ? !1 : t in e;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Pv(e, t) {
  const n = /* @__PURE__ */ Q(e);
  class r extends al {
    constructor(a) {
      super(n, a, t);
    }
  }
  return r.def = n, r;
}
const Tv = typeof HTMLElement < "u" ? HTMLElement : class {
};
class al extends Tv {
  constructor(t, n = {}, r) {
    super(), this._childStylesAnchor = null, this._childStylesSet = /* @__PURE__ */ new Set(), this._def = t, this._props = n, this._instance = null, this._connected = !1, this._resolved = !1, this._numberProps = null, this._ob = null, this.shadowRoot && r ? r(this._createVNode(), this.shadowRoot) : (this.attachShadow({ mode: "open" }), this._def.__asyncLoader || this._resolveProps(this._def));
  }
  connectedCallback() {
    this._connected = !0, this._instance || (this._resolved ? this._update() : this._resolveDef());
  }
  disconnectedCallback() {
    this._connected = !1, this._ob && (this._ob.disconnect(), this._ob = null), Qm(() => {
      this._connected || (Hc(null, this.shadowRoot), this._instance = null);
    });
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    this._resolved = !0;
    for (let r = 0; r < this.attributes.length; r++)
      this._setAttr(this.attributes[r].name);
    this._ob = new MutationObserver((r) => {
      for (const o of r)
        this._setAttr(o.attributeName);
    }), this._ob.observe(this, { attributes: !0 });
    const t = (r, o = !1) => {
      const { props: a, styles: i } = r;
      let s;
      if (a && !ce(a))
        for (const l in a) {
          const c = a[l];
          (c === Number || c && c.type === Number) && (l in this._props && (this._props[l] = Gi(this._props[l])), (s || (s = /* @__PURE__ */ Object.create(null)))[vt(l)] = !0);
        }
      this._numberProps = s, o && this._resolveProps(r), this._applyStyles(i), this._update();
    }, n = this._def.__asyncLoader;
    n ? n().then((r) => t(r, !0)) : t(this._def);
  }
  _resolveProps(t) {
    const { props: n } = t, r = ce(n) ? n : Object.keys(n || {});
    for (const o of Object.keys(this))
      o[0] !== "_" && r.includes(o) && this._setProp(o, this[o], !0, !1);
    for (const o of r.map(vt))
      Object.defineProperty(this, o, {
        get() {
          return this._getProp(o);
        },
        set(a) {
          this._setProp(o, a);
        }
      });
  }
  _setAttr(t) {
    let n = this.getAttribute(t);
    const r = vt(t);
    this._numberProps && this._numberProps[r] && (n = Gi(n)), this._setProp(r, n, !1);
  }
  /**
   * @internal
   */
  _getProp(t) {
    return this._props[t];
  }
  /**
   * @internal
   */
  _setProp(t, n, r = !0, o = !0) {
    n !== this._props[t] && (this._props[t] = n, o && this._instance && this._update(), r && (n === !0 ? this.setAttribute($t(t), "") : typeof n == "string" || typeof n == "number" ? this.setAttribute($t(t), n + "") : n || this.removeAttribute($t(t))));
  }
  _update() {
    Hc(this._createVNode(), this.shadowRoot);
  }
  _createVNode() {
    const t = B(this._def, Ke({}, this._props));
    return this._instance || (t.ce = (n) => {
      this._instance = n, n.ceContext = {
        addCEChildStyle: this._addChildStyles.bind(this),
        removeCEChildStyles: this._removeChildStyles.bind(this)
      }, n.isCE = !0;
      const r = (a, i) => {
        this.dispatchEvent(
          new CustomEvent(a, {
            detail: i
          })
        );
      };
      n.emit = (a, ...i) => {
        r(a, i), $t(a) !== a && r($t(a), i);
      };
      let o = this;
      for (; o = o && (o.parentNode || o.host); )
        if (o instanceof al) {
          n.parent = o._instance, n.provides = o._instance.provides;
          break;
        }
    }), t;
  }
  _applyStyles(t) {
    t && t.forEach((n) => {
      const r = document.createElement("style");
      r.textContent = n, r.setAttribute("data-v-ce-root", ""), this.shadowRoot.appendChild(r), this._childStylesAnchor = r;
    });
  }
  // The method used by custom element child components
  // to add styles to the shadow dom
  _addChildStyles(t, n, r) {
    if (t) {
      if (this.isHasChildStyle(t) && !r)
        return;
      t.forEach((a, i) => {
        const s = document.createElement("style");
        s.textContent = a, s.setAttribute(`data-v-ce-${n}`, ""), this._childStylesAnchor ? this.shadowRoot.insertBefore(s, this._childStylesAnchor) : this.shadowRoot.appendChild(s), this._childStylesAnchor = s, (this._styles || (this._styles = [])).push(s);
      });
    }
  }
  _removeChildStyles(t) {
    {
      const n = this.shadowRoot.querySelectorAll(`[data-v-ce-${t}]`);
      let r = [];
      n.length > 0 && n.forEach((o) => {
        r.unshift(o.innerHTML), this.shadowRoot.removeChild(o);
        const a = this.shadowRoot.querySelectorAll("style");
        this._childStylesAnchor = a.length > 0 ? a[a.length - 1] : void 0;
      }), this._childStylesSet.delete(r.join());
    }
  }
  isHasChildStyle(t) {
    if (t) {
      const n = t.join();
      return this._childStylesSet.has(n) ? !0 : (this._childStylesSet.add(n), !1);
    }
  }
}
const Cv = ["ctrl", "shift", "alt", "meta"], Av = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => Cv.some((n) => e[`${n}Key`] && !t.includes(n))
}, Or = (e, t) => {
  const n = e._withMods || (e._withMods = {}), r = t.join(".");
  return n[r] || (n[r] = (o, ...a) => {
    for (let i = 0; i < t.length; i++) {
      const s = Av[t[i]];
      if (s && s(o, t))
        return;
    }
    return e(o, ...a);
  });
}, Ov = /* @__PURE__ */ Ke({ patchProp: Sv }, av);
let qc;
function Iv() {
  return qc || (qc = Dh(Ov));
}
const Hc = (...e) => {
  Iv().render(...e);
}, oo = /^[a-z0-9]+(-[a-z0-9]+)*$/, Wa = (e, t, n, r = "") => {
  const o = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (o.length < 2 || o.length > 3)
      return null;
    r = o.shift().slice(1);
  }
  if (o.length > 3 || !o.length)
    return null;
  if (o.length > 1) {
    const s = o.pop(), l = o.pop(), c = {
      // Allow provider without '@': "provider:prefix:name"
      provider: o.length > 0 ? o[0] : r,
      prefix: l,
      name: s
    };
    return t && !ra(c) ? null : c;
  }
  const a = o[0], i = a.split("-");
  if (i.length > 1) {
    const s = {
      provider: r,
      prefix: i.shift(),
      name: i.join("-")
    };
    return t && !ra(s) ? null : s;
  }
  if (n && r === "") {
    const s = {
      provider: r,
      prefix: "",
      name: a
    };
    return t && !ra(s, n) ? null : s;
  }
  return null;
}, ra = (e, t) => e ? !!((e.provider === "" || e.provider.match(oo)) && (t && e.prefix === "" || e.prefix.match(oo)) && e.name.match(oo)) : !1, Od = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), ha = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), Ya = Object.freeze({
  ...Od,
  ...ha
}), ms = Object.freeze({
  ...Ya,
  body: "",
  hidden: !1
});
function Lv(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const r = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return r && (n.rotate = r), n;
}
function Bc(e, t) {
  const n = Lv(e, t);
  for (const r in ms)
    r in ha ? r in e && !(r in n) && (n[r] = ha[r]) : r in t ? n[r] = t[r] : r in e && (n[r] = e[r]);
  return n;
}
function Nv(e, t) {
  const n = e.icons, r = e.aliases || /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  function a(i) {
    if (n[i])
      return o[i] = [];
    if (!(i in o)) {
      o[i] = null;
      const s = r[i] && r[i].parent, l = s && a(s);
      l && (o[i] = [s].concat(l));
    }
    return o[i];
  }
  return Object.keys(n).concat(Object.keys(r)).forEach(a), o;
}
function Mv(e, t, n) {
  const r = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null);
  let a = {};
  function i(s) {
    a = Bc(
      r[s] || o[s],
      a
    );
  }
  return i(t), n.forEach(i), Bc(e, a);
}
function Id(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((o) => {
    t(o, null), n.push(o);
  });
  const r = Nv(e);
  for (const o in r) {
    const a = r[o];
    a && (t(o, Mv(e, o, a)), n.push(o));
  }
  return n;
}
const Rv = {
  provider: "",
  aliases: {},
  not_found: {},
  ...Od
};
function Ii(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function Ld(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Ii(e, Rv))
    return null;
  const n = t.icons;
  for (const o in n) {
    const a = n[o];
    if (!o.match(oo) || typeof a.body != "string" || !Ii(
      a,
      ms
    ))
      return null;
  }
  const r = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const o in r) {
    const a = r[o], i = a.parent;
    if (!o.match(oo) || typeof i != "string" || !n[i] && !r[i] || !Ii(
      a,
      ms
    ))
      return null;
  }
  return t;
}
const Jc = /* @__PURE__ */ Object.create(null);
function $v(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function nr(e, t) {
  const n = Jc[e] || (Jc[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = $v(e, t));
}
function il(e, t) {
  return Ld(t) ? Id(t, (n, r) => {
    r ? e.icons[n] = r : e.missing.add(n);
  }) : [];
}
function Dv(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
let fo = !1;
function Nd(e) {
  return typeof e == "boolean" && (fo = e), fo;
}
function Fv(e) {
  const t = typeof e == "string" ? Wa(e, !0, fo) : e;
  if (t) {
    const n = nr(t.provider, t.prefix), r = t.name;
    return n.icons[r] || (n.missing.has(r) ? null : void 0);
  }
}
function Uv(e, t) {
  const n = Wa(e, !0, fo);
  if (!n)
    return !1;
  const r = nr(n.provider, n.prefix);
  return Dv(r, n.name, t);
}
function Md(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), fo && !t && !e.prefix) {
    let o = !1;
    return Ld(e) && (e.prefix = "", Id(e, (a, i) => {
      i && Uv(a, i) && (o = !0);
    })), o;
  }
  const n = e.prefix;
  if (!ra({
    provider: t,
    prefix: n,
    name: "a"
  }))
    return !1;
  const r = nr(t, n);
  return !!il(r, e);
}
const Rd = Object.freeze({
  width: null,
  height: null
}), $d = Object.freeze({
  // Dimensions
  ...Rd,
  // Transformations
  ...ha
}), Vv = /(-?[0-9.]*[0-9]+[0-9.]*)/g, qv = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Wc(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const r = e.split(Vv);
  if (r === null || !r.length)
    return e;
  const o = [];
  let a = r.shift(), i = qv.test(a);
  for (; ; ) {
    if (i) {
      const s = parseFloat(a);
      isNaN(s) ? o.push(a) : o.push(Math.ceil(s * t * n) / n);
    } else
      o.push(a);
    if (a = r.shift(), a === void 0)
      return o.join("");
    i = !i;
  }
}
const Hv = (e) => e === "unset" || e === "undefined" || e === "none";
function Bv(e, t) {
  const n = {
    ...Ya,
    ...e
  }, r = {
    ...$d,
    ...t
  }, o = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let a = n.body;
  [n, r].forEach((f) => {
    const _ = [], y = f.hFlip, A = f.vFlip;
    let I = f.rotate;
    y ? A ? I += 2 : (_.push(
      "translate(" + (o.width + o.left).toString() + " " + (0 - o.top).toString() + ")"
    ), _.push("scale(-1 1)"), o.top = o.left = 0) : A && (_.push(
      "translate(" + (0 - o.left).toString() + " " + (o.height + o.top).toString() + ")"
    ), _.push("scale(1 -1)"), o.top = o.left = 0);
    let j;
    switch (I < 0 && (I -= Math.floor(I / 4) * 4), I = I % 4, I) {
      case 1:
        j = o.height / 2 + o.top, _.unshift(
          "rotate(90 " + j.toString() + " " + j.toString() + ")"
        );
        break;
      case 2:
        _.unshift(
          "rotate(180 " + (o.width / 2 + o.left).toString() + " " + (o.height / 2 + o.top).toString() + ")"
        );
        break;
      case 3:
        j = o.width / 2 + o.left, _.unshift(
          "rotate(-90 " + j.toString() + " " + j.toString() + ")"
        );
        break;
    }
    I % 2 === 1 && (o.left !== o.top && (j = o.left, o.left = o.top, o.top = j), o.width !== o.height && (j = o.width, o.width = o.height, o.height = j)), _.length && (a = '<g transform="' + _.join(" ") + '">' + a + "</g>");
  });
  const i = r.width, s = r.height, l = o.width, c = o.height;
  let u, d;
  i === null ? (d = s === null ? "1em" : s === "auto" ? c : s, u = Wc(d, l / c)) : (u = i === "auto" ? l : i, d = s === null ? Wc(u, c / l) : s === "auto" ? c : s);
  const p = {}, m = (f, _) => {
    Hv(_) || (p[f] = _.toString());
  };
  return m("width", u), m("height", d), p.viewBox = o.left.toString() + " " + o.top.toString() + " " + l.toString() + " " + c.toString(), {
    attributes: p,
    body: a
  };
}
const Jv = /\sid="(\S+)"/g, Wv = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let Yv = 0;
function Gv(e, t = Wv) {
  const n = [];
  let r;
  for (; r = Jv.exec(e); )
    n.push(r[1]);
  if (!n.length)
    return e;
  const o = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return n.forEach((a) => {
    const i = typeof t == "function" ? t(a) : t + (Yv++).toString(), s = a.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + s + ')([")]|\\.[a-z])', "g"),
      "$1" + i + o + "$3"
    );
  }), e = e.replace(new RegExp(o, "g"), ""), e;
}
const ds = /* @__PURE__ */ Object.create(null);
function Kv(e, t) {
  ds[e] = t;
}
function ps(e) {
  return ds[e] || ds[""];
}
function sl(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const ll = /* @__PURE__ */ Object.create(null), qr = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], oa = [];
for (; qr.length > 0; )
  qr.length === 1 || Math.random() > 0.5 ? oa.push(qr.shift()) : oa.push(qr.pop());
ll[""] = sl({
  resources: ["https://api.iconify.design"].concat(oa)
});
function Qv(e, t) {
  const n = sl(t);
  return n === null ? !1 : (ll[e] = n, !0);
}
function cl(e) {
  return ll[e];
}
const Xv = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Yc = Xv();
function Zv(e, t) {
  const n = cl(e);
  if (!n)
    return 0;
  let r;
  if (!n.maxURL)
    r = 0;
  else {
    let o = 0;
    n.resources.forEach((i) => {
      o = Math.max(o, i.length);
    });
    const a = t + ".json?icons=";
    r = n.maxURL - o - n.path.length - a.length;
  }
  return r;
}
function ey(e) {
  return e === 404;
}
const ty = (e, t, n) => {
  const r = [], o = Zv(e, t), a = "icons";
  let i = {
    type: a,
    provider: e,
    prefix: t,
    icons: []
  }, s = 0;
  return n.forEach((l, c) => {
    s += l.length + 1, s >= o && c > 0 && (r.push(i), i = {
      type: a,
      provider: e,
      prefix: t,
      icons: []
    }, s = l.length), i.icons.push(l);
  }), r.push(i), r;
};
function ny(e) {
  if (typeof e == "string") {
    const t = cl(e);
    if (t)
      return t.path;
  }
  return "/";
}
const ry = (e, t, n) => {
  if (!Yc) {
    n("abort", 424);
    return;
  }
  let r = ny(t.provider);
  switch (t.type) {
    case "icons": {
      const a = t.prefix, s = t.icons.join(","), l = new URLSearchParams({
        icons: s
      });
      r += a + ".json?" + l.toString();
      break;
    }
    case "custom": {
      const a = t.uri;
      r += a.slice(0, 1) === "/" ? a.slice(1) : a;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let o = 503;
  Yc(e + r).then((a) => {
    const i = a.status;
    if (i !== 200) {
      setTimeout(() => {
        n(ey(i) ? "abort" : "next", i);
      });
      return;
    }
    return o = 501, a.json();
  }).then((a) => {
    if (typeof a != "object" || a === null) {
      setTimeout(() => {
        a === 404 ? n("abort", a) : n("next", o);
      });
      return;
    }
    setTimeout(() => {
      n("success", a);
    });
  }).catch(() => {
    n("next", o);
  });
}, oy = {
  prepare: ty,
  send: ry
};
function ay(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((o, a) => o.provider !== a.provider ? o.provider.localeCompare(a.provider) : o.prefix !== a.prefix ? o.prefix.localeCompare(a.prefix) : o.name.localeCompare(a.name));
  let r = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((o) => {
    if (r.name === o.name && r.prefix === o.prefix && r.provider === o.provider)
      return;
    r = o;
    const a = o.provider, i = o.prefix, s = o.name, l = n[a] || (n[a] = /* @__PURE__ */ Object.create(null)), c = l[i] || (l[i] = nr(a, i));
    let u;
    s in c.icons ? u = t.loaded : i === "" || c.missing.has(s) ? u = t.missing : u = t.pending;
    const d = {
      provider: a,
      prefix: i,
      name: s
    };
    u.push(d);
  }), t;
}
function Dd(e, t) {
  e.forEach((n) => {
    const r = n.loaderCallbacks;
    r && (n.loaderCallbacks = r.filter((o) => o.id !== t));
  });
}
function iy(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const r = e.provider, o = e.prefix;
    t.forEach((a) => {
      const i = a.icons, s = i.pending.length;
      i.pending = i.pending.filter((l) => {
        if (l.prefix !== o)
          return !0;
        const c = l.name;
        if (e.icons[c])
          i.loaded.push({
            provider: r,
            prefix: o,
            name: c
          });
        else if (e.missing.has(c))
          i.missing.push({
            provider: r,
            prefix: o,
            name: c
          });
        else
          return n = !0, !0;
        return !1;
      }), i.pending.length !== s && (n || Dd([e], a.id), a.callback(
        i.loaded.slice(0),
        i.missing.slice(0),
        i.pending.slice(0),
        a.abort
      ));
    });
  }));
}
let sy = 0;
function ly(e, t, n) {
  const r = sy++, o = Dd.bind(null, n, r);
  if (!t.pending.length)
    return o;
  const a = {
    id: r,
    icons: t,
    callback: e,
    abort: o
  };
  return n.forEach((i) => {
    (i.loaderCallbacks || (i.loaderCallbacks = [])).push(a);
  }), o;
}
function cy(e, t = !0, n = !1) {
  const r = [];
  return e.forEach((o) => {
    const a = typeof o == "string" ? Wa(o, t, n) : o;
    a && r.push(a);
  }), r;
}
var uy = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function my(e, t, n, r) {
  const o = e.resources.length, a = e.random ? Math.floor(Math.random() * o) : e.index;
  let i;
  if (e.random) {
    let z = e.resources.slice(0);
    for (i = []; z.length > 1; ) {
      const O = Math.floor(Math.random() * z.length);
      i.push(z[O]), z = z.slice(0, O).concat(z.slice(O + 1));
    }
    i = i.concat(z);
  } else
    i = e.resources.slice(a).concat(e.resources.slice(0, a));
  const s = Date.now();
  let l = "pending", c = 0, u, d = null, p = [], m = [];
  typeof r == "function" && m.push(r);
  function f() {
    d && (clearTimeout(d), d = null);
  }
  function _() {
    l === "pending" && (l = "aborted"), f(), p.forEach((z) => {
      z.status === "pending" && (z.status = "aborted");
    }), p = [];
  }
  function y(z, O) {
    O && (m = []), typeof z == "function" && m.push(z);
  }
  function A() {
    return {
      startTime: s,
      payload: t,
      status: l,
      queriesSent: c,
      queriesPending: p.length,
      subscribe: y,
      abort: _
    };
  }
  function I() {
    l = "failed", m.forEach((z) => {
      z(void 0, u);
    });
  }
  function j() {
    p.forEach((z) => {
      z.status === "pending" && (z.status = "aborted");
    }), p = [];
  }
  function S(z, O, N) {
    const F = O !== "success";
    switch (p = p.filter((te) => te !== z), l) {
      case "pending":
        break;
      case "failed":
        if (F || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (O === "abort") {
      u = N, I();
      return;
    }
    if (F) {
      u = N, p.length || (i.length ? T() : I());
      return;
    }
    if (f(), j(), !e.random) {
      const te = e.resources.indexOf(z.resource);
      te !== -1 && te !== e.index && (e.index = te);
    }
    l = "completed", m.forEach((te) => {
      te(N);
    });
  }
  function T() {
    if (l !== "pending")
      return;
    f();
    const z = i.shift();
    if (z === void 0) {
      if (p.length) {
        d = setTimeout(() => {
          f(), l === "pending" && (j(), I());
        }, e.timeout);
        return;
      }
      I();
      return;
    }
    const O = {
      status: "pending",
      resource: z,
      callback: (N, F) => {
        S(O, N, F);
      }
    };
    p.push(O), c++, d = setTimeout(T, e.rotate), n(z, t, O.callback);
  }
  return setTimeout(T), A;
}
function Fd(e) {
  const t = {
    ...uy,
    ...e
  };
  let n = [];
  function r() {
    n = n.filter((s) => s().status === "pending");
  }
  function o(s, l, c) {
    const u = my(
      t,
      s,
      l,
      (d, p) => {
        r(), c && c(d, p);
      }
    );
    return n.push(u), u;
  }
  function a(s) {
    return n.find((l) => s(l)) || null;
  }
  return {
    query: o,
    find: a,
    setIndex: (s) => {
      t.index = s;
    },
    getIndex: () => t.index,
    cleanup: r
  };
}
function Gc() {
}
const Li = /* @__PURE__ */ Object.create(null);
function dy(e) {
  if (!Li[e]) {
    const t = cl(e);
    if (!t)
      return;
    const n = Fd(t), r = {
      config: t,
      redundancy: n
    };
    Li[e] = r;
  }
  return Li[e];
}
function py(e, t, n) {
  let r, o;
  if (typeof e == "string") {
    const a = ps(e);
    if (!a)
      return n(void 0, 424), Gc;
    o = a.send;
    const i = dy(e);
    i && (r = i.redundancy);
  } else {
    const a = sl(e);
    if (a) {
      r = Fd(a);
      const i = e.resources ? e.resources[0] : "", s = ps(i);
      s && (o = s.send);
    }
  }
  return !r || !o ? (n(void 0, 424), Gc) : r.query(t, o, n)().abort;
}
const Kc = "iconify2", _o = "iconify", Ud = _o + "-count", Qc = _o + "-version", Vd = 36e5, fy = 168;
function fs(e, t) {
  try {
    return e.getItem(t);
  } catch {
  }
}
function ul(e, t, n) {
  try {
    return e.setItem(t, n), !0;
  } catch {
  }
}
function Xc(e, t) {
  try {
    e.removeItem(t);
  } catch {
  }
}
function _s(e, t) {
  return ul(e, Ud, t.toString());
}
function gs(e) {
  return parseInt(fs(e, Ud)) || 0;
}
const Ga = {
  local: !0,
  session: !0
}, qd = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
let ml = !1;
function _y(e) {
  ml = e;
}
let Yo = typeof window > "u" ? {} : window;
function Hd(e) {
  const t = e + "Storage";
  try {
    if (Yo && Yo[t] && typeof Yo[t].length == "number")
      return Yo[t];
  } catch {
  }
  Ga[e] = !1;
}
function Bd(e, t) {
  const n = Hd(e);
  if (!n)
    return;
  const r = fs(n, Qc);
  if (r !== Kc) {
    if (r) {
      const s = gs(n);
      for (let l = 0; l < s; l++)
        Xc(n, _o + l.toString());
    }
    ul(n, Qc, Kc), _s(n, 0);
    return;
  }
  const o = Math.floor(Date.now() / Vd) - fy, a = (s) => {
    const l = _o + s.toString(), c = fs(n, l);
    if (typeof c == "string") {
      try {
        const u = JSON.parse(c);
        if (typeof u == "object" && typeof u.cached == "number" && u.cached > o && typeof u.provider == "string" && typeof u.data == "object" && typeof u.data.prefix == "string" && // Valid item: run callback
        t(u, s))
          return !0;
      } catch {
      }
      Xc(n, l);
    }
  };
  let i = gs(n);
  for (let s = i - 1; s >= 0; s--)
    a(s) || (s === i - 1 ? (i--, _s(n, i)) : qd[e].add(s));
}
function Jd() {
  if (!ml) {
    _y(!0);
    for (const e in Ga)
      Bd(e, (t) => {
        const n = t.data, r = t.provider, o = n.prefix, a = nr(
          r,
          o
        );
        if (!il(a, n).length)
          return !1;
        const i = n.lastModified || -1;
        return a.lastModifiedCached = a.lastModifiedCached ? Math.min(a.lastModifiedCached, i) : i, !0;
      });
  }
}
function gy(e, t) {
  const n = e.lastModifiedCached;
  if (
    // Matches or newer
    n && n >= t
  )
    return n === t;
  if (e.lastModifiedCached = t, n)
    for (const r in Ga)
      Bd(r, (o) => {
        const a = o.data;
        return o.provider !== e.provider || a.prefix !== e.prefix || a.lastModified === t;
      });
  return !0;
}
function hy(e, t) {
  ml || Jd();
  function n(r) {
    let o;
    if (!Ga[r] || !(o = Hd(r)))
      return;
    const a = qd[r];
    let i;
    if (a.size)
      a.delete(i = Array.from(a).shift());
    else if (i = gs(o), !_s(o, i + 1))
      return;
    const s = {
      cached: Math.floor(Date.now() / Vd),
      provider: e.provider,
      data: t
    };
    return ul(
      o,
      _o + i.toString(),
      JSON.stringify(s)
    );
  }
  t.lastModified && !gy(e, t.lastModified) || Object.keys(t.icons).length && (t.not_found && (t = Object.assign({}, t), delete t.not_found), n("local") || n("session"));
}
function Zc() {
}
function vy(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, iy(e);
  }));
}
function yy(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: r } = e, o = e.iconsToLoad;
    delete e.iconsToLoad;
    let a;
    if (!o || !(a = ps(n)))
      return;
    a.prepare(n, r, o).forEach((s) => {
      py(n, s, (l) => {
        if (typeof l != "object")
          s.icons.forEach((c) => {
            e.missing.add(c);
          });
        else
          try {
            const c = il(
              e,
              l
            );
            if (!c.length)
              return;
            const u = e.pendingIcons;
            u && c.forEach((d) => {
              u.delete(d);
            }), hy(e, l);
          } catch (c) {
            console.error(c);
          }
        vy(e);
      });
    });
  }));
}
const by = (e, t) => {
  const n = cy(e, !0, Nd()), r = ay(n);
  if (!r.pending.length) {
    let l = !0;
    return t && setTimeout(() => {
      l && t(
        r.loaded,
        r.missing,
        r.pending,
        Zc
      );
    }), () => {
      l = !1;
    };
  }
  const o = /* @__PURE__ */ Object.create(null), a = [];
  let i, s;
  return r.pending.forEach((l) => {
    const { provider: c, prefix: u } = l;
    if (u === s && c === i)
      return;
    i = c, s = u, a.push(nr(c, u));
    const d = o[c] || (o[c] = /* @__PURE__ */ Object.create(null));
    d[u] || (d[u] = []);
  }), r.pending.forEach((l) => {
    const { provider: c, prefix: u, name: d } = l, p = nr(c, u), m = p.pendingIcons || (p.pendingIcons = /* @__PURE__ */ new Set());
    m.has(d) || (m.add(d), o[c][u].push(d));
  }), a.forEach((l) => {
    const { provider: c, prefix: u } = l;
    o[c][u].length && yy(l, o[c][u]);
  }), t ? ly(t, r, a) : Zc;
};
function zy(e, t) {
  const n = {
    ...e
  };
  for (const r in t) {
    const o = t[r], a = typeof o;
    r in Rd ? (o === null || o && (a === "string" || a === "number")) && (n[r] = o) : a === typeof n[r] && (n[r] = r === "rotate" ? o % 4 : o);
  }
  return n;
}
const jy = /[\s,]+/;
function wy(e, t) {
  t.split(jy).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function xy(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function r(o) {
    for (; o < 0; )
      o += 4;
    return o % 4;
  }
  if (n === "") {
    const o = parseInt(e);
    return isNaN(o) ? 0 : r(o);
  } else if (n !== e) {
    let o = 0;
    switch (n) {
      case "%":
        o = 25;
        break;
      case "deg":
        o = 90;
    }
    if (o) {
      let a = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(a) ? 0 : (a = a / o, a % 1 === 0 ? r(a) : 0);
    }
  }
  return t;
}
function ky(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const r in t)
    n += " " + r + '="' + t[r] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function Sy(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Ey(e) {
  return "data:image/svg+xml," + Sy(e);
}
function Py(e) {
  return 'url("' + Ey(e) + '")';
}
const eu = {
  ...$d,
  inline: !1
}, Ty = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, Cy = {
  display: "inline-block"
}, hs = {
  backgroundColor: "currentColor"
}, Wd = {
  backgroundColor: "transparent"
}, tu = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, nu = {
  webkitMask: hs,
  mask: hs,
  background: Wd
};
for (const e in nu) {
  const t = nu[e];
  for (const n in tu)
    t[e + n] = tu[n];
}
const aa = {};
["horizontal", "vertical"].forEach((e) => {
  const t = e.slice(0, 1) + "Flip";
  aa[e + "-flip"] = t, aa[e.slice(0, 1) + "-flip"] = t, aa[e + "Flip"] = t;
});
function ru(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const ou = (e, t) => {
  const n = zy(eu, t), r = { ...Ty }, o = t.mode || "svg", a = {}, i = t.style, s = typeof i == "object" && !(i instanceof Array) ? i : {};
  for (let _ in t) {
    const y = t[_];
    if (y !== void 0)
      switch (_) {
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
          break;
        case "inline":
        case "hFlip":
        case "vFlip":
          n[_] = y === !0 || y === "true" || y === 1;
          break;
        case "flip":
          typeof y == "string" && wy(n, y);
          break;
        case "color":
          a.color = y;
          break;
        case "rotate":
          typeof y == "string" ? n[_] = xy(y) : typeof y == "number" && (n[_] = y);
          break;
        case "ariaHidden":
        case "aria-hidden":
          y !== !0 && y !== "true" && delete r["aria-hidden"];
          break;
        default: {
          const A = aa[_];
          A ? (y === !0 || y === "true" || y === 1) && (n[A] = !0) : eu[_] === void 0 && (r[_] = y);
        }
      }
  }
  const l = Bv(e, n), c = l.attributes;
  if (n.inline && (a.verticalAlign = "-0.125em"), o === "svg") {
    r.style = {
      ...a,
      ...s
    }, Object.assign(r, c);
    let _ = 0, y = t.id;
    return typeof y == "string" && (y = y.replace(/-/g, "_")), r.innerHTML = Gv(l.body, y ? () => y + "ID" + _++ : "iconifyVue"), pt("svg", r);
  }
  const { body: u, width: d, height: p } = e, m = o === "mask" || (o === "bg" ? !1 : u.indexOf("currentColor") !== -1), f = ky(u, {
    ...c,
    width: d + "",
    height: p + ""
  });
  return r.style = {
    ...a,
    "--svg": Py(f),
    width: ru(c.width),
    height: ru(c.height),
    ...Cy,
    ...m ? hs : Wd,
    ...s
  }, pt("span", r);
};
Nd(!0);
Kv("", oy);
if (typeof document < "u" && typeof window < "u") {
  Jd();
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const t = e.IconifyPreload, n = "Invalid IconifyPreload syntax.";
    typeof t == "object" && t !== null && (t instanceof Array ? t : [t]).forEach((r) => {
      try {
        // Check if item is an object and not null/array
        (typeof r != "object" || r === null || r instanceof Array || // Check for 'icons' and 'prefix'
        typeof r.icons != "object" || typeof r.prefix != "string" || // Add icon set
        !Md(r)) && console.error(n);
      } catch {
        console.error(n);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const t = e.IconifyProviders;
    if (typeof t == "object" && t !== null)
      for (let n in t) {
        const r = "IconifyProviders[" + n + "] is invalid.";
        try {
          const o = t[n];
          if (typeof o != "object" || !o || o.resources === void 0)
            continue;
          Qv(n, o) || console.error(r);
        } catch {
          console.error(r);
        }
      }
  }
}
const Ay = {
  ...Ya,
  body: ""
}, dl = /* @__PURE__ */ Q({
  // Do not inherit other attributes: it is handled by render()
  inheritAttrs: !1,
  // Set initial data
  data() {
    return {
      // Mounted status
      iconMounted: !1,
      // Callback counter to trigger re-render
      counter: 0
    };
  },
  mounted() {
    this._name = "", this._loadingIcon = null, this.iconMounted = !0;
  },
  unmounted() {
    this.abortLoading();
  },
  methods: {
    abortLoading() {
      this._loadingIcon && (this._loadingIcon.abort(), this._loadingIcon = null);
    },
    // Get data for icon to render or null
    getIcon(e, t) {
      if (typeof e == "object" && e !== null && typeof e.body == "string")
        return this._name = "", this.abortLoading(), {
          data: e
        };
      let n;
      if (typeof e != "string" || (n = Wa(e, !1, !0)) === null)
        return this.abortLoading(), null;
      const r = Fv(n);
      if (!r)
        return (!this._loadingIcon || this._loadingIcon.name !== e) && (this.abortLoading(), this._name = "", r !== null && (this._loadingIcon = {
          name: e,
          abort: by([n], () => {
            this.counter++;
          })
        })), null;
      this.abortLoading(), this._name !== e && (this._name = e, t && t(e));
      const o = ["iconify"];
      return n.prefix !== "" && o.push("iconify--" + n.prefix), n.provider !== "" && o.push("iconify--" + n.provider), { data: r, classes: o };
    }
  },
  // Render icon
  render() {
    this.counter;
    const e = this.$attrs, t = this.iconMounted ? this.getIcon(e.icon, e.onLoad) : null;
    if (!t)
      return ou(Ay, e);
    let n = e;
    return t.classes && (n = {
      ...e,
      class: (typeof e.class == "string" ? e.class + " " : "") + t.classes.join(" ")
    }), ou({
      ...Ya,
      ...t.data
    }, n);
  }
}), Oy = "nmd", Iy = 1720801998, Ly = {
  fm: {
    body: '<path fill="currentColor" d="M0 8.91h8.91V0H0zM2 2h4.91v4.91H2zm11-2v8.91h8.91V0zm6.91 6.91H15V2h4.91zM0 22.28h8.91v-8.91H0zm2-6.91h4.91v4.91H2zm11 6.91h8.91v-8.91H13zm2-6.91h4.91v4.91H15z"/>',
    width: 21.91,
    height: 22.28
  },
  journey: {
    body: '<path fill="currentColor" d="m11.45 5.78 1.21 3.28.32.87.87.32 3.28 1.21-3.28 1.21-.87.32-.32.87-1.21 3.28-1.21-3.28-.32-.87-.87-.32-3.28-1.21 3.28-1.21.87-.32.32-.87zm0-5.78L8.36 8.37 0 11.45l8.37 3.09 3.09 8.37 3.09-8.37 8.37-3.09-8.37-3.09z"/>'
  },
  "journey-filled": {
    body: '<path fill="currentColor" d="M11.45 0 8.36 8.37 0 11.45l8.37 3.09 3.09 8.37 3.09-8.37 8.37-3.09-8.37-3.09z"/>'
  },
  "journey-step": {
    body: '<path fill="currentColor" d="M16.41 0H0v18.23h16.41zm-2 16.23H2V2h12.41z"/><path fill="currentColor" d="M17.85 2.57V19.8H2.44v2h17.41V2.57z"/><path fill="currentColor" d="m8.21 13.92 1.29-3.51 3.51-1.29-3.51-1.3-1.29-3.51-1.3 3.51-3.51 1.3 3.51 1.29z"/>',
    width: 19.85,
    height: 21.8
  },
  program: {
    body: '<path fill="currentColor" d="M14.75 0H3.77C1.69 0 0 1.69 0 3.77v15.38c0 2.08 1.69 3.77 3.77 3.77h10.98c2.08 0 3.77-1.69 3.77-3.77V3.77c0-2.08-1.69-3.77-3.77-3.77m1.77 19.14c0 .97-.79 1.77-1.77 1.77H3.77c-.97 0-1.77-.79-1.77-1.77V3.77C2 2.8 2.79 2 3.77 2h10.98c.97 0 1.77.79 1.77 1.77v15.38Z"/><path fill="currentColor" d="M4.48 4.64h9.76v2H4.48zM4.47 8.3H10v2H4.47z"/>',
    width: 18.51
  },
  resource: {
    body: '<path fill="currentColor" d="M0 0v22.91h20.62V0zm18.62 20.91H2V2h16.62z"/><path fill="currentColor" d="M4.66 5.03h11.53v2H4.66zm0 3.86h11.53v2H4.66zm0 4.1h7.53v2H4.66z"/>',
    width: 20.62
  }
}, Ny = 22.91, My = 22.91, Ry = {
  prefix: Oy,
  lastModified: Iy,
  icons: Ly,
  width: Ny,
  height: My
}, $y = ".loader[data-v-45c2c80e]{width:3rem;aspect-ratio:2.35;--_g: no-repeat radial-gradient(circle closest-side, #ffffff 90%, #0000);background:var(--_g) 0% 50%,var(--_g) 50% 50%,var(--_g) 100% 50%;background-size:calc(100% / 3) 50%;animation:l3-45c2c80e 1s infinite linear}@keyframes l3-45c2c80e{20%{background-position:0% 0%,50% 50%,100% 50%}40%{background-position:0% 100%,50% 0%,100% 50%}60%{background-position:0% 50%,50% 100%,100% 0%}80%{background-position:0% 50%,50% 50%,100% 100%}}", ae = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [r, o] of t)
    n[r] = o;
  return n;
}, Dy = {}, Fy = { class: "loader" };
function Uy(e, t) {
  return w(), P("div", Fy);
}
const Vy = /* @__PURE__ */ ae(Dy, [["render", Uy], ["styles", [$y]], ["__scopeId", "data-v-45c2c80e"]]), qy = ".homepage-tile[data-v-2cd8e2c7]{border-radius:18px;padding:1.5rem 1.5rem 1.5rem 2rem;display:flex;flex-wrap:wrap;justify-content:space-between;gap:1.5rem;max-width:1140px;width:100%;outline:1px solid transparent;box-sizing:border-box;background:#dcdcdc;min-height:400px;animation:pulse-2cd8e2c7 2s infinite}.homepage-tile .homepage-tile__info[data-v-2cd8e2c7]{display:flex;flex-direction:column;gap:1rem;max-width:27rem;min-width:20rem;color:#fff;width:100%}.homepage-tile .homepage-tile__feed[data-v-2cd8e2c7]{display:flex;flex-direction:column;gap:.5rem;border-radius:18px;flex:1;min-width:20rem;box-sizing:border-box}.homepage-tile .homepage-tile__feed .row[data-v-2cd8e2c7]{display:flex;flex-direction:column;border-radius:10px;background:#e4ecf4;color:#000;padding:1.2rem 1.5rem;gap:1.5rem;outline:1px solid transparent;align-self:flex-end;width:100%;box-sizing:border-box;max-width:600px}.homepage-tile .homepage-tile__feed .row.image[data-v-2cd8e2c7]{background:none;padding:0}.homepage-tile .homepage-tile__feed .row.shadow[data-v-2cd8e2c7]{box-shadow:0 2px 24px #00000040}.homepage-tile .homepage-tile__feed .row.clear[data-v-2cd8e2c7]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.homepage-tile .homepage-tile__feed .row.event[data-v-2cd8e2c7]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.homepage-tile .homepage-tile__feed .row.programs[data-v-2cd8e2c7]{max-width:unset}.homepage-tile .homepage-tile__feed .row.topics[data-v-2cd8e2c7]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}@keyframes pulse-2cd8e2c7{0%{opacity:1}50%{opacity:.75}to{opacity:1}}.line[data-v-2cd8e2c7]{color:gray;width:100%;height:1.25rem;background:#ffffffa9;-webkit-mask:linear-gradient(-60deg,#000 30%,#0005,#000 70%) right / 300% 100%;background-repeat:no-repeat;animation:shimmer-2cd8e2c7 2s infinite;border-radius:.25rem}@keyframes shimmer-2cd8e2c7{to{-webkit-mask-position:left}}.vertical[data-v-2cd8e2c7]{flex-direction:column;width:100%}.program[data-v-2cd8e2c7]{background:#0072ef}.program .tile-title strong[data-v-2cd8e2c7]{color:#fff!important}", Hy = {}, By = { class: "homepage-tile" }, Jy = /* @__PURE__ */ Jh('<div class="homepage-tile__info" data-v-2cd8e2c7><div class="line" style="width:50%;height:0.75rem;opacity:0.5;" data-v-2cd8e2c7></div><div class="line" style="width:80%;" data-v-2cd8e2c7></div><div class="line" style="width:60%;" data-v-2cd8e2c7></div></div><div class="homepage-tile__feed" data-v-2cd8e2c7><div class="line" style="height:4rem;" data-v-2cd8e2c7></div><div class="line" style="height:9rem;" data-v-2cd8e2c7></div></div>', 2), Wy = [
  Jy
];
function Yy(e, t) {
  return w(), P("div", By, Wy);
}
const Gy = /* @__PURE__ */ ae(Hy, [["render", Yy], ["styles", [qy]], ["__scopeId", "data-v-2cd8e2c7"]]), Yd = (e, t, n) => {
  const r = e[t];
  return r ? typeof r == "function" ? r() : Promise.resolve(r) : new Promise((o, a) => {
    (typeof queueMicrotask == "function" ? queueMicrotask : setTimeout)(
      a.bind(
        null,
        new Error(
          "Unknown variable dynamic import: " + t + (t.split("/").length !== n ? ". Note that variables only represent file names one level deep." : "")
        )
      )
    );
  });
}, Ky = {
  "program-in-progress": "ProgramInProgress",
  "program-happening-now": "ProgramHappeningNow",
  "journey-invited": "JourneyInvited",
  "resource-happening-today": "ResourceHappeningToday",
  "resource-step": "ResourceStep",
  "journey-ending": "JourneyEnding",
  "journey-progress": "JourneyProgress",
  "journey-completed": "JourneyCompleted",
  "journey_step-community": "JourneyStepCommunity",
  "journey_step-resource_list": "JourneyStepResourceList",
  "journey_step-webinar": "JourneyStepWebinar",
  "resource-share": "ResourceShare",
  "explore-journeys": "ExploreJourneys",
  "explore-programs": "ExplorePrograms",
  "explore-resources": "ExploreResources",
  "explore-community": "ExploreCommunity"
}, Qy = (e) => {
  const t = Ky[e];
  return t ? Yd(/* @__PURE__ */ Object.assign({ "./ExploreCommunity.vue": () => Promise.resolve().then(() => KT), "./ExploreJourneys.vue": () => Promise.resolve().then(() => XT), "./ExplorePrograms.vue": () => Promise.resolve().then(() => eC), "./ExploreResources.vue": () => Promise.resolve().then(() => oC), "./JourneyCompleted.vue": () => Promise.resolve().then(() => sC), "./JourneyEnding.vue": () => Promise.resolve().then(() => uC), "./JourneyInvited.vue": () => Promise.resolve().then(() => pC), "./JourneyProgress.vue": () => Promise.resolve().then(() => _C), "./JourneyStepCommunity.vue": () => Promise.resolve().then(() => hC), "./JourneyStepResourceList.vue": () => Promise.resolve().then(() => yC), "./JourneyStepWebinar.vue": () => Promise.resolve().then(() => jC), "./ProgramHappeningNow.vue": () => Promise.resolve().then(() => xC), "./ProgramInProgress.vue": () => Promise.resolve().then(() => SC), "./ResourceHappeningToday.vue": () => Promise.resolve().then(() => TC), "./ResourceShare.vue": () => Promise.resolve().then(() => AC), "./ResourceStep.vue": () => Promise.resolve().then(() => LC) }), `./${t}.vue`, 2) : (console.warn(`No component mapped for key: ${e}`), Promise.resolve(null));
}, Xy = { class: "tile-description" }, Zy = ["innerHTML"], eb = /* @__PURE__ */ Q({
  __name: "TileDescription",
  props: {
    tile: {
      type: Object,
      required: !0
    },
    clampLimit: {
      type: Number
    }
  },
  setup(e) {
    Ad((a) => ({
      "4fc0ebc0": n.value
    }));
    const t = e, n = ee(() => t.tile.clampDescription || t.clampLimit), r = ee(() => `${t.tile.type}-${t.tile.subType}`), o = ee(() => /* @__PURE__ */ cd(
      () => Qy(r.value)
    ));
    return (a, i) => (w(), P("div", Xy, [
      e.tile.description || e.tile?.program?.introduction ? (w(), P("div", {
        key: 0,
        class: Ce(["standard-description", { truncated: n.value }]),
        innerHTML: e.tile.description || e.tile?.program?.introduction
      }, null, 10, Zy)) : (w(), ge(er(o.value), {
        key: 1,
        tile: e.tile
      }, null, 8, ["tile"]))
    ]));
  }
}), tb = ".tile-description[data-v-92d0393d]{display:flex;flex-direction:column;gap:1rem}.tile-description .standard-description[data-v-92d0393d]{margin:0;line-height:1.5}.tile-description .standard-description[data-v-92d0393d] p{margin-bottom:1em}.tile-description .standard-description.truncated[data-v-92d0393d]{-webkit-line-clamp:var(--4fc0ebc0);overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-box-orient:vertical}[data-v-92d0393d] p{margin:0;line-height:1.25rem}[data-v-92d0393d] a{color:inherit}", Ir = /* @__PURE__ */ ae(eb, [["styles", [tb]], ["__scopeId", "data-v-92d0393d"]]), nb = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ir
}, Symbol.toStringTag, { value: "Module" }));
/*!
  * shared v9.14.3
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const va = typeof window < "u", An = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), rb = (e, t, n) => ob({ l: e, k: t, s: n }), ob = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), He = (e) => typeof e == "number" && isFinite(e), ab = (e) => Kd(e) === "[object Date]", ya = (e) => Kd(e) === "[object RegExp]", Ka = (e) => ze(e) && Object.keys(e).length === 0, tt = Object.assign, ib = Object.create, Ae = (e = null) => ib(e);
let au;
const pl = () => au || (au = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : Ae());
function iu(e) {
  return e.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
const sb = Object.prototype.hasOwnProperty;
function Ft(e, t) {
  return sb.call(e, t);
}
const We = Array.isArray, Ue = (e) => typeof e == "function", ne = (e) => typeof e == "string", Re = (e) => typeof e == "boolean", ke = (e) => e !== null && typeof e == "object", lb = (e) => ke(e) && Ue(e.then) && Ue(e.catch), Gd = Object.prototype.toString, Kd = (e) => Gd.call(e), ze = (e) => {
  if (!ke(e))
    return !1;
  const t = Object.getPrototypeOf(e);
  return t === null || t.constructor === Object;
}, cb = (e) => e == null ? "" : We(e) || ze(e) && e.toString === Gd ? JSON.stringify(e, null, 2) : String(e);
function ub(e, t = "") {
  return e.reduce((n, r, o) => o === 0 ? n + r : n + t + r, "");
}
function Qa(e) {
  let t = e;
  return () => ++t;
}
function mb(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const Go = (e) => !ke(e) || We(e);
function ia(e, t) {
  if (Go(e) || Go(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: r, des: o } = n.pop();
    Object.keys(r).forEach((a) => {
      a !== "__proto__" && (ke(r[a]) && !ke(o[a]) && (o[a] = Array.isArray(r[a]) ? [] : Ae()), Go(o[a]) || Go(r[a]) ? o[a] = r[a] : n.push({ src: r[a], des: o[a] }));
    });
  }
}
/*!
  * message-compiler v9.14.3
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function db(e, t, n) {
  return { line: e, column: t, offset: n };
}
function ba(e, t, n) {
  return { start: e, end: t };
}
const pb = /\{([0-9a-zA-Z]+)\}/g;
function Qd(e, ...t) {
  return t.length === 1 && fb(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(pb, (n, r) => t.hasOwnProperty(r) ? t[r] : "");
}
const Xd = Object.assign, su = (e) => typeof e == "string", fb = (e) => e !== null && typeof e == "object";
function Zd(e, t = "") {
  return e.reduce((n, r, o) => o === 0 ? n + r : n + t + r, "");
}
const fl = {
  USE_MODULO_SYNTAX: 1,
  __EXTEND_POINT__: 2
}, _b = {
  [fl.USE_MODULO_SYNTAX]: "Use modulo before '{{0}}'."
};
function gb(e, t, ...n) {
  const r = Qd(_b[e], ...n || []), o = { message: String(r), code: e };
  return t && (o.location = t), o;
}
const le = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16,
  // Special value for higher-order compilers to pick up the last code
  // to avoid collision of error codes. This should always be kept as the last
  // item.
  __EXTEND_POINT__: 17
}, hb = {
  // tokenizer error messages
  [le.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [le.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [le.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [le.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [le.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [le.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [le.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [le.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [le.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [le.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [le.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [le.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [le.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [le.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [le.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [le.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function Lr(e, t, n = {}) {
  const { domain: r, messages: o, args: a } = n, i = Qd((o || hb)[e] || "", ...a || []), s = new SyntaxError(String(i));
  return s.code = e, t && (s.location = t), s.domain = r, s;
}
function vb(e) {
  throw e;
}
const an = " ", yb = "\r", at = `
`, bb = "\u2028", zb = "\u2029";
function jb(e) {
  const t = e;
  let n = 0, r = 1, o = 1, a = 0;
  const i = (O) => t[O] === yb && t[O + 1] === at, s = (O) => t[O] === at, l = (O) => t[O] === zb, c = (O) => t[O] === bb, u = (O) => i(O) || s(O) || l(O) || c(O), d = () => n, p = () => r, m = () => o, f = () => a, _ = (O) => i(O) || l(O) || c(O) ? at : t[O], y = () => _(n), A = () => _(n + a);
  function I() {
    return a = 0, u(n) && (r++, o = 0), i(n) && n++, n++, o++, t[n];
  }
  function j() {
    return i(n + a) && a++, a++, t[n + a];
  }
  function S() {
    n = 0, r = 1, o = 1, a = 0;
  }
  function T(O = 0) {
    a = O;
  }
  function z() {
    const O = n + a;
    for (; O !== n; )
      I();
    a = 0;
  }
  return {
    index: d,
    line: p,
    column: m,
    peekOffset: f,
    charAt: _,
    currentChar: y,
    currentPeek: A,
    next: I,
    peek: j,
    reset: S,
    resetPeek: T,
    skipToPeek: z
  };
}
const yn = void 0, wb = ".", lu = "'", xb = "tokenizer";
function kb(e, t = {}) {
  const n = t.location !== !1, r = jb(e), o = () => r.index(), a = () => db(r.line(), r.column(), r.index()), i = a(), s = o(), l = {
    currentType: 14,
    offset: s,
    startLoc: i,
    endLoc: i,
    lastType: 14,
    lastOffset: s,
    lastStartLoc: i,
    lastEndLoc: i,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, c = () => l, { onError: u } = t;
  function d(g, h, E, ...H) {
    const K = c();
    if (h.column += E, h.offset += E, u) {
      const J = n ? ba(K.startLoc, h) : null, C = Lr(g, J, {
        domain: xb,
        args: H
      });
      u(C);
    }
  }
  function p(g, h, E) {
    g.endLoc = a(), g.currentType = h;
    const H = { type: h };
    return n && (H.loc = ba(g.startLoc, g.endLoc)), E != null && (H.value = E), H;
  }
  const m = (g) => p(
    g,
    14
    /* TokenTypes.EOF */
  );
  function f(g, h) {
    return g.currentChar() === h ? (g.next(), h) : (d(le.EXPECTED_TOKEN, a(), 0, h), "");
  }
  function _(g) {
    let h = "";
    for (; g.currentPeek() === an || g.currentPeek() === at; )
      h += g.currentPeek(), g.peek();
    return h;
  }
  function y(g) {
    const h = _(g);
    return g.skipToPeek(), h;
  }
  function A(g) {
    if (g === yn)
      return !1;
    const h = g.charCodeAt(0);
    return h >= 97 && h <= 122 || // a-z
    h >= 65 && h <= 90 || // A-Z
    h === 95;
  }
  function I(g) {
    if (g === yn)
      return !1;
    const h = g.charCodeAt(0);
    return h >= 48 && h <= 57;
  }
  function j(g, h) {
    const { currentType: E } = h;
    if (E !== 2)
      return !1;
    _(g);
    const H = A(g.currentPeek());
    return g.resetPeek(), H;
  }
  function S(g, h) {
    const { currentType: E } = h;
    if (E !== 2)
      return !1;
    _(g);
    const H = g.currentPeek() === "-" ? g.peek() : g.currentPeek(), K = I(H);
    return g.resetPeek(), K;
  }
  function T(g, h) {
    const { currentType: E } = h;
    if (E !== 2)
      return !1;
    _(g);
    const H = g.currentPeek() === lu;
    return g.resetPeek(), H;
  }
  function z(g, h) {
    const { currentType: E } = h;
    if (E !== 8)
      return !1;
    _(g);
    const H = g.currentPeek() === ".";
    return g.resetPeek(), H;
  }
  function O(g, h) {
    const { currentType: E } = h;
    if (E !== 9)
      return !1;
    _(g);
    const H = A(g.currentPeek());
    return g.resetPeek(), H;
  }
  function N(g, h) {
    const { currentType: E } = h;
    if (!(E === 8 || E === 12))
      return !1;
    _(g);
    const H = g.currentPeek() === ":";
    return g.resetPeek(), H;
  }
  function F(g, h) {
    const { currentType: E } = h;
    if (E !== 10)
      return !1;
    const H = () => {
      const J = g.currentPeek();
      return J === "{" ? A(g.peek()) : J === "@" || J === "%" || J === "|" || J === ":" || J === "." || J === an || !J ? !1 : J === at ? (g.peek(), H()) : Y(g, !1);
    }, K = H();
    return g.resetPeek(), K;
  }
  function te(g) {
    _(g);
    const h = g.currentPeek() === "|";
    return g.resetPeek(), h;
  }
  function he(g) {
    const h = _(g), E = g.currentPeek() === "%" && g.peek() === "{";
    return g.resetPeek(), {
      isModulo: E,
      hasSpace: h.length > 0
    };
  }
  function Y(g, h = !0) {
    const E = (K = !1, J = "", C = !1) => {
      const $ = g.currentPeek();
      return $ === "{" ? J === "%" ? !1 : K : $ === "@" || !$ ? J === "%" ? !0 : K : $ === "%" ? (g.peek(), E(K, "%", !0)) : $ === "|" ? J === "%" || C ? !0 : !(J === an || J === at) : $ === an ? (g.peek(), E(!0, an, C)) : $ === at ? (g.peek(), E(!0, at, C)) : !0;
    }, H = E();
    return h && g.resetPeek(), H;
  }
  function me(g, h) {
    const E = g.currentChar();
    return E === yn ? yn : h(E) ? (g.next(), E) : null;
  }
  function qe(g) {
    const h = g.charCodeAt(0);
    return h >= 97 && h <= 122 || // a-z
    h >= 65 && h <= 90 || // A-Z
    h >= 48 && h <= 57 || // 0-9
    h === 95 || // _
    h === 36;
  }
  function zt(g) {
    return me(g, qe);
  }
  function Me(g) {
    const h = g.charCodeAt(0);
    return h >= 97 && h <= 122 || // a-z
    h >= 65 && h <= 90 || // A-Z
    h >= 48 && h <= 57 || // 0-9
    h === 95 || // _
    h === 36 || // $
    h === 45;
  }
  function Pe(g) {
    return me(g, Me);
  }
  function xe(g) {
    const h = g.charCodeAt(0);
    return h >= 48 && h <= 57;
  }
  function gt(g) {
    return me(g, xe);
  }
  function ye(g) {
    const h = g.charCodeAt(0);
    return h >= 48 && h <= 57 || // 0-9
    h >= 65 && h <= 70 || // A-F
    h >= 97 && h <= 102;
  }
  function Be(g) {
    return me(g, ye);
  }
  function Ye(g) {
    let h = "", E = "";
    for (; h = gt(g); )
      E += h;
    return E;
  }
  function Xe(g) {
    y(g);
    const h = g.currentChar();
    return h !== "%" && d(le.EXPECTED_TOKEN, a(), 0, h), g.next(), "%";
  }
  function Zt(g) {
    let h = "";
    for (; ; ) {
      const E = g.currentChar();
      if (E === "{" || E === "}" || E === "@" || E === "|" || !E)
        break;
      if (E === "%")
        if (Y(g))
          h += E, g.next();
        else
          break;
      else if (E === an || E === at)
        if (Y(g))
          h += E, g.next();
        else {
          if (te(g))
            break;
          h += E, g.next();
        }
      else
        h += E, g.next();
    }
    return h;
  }
  function fn(g) {
    y(g);
    let h = "", E = "";
    for (; h = Pe(g); )
      E += h;
    return g.currentChar() === yn && d(le.UNTERMINATED_CLOSING_BRACE, a(), 0), E;
  }
  function nt(g) {
    y(g);
    let h = "";
    return g.currentChar() === "-" ? (g.next(), h += `-${Ye(g)}`) : h += Ye(g), g.currentChar() === yn && d(le.UNTERMINATED_CLOSING_BRACE, a(), 0), h;
  }
  function en(g) {
    return g !== lu && g !== at;
  }
  function tn(g) {
    y(g), f(g, "'");
    let h = "", E = "";
    for (; h = me(g, en); )
      h === "\\" ? E += _n(g) : E += h;
    const H = g.currentChar();
    return H === at || H === yn ? (d(le.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, a(), 0), H === at && (g.next(), f(g, "'")), E) : (f(g, "'"), E);
  }
  function _n(g) {
    const h = g.currentChar();
    switch (h) {
      case "\\":
      case "'":
        return g.next(), `\\${h}`;
      case "u":
        return jt(g, h, 4);
      case "U":
        return jt(g, h, 6);
      default:
        return d(le.UNKNOWN_ESCAPE_SEQUENCE, a(), 0, h), "";
    }
  }
  function jt(g, h, E) {
    f(g, h);
    let H = "";
    for (let K = 0; K < E; K++) {
      const J = Be(g);
      if (!J) {
        d(le.INVALID_UNICODE_ESCAPE_SEQUENCE, a(), 0, `\\${h}${H}${g.currentChar()}`);
        break;
      }
      H += J;
    }
    return `\\${h}${H}`;
  }
  function Nn(g) {
    return g !== "{" && g !== "}" && g !== an && g !== at;
  }
  function b(g) {
    y(g);
    let h = "", E = "";
    for (; h = me(g, Nn); )
      E += h;
    return E;
  }
  function k(g) {
    let h = "", E = "";
    for (; h = zt(g); )
      E += h;
    return E;
  }
  function R(g) {
    const h = (E) => {
      const H = g.currentChar();
      return H === "{" || H === "%" || H === "@" || H === "|" || H === "(" || H === ")" || !H || H === an ? E : (E += H, g.next(), h(E));
    };
    return h("");
  }
  function U(g) {
    y(g);
    const h = f(
      g,
      "|"
      /* TokenChars.Pipe */
    );
    return y(g), h;
  }
  function V(g, h) {
    let E = null;
    switch (g.currentChar()) {
      case "{":
        return h.braceNest >= 1 && d(le.NOT_ALLOW_NEST_PLACEHOLDER, a(), 0), g.next(), E = p(
          h,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), y(g), h.braceNest++, E;
      case "}":
        return h.braceNest > 0 && h.currentType === 2 && d(le.EMPTY_PLACEHOLDER, a(), 0), g.next(), E = p(
          h,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), h.braceNest--, h.braceNest > 0 && y(g), h.inLinked && h.braceNest === 0 && (h.inLinked = !1), E;
      case "@":
        return h.braceNest > 0 && d(le.UNTERMINATED_CLOSING_BRACE, a(), 0), E = W(g, h) || m(h), h.braceNest = 0, E;
      default: {
        let K = !0, J = !0, C = !0;
        if (te(g))
          return h.braceNest > 0 && d(le.UNTERMINATED_CLOSING_BRACE, a(), 0), E = p(h, 1, U(g)), h.braceNest = 0, h.inLinked = !1, E;
        if (h.braceNest > 0 && (h.currentType === 5 || h.currentType === 6 || h.currentType === 7))
          return d(le.UNTERMINATED_CLOSING_BRACE, a(), 0), h.braceNest = 0, Z(g, h);
        if (K = j(g, h))
          return E = p(h, 5, fn(g)), y(g), E;
        if (J = S(g, h))
          return E = p(h, 6, nt(g)), y(g), E;
        if (C = T(g, h))
          return E = p(h, 7, tn(g)), y(g), E;
        if (!K && !J && !C)
          return E = p(h, 13, b(g)), d(le.INVALID_TOKEN_IN_PLACEHOLDER, a(), 0, E.value), y(g), E;
        break;
      }
    }
    return E;
  }
  function W(g, h) {
    const { currentType: E } = h;
    let H = null;
    const K = g.currentChar();
    switch ((E === 8 || E === 9 || E === 12 || E === 10) && (K === at || K === an) && d(le.INVALID_LINKED_FORMAT, a(), 0), K) {
      case "@":
        return g.next(), H = p(
          h,
          8,
          "@"
          /* TokenChars.LinkedAlias */
        ), h.inLinked = !0, H;
      case ".":
        return y(g), g.next(), p(
          h,
          9,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return y(g), g.next(), p(
          h,
          10,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return te(g) ? (H = p(h, 1, U(g)), h.braceNest = 0, h.inLinked = !1, H) : z(g, h) || N(g, h) ? (y(g), W(g, h)) : O(g, h) ? (y(g), p(h, 12, k(g))) : F(g, h) ? (y(g), K === "{" ? V(g, h) || H : p(h, 11, R(g))) : (E === 8 && d(le.INVALID_LINKED_FORMAT, a(), 0), h.braceNest = 0, h.inLinked = !1, Z(g, h));
    }
  }
  function Z(g, h) {
    let E = {
      type: 14
      /* TokenTypes.EOF */
    };
    if (h.braceNest > 0)
      return V(g, h) || m(h);
    if (h.inLinked)
      return W(g, h) || m(h);
    switch (g.currentChar()) {
      case "{":
        return V(g, h) || m(h);
      case "}":
        return d(le.UNBALANCED_CLOSING_BRACE, a(), 0), g.next(), p(
          h,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return W(g, h) || m(h);
      default: {
        if (te(g))
          return E = p(h, 1, U(g)), h.braceNest = 0, h.inLinked = !1, E;
        const { isModulo: K, hasSpace: J } = he(g);
        if (K)
          return J ? p(h, 0, Zt(g)) : p(h, 4, Xe(g));
        if (Y(g))
          return p(h, 0, Zt(g));
        break;
      }
    }
    return E;
  }
  function G() {
    const { currentType: g, offset: h, startLoc: E, endLoc: H } = l;
    return l.lastType = g, l.lastOffset = h, l.lastStartLoc = E, l.lastEndLoc = H, l.offset = o(), l.startLoc = a(), r.currentChar() === yn ? p(
      l,
      14
      /* TokenTypes.EOF */
    ) : Z(r, l);
  }
  return {
    nextToken: G,
    currentOffset: o,
    currentPosition: a,
    context: c
  };
}
const Sb = "parser", Eb = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function Pb(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const r = parseInt(t || n, 16);
      return r <= 55295 || r >= 57344 ? String.fromCodePoint(r) : "�";
    }
  }
}
function Tb(e = {}) {
  const t = e.location !== !1, { onError: n, onWarn: r } = e;
  function o(j, S, T, z, ...O) {
    const N = j.currentPosition();
    if (N.offset += z, N.column += z, n) {
      const F = t ? ba(T, N) : null, te = Lr(S, F, {
        domain: Sb,
        args: O
      });
      n(te);
    }
  }
  function a(j, S, T, z, ...O) {
    const N = j.currentPosition();
    if (N.offset += z, N.column += z, r) {
      const F = t ? ba(T, N) : null;
      r(gb(S, F, O));
    }
  }
  function i(j, S, T) {
    const z = { type: j };
    return t && (z.start = S, z.end = S, z.loc = { start: T, end: T }), z;
  }
  function s(j, S, T, z) {
    t && (j.end = S, j.loc && (j.loc.end = T));
  }
  function l(j, S) {
    const T = j.context(), z = i(3, T.offset, T.startLoc);
    return z.value = S, s(z, j.currentOffset(), j.currentPosition()), z;
  }
  function c(j, S) {
    const T = j.context(), { lastOffset: z, lastStartLoc: O } = T, N = i(5, z, O);
    return N.index = parseInt(S, 10), j.nextToken(), s(N, j.currentOffset(), j.currentPosition()), N;
  }
  function u(j, S, T) {
    const z = j.context(), { lastOffset: O, lastStartLoc: N } = z, F = i(4, O, N);
    return F.key = S, T === !0 && (F.modulo = !0), j.nextToken(), s(F, j.currentOffset(), j.currentPosition()), F;
  }
  function d(j, S) {
    const T = j.context(), { lastOffset: z, lastStartLoc: O } = T, N = i(9, z, O);
    return N.value = S.replace(Eb, Pb), j.nextToken(), s(N, j.currentOffset(), j.currentPosition()), N;
  }
  function p(j) {
    const S = j.nextToken(), T = j.context(), { lastOffset: z, lastStartLoc: O } = T, N = i(8, z, O);
    return S.type !== 12 ? (o(j, le.UNEXPECTED_EMPTY_LINKED_MODIFIER, T.lastStartLoc, 0), N.value = "", s(N, z, O), {
      nextConsumeToken: S,
      node: N
    }) : (S.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, Mt(S)), N.value = S.value || "", s(N, j.currentOffset(), j.currentPosition()), {
      node: N
    });
  }
  function m(j, S) {
    const T = j.context(), z = i(7, T.offset, T.startLoc);
    return z.value = S, s(z, j.currentOffset(), j.currentPosition()), z;
  }
  function f(j) {
    const S = j.context(), T = i(6, S.offset, S.startLoc);
    let z = j.nextToken();
    if (z.type === 9) {
      const O = p(j);
      T.modifier = O.node, z = O.nextConsumeToken || j.nextToken();
    }
    switch (z.type !== 10 && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(z)), z = j.nextToken(), z.type === 2 && (z = j.nextToken()), z.type) {
      case 11:
        z.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(z)), T.key = m(j, z.value || "");
        break;
      case 5:
        z.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(z)), T.key = u(j, z.value || "");
        break;
      case 6:
        z.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(z)), T.key = c(j, z.value || "");
        break;
      case 7:
        z.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(z)), T.key = d(j, z.value || "");
        break;
      default: {
        o(j, le.UNEXPECTED_EMPTY_LINKED_KEY, S.lastStartLoc, 0);
        const O = j.context(), N = i(7, O.offset, O.startLoc);
        return N.value = "", s(N, O.offset, O.startLoc), T.key = N, s(T, O.offset, O.startLoc), {
          nextConsumeToken: z,
          node: T
        };
      }
    }
    return s(T, j.currentOffset(), j.currentPosition()), {
      node: T
    };
  }
  function _(j) {
    const S = j.context(), T = S.currentType === 1 ? j.currentOffset() : S.offset, z = S.currentType === 1 ? S.endLoc : S.startLoc, O = i(2, T, z);
    O.items = [];
    let N = null, F = null;
    do {
      const Y = N || j.nextToken();
      switch (N = null, Y.type) {
        case 0:
          Y.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(Y)), O.items.push(l(j, Y.value || ""));
          break;
        case 6:
          Y.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(Y)), O.items.push(c(j, Y.value || ""));
          break;
        case 4:
          F = !0;
          break;
        case 5:
          Y.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(Y)), O.items.push(u(j, Y.value || "", !!F)), F && (a(j, fl.USE_MODULO_SYNTAX, S.lastStartLoc, 0, Mt(Y)), F = null);
          break;
        case 7:
          Y.value == null && o(j, le.UNEXPECTED_LEXICAL_ANALYSIS, S.lastStartLoc, 0, Mt(Y)), O.items.push(d(j, Y.value || ""));
          break;
        case 8: {
          const me = f(j);
          O.items.push(me.node), N = me.nextConsumeToken || null;
          break;
        }
      }
    } while (S.currentType !== 14 && S.currentType !== 1);
    const te = S.currentType === 1 ? S.lastOffset : j.currentOffset(), he = S.currentType === 1 ? S.lastEndLoc : j.currentPosition();
    return s(O, te, he), O;
  }
  function y(j, S, T, z) {
    const O = j.context();
    let N = z.items.length === 0;
    const F = i(1, S, T);
    F.cases = [], F.cases.push(z);
    do {
      const te = _(j);
      N || (N = te.items.length === 0), F.cases.push(te);
    } while (O.currentType !== 14);
    return N && o(j, le.MUST_HAVE_MESSAGES_IN_PLURAL, T, 0), s(F, j.currentOffset(), j.currentPosition()), F;
  }
  function A(j) {
    const S = j.context(), { offset: T, startLoc: z } = S, O = _(j);
    return S.currentType === 14 ? O : y(j, T, z, O);
  }
  function I(j) {
    const S = kb(j, Xd({}, e)), T = S.context(), z = i(0, T.offset, T.startLoc);
    return t && z.loc && (z.loc.source = j), z.body = A(S), e.onCacheKey && (z.cacheKey = e.onCacheKey(j)), T.currentType !== 14 && o(S, le.UNEXPECTED_LEXICAL_ANALYSIS, T.lastStartLoc, 0, j[T.offset] || ""), s(z, S.currentOffset(), S.currentPosition()), z;
  }
  return { parse: I };
}
function Mt(e) {
  if (e.type === 14)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function Cb(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (a) => (n.helpers.add(a), a) };
}
function cu(e, t) {
  for (let n = 0; n < e.length; n++)
    _l(e[n], t);
}
function _l(e, t) {
  switch (e.type) {
    case 1:
      cu(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      cu(e.items, t);
      break;
    case 6: {
      _l(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function Ab(e, t = {}) {
  const n = Cb(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && _l(e.body, n);
  const r = n.context();
  e.helpers = Array.from(r.helpers);
}
function Ob(e) {
  const t = e.body;
  return t.type === 2 ? uu(t) : t.cases.forEach((n) => uu(n)), e;
}
function uu(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const r = e.items[n];
      if (!(r.type === 3 || r.type === 9) || r.value == null)
        break;
      t.push(r.value);
    }
    if (t.length === e.items.length) {
      e.static = Zd(t);
      for (let n = 0; n < e.items.length; n++) {
        const r = e.items[n];
        (r.type === 3 || r.type === 9) && delete r.value;
      }
    }
  }
}
const Ib = "minifier";
function br(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      br(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let r = 0; r < n.length; r++)
        br(n[r]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let r = 0; r < n.length; r++)
        br(n[r]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      br(t.key), t.k = t.key, delete t.key, t.modifier && (br(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      throw Lr(le.UNHANDLED_MINIFIER_NODE_TYPE, null, {
        domain: Ib,
        args: [e.type]
      });
  }
  delete e.type;
}
const Lb = "parser";
function Nb(e, t) {
  const { filename: n, breakLineCode: r, needIndent: o } = t, a = t.location !== !1, i = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: r,
    needIndent: o,
    indentLevel: 0
  };
  a && e.loc && (i.source = e.loc.source);
  const s = () => i;
  function l(_, y) {
    i.code += _;
  }
  function c(_, y = !0) {
    const A = y ? r : "";
    l(o ? A + "  ".repeat(_) : A);
  }
  function u(_ = !0) {
    const y = ++i.indentLevel;
    _ && c(y);
  }
  function d(_ = !0) {
    const y = --i.indentLevel;
    _ && c(y);
  }
  function p() {
    c(i.indentLevel);
  }
  return {
    context: s,
    push: l,
    indent: u,
    deindent: d,
    newline: p,
    helper: (_) => `_${_}`,
    needIndent: () => i.needIndent
  };
}
function Mb(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), Pr(e, t.key), t.modifier ? (e.push(", "), Pr(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function Rb(e, t) {
  const { helper: n, needIndent: r } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(r());
  const o = t.items.length;
  for (let a = 0; a < o && (Pr(e, t.items[a]), a !== o - 1); a++)
    e.push(", ");
  e.deindent(r()), e.push("])");
}
function $b(e, t) {
  const { helper: n, needIndent: r } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(r());
    const o = t.cases.length;
    for (let a = 0; a < o && (Pr(e, t.cases[a]), a !== o - 1); a++)
      e.push(", ");
    e.deindent(r()), e.push("])");
  }
}
function Db(e, t) {
  t.body ? Pr(e, t.body) : e.push("null");
}
function Pr(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      Db(e, t);
      break;
    case 1:
      $b(e, t);
      break;
    case 2:
      Rb(e, t);
      break;
    case 6:
      Mb(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      throw Lr(le.UNHANDLED_CODEGEN_NODE_TYPE, null, {
        domain: Lb,
        args: [t.type]
      });
  }
}
const Fb = (e, t = {}) => {
  const n = su(t.mode) ? t.mode : "normal", r = su(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const o = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, a = t.needIndent ? t.needIndent : n !== "arrow", i = e.helpers || [], s = Nb(e, {
    filename: r,
    breakLineCode: o,
    needIndent: a
  });
  s.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), s.indent(a), i.length > 0 && (s.push(`const { ${Zd(i.map((u) => `${u}: _${u}`), ", ")} } = ctx`), s.newline()), s.push("return "), Pr(s, e), s.deindent(a), s.push("}"), delete e.helpers;
  const { code: l, map: c } = s.context();
  return {
    ast: e,
    code: l,
    map: c ? c.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function Ub(e, t = {}) {
  const n = Xd({}, t), r = !!n.jit, o = !!n.minify, a = n.optimize == null ? !0 : n.optimize, s = Tb(n).parse(e);
  return r ? (a && Ob(s), o && br(s), { ast: s, code: "" }) : (Ab(s, n), Fb(s, n));
}
/*!
  * core-base v9.14.3
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
function Vb() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (pl().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const On = [];
On[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
On[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
On[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
On[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
On[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
On[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
On[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const qb = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Hb(e) {
  return qb.test(e);
}
function Bb(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Jb(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Wb(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Hb(t) ? Bb(t) : "*" + t;
}
function Yb(e) {
  const t = [];
  let n = -1, r = 0, o = 0, a, i, s, l, c, u, d;
  const p = [];
  p[
    0
    /* Actions.APPEND */
  ] = () => {
    i === void 0 ? i = s : i += s;
  }, p[
    1
    /* Actions.PUSH */
  ] = () => {
    i !== void 0 && (t.push(i), i = void 0);
  }, p[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    p[
      0
      /* Actions.APPEND */
    ](), o++;
  }, p[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (o > 0)
      o--, r = 4, p[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (o = 0, i === void 0 || (i = Wb(i), i === !1))
        return !1;
      p[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function m() {
    const f = e[n + 1];
    if (r === 5 && f === "'" || r === 6 && f === '"')
      return n++, s = "\\" + f, p[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; r !== null; )
    if (n++, a = e[n], !(a === "\\" && m())) {
      if (l = Jb(a), d = On[r], c = d[l] || d.l || 8, c === 8 || (r = c[0], c[1] !== void 0 && (u = p[c[1]], u && (s = a, u() === !1))))
        return;
      if (r === 7)
        return t;
    }
}
const mu = /* @__PURE__ */ new Map();
function Gb(e, t) {
  return ke(e) ? e[t] : null;
}
function Kb(e, t) {
  if (!ke(e))
    return null;
  let n = mu.get(t);
  if (n || (n = Yb(t), n && mu.set(t, n)), !n)
    return null;
  const r = n.length;
  let o = e, a = 0;
  for (; a < r; ) {
    const i = o[n[a]];
    if (i === void 0 || Ue(o))
      return null;
    o = i, a++;
  }
  return o;
}
const Qb = (e) => e, Xb = (e) => "", Zb = "text", ez = (e) => e.length === 0 ? "" : ub(e), tz = cb;
function du(e, t) {
  return e = Math.abs(e), t === 2 ? e ? e > 1 ? 1 : 0 : 1 : e ? Math.min(e, 2) : 0;
}
function nz(e) {
  const t = He(e.pluralIndex) ? e.pluralIndex : -1;
  return e.named && (He(e.named.count) || He(e.named.n)) ? He(e.named.count) ? e.named.count : He(e.named.n) ? e.named.n : t : t;
}
function rz(e, t) {
  t.count || (t.count = e), t.n || (t.n = e);
}
function oz(e = {}) {
  const t = e.locale, n = nz(e), r = ke(e.pluralRules) && ne(t) && Ue(e.pluralRules[t]) ? e.pluralRules[t] : du, o = ke(e.pluralRules) && ne(t) && Ue(e.pluralRules[t]) ? du : void 0, a = (A) => A[r(n, A.length, o)], i = e.list || [], s = (A) => i[A], l = e.named || Ae();
  He(e.pluralIndex) && rz(n, l);
  const c = (A) => l[A];
  function u(A) {
    const I = Ue(e.messages) ? e.messages(A) : ke(e.messages) ? e.messages[A] : !1;
    return I || (e.parent ? e.parent.message(A) : Xb);
  }
  const d = (A) => e.modifiers ? e.modifiers[A] : Qb, p = ze(e.processor) && Ue(e.processor.normalize) ? e.processor.normalize : ez, m = ze(e.processor) && Ue(e.processor.interpolate) ? e.processor.interpolate : tz, f = ze(e.processor) && ne(e.processor.type) ? e.processor.type : Zb, y = {
    list: s,
    named: c,
    plural: a,
    linked: (A, ...I) => {
      const [j, S] = I;
      let T = "text", z = "";
      I.length === 1 ? ke(j) ? (z = j.modifier || z, T = j.type || T) : ne(j) && (z = j || z) : I.length === 2 && (ne(j) && (z = j || z), ne(S) && (T = S || T));
      const O = u(A)(y), N = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        T === "vnode" && We(O) && z ? O[0] : O
      );
      return z ? d(z)(N, T) : N;
    },
    message: u,
    type: f,
    interpolate: m,
    normalize: p,
    values: tt(Ae(), i, l)
  };
  return y;
}
let go = null;
function az(e) {
  go = e;
}
function iz(e, t, n) {
  go && go.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const sz = /* @__PURE__ */ lz(
  "function:translate"
  /* IntlifyDevToolsHooks.FunctionTranslate */
);
function lz(e) {
  return (t) => go && go.emit(e, t);
}
const cz = fl.__EXTEND_POINT__, qn = Qa(cz), uz = {
  // 2
  FALLBACK_TO_TRANSLATE: qn(),
  // 3
  CANNOT_FORMAT_NUMBER: qn(),
  // 4
  FALLBACK_TO_NUMBER_FORMAT: qn(),
  // 5
  CANNOT_FORMAT_DATE: qn(),
  // 6
  FALLBACK_TO_DATE_FORMAT: qn(),
  // 7
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: qn(),
  // 8
  __EXTEND_POINT__: qn()
  // 9
}, ep = le.__EXTEND_POINT__, Hn = Qa(ep), Yt = {
  INVALID_ARGUMENT: ep,
  // 17
  INVALID_DATE_ARGUMENT: Hn(),
  // 18
  INVALID_ISO_DATE_ARGUMENT: Hn(),
  // 19
  NOT_SUPPORT_NON_STRING_MESSAGE: Hn(),
  // 20
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: Hn(),
  // 21
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: Hn(),
  // 22
  NOT_SUPPORT_LOCALE_TYPE: Hn(),
  // 23
  __EXTEND_POINT__: Hn()
  // 24
};
function ln(e) {
  return Lr(e, null, void 0);
}
function gl(e, t) {
  return t.locale != null ? pu(t.locale) : pu(e.locale);
}
let Ni;
function pu(e) {
  if (ne(e))
    return e;
  if (Ue(e)) {
    if (e.resolvedOnce && Ni != null)
      return Ni;
    if (e.constructor.name === "Function") {
      const t = e();
      if (lb(t))
        throw ln(Yt.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Ni = t;
    } else
      throw ln(Yt.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw ln(Yt.NOT_SUPPORT_LOCALE_TYPE);
}
function mz(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...We(t) ? t : ke(t) ? Object.keys(t) : ne(t) ? [t] : [n]
  ])];
}
function tp(e, t, n) {
  const r = ne(n) ? n : za, o = e;
  o.__localeChainCache || (o.__localeChainCache = /* @__PURE__ */ new Map());
  let a = o.__localeChainCache.get(r);
  if (!a) {
    a = [];
    let i = [n];
    for (; We(i); )
      i = fu(a, i, t);
    const s = We(t) || !ze(t) ? t : t.default ? t.default : null;
    i = ne(s) ? [s] : s, We(i) && fu(a, i, !1), o.__localeChainCache.set(r, a);
  }
  return a;
}
function fu(e, t, n) {
  let r = !0;
  for (let o = 0; o < t.length && Re(r); o++) {
    const a = t[o];
    ne(a) && (r = dz(e, t[o], n));
  }
  return r;
}
function dz(e, t, n) {
  let r;
  const o = t.split("-");
  do {
    const a = o.join("-");
    r = pz(e, a, n), o.splice(-1, 1);
  } while (o.length && r === !0);
  return r;
}
function pz(e, t, n) {
  let r = !1;
  if (!e.includes(t) && (r = !0, t)) {
    r = t[t.length - 1] !== "!";
    const o = t.replace(/!/g, "");
    e.push(o), (We(n) || ze(n)) && n[o] && (r = n[o]);
  }
  return r;
}
const fz = "9.14.3", Xa = -1, za = "en-US", _u = "", gu = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function _z() {
  return {
    upper: (e, t) => t === "text" && ne(e) ? e.toUpperCase() : t === "vnode" && ke(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && ne(e) ? e.toLowerCase() : t === "vnode" && ke(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && ne(e) ? gu(e) : t === "vnode" && ke(e) && "__v_isVNode" in e ? gu(e.children) : e
  };
}
let np;
function gz(e) {
  np = e;
}
let rp;
function hz(e) {
  rp = e;
}
let op;
function vz(e) {
  op = e;
}
let ap = null;
const yz = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ap = e;
}, bz = /* @__NO_SIDE_EFFECTS__ */ () => ap;
let ip = null;
const hu = (e) => {
  ip = e;
}, zz = () => ip;
let vu = 0;
function jz(e = {}) {
  const t = Ue(e.onWarn) ? e.onWarn : mb, n = ne(e.version) ? e.version : fz, r = ne(e.locale) || Ue(e.locale) ? e.locale : za, o = Ue(r) ? za : r, a = We(e.fallbackLocale) || ze(e.fallbackLocale) || ne(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : o, i = ze(e.messages) ? e.messages : Mi(o), s = ze(e.datetimeFormats) ? e.datetimeFormats : Mi(o), l = ze(e.numberFormats) ? e.numberFormats : Mi(o), c = tt(Ae(), e.modifiers, _z()), u = e.pluralRules || Ae(), d = Ue(e.missing) ? e.missing : null, p = Re(e.missingWarn) || ya(e.missingWarn) ? e.missingWarn : !0, m = Re(e.fallbackWarn) || ya(e.fallbackWarn) ? e.fallbackWarn : !0, f = !!e.fallbackFormat, _ = !!e.unresolving, y = Ue(e.postTranslation) ? e.postTranslation : null, A = ze(e.processor) ? e.processor : null, I = Re(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, j = !!e.escapeParameter, S = Ue(e.messageCompiler) ? e.messageCompiler : np, T = Ue(e.messageResolver) ? e.messageResolver : rp || Gb, z = Ue(e.localeFallbacker) ? e.localeFallbacker : op || mz, O = ke(e.fallbackContext) ? e.fallbackContext : void 0, N = e, F = ke(N.__datetimeFormatters) ? N.__datetimeFormatters : /* @__PURE__ */ new Map(), te = ke(N.__numberFormatters) ? N.__numberFormatters : /* @__PURE__ */ new Map(), he = ke(N.__meta) ? N.__meta : {};
  vu++;
  const Y = {
    version: n,
    cid: vu,
    locale: r,
    fallbackLocale: a,
    messages: i,
    modifiers: c,
    pluralRules: u,
    missing: d,
    missingWarn: p,
    fallbackWarn: m,
    fallbackFormat: f,
    unresolving: _,
    postTranslation: y,
    processor: A,
    warnHtmlMessage: I,
    escapeParameter: j,
    messageCompiler: S,
    messageResolver: T,
    localeFallbacker: z,
    fallbackContext: O,
    onWarn: t,
    __meta: he
  };
  return Y.datetimeFormats = s, Y.numberFormats = l, Y.__datetimeFormatters = F, Y.__numberFormatters = te, __INTLIFY_PROD_DEVTOOLS__ && iz(Y, n, he), Y;
}
const Mi = (e) => ({ [e]: Ae() });
function hl(e, t, n, r, o) {
  const { missing: a, onWarn: i } = e;
  if (a !== null) {
    const s = a(e, n, t, o);
    return ne(s) ? s : t;
  } else
    return t;
}
function Hr(e, t, n) {
  const r = e;
  r.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function wz(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function xz(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let r = n + 1; r < t.length; r++)
    if (wz(e, t[r]))
      return !0;
  return !1;
}
function Ri(e) {
  return (n) => kz(n, e);
}
function kz(e, t) {
  const n = Ez(t);
  if (n == null)
    throw ho(
      0
      /* NodeTypes.Resource */
    );
  if (vl(n) === 1) {
    const a = Tz(n);
    return e.plural(a.reduce((i, s) => [
      ...i,
      yu(e, s)
    ], []));
  } else
    return yu(e, n);
}
const Sz = ["b", "body"];
function Ez(e) {
  return In(e, Sz);
}
const Pz = ["c", "cases"];
function Tz(e) {
  return In(e, Pz, []);
}
function yu(e, t) {
  const n = Az(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const r = Iz(t).reduce((o, a) => [...o, vs(e, a)], []);
    return e.normalize(r);
  }
}
const Cz = ["s", "static"];
function Az(e) {
  return In(e, Cz);
}
const Oz = ["i", "items"];
function Iz(e) {
  return In(e, Oz, []);
}
function vs(e, t) {
  const n = vl(t);
  switch (n) {
    case 3:
      return Ko(t, n);
    case 9:
      return Ko(t, n);
    case 4: {
      const r = t;
      if (Ft(r, "k") && r.k)
        return e.interpolate(e.named(r.k));
      if (Ft(r, "key") && r.key)
        return e.interpolate(e.named(r.key));
      throw ho(n);
    }
    case 5: {
      const r = t;
      if (Ft(r, "i") && He(r.i))
        return e.interpolate(e.list(r.i));
      if (Ft(r, "index") && He(r.index))
        return e.interpolate(e.list(r.index));
      throw ho(n);
    }
    case 6: {
      const r = t, o = Rz(r), a = Dz(r);
      return e.linked(vs(e, a), o ? vs(e, o) : void 0, e.type);
    }
    case 7:
      return Ko(t, n);
    case 8:
      return Ko(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const Lz = ["t", "type"];
function vl(e) {
  return In(e, Lz);
}
const Nz = ["v", "value"];
function Ko(e, t) {
  const n = In(e, Nz);
  if (n)
    return n;
  throw ho(t);
}
const Mz = ["m", "modifier"];
function Rz(e) {
  return In(e, Mz);
}
const $z = ["k", "key"];
function Dz(e) {
  const t = In(e, $z);
  if (t)
    return t;
  throw ho(
    6
    /* NodeTypes.Linked */
  );
}
function In(e, t, n) {
  for (let r = 0; r < t.length; r++) {
    const o = t[r];
    if (Ft(e, o) && e[o] != null)
      return e[o];
  }
  return n;
}
function ho(e) {
  return new Error(`unhandled node type: ${e}`);
}
const Fz = (e) => e;
let Qo = Ae();
function Tr(e) {
  return ke(e) && vl(e) === 0 && (Ft(e, "b") || Ft(e, "body"));
}
function Uz(e, t = {}) {
  let n = !1;
  const r = t.onError || vb;
  return t.onError = (o) => {
    n = !0, r(o);
  }, { ...Ub(e, t), detectError: n };
}
function Vz(e, t) {
  if (ne(e)) {
    Re(t.warnHtmlMessage) && t.warnHtmlMessage;
    const r = (t.onCacheKey || Fz)(e), o = Qo[r];
    if (o)
      return o;
    const { ast: a, detectError: i } = Uz(e, {
      ...t,
      location: !1,
      jit: !0
    }), s = Ri(a);
    return i ? s : Qo[r] = s;
  } else {
    const n = e.cacheKey;
    if (n) {
      const r = Qo[n];
      return r || (Qo[n] = Ri(e));
    } else
      return Ri(e);
  }
}
const bu = () => "", kt = (e) => Ue(e);
function zu(e, ...t) {
  const { fallbackFormat: n, postTranslation: r, unresolving: o, messageCompiler: a, fallbackLocale: i, messages: s } = e, [l, c] = ys(...t), u = Re(c.missingWarn) ? c.missingWarn : e.missingWarn, d = Re(c.fallbackWarn) ? c.fallbackWarn : e.fallbackWarn, p = Re(c.escapeParameter) ? c.escapeParameter : e.escapeParameter, m = !!c.resolvedMessage, f = ne(c.default) || Re(c.default) ? Re(c.default) ? a ? l : () => l : c.default : n ? a ? l : () => l : "", _ = n || f !== "", y = gl(e, c);
  p && qz(c);
  let [A, I, j] = m ? [
    l,
    y,
    s[y] || Ae()
  ] : sp(e, l, y, i, d, u), S = A, T = l;
  if (!m && !(ne(S) || Tr(S) || kt(S)) && _ && (S = f, T = S), !m && (!(ne(S) || Tr(S) || kt(S)) || !ne(I)))
    return o ? Xa : l;
  let z = !1;
  const O = () => {
    z = !0;
  }, N = kt(S) ? S : lp(e, l, I, S, T, O);
  if (z)
    return S;
  const F = Jz(e, I, j, c), te = oz(F), he = Hz(e, N, te), Y = r ? r(he, l) : he;
  if (__INTLIFY_PROD_DEVTOOLS__) {
    const me = {
      timestamp: Date.now(),
      key: ne(l) ? l : kt(S) ? S.key : "",
      locale: I || (kt(S) ? S.locale : ""),
      format: ne(S) ? S : kt(S) ? S.source : "",
      message: Y
    };
    me.meta = tt({}, e.__meta, /* @__PURE__ */ bz() || {}), sz(me);
  }
  return Y;
}
function qz(e) {
  We(e.list) ? e.list = e.list.map((t) => ne(t) ? iu(t) : t) : ke(e.named) && Object.keys(e.named).forEach((t) => {
    ne(e.named[t]) && (e.named[t] = iu(e.named[t]));
  });
}
function sp(e, t, n, r, o, a) {
  const { messages: i, onWarn: s, messageResolver: l, localeFallbacker: c } = e, u = c(e, r, n);
  let d = Ae(), p, m = null;
  const f = "translate";
  for (let _ = 0; _ < u.length && (p = u[_], d = i[p] || Ae(), (m = l(d, t)) === null && (m = d[t]), !(ne(m) || Tr(m) || kt(m))); _++)
    if (!xz(p, u)) {
      const y = hl(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        p,
        a,
        f
      );
      y !== t && (m = y);
    }
  return [m, p, d];
}
function lp(e, t, n, r, o, a) {
  const { messageCompiler: i, warnHtmlMessage: s } = e;
  if (kt(r)) {
    const c = r;
    return c.locale = c.locale || n, c.key = c.key || t, c;
  }
  if (i == null) {
    const c = () => r;
    return c.locale = n, c.key = t, c;
  }
  const l = i(r, Bz(e, n, o, r, s, a));
  return l.locale = n, l.key = t, l.source = r, l;
}
function Hz(e, t, n) {
  return t(n);
}
function ys(...e) {
  const [t, n, r] = e, o = Ae();
  if (!ne(t) && !He(t) && !kt(t) && !Tr(t))
    throw ln(Yt.INVALID_ARGUMENT);
  const a = He(t) ? String(t) : (kt(t), t);
  return He(n) ? o.plural = n : ne(n) ? o.default = n : ze(n) && !Ka(n) ? o.named = n : We(n) && (o.list = n), He(r) ? o.plural = r : ne(r) ? o.default = r : ze(r) && tt(o, r), [a, o];
}
function Bz(e, t, n, r, o, a) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: o,
    onError: (i) => {
      throw a && a(i), i;
    },
    onCacheKey: (i) => rb(t, n, i)
  };
}
function Jz(e, t, n, r) {
  const { modifiers: o, pluralRules: a, messageResolver: i, fallbackLocale: s, fallbackWarn: l, missingWarn: c, fallbackContext: u } = e, p = {
    locale: t,
    modifiers: o,
    pluralRules: a,
    messages: (m) => {
      let f = i(n, m);
      if (f == null && u) {
        const [, , _] = sp(u, m, t, s, l, c);
        f = i(_, m);
      }
      if (ne(f) || Tr(f)) {
        let _ = !1;
        const A = lp(e, m, t, f, m, () => {
          _ = !0;
        });
        return _ ? bu : A;
      } else return kt(f) ? f : bu;
    }
  };
  return e.processor && (p.processor = e.processor), r.list && (p.list = r.list), r.named && (p.named = r.named), He(r.plural) && (p.pluralIndex = r.plural), p;
}
function ju(e, ...t) {
  const { datetimeFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: i } = e, { __datetimeFormatters: s } = e, [l, c, u, d] = bs(...t), p = Re(u.missingWarn) ? u.missingWarn : e.missingWarn;
  Re(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn;
  const m = !!u.part, f = gl(e, u), _ = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    f
  );
  if (!ne(l) || l === "")
    return new Intl.DateTimeFormat(f, d).format(c);
  let y = {}, A, I = null;
  const j = "datetime format";
  for (let z = 0; z < _.length && (A = _[z], y = n[A] || {}, I = y[l], !ze(I)); z++)
    hl(e, l, A, p, j);
  if (!ze(I) || !ne(A))
    return r ? Xa : l;
  let S = `${A}__${l}`;
  Ka(d) || (S = `${S}__${JSON.stringify(d)}`);
  let T = s.get(S);
  return T || (T = new Intl.DateTimeFormat(A, tt({}, I, d)), s.set(S, T)), m ? T.formatToParts(c) : T.format(c);
}
const cp = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function bs(...e) {
  const [t, n, r, o] = e, a = Ae();
  let i = Ae(), s;
  if (ne(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw ln(Yt.INVALID_ISO_DATE_ARGUMENT);
    const c = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    s = new Date(c);
    try {
      s.toISOString();
    } catch {
      throw ln(Yt.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (ab(t)) {
    if (isNaN(t.getTime()))
      throw ln(Yt.INVALID_DATE_ARGUMENT);
    s = t;
  } else if (He(t))
    s = t;
  else
    throw ln(Yt.INVALID_ARGUMENT);
  return ne(n) ? a.key = n : ze(n) && Object.keys(n).forEach((l) => {
    cp.includes(l) ? i[l] = n[l] : a[l] = n[l];
  }), ne(r) ? a.locale = r : ze(r) && (i = r), ze(o) && (i = o), [a.key || "", s, a, i];
}
function wu(e, t, n) {
  const r = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    r.__datetimeFormatters.has(a) && r.__datetimeFormatters.delete(a);
  }
}
function xu(e, ...t) {
  const { numberFormats: n, unresolving: r, fallbackLocale: o, onWarn: a, localeFallbacker: i } = e, { __numberFormatters: s } = e, [l, c, u, d] = zs(...t), p = Re(u.missingWarn) ? u.missingWarn : e.missingWarn;
  Re(u.fallbackWarn) ? u.fallbackWarn : e.fallbackWarn;
  const m = !!u.part, f = gl(e, u), _ = i(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    o,
    f
  );
  if (!ne(l) || l === "")
    return new Intl.NumberFormat(f, d).format(c);
  let y = {}, A, I = null;
  const j = "number format";
  for (let z = 0; z < _.length && (A = _[z], y = n[A] || {}, I = y[l], !ze(I)); z++)
    hl(e, l, A, p, j);
  if (!ze(I) || !ne(A))
    return r ? Xa : l;
  let S = `${A}__${l}`;
  Ka(d) || (S = `${S}__${JSON.stringify(d)}`);
  let T = s.get(S);
  return T || (T = new Intl.NumberFormat(A, tt({}, I, d)), s.set(S, T)), m ? T.formatToParts(c) : T.format(c);
}
const up = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function zs(...e) {
  const [t, n, r, o] = e, a = Ae();
  let i = Ae();
  if (!He(t))
    throw ln(Yt.INVALID_ARGUMENT);
  const s = t;
  return ne(n) ? a.key = n : ze(n) && Object.keys(n).forEach((l) => {
    up.includes(l) ? i[l] = n[l] : a[l] = n[l];
  }), ne(r) ? a.locale = r : ze(r) && (i = r), ze(o) && (i = o), [a.key || "", s, a, i];
}
function ku(e, t, n) {
  const r = e;
  for (const o in n) {
    const a = `${t}__${o}`;
    r.__numberFormatters.has(a) && r.__numberFormatters.delete(a);
  }
}
Vb();
/*!
  * vue-i18n v9.14.3
  * (c) 2025 kazuya kawaguchi
  * Released under the MIT License.
  */
const Wz = "9.14.3";
function Yz() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (pl().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Gz = uz.__EXTEND_POINT__, sn = Qa(Gz);
sn(), sn(), sn(), sn(), sn(), sn(), sn(), sn(), sn();
const mp = Yt.__EXTEND_POINT__, ut = Qa(mp), Ot = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: mp,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: ut(),
  // 25
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: ut(),
  // 26
  NOT_INSTALLED: ut(),
  // 27
  NOT_AVAILABLE_IN_LEGACY_MODE: ut(),
  // 28
  // directive module errors
  REQUIRED_VALUE: ut(),
  // 29
  INVALID_VALUE: ut(),
  // 30
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: ut(),
  // 31
  NOT_INSTALLED_WITH_PROVIDE: ut(),
  // 32
  // unexpected error
  UNEXPECTED_ERROR: ut(),
  // 33
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: ut(),
  // 34
  // bridge support vue 2.x only
  BRIDGE_SUPPORT_VUE_2_ONLY: ut(),
  // 35
  // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
  MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: ut(),
  // 36
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: ut(),
  // 37
  // for enhancement
  __EXTEND_POINT__: ut()
  // 38
};
function Vt(e, ...t) {
  return Lr(e, null, void 0);
}
const js = /* @__PURE__ */ An("__translateVNode"), ws = /* @__PURE__ */ An("__datetimeParts"), xs = /* @__PURE__ */ An("__numberParts"), Kz = An("__setPluralRules"), Qz = /* @__PURE__ */ An("__injectWithOption"), ks = /* @__PURE__ */ An("__dispose");
function vo(e) {
  if (!ke(e))
    return e;
  for (const t in e)
    if (Ft(e, t))
      if (!t.includes("."))
        ke(e[t]) && vo(e[t]);
      else {
        const n = t.split("."), r = n.length - 1;
        let o = e, a = !1;
        for (let i = 0; i < r; i++) {
          if (n[i] === "__proto__")
            throw new Error(`unsafe key: ${n[i]}`);
          if (n[i] in o || (o[n[i]] = Ae()), !ke(o[n[i]])) {
            a = !0;
            break;
          }
          o = o[n[i]];
        }
        a || (o[n[r]] = e[t], delete e[t]), ke(o[n[r]]) && vo(o[n[r]]);
      }
  return e;
}
function dp(e, t) {
  const { messages: n, __i18n: r, messageResolver: o, flatJson: a } = t, i = ze(n) ? n : We(r) ? Ae() : { [e]: Ae() };
  if (We(r) && r.forEach((s) => {
    if ("locale" in s && "resource" in s) {
      const { locale: l, resource: c } = s;
      l ? (i[l] = i[l] || Ae(), ia(c, i[l])) : ia(c, i);
    } else
      ne(s) && ia(JSON.parse(s), i);
  }), o == null && a)
    for (const s in i)
      Ft(i, s) && vo(i[s]);
  return i;
}
function pp(e) {
  return e.type;
}
function Xz(e, t, n) {
  let r = ke(t.messages) ? t.messages : Ae();
  "__i18nGlobal" in n && (r = dp(e.locale.value, {
    messages: r,
    __i18n: n.__i18nGlobal
  }));
  const o = Object.keys(r);
  o.length && o.forEach((a) => {
    e.mergeLocaleMessage(a, r[a]);
  });
  {
    if (ke(t.datetimeFormats)) {
      const a = Object.keys(t.datetimeFormats);
      a.length && a.forEach((i) => {
        e.mergeDateTimeFormat(i, t.datetimeFormats[i]);
      });
    }
    if (ke(t.numberFormats)) {
      const a = Object.keys(t.numberFormats);
      a.length && a.forEach((i) => {
        e.mergeNumberFormat(i, t.numberFormats[i]);
      });
    }
  }
}
function Su(e) {
  return B(Po, null, e, 0);
}
const Eu = "__INTLIFY_META__", Pu = () => [], Zz = () => !1;
let Tu = 0;
function Cu(e) {
  return (t, n, r, o) => e(n, r, ur() || void 0, o);
}
const e0 = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = ur();
  let t = null;
  return e && (t = pp(e)[Eu]) ? { [Eu]: t } : null;
};
function fp(e = {}, t) {
  const { __root: n, __injectWithOption: r } = e, o = n === void 0, a = e.flatJson, i = va ? ue : Jg, s = !!e.translateExistCompatible;
  let l = Re(e.inheritLocale) ? e.inheritLocale : !0;
  const c = i(
    // prettier-ignore
    n && l ? n.locale.value : ne(e.locale) ? e.locale : za
  ), u = i(
    // prettier-ignore
    n && l ? n.fallbackLocale.value : ne(e.fallbackLocale) || We(e.fallbackLocale) || ze(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : c.value
  ), d = i(dp(c.value, e)), p = i(ze(e.datetimeFormats) ? e.datetimeFormats : { [c.value]: {} }), m = i(ze(e.numberFormats) ? e.numberFormats : { [c.value]: {} });
  let f = n ? n.missingWarn : Re(e.missingWarn) || ya(e.missingWarn) ? e.missingWarn : !0, _ = n ? n.fallbackWarn : Re(e.fallbackWarn) || ya(e.fallbackWarn) ? e.fallbackWarn : !0, y = n ? n.fallbackRoot : Re(e.fallbackRoot) ? e.fallbackRoot : !0, A = !!e.fallbackFormat, I = Ue(e.missing) ? e.missing : null, j = Ue(e.missing) ? Cu(e.missing) : null, S = Ue(e.postTranslation) ? e.postTranslation : null, T = n ? n.warnHtmlMessage : Re(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, z = !!e.escapeParameter;
  const O = n ? n.modifiers : ze(e.modifiers) ? e.modifiers : {};
  let N = e.pluralRules || n && n.pluralRules, F;
  F = (() => {
    o && hu(null);
    const C = {
      version: Wz,
      locale: c.value,
      fallbackLocale: u.value,
      messages: d.value,
      modifiers: O,
      pluralRules: N,
      missing: j === null ? void 0 : j,
      missingWarn: f,
      fallbackWarn: _,
      fallbackFormat: A,
      unresolving: !0,
      postTranslation: S === null ? void 0 : S,
      warnHtmlMessage: T,
      escapeParameter: z,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    C.datetimeFormats = p.value, C.numberFormats = m.value, C.__datetimeFormatters = ze(F) ? F.__datetimeFormatters : void 0, C.__numberFormatters = ze(F) ? F.__numberFormatters : void 0;
    const $ = jz(C);
    return o && hu($), $;
  })(), Hr(F, c.value, u.value);
  function he() {
    return [
      c.value,
      u.value,
      d.value,
      p.value,
      m.value
    ];
  }
  const Y = ee({
    get: () => c.value,
    set: (C) => {
      c.value = C, F.locale = c.value;
    }
  }), me = ee({
    get: () => u.value,
    set: (C) => {
      u.value = C, F.fallbackLocale = u.value, Hr(F, c.value, C);
    }
  }), qe = ee(() => d.value), zt = /* @__PURE__ */ ee(() => p.value), Me = /* @__PURE__ */ ee(() => m.value);
  function Pe() {
    return Ue(S) ? S : null;
  }
  function xe(C) {
    S = C, F.postTranslation = C;
  }
  function gt() {
    return I;
  }
  function ye(C) {
    C !== null && (j = Cu(C)), I = C, F.missing = j;
  }
  const Be = (C, $, ie, _e, Ie, ht) => {
    he();
    let Nt;
    try {
      __INTLIFY_PROD_DEVTOOLS__, o || (F.fallbackContext = n ? zz() : void 0), Nt = C(F);
    } finally {
      __INTLIFY_PROD_DEVTOOLS__, o || (F.fallbackContext = void 0);
    }
    if (ie !== "translate exists" && // for not `te` (e.g `t`)
    He(Nt) && Nt === Xa || ie === "translate exists" && !Nt) {
      const [nn, pr] = $();
      return n && y ? _e(n) : Ie(nn);
    } else {
      if (ht(Nt))
        return Nt;
      throw Vt(Ot.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Ye(...C) {
    return Be(($) => Reflect.apply(zu, null, [$, ...C]), () => ys(...C), "translate", ($) => Reflect.apply($.t, $, [...C]), ($) => $, ($) => ne($));
  }
  function Xe(...C) {
    const [$, ie, _e] = C;
    if (_e && !ke(_e))
      throw Vt(Ot.INVALID_ARGUMENT);
    return Ye($, ie, tt({ resolvedMessage: !0 }, _e || {}));
  }
  function Zt(...C) {
    return Be(($) => Reflect.apply(ju, null, [$, ...C]), () => bs(...C), "datetime format", ($) => Reflect.apply($.d, $, [...C]), () => _u, ($) => ne($));
  }
  function fn(...C) {
    return Be(($) => Reflect.apply(xu, null, [$, ...C]), () => zs(...C), "number format", ($) => Reflect.apply($.n, $, [...C]), () => _u, ($) => ne($));
  }
  function nt(C) {
    return C.map(($) => ne($) || He($) || Re($) ? Su(String($)) : $);
  }
  const tn = {
    normalize: nt,
    interpolate: (C) => C,
    type: "vnode"
  };
  function _n(...C) {
    return Be(
      ($) => {
        let ie;
        const _e = $;
        try {
          _e.processor = tn, ie = Reflect.apply(zu, null, [_e, ...C]);
        } finally {
          _e.processor = null;
        }
        return ie;
      },
      () => ys(...C),
      "translate",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ($) => $[js](...C),
      ($) => [Su($)],
      ($) => We($)
    );
  }
  function jt(...C) {
    return Be(
      ($) => Reflect.apply(xu, null, [$, ...C]),
      () => zs(...C),
      "number format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ($) => $[xs](...C),
      Pu,
      ($) => ne($) || We($)
    );
  }
  function Nn(...C) {
    return Be(
      ($) => Reflect.apply(ju, null, [$, ...C]),
      () => bs(...C),
      "datetime format",
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ($) => $[ws](...C),
      Pu,
      ($) => ne($) || We($)
    );
  }
  function b(C) {
    N = C, F.pluralRules = N;
  }
  function k(C, $) {
    return Be(() => {
      if (!C)
        return !1;
      const ie = ne($) ? $ : c.value, _e = V(ie), Ie = F.messageResolver(_e, C);
      return s ? Ie != null : Tr(Ie) || kt(Ie) || ne(Ie);
    }, () => [C], "translate exists", (ie) => Reflect.apply(ie.te, ie, [C, $]), Zz, (ie) => Re(ie));
  }
  function R(C) {
    let $ = null;
    const ie = tp(F, u.value, c.value);
    for (let _e = 0; _e < ie.length; _e++) {
      const Ie = d.value[ie[_e]] || {}, ht = F.messageResolver(Ie, C);
      if (ht != null) {
        $ = ht;
        break;
      }
    }
    return $;
  }
  function U(C) {
    const $ = R(C);
    return $ ?? (n ? n.tm(C) || {} : {});
  }
  function V(C) {
    return d.value[C] || {};
  }
  function W(C, $) {
    if (a) {
      const ie = { [C]: $ };
      for (const _e in ie)
        Ft(ie, _e) && vo(ie[_e]);
      $ = ie[C];
    }
    d.value[C] = $, F.messages = d.value;
  }
  function Z(C, $) {
    d.value[C] = d.value[C] || {};
    const ie = { [C]: $ };
    if (a)
      for (const _e in ie)
        Ft(ie, _e) && vo(ie[_e]);
    $ = ie[C], ia($, d.value[C]), F.messages = d.value;
  }
  function G(C) {
    return p.value[C] || {};
  }
  function g(C, $) {
    p.value[C] = $, F.datetimeFormats = p.value, wu(F, C, $);
  }
  function h(C, $) {
    p.value[C] = tt(p.value[C] || {}, $), F.datetimeFormats = p.value, wu(F, C, $);
  }
  function E(C) {
    return m.value[C] || {};
  }
  function H(C, $) {
    m.value[C] = $, F.numberFormats = m.value, ku(F, C, $);
  }
  function K(C, $) {
    m.value[C] = tt(m.value[C] || {}, $), F.numberFormats = m.value, ku(F, C, $);
  }
  Tu++, n && va && (un(n.locale, (C) => {
    l && (c.value = C, F.locale = C, Hr(F, c.value, u.value));
  }), un(n.fallbackLocale, (C) => {
    l && (u.value = C, F.fallbackLocale = C, Hr(F, c.value, u.value));
  }));
  const J = {
    id: Tu,
    locale: Y,
    fallbackLocale: me,
    get inheritLocale() {
      return l;
    },
    set inheritLocale(C) {
      l = C, C && n && (c.value = n.locale.value, u.value = n.fallbackLocale.value, Hr(F, c.value, u.value));
    },
    get availableLocales() {
      return Object.keys(d.value).sort();
    },
    messages: qe,
    get modifiers() {
      return O;
    },
    get pluralRules() {
      return N || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return f;
    },
    set missingWarn(C) {
      f = C, F.missingWarn = f;
    },
    get fallbackWarn() {
      return _;
    },
    set fallbackWarn(C) {
      _ = C, F.fallbackWarn = _;
    },
    get fallbackRoot() {
      return y;
    },
    set fallbackRoot(C) {
      y = C;
    },
    get fallbackFormat() {
      return A;
    },
    set fallbackFormat(C) {
      A = C, F.fallbackFormat = A;
    },
    get warnHtmlMessage() {
      return T;
    },
    set warnHtmlMessage(C) {
      T = C, F.warnHtmlMessage = C;
    },
    get escapeParameter() {
      return z;
    },
    set escapeParameter(C) {
      z = C, F.escapeParameter = C;
    },
    t: Ye,
    getLocaleMessage: V,
    setLocaleMessage: W,
    mergeLocaleMessage: Z,
    getPostTranslationHandler: Pe,
    setPostTranslationHandler: xe,
    getMissingHandler: gt,
    setMissingHandler: ye,
    [Kz]: b
  };
  return J.datetimeFormats = zt, J.numberFormats = Me, J.rt = Xe, J.te = k, J.tm = U, J.d = Zt, J.n = fn, J.getDateTimeFormat = G, J.setDateTimeFormat = g, J.mergeDateTimeFormat = h, J.getNumberFormat = E, J.setNumberFormat = H, J.mergeNumberFormat = K, J[Qz] = r, J[js] = _n, J[ws] = Nn, J[xs] = jt, J;
}
const yl = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function t0({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((r, o) => [
    ...r,
    // prettier-ignore
    ...o.type === se ? o.children : [o]
  ], []) : t.reduce((n, r) => {
    const o = e[r];
    return o && (n[r] = o()), n;
  }, Ae());
}
function _p(e) {
  return se;
}
const n0 = /* @__PURE__ */ Q({
  /* eslint-disable */
  name: "i18n-t",
  props: tt({
    keypath: {
      type: String,
      required: !0
    },
    plural: {
      type: [Number, String],
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      validator: (e) => He(e) || !isNaN(e)
    }
  }, yl),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const { slots: n, attrs: r } = t, o = e.i18n || ve({
      useScope: e.scope,
      __useComponent: !0
    });
    return () => {
      const a = Object.keys(n).filter((d) => d !== "_"), i = Ae();
      e.locale && (i.locale = e.locale), e.plural !== void 0 && (i.plural = ne(e.plural) ? +e.plural : e.plural);
      const s = t0(t, a), l = o[js](e.keypath, s, i), c = tt(Ae(), r), u = ne(e.tag) || ke(e.tag) ? e.tag : _p();
      return pt(u, c, l);
    };
  }
}), Au = n0;
function r0(e) {
  return We(e) && !ne(e[0]);
}
function gp(e, t, n, r) {
  const { slots: o, attrs: a } = t;
  return () => {
    const i = { part: !0 };
    let s = Ae();
    e.locale && (i.locale = e.locale), ne(e.format) ? i.key = e.format : ke(e.format) && (ne(e.format.key) && (i.key = e.format.key), s = Object.keys(e.format).reduce((p, m) => n.includes(m) ? tt(Ae(), p, { [m]: e.format[m] }) : p, Ae()));
    const l = r(e.value, i, s);
    let c = [i.key];
    We(l) ? c = l.map((p, m) => {
      const f = o[p.type], _ = f ? f({ [p.type]: p.value, index: m, parts: l }) : [p.value];
      return r0(_) && (_[0].key = `${p.type}-${m}`), _;
    }) : ne(l) && (c = [l]);
    const u = tt(Ae(), a), d = ne(e.tag) || ke(e.tag) ? e.tag : _p();
    return pt(d, u, c);
  };
}
const o0 = /* @__PURE__ */ Q({
  /* eslint-disable */
  name: "i18n-n",
  props: tt({
    value: {
      type: Number,
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, yl),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || ve({
      useScope: e.scope,
      __useComponent: !0
    });
    return gp(e, t, up, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[xs](...r)
    ));
  }
}), Ou = o0, a0 = /* @__PURE__ */ Q({
  /* eslint-disable */
  name: "i18n-d",
  props: tt({
    value: {
      type: [Number, Date],
      required: !0
    },
    format: {
      type: [String, Object]
    }
  }, yl),
  /* eslint-enable */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setup(e, t) {
    const n = e.i18n || ve({
      useScope: e.scope,
      __useComponent: !0
    });
    return gp(e, t, cp, (...r) => (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      n[ws](...r)
    ));
  }
}), Iu = a0;
function i0(e, t) {
  const n = e;
  if (e.mode === "composition")
    return n.__getInstance(t) || e.global;
  {
    const r = n.__getInstance(t);
    return r != null ? r.__composer : e.global.__composer;
  }
}
function s0(e) {
  const t = (i) => {
    const { instance: s, modifiers: l, value: c } = i;
    if (!s || !s.$)
      throw Vt(Ot.UNEXPECTED_ERROR);
    const u = i0(e, s.$), d = Lu(c);
    return [
      Reflect.apply(u.t, u, [...Nu(d)]),
      u
    ];
  };
  return {
    created: (i, s) => {
      const [l, c] = t(s);
      va && e.global === c && (i.__i18nWatcher = un(c.locale, () => {
        s.instance && s.instance.$forceUpdate();
      })), i.__composer = c, i.textContent = l;
    },
    unmounted: (i) => {
      va && i.__i18nWatcher && (i.__i18nWatcher(), i.__i18nWatcher = void 0, delete i.__i18nWatcher), i.__composer && (i.__composer = void 0, delete i.__composer);
    },
    beforeUpdate: (i, { value: s }) => {
      if (i.__composer) {
        const l = i.__composer, c = Lu(s);
        i.textContent = Reflect.apply(l.t, l, [
          ...Nu(c)
        ]);
      }
    },
    getSSRProps: (i) => {
      const [s] = t(i);
      return { textContent: s };
    }
  };
}
function Lu(e) {
  if (ne(e))
    return { path: e };
  if (ze(e)) {
    if (!("path" in e))
      throw Vt(Ot.REQUIRED_VALUE, "path");
    return e;
  } else
    throw Vt(Ot.INVALID_VALUE);
}
function Nu(e) {
  const { path: t, locale: n, args: r, choice: o, plural: a } = e, i = {}, s = r || {};
  return ne(n) && (i.locale = n), He(o) && (i.plural = o), He(a) && (i.plural = a), [t, s, i];
}
function l0(e, t, ...n) {
  const r = ze(n[0]) ? n[0] : {}, o = !!r.useI18nComponentName;
  (Re(r.globalInstall) ? r.globalInstall : !0) && ([o ? "i18n" : Au.name, "I18nT"].forEach((i) => e.component(i, Au)), [Ou.name, "I18nN"].forEach((i) => e.component(i, Ou)), [Iu.name, "I18nD"].forEach((i) => e.component(i, Iu))), e.directive("t", s0(t));
}
const hp = /* @__PURE__ */ An("global-vue-i18n");
function c0(e = {}, t) {
  const n = Re(e.globalInjection) ? e.globalInjection : !0, r = !0, o = /* @__PURE__ */ new Map(), [a, i] = u0(e), s = /* @__PURE__ */ An("");
  function l(d) {
    return o.get(d) || null;
  }
  function c(d, p) {
    o.set(d, p);
  }
  function u(d) {
    o.delete(d);
  }
  {
    const d = {
      // mode
      get mode() {
        return "composition";
      },
      // allowComposition
      get allowComposition() {
        return r;
      },
      // install plugin
      async install(p, ...m) {
        if (p.__VUE_I18N_SYMBOL__ = s, p.provide(p.__VUE_I18N_SYMBOL__, d), ze(m[0])) {
          const y = m[0];
          d.__composerExtend = y.__composerExtend, d.__vueI18nExtend = y.__vueI18nExtend;
        }
        let f = null;
        n && (f = v0(p, d.global)), l0(p, d, ...m);
        const _ = p.unmount;
        p.unmount = () => {
          f && f(), d.dispose(), _();
        };
      },
      // global accessor
      get global() {
        return i;
      },
      dispose() {
        a.stop();
      },
      // @internal
      __instances: o,
      // @internal
      __getInstance: l,
      // @internal
      __setInstance: c,
      // @internal
      __deleteInstance: u
    };
    return d;
  }
}
function ve(e = {}) {
  const t = ur();
  if (t == null)
    throw Vt(Ot.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Vt(Ot.NOT_INSTALLED);
  const n = m0(t), r = p0(n), o = pp(t), a = d0(e, o);
  if (a === "global")
    return Xz(r, e, o), r;
  if (a === "parent") {
    let l = f0(n, t, e.__useComponent);
    return l == null && (l = r), l;
  }
  const i = n;
  let s = i.__getInstance(t);
  if (s == null) {
    const l = tt({}, e);
    "__i18n" in o && (l.__i18n = o.__i18n), r && (l.__root = r), s = fp(l), i.__composerExtend && (s[ks] = i.__composerExtend(s)), g0(i, t, s), i.__setInstance(t, s);
  }
  return s;
}
function u0(e, t, n) {
  const r = jg();
  {
    const o = r.run(() => fp(e));
    if (o == null)
      throw Vt(Ot.UNEXPECTED_ERROR);
    return [r, o];
  }
}
function m0(e) {
  {
    const t = Gt(e.isCE ? hp : e.appContext.app.__VUE_I18N_SYMBOL__);
    if (!t)
      throw Vt(e.isCE ? Ot.NOT_INSTALLED_WITH_PROVIDE : Ot.UNEXPECTED_ERROR);
    return t;
  }
}
function d0(e, t) {
  return Ka(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function p0(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function f0(e, t, n = !1) {
  let r = null;
  const o = t.root;
  let a = _0(t, n);
  for (; a != null; ) {
    const i = e;
    if (e.mode === "composition" && (r = i.__getInstance(a)), r != null || o === a)
      break;
    a = a.parent;
  }
  return r;
}
function _0(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function g0(e, t, n) {
  Xt(() => {
  }, t), cr(() => {
    const r = n;
    e.__deleteInstance(t);
    const o = r[ks];
    o && (o(), delete r[ks]);
  }, t);
}
const h0 = [
  "locale",
  "fallbackLocale",
  "availableLocales"
], Mu = ["t", "rt", "d", "n", "tm", "te"];
function v0(e, t) {
  const n = /* @__PURE__ */ Object.create(null);
  return h0.forEach((o) => {
    const a = Object.getOwnPropertyDescriptor(t, o);
    if (!a)
      throw Vt(Ot.UNEXPECTED_ERROR);
    const i = it(a.value) ? {
      get() {
        return a.value.value;
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      set(s) {
        a.value.value = s;
      }
    } : {
      get() {
        return a.get && a.get();
      }
    };
    Object.defineProperty(n, o, i);
  }), e.config.globalProperties.$i18n = n, Mu.forEach((o) => {
    const a = Object.getOwnPropertyDescriptor(t, o);
    if (!a || !a.value)
      throw Vt(Ot.UNEXPECTED_ERROR);
    Object.defineProperty(e.config.globalProperties, `$${o}`, a);
  }), () => {
    delete e.config.globalProperties.$i18n, Mu.forEach((o) => {
      delete e.config.globalProperties[`$${o}`];
    });
  };
}
Yz();
gz(Vz);
hz(Kb);
vz(tp);
if (__INTLIFY_PROD_DEVTOOLS__) {
  const e = pl();
  e.__INTLIFY__ = !0, az(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
function Ln(e) {
  const { t, te: n } = ve();
  function r(m) {
    const f = ur();
    if (!f)
      throw new Error("useTileEmits must be used within a component setup");
    const _ = {
      tileHeader: "update-tileHeader",
      tileHeaderIcon: "update-tileHeaderIcon",
      tileThemeColor: "update-tileThemeColor",
      setCustomBackground: "update-setCustomBackground",
      variant: "update-variant"
      // ... add more mappings as needed
    };
    Object.entries(m).forEach(([y, A]) => {
      const I = _[y];
      A && I && un(
        A,
        (j) => {
          f.emit(I, j);
        },
        { immediate: !0 }
      );
    });
  }
  const o = ee(() => `${e.tile.type}-${e.tile.subType}`);
  function a() {
    return e.tile?.program?.title || e.tile?.journey?.title || e.tile?.resource?.title || e.tile?.community?.title || e.tile?.stepTitle || e.tile?.title;
  }
  const i = ee(() => {
    const m = `${e.tile.type}-${e.tile.subType}`;
    return m == "explore-programs" || m == "explore-resources" ? "vertical" : "";
  }), s = (m, f) => {
    const _ = m[f];
    return Array.isArray(_) ? _.length > 0 : f === "group_activity" ? !!_?.profiles?.length : f === "replySummary" && _?.count == 0 && _.authors?.length == 0 && !_.show_placeholder ? !1 : !!_;
  };
  function l(m) {
    if (m.startsWith("journey_step")) {
      switch (m) {
        case "journey_step-program-enrol":
          return "coming-up-in-journey-enroll-program";
        case "journey_step-program_not_started":
          return "complete-this-step-in-your-journey";
        case "journey_step-program_ended":
          return "x-has-ended";
        case "journey_step-program_ending":
          return "x-is-ending-soon";
        case "journey_step-program_enrol_session":
          return "enroll-for-the-next-session-of-x";
        case "journey_step-program_active":
          return "keep-making-progress-in-program";
      }
      return "complete-next-step-in-journey";
    }
    switch (m) {
      case "journey-invited":
        return "journey-invited";
      case "journey-ending":
        return "journey-ending";
      case "journey-completed":
        return "journey-completed";
      case "program-ending":
        return "x-is-ending-soon";
      case "program-completed":
        return "completed-your-program";
      case "program-not_started.enrolled":
        return "you-enrolled-in-x-when";
      case "program-not_started.started":
        return "your-program-has-started";
      case "program-not_started.started-session":
        return "your-program-has-started-when";
      case "program-not_started.added":
        return "added-to-new-program";
      case "program-in-progress":
        return "keep-making-progress-in-program";
      case "explore-programs":
        return "explore-programs";
      case "explore-journeys":
        return "explore-journeys";
      case "explore-resources":
        return e.tile.initial ? "explore-resources" : "happening-now-resources";
      case "explore-community":
        return e.tile.initial ? "join-the-community" : "happening-now-community";
    }
  }
  const c = ee(() => {
    const m = e.tile.type, f = e.tile?.journeyTitle || e.tile?.stepTitle || m === "resource" && e.tile?.title?.length > 0;
    return m === "journey_step" || m === "journey" || m === "resource" && f;
  }), u = {
    video: { component: "BrightcoveVideo", order: 1 },
    progress: { component: "TileProgress", order: 2 },
    image: { component: "TileImage", order: 3 },
    discussions: { component: "ProgramDiscussion", order: 4 },
    resourceList: { component: "ResourceProgress", order: 5 },
    group_activity: { component: "GroupActivity", order: 6 },
    topics: { component: "TopicSnapshot", order: 7 },
    event: { component: "TheWebinar", order: 8 },
    //event: { component: "JourneyEvent", order: 8 },
    JourneyEventPreviewImage: {
      component: "JourneyEventPreviewImage",
      order: 9
    },
    community_posts_progress: {
      component: "CommunityPostsProgress",
      order: 10
    },
    communityPost: { component: "CommunityPost", order: 10 },
    certificate: { component: "ProgramCertificate", order: 11 },
    program: { component: "ProgramCard", order: 12 },
    program_details: { component: "ProgramDetails", order: 3 },
    programs: { component: "ExplorePrograms", order: 13 },
    journeys: { component: "ExploreJourneys", order: 14 },
    resources: { component: "ExploreResources", order: 15 },
    posts: { component: "ExploreCommunity", order: 16 },
    attachments: { component: "AttachmentLoader", order: 17 },
    replySummary: { component: "CommentGroup", order: 18 },
    summaryLeaderboard: { component: "SummaryLeaderboard", order: 19 },
    summaryProgress: { component: "SummaryProgress", order: 20 },
    summaryPollResults: { component: "SummaryPollResults", order: 21 },
    summaryNewPoll: { component: "SummaryNewPoll", order: 21 },
    page: { component: "SummaryPage", order: 22 }
    // Add other tile types here with dynamic imports
  };
  function d(m, f) {
    if (!m) return;
    const [_, y] = m.split("#"), [A, I] = _.split("?"), j = I ? Object.fromEntries(new URLSearchParams(I)) : {};
    Object.assign(j, f);
    const S = new URLSearchParams(j).toString();
    return `${A}${S ? "?" + S : ""}${y ? "#" + y : ""}`;
  }
  function p(m, f, _) {
    return d(m, {
      hp_src_ip: `${e.tile.subType}_${f}${_ ? `_${_}` : ""}`
    });
  }
  return {
    defaultTileComponentConfig: u,
    homepageTileType: o,
    homepageTileTitle: a,
    feedStyleClass: i,
    showTile: s,
    getLocStringKey: l,
    shouldDisplayStepTitle: c,
    t,
    te: n,
    useTileEmits: r,
    getLinkWithReferer: p
  };
}
const y0 = {
  key: 0,
  class: "title-container"
}, b0 = ["href"], z0 = {
  key: 0,
  class: "timeline"
}, j0 = /* @__PURE__ */ Q({
  __name: "TileTitle",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const t = e, { homepageTileTitle: n, shouldDisplayStepTitle: r } = Ln(t), o = t.tile.journeyTitle || n(), a = t.tile?.journeyId;
    function i() {
      window.homeActionHandler("openJourneyPanel", a);
    }
    return (s, l) => X(r) ? (w(), P("div", y0, [
      x("div", {
        id: "tile-tile",
        class: Ce(["tile-title", `${s.tile.type}_title`])
      }, [
        x("strong", null, [
          x("a", {
            onClick: Or(i, ["prevent"]),
            href: `?journey=${X(a)}`
          }, D(X(o).title || X(o)), 9, b0)
        ]),
        s.tile.stepLabel ? (w(), P("span", z0, D(s.tile.stepLabel), 1)) : re("", !0)
      ], 2)
    ])) : re("", !0);
  }
}), w0 = `.tile-title[data-v-b04a9ceb]{display:inline;color:#4d4d4d;height:fit-content;position:relative}.tile-title strong[data-v-b04a9ceb]{color:#0072ef;font-size:1rem;display:inline-flex;margin-right:.15rem;align-items:center;gap:.25rem;font-weight:400;width:fit-content;flex:1}.tile-title strong a[data-v-b04a9ceb]{text-decoration:none;color:unset}.tile-title strong a[data-v-b04a9ceb]:hover{text-decoration:underline}.tile-title strong[data-v-b04a9ceb]:after{display:inline-block;content:"";background-image:url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.3226 7.26112L9 0.874023L6.3871 7.26112L0 9.87402L6.3871 12.4869L9 18.874L11.6129 12.4869L18 9.87402L11.3226 7.26112Z' fill='%230072EF'/%3E%3C/svg%3E%0A");background-repeat:no-repeat;background-size:contain;width:1rem;height:1rem}.tile-title span[data-v-b04a9ceb]{width:fit-content;font-size:1rem;font-weight:400}.journey_title strong[data-v-b04a9ceb]{color:#fff}`, vp = /* @__PURE__ */ ae(j0, [["styles", [w0]], ["__scopeId", "data-v-b04a9ceb"]]), x0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vp
}, Symbol.toStringTag, { value: "Module" })), k0 = {
  key: 0,
  class: "loader"
}, S0 = /* @__PURE__ */ Q({
  __name: "BaseButton",
  props: {
    type: {
      type: String,
      default: "button"
    },
    variant: {
      type: String,
      default: "primary",
      validators: (e) => ["primary", "row", "unstyled"].includes(e)
    },
    icon: {
      type: String,
      default: ""
    },
    iconPosition: {
      type: String,
      default: "left",
      validators: (e) => ["left", "right"].includes(e)
    },
    busy: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    href: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = e, n = ee(() => t.href ? "a" : "button"), r = ee(
      () => t.href ? { href: t.href } : { type: t.type }
    );
    return (o, a) => (w(), ge(er(n.value), Er({
      class: ["base-button", [e.variant, e.iconPosition == "right" ? "right-icon" : null]],
      disabled: e.disabled
    }, r.value), {
      default: Oe(() => [
        e.busy ? (w(), P("span", k0)) : re("", !0),
        e.icon ? (w(), ge(X(dl), {
          key: 1,
          icon: e.icon,
          width: "15",
          height: "15"
        }, null, 8, ["icon"])) : re("", !0),
        Ha(o.$slots, "default", {}, void 0, !0)
      ]),
      _: 3
    }, 16, ["class", "disabled"]));
  }
}), E0 = ".base-button[data-v-3f461470]{position:relative;display:flex;align-items:center;justify-content:center;gap:.5rem;padding:.5rem 1rem;border:1px solid #ccc;border-radius:20px;background-color:#fff;color:#333;cursor:pointer;transition:all .3s;box-shadow:0 1px 4px #00000021;font-family:myriad-pro,Helvetica,Arial,sans-serif;font-size:1rem;width:fit-content;text-align:center;letter-spacing:unset;word-spacing:unset;line-height:unset}.base-button[data-v-3f461470]:disabled{cursor:not-allowed;filter:brightness(.9)}.base-button[data-v-3f461470]:focus-visible{outline:2px solid black;outline-offset:3px}a[data-v-3f461470]{text-decoration:none;padding:0;display:flex;align-items:center;justify-content:center}.unstyled[data-v-3f461470]{border:unset;background-color:unset;color:unset;padding:unset;gap:unset;border-radius:unset;justify-content:unset;box-shadow:unset}.unstyled[data-v-3f461470]:hover{background-color:unset}.base-button.right-icon[data-v-3f461470]{flex-direction:row-reverse}.primary[data-v-3f461470]{border-color:#0072ef;color:#fff;background-color:#0072ef}.primary[data-v-3f461470]:hover{background-color:#0067d9;border-color:#0067d9}.left[data-v-3f461470]{order:0}.row[data-v-3f461470]{border:1px solid #3f3f3f;background:#fff}.row .loader[data-v-3f461470]{border:2px solid black;border-bottom-color:transparent}.row[data-v-3f461470]:hover{background-color:#e1e1e1}.white[data-v-3f461470]{border-color:#fff}.white[data-v-3f461470]:hover{background-color:#e1e1e1;border-color:#e1e1e1}.white[data-v-3f461470]:focus-visible{outline-color:#fff}.dark[data-v-3f461470]{background-color:transparent;color:#fff;border-color:#fff}.dark[data-v-3f461470]:hover{background-color:#f5f5f51a}.dark[data-v-3f461470]:focus-visible{outline-color:#fff}.loader[data-v-3f461470]{width:15px;height:15px;border:2px solid #fff;border-bottom-color:transparent;border-radius:50%;display:inline-block;box-sizing:border-box;animation:rotation-3f461470 .9s linear infinite}@keyframes rotation-3f461470{0%{transform:rotate(0)}to{transform:rotate(360deg)}}", bt = /* @__PURE__ */ ae(S0, [["styles", [E0]], ["__scopeId", "data-v-3f461470"]]);
function we(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Tn(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
const yp = 6048e5, P0 = 864e5, Ru = 6e4, $u = 525600, zr = 43200, ja = 1440;
let T0 = {};
function Nr() {
  return T0;
}
function yo(e, t) {
  const n = Nr(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? n.weekStartsOn ?? n.locale?.options?.weekStartsOn ?? 0, o = we(e), a = o.getDay(), i = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function wa(e) {
  return yo(e, { weekStartsOn: 1 });
}
function bp(e) {
  const t = we(e), n = t.getFullYear(), r = Tn(e, 0);
  r.setFullYear(n + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const o = wa(r), a = Tn(e, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const i = wa(a);
  return t.getTime() >= o.getTime() ? n + 1 : t.getTime() >= i.getTime() ? n : n - 1;
}
function xa(e) {
  const t = we(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Cr(e) {
  const t = we(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function ao(e, t) {
  const n = xa(e), r = xa(t), o = +n - Cr(n), a = +r - Cr(r);
  return Math.round((o - a) / P0);
}
function C0(e) {
  const t = bp(e), n = Tn(e, 0);
  return n.setFullYear(t, 0, 4), n.setHours(0, 0, 0, 0), wa(n);
}
function io(e, t) {
  const n = we(e), r = we(t), o = n.getTime() - r.getTime();
  return o < 0 ? -1 : o > 0 ? 1 : o;
}
function bl(e) {
  return Tn(e, Date.now());
}
function A0(e, t) {
  const n = xa(e), r = xa(t);
  return +n == +r;
}
function O0(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function I0(e) {
  if (!O0(e) && typeof e != "number")
    return !1;
  const t = we(e);
  return !isNaN(Number(t));
}
function L0(e, t) {
  const n = we(e), r = we(t), o = n.getFullYear() - r.getFullYear(), a = n.getMonth() - r.getMonth();
  return o * 12 + a;
}
function zp(e) {
  return (t) => {
    const r = (e ? Math[e] : Math.trunc)(t);
    return r === 0 ? 0 : r;
  };
}
function N0(e, t) {
  return +we(e) - +we(t);
}
function M0(e) {
  const t = we(e);
  return t.setHours(23, 59, 59, 999), t;
}
function R0(e) {
  const t = we(e), n = t.getMonth();
  return t.setFullYear(t.getFullYear(), n + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function $0(e) {
  const t = we(e);
  return +M0(t) == +R0(t);
}
function D0(e, t) {
  const n = we(e), r = we(t), o = io(n, r), a = Math.abs(
    L0(n, r)
  );
  let i;
  if (a < 1)
    i = 0;
  else {
    n.getMonth() === 1 && n.getDate() > 27 && n.setDate(30), n.setMonth(n.getMonth() - o * a);
    let s = io(n, r) === -o;
    $0(we(e)) && a === 1 && io(e, r) === 1 && (s = !1), i = o * (a - Number(s));
  }
  return i === 0 ? 0 : i;
}
function F0(e, t, n) {
  const r = N0(e, t) / 1e3;
  return zp(n?.roundingMethod)(r);
}
function U0(e) {
  const t = we(e), n = Tn(e, 0);
  return n.setFullYear(t.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const V0 = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, q0 = (e, t, n) => {
  let r;
  const o = V0[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n?.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function $i(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const H0 = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, B0 = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, J0 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, W0 = {
  date: $i({
    formats: H0,
    defaultWidth: "full"
  }),
  time: $i({
    formats: B0,
    defaultWidth: "full"
  }),
  dateTime: $i({
    formats: J0,
    defaultWidth: "full"
  })
}, Y0 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, G0 = (e, t, n, r) => Y0[e];
function Br(e) {
  return (t, n) => {
    const r = n?.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = n?.width ? String(n.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = n?.width ? String(n.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const K0 = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Q0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, X0 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Z0 = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, ej = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, tj = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, nj = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, rj = {
  ordinalNumber: nj,
  era: Br({
    values: K0,
    defaultWidth: "wide"
  }),
  quarter: Br({
    values: Q0,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Br({
    values: X0,
    defaultWidth: "wide"
  }),
  day: Br({
    values: Z0,
    defaultWidth: "wide"
  }),
  dayPeriod: Br({
    values: ej,
    defaultWidth: "wide",
    formattingValues: tj,
    defaultFormattingWidth: "wide"
  })
};
function Jr(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? aj(s, (d) => d.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      oj(s, (d) => d.test(i))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(i.length);
    return { value: c, rest: u };
  };
}
function oj(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function aj(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function ij(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = n.valueCallback ? n.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const sj = /^(\d+)(th|st|nd|rd)?/i, lj = /\d+/i, cj = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, uj = {
  any: [/^b/i, /^(a|c)/i]
}, mj = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, dj = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, pj = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, fj = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, _j = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, gj = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, hj = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, vj = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, yj = {
  ordinalNumber: ij({
    matchPattern: sj,
    parsePattern: lj,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Jr({
    matchPatterns: cj,
    defaultMatchWidth: "wide",
    parsePatterns: uj,
    defaultParseWidth: "any"
  }),
  quarter: Jr({
    matchPatterns: mj,
    defaultMatchWidth: "wide",
    parsePatterns: dj,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Jr({
    matchPatterns: pj,
    defaultMatchWidth: "wide",
    parsePatterns: fj,
    defaultParseWidth: "any"
  }),
  day: Jr({
    matchPatterns: _j,
    defaultMatchWidth: "wide",
    parsePatterns: gj,
    defaultParseWidth: "any"
  }),
  dayPeriod: Jr({
    matchPatterns: hj,
    defaultMatchWidth: "any",
    parsePatterns: vj,
    defaultParseWidth: "any"
  })
}, zl = {
  code: "en-US",
  formatDistance: q0,
  formatLong: W0,
  formatRelative: G0,
  localize: rj,
  match: yj,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function bj(e) {
  const t = we(e);
  return ao(t, U0(t)) + 1;
}
function zj(e) {
  const t = we(e), n = +wa(t) - +C0(t);
  return Math.round(n / yp) + 1;
}
function jp(e, t) {
  const n = we(e), r = n.getFullYear(), o = Nr(), a = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? o.firstWeekContainsDate ?? o.locale?.options?.firstWeekContainsDate ?? 1, i = Tn(e, 0);
  i.setFullYear(r + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = yo(i, t), l = Tn(e, 0);
  l.setFullYear(r, 0, a), l.setHours(0, 0, 0, 0);
  const c = yo(l, t);
  return n.getTime() >= s.getTime() ? r + 1 : n.getTime() >= c.getTime() ? r : r - 1;
}
function jj(e, t) {
  const n = Nr(), r = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? n.firstWeekContainsDate ?? n.locale?.options?.firstWeekContainsDate ?? 1, o = jp(e, t), a = Tn(e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), yo(a, t);
}
function wj(e, t) {
  const n = we(e), r = +yo(n, t) - +jj(n, t);
  return Math.round(r / yp) + 1;
}
function Te(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const bn = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return Te(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : Te(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return Te(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return Te(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return Te(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return Te(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return Te(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return Te(o, t.length);
  }
}, yr = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Du = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return bn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = jp(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return Te(i, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : Te(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = bp(e);
    return Te(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return Te(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(r);
      case "QQ":
        return Te(r, 2);
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(r);
      case "qq":
        return Te(r, 2);
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return bn.M(e, t);
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "L":
        return String(r + 1);
      case "LL":
        return Te(r + 1, 2);
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = wj(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : Te(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = zj(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : Te(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : bn.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = bj(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : Te(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return Te(a, 2);
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return Te(a, t.length);
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return Te(o, t.length);
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = yr.noon : r === 0 ? o = yr.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = yr.evening : r >= 12 ? o = yr.afternoon : r >= 4 ? o = yr.morning : o = yr.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return bn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : bn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : Te(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : Te(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : bn.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : bn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return bn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      case "X":
        return Uu(r);
      case "XXXX":
      case "XX":
        return Bn(r);
      case "XXXXX":
      case "XXX":
      default:
        return Bn(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Uu(r);
      case "xxxx":
      case "xx":
        return Bn(r);
      case "xxxxx":
      case "xxx":
      default:
        return Bn(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Fu(r, ":");
      case "OOOO":
      default:
        return "GMT" + Bn(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Fu(r, ":");
      case "zzzz":
      default:
        return "GMT" + Bn(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(e.getTime() / 1e3);
    return Te(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    const r = e.getTime();
    return Te(r, t.length);
  }
};
function Fu(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + Te(a, 2);
}
function Uu(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + Te(Math.abs(e) / 60, 2) : Bn(e, t);
}
function Bn(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Te(Math.trunc(r / 60), 2), a = Te(r % 60, 2);
  return n + o + t + a;
}
const Vu = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, wp = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, xj = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return Vu(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Vu(r, t)).replace("{{time}}", wp(o, t));
}, kj = {
  p: wp,
  P: xj
}, Sj = /^D+$/, Ej = /^Y+$/, Pj = ["D", "DD", "YY", "YYYY"];
function Tj(e) {
  return Sj.test(e);
}
function Cj(e) {
  return Ej.test(e);
}
function Aj(e, t, n) {
  const r = Oj(e, t, n);
  if (console.warn(r), Pj.includes(e)) throw new RangeError(r);
}
function Oj(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Ij = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Lj = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Nj = /^'([^]*?)'?$/, Mj = /''/g, Rj = /[a-zA-Z]/;
function Et(e, t, n) {
  const r = Nr(), o = n?.locale ?? r.locale ?? zl, a = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, i = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, s = we(e);
  if (!I0(s))
    throw new RangeError("Invalid time value");
  let l = t.match(Lj).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const p = kj[d];
      return p(u, o.formatLong);
    }
    return u;
  }).join("").match(Ij).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: $j(u) };
    if (Du[d])
      return { isToken: !0, value: u };
    if (d.match(Rj))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!n?.useAdditionalWeekYearTokens && Cj(d) || !n?.useAdditionalDayOfYearTokens && Tj(d)) && Aj(d, t, String(e));
    const p = Du[d[0]];
    return p(s, d, o.localize, c);
  }).join("");
}
function $j(e) {
  const t = e.match(Nj);
  return t ? t[1].replace(Mj, "'") : e;
}
function Dj(e, t, n) {
  const r = Nr(), o = n?.locale ?? r.locale ?? zl, a = 2520, i = io(e, t);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  const s = Object.assign({}, n, {
    addSuffix: n?.addSuffix,
    comparison: i
  });
  let l, c;
  i > 0 ? (l = we(t), c = we(e)) : (l = we(e), c = we(t));
  const u = F0(c, l), d = (Cr(c) - Cr(l)) / 1e3, p = Math.round((u - d) / 60);
  let m;
  if (p < 2)
    return n?.includeSeconds ? u < 5 ? o.formatDistance("lessThanXSeconds", 5, s) : u < 10 ? o.formatDistance("lessThanXSeconds", 10, s) : u < 20 ? o.formatDistance("lessThanXSeconds", 20, s) : u < 40 ? o.formatDistance("halfAMinute", 0, s) : u < 60 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", 1, s) : p === 0 ? o.formatDistance("lessThanXMinutes", 1, s) : o.formatDistance("xMinutes", p, s);
  if (p < 45)
    return o.formatDistance("xMinutes", p, s);
  if (p < 90)
    return o.formatDistance("aboutXHours", 1, s);
  if (p < ja) {
    const f = Math.round(p / 60);
    return o.formatDistance("aboutXHours", f, s);
  } else {
    if (p < a)
      return o.formatDistance("xDays", 1, s);
    if (p < zr) {
      const f = Math.round(p / ja);
      return o.formatDistance("xDays", f, s);
    } else if (p < zr * 2)
      return m = Math.round(p / zr), o.formatDistance("aboutXMonths", m, s);
  }
  if (m = D0(c, l), m < 12) {
    const f = Math.round(p / zr);
    return o.formatDistance("xMonths", f, s);
  } else {
    const f = m % 12, _ = Math.trunc(m / 12);
    return f < 3 ? o.formatDistance("aboutXYears", _, s) : f < 9 ? o.formatDistance("overXYears", _, s) : o.formatDistance("almostXYears", _ + 1, s);
  }
}
function Fj(e, t, n) {
  const r = Nr(), o = n?.locale ?? r.locale ?? zl, a = io(e, t);
  if (isNaN(a))
    throw new RangeError("Invalid time value");
  const i = Object.assign({}, n, {
    addSuffix: n?.addSuffix,
    comparison: a
  });
  let s, l;
  a > 0 ? (s = we(t), l = we(e)) : (s = we(e), l = we(t));
  const c = zp(n?.roundingMethod ?? "round"), u = l.getTime() - s.getTime(), d = u / Ru, p = Cr(l) - Cr(s), m = (u - p) / Ru, f = n?.unit;
  let _;
  if (f ? _ = f : d < 1 ? _ = "second" : d < 60 ? _ = "minute" : d < ja ? _ = "hour" : m < zr ? _ = "day" : m < $u ? _ = "month" : _ = "year", _ === "second") {
    const y = c(u / 1e3);
    return o.formatDistance("xSeconds", y, i);
  } else if (_ === "minute") {
    const y = c(d);
    return o.formatDistance("xMinutes", y, i);
  } else if (_ === "hour") {
    const y = c(d / 60);
    return o.formatDistance("xHours", y, i);
  } else if (_ === "day") {
    const y = c(m / ja);
    return o.formatDistance("xDays", y, i);
  } else if (_ === "month") {
    const y = c(m / zr);
    return y === 12 && f !== "month" ? o.formatDistance("xYears", 1, i) : o.formatDistance("xMonths", y, i);
  } else {
    const y = c(m / $u);
    return o.formatDistance("xYears", y, i);
  }
}
function jl(e, t) {
  return Dj(e, bl(e), t);
}
function Uj(e, t) {
  return Fj(e, bl(e), t);
}
function Di(e) {
  return +we(e) > Date.now();
}
function so(e) {
  return +we(e) < Date.now();
}
function Fi(e) {
  return A0(e, bl(e));
}
const Wr = (e) => {
  if (!e.tile?.continue_link) return;
  const { getLinkWithReferer: t } = Ln(e);
  return t(e.tile.continue_link, "continue");
}, Vj = (e) => ({
  program: {
    invited: {
      primary: {
        label: "Get started",
        action: "showProgram",
        messageId: "get-started"
      }
    },
    "happening-now": {
      primary: {
        label: "Continue Program",
        action: "link",
        link: Wr(e),
        messageId: "continue-program"
      }
    },
    started: {
      primary: {
        label: "Start Program",
        action: "showProgram",
        messageId: "start-program"
      }
    },
    completed: {
      primary: {
        label: "Review Program",
        action: "route",
        route: `/programs/${e.tile?.program?.id}`,
        messageId: "review-program"
      }
    },
    not_started: {
      ...so(e.tile?.program?.group?.start_date) ? {
        primary: {
          label: "Start Program",
          action: "link",
          link: `/library?groupselect=${e.tile.program.group.id}`,
          messageId: "start-program"
        }
      } : {},
      secondary: {
        label: "Program Details",
        action: "showProgram",
        messageId: "program-details"
      }
    },
    "in-progress": {
      primary: {
        label: "Continue Program",
        action: "link",
        link: Wr(e),
        messageId: "continue-program"
      }
    },
    ending: {
      primary: {
        label: "Continue Program",
        action: "link",
        link: Wr(e),
        messageId: "continue-program"
      }
    }
  },
  journey: {
    invited: {
      primary: {
        action: "join-journey",
        messageId: "start-journey"
      }
    },
    active: {
      primary: {
        action: "open-journey",
        messageId: "journey-details"
      }
    },
    "happening-now": {
      primary: {
        action: "continue-journey",
        messageId: "continue-journey"
      }
    },
    progress: {
      primary: {
        action: "openJourneyPanel",
        messageId: "view-all-journey-steps"
      }
    },
    ending: {
      primary: {
        action: "openJourneyPanel",
        messageId: "view-all-journey-steps"
      }
    }
  },
  journey_step: {
    resource_list: {
      primary: {
        action: "openJourneyPanel",
        messageId: "view-all-journey-steps"
      }
    },
    webinar: {
      primary: {
        action: "start-webinar",
        messageId: "launch-webinar"
      }
    },
    community: {
      primary: {
        action: "route",
        route: "/community",
        messageId: "open-community"
      }
    },
    program_start: {
      primary: {
        action: "openProgram",
        messageId: "start-program"
      },
      secondary: {
        action: "showProgram",
        messageId: "program-details"
      }
    },
    program_ended: {
      primary: {
        action: "openProgram",
        messageId: "open-program"
      },
      secondary: {
        action: "showProgram",
        messageId: "program-details"
      }
    },
    program_ending: {
      primary: {
        action: "link",
        link: Wr(e),
        messageId: "continue-program"
      },
      secondary: {
        action: "showProgram",
        messageId: "program-details"
      }
    },
    program_active: {
      primary: {
        action: "link",
        link: Wr(e),
        messageId: "continue-program"
      },
      secondary: {
        action: "showProgram",
        messageId: "program-details"
      }
    },
    program_waiting: {
      primary: {
        action: "enrolled",
        messageId: "enrolled"
      },
      secondary: {
        action: "showProgram",
        messageId: "program-details"
      }
    },
    program_always_on: {
      primary: {
        action: "showProgram",
        messageId: "start-now"
      },
      secondary: {
        action: "showProgram",
        messageId: "program-details"
      }
    },
    click_to_complete: {
      primary: {
        action: "markAsComplete",
        messageId: "mark-as-complete"
      }
    }
  },
  resource: {
    share: {
      primary: {
        action: "share-resource",
        messageId: "share-resource"
      },
      secondary: {
        action: "remind-later",
        messageId: "remind-me-later"
      }
    },
    "happening-today": {
      primary: {
        action: "webinar",
        messageId: "launch-webinar"
      }
    }
  },
  explore: {
    programs: {
      primary: {
        action: "route",
        route: "/programs",
        messageId: "explore-all-programs"
      }
    },
    journeys: {
      primary: {
        action: "openJourneyPanel",
        messageId: "explore-all-journeys"
      }
    },
    resources: {
      primary: {
        action: "route",
        route: "/resource-library",
        messageId: "resource-library"
      }
    },
    community: {
      primary: {
        key: e.tile?.initial ? "initial" : "subsequent",
        action: "route",
        route: "/community",
        messageId: e.tile?.initial ? "open-community" : "join-community"
      }
    }
  }
}), qj = /* @__PURE__ */ Q({
  __name: "TileActions",
  props: {
    tile: Object,
    actions: {
      type: Object,
      default: null,
      required: !1
    },
    flipped: Boolean,
    styleOverride: Boolean,
    displayType: {
      default: "all",
      type: String
    }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ue(n.actions || n.tile?.actions || {});
    async function o(f) {
      const _ = f.action;
      if (_ === "showProgram") {
        const y = n.tile.program.id;
        window.homeActionHandler && window.homeActionHandler("showProgram", y);
      } else _ == "route" ? window.homeActionHandler("route", f.route) : _ == "join-journey" ? window.homeActionHandler("join-journey", n.tile.journey.id) : _ == "open-journey" ? window.homeActionHandler("openJourneyPanel", n.tile.journey.id) : _ == "complete_step" ? window.homeActionHandler("complete-step", {
        stepId: n.tile.stepId,
        journeyId: n.tile.journeyId
      }) : window.homeActionHandler(_);
    }
    const a = Vj(n), i = ee(() => ({
      "tile-actions": !0,
      [n.tile?.type]: !n.styleOverride,
      disabled: n.tile?.subType === "program_waiting",
      "explore-programs": n.tile?.type === "explore" && n.tile?.subType === "programs"
    })), s = (f, _) => r.value?.[f]?.[_] || a[n.tile.type]?.[n.tile.subType]?.[f]?.[_], l = (f) => !!s(f, "link"), c = (f) => {
      const _ = u(f), y = _?.messageId;
      if (y)
        return t(`${y}`);
      if (console.warn(`No label found for action type: ${f}`), _?.label)
        return _?.label;
      let A = "";
      n.tile && !n.actions ? A = `homepage-tile-actions.actions.${n.tile.type}.${n.tile.subType}.${f}` : A = `homepage-tile-actions.actions.${r.value[f]?.label}`;
      const I = s(f, "key");
      return t(I ? `${A}.${I}` : A);
    }, u = (f) => r.value?.[f] || a[n.tile.type]?.[n.tile.subType]?.[f], d = (f) => s(f, "link"), p = (f) => {
      const _ = s(f, "action");
      return !(_ == null || _ == null);
    };
    function m(f) {
      return {
        program: {
          primary: "white",
          secondary: "dark"
        },
        journey_step: {
          primary: "primary",
          secondary: "row"
        }
        // add more cases as needed
      }[n.tile.type]?.[f] || f;
    }
    return (f, _) => (w(), P("div", {
      class: Ce([i.value, { flipped: e.flipped }, { override: e.styleOverride }])
    }, [
      (w(), P(se, null, De(["primary", "secondary"], (y) => (w(), P(se, { key: y }, [
        p(y) && e.displayType == "all" || e.displayType == y ? (w(), P(se, { key: 0 }, [
          l(y) ? (w(), ge(bt, {
            key: 0,
            variant: m(y),
            href: d(y)
          }, {
            default: Oe(() => [
              Ee(D(c(y)), 1)
            ]),
            _: 2
          }, 1032, ["variant", "href"])) : (w(), ge(bt, {
            key: 1,
            variant: m(y),
            onClick: (A) => o(u(y))
          }, {
            default: Oe(() => [
              Ee(D(c(y)), 1)
            ]),
            _: 2
          }, 1032, ["variant", "onClick"]))
        ], 64)) : re("", !0)
      ], 64))), 64))
    ], 2));
  }
}), Hj = ".tile-actions[data-v-25c216db]{display:flex;align-items:flex-start;gap:.5rem;width:fit-content}.tile-actions .base-button[data-v-25c216db]{box-sizing:border-box;width:100%;width:fit-content;padding:0 1.5rem;height:2.7rem;border-radius:6rem;box-shadow:none}.flipped[data-v-25c216db]{flex-direction:row-reverse}.disabled[data-v-25c216db]{opacity:.5;pointer-events:none;filter:grayscale(1)}.override .primary[data-v-25c216db]{background:#0072ef;color:#fff}.override .secondary[data-v-25c216db]{background:#fff;color:#000;border:1px solid #979797}@media screen and (max-width: 600px){.tile-actions[data-v-25c216db]{flex-direction:column;width:100%}.tile-actions .primary[data-v-25c216db],.tile-actions .secondary[data-v-25c216db]{width:100%}.flipped[data-v-25c216db]{flex-direction:column-reverse}}", rr = /* @__PURE__ */ ae(qj, [["styles", [Hj]], ["__scopeId", "data-v-25c216db"]]), Bj = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rr
}, Symbol.toStringTag, { value: "Module" }));
function Jj(e) {
  return !(typeof e != "object" || e instanceof Array);
}
class Wj {
  filterOutNonSupportedKeys(t, n) {
    const r = /* @__PURE__ */ Object.create({});
    return Jj(t) ? (Object.keys(t).forEach((o) => {
      n.indexOf(o) >= 0 ? r[o] = t[o] : console.warn("Warning - unsupported key provided to configuration: ", o);
    }), r) : /* @__PURE__ */ Object.create({});
  }
}
const qu = [
  "cname",
  "secureDistribution",
  "privateCdn",
  "signUrl",
  "longUrlSignature",
  "shorten",
  "useRootPath",
  "secure",
  "forceVersion",
  "analytics",
  "queryParams"
];
class wl extends Wj {
  /**
   * @param {IURLConfig} userURLConfig
   */
  constructor(t) {
    super();
    const n = this.filterOutNonSupportedKeys(t, qu);
    Object.assign(this, {
      secure: !0
    }, n);
  }
  extend(t) {
    const n = this.filterOutNonSupportedKeys(t, qu);
    return new wl(Object.assign({}, this, n));
  }
  /**
   * @param {string} value Sets the cname
   */
  setCname(t) {
    return this.cname = t, this;
  }
  /**
   * @param {string} value Sets the secureDistribution
   */
  setSecureDistribution(t) {
    return this.secureDistribution = t, this;
  }
  /**
   * @param {boolean} value Sets whether to use a private CDN (Removes cloudName from URL)
   */
  setPrivateCdn(t) {
    return this.privateCdn = t, this;
  }
  /**
   * @param value Sets whether or not to sign the URL
   */
  setSignUrl(t) {
    return this.signUrl = t, this;
  }
  /**
   * @param value Sets whether or not to use a long signature
   */
  setLongUrlSignature(t) {
    return this.longUrlSignature = t, this;
  }
  /**
   * @param value Sets whether or not to shorten the URL
   */
  setShorten(t) {
    return this.shorten = t, this;
  }
  /**
   * @param value Sets whether or not to use a root path
   */
  setUseRootPath(t) {
    return this.useRootPath = t, this;
  }
  /**
   * @param value Sets whether or not to deliver the asset through https
   */
  setSecure(t) {
    return this.secure = t, this;
  }
  /**
   * @param value Sets whether to force a version in the URL
   */
  setForceVersion(t) {
    return this.forceVersion = t, this;
  }
  /**
   * @param params Sets additional params
   */
  setQueryParams(t) {
    return this.queryParams = t, this;
  }
}
let Kt = class {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(t) {
    this.values = [], this.delimiter = ":", this.hasValue(t) && this.addValue(t);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(t) {
    return typeof t < "u" && t !== null && t !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(t) {
    return Array.isArray(t) ? this.values = this.values.concat(t) : this.values.push(t), this.values = this.values.filter((n) => this.hasValue(n)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(t) {
    return this.delimiter = t, this;
  }
}, Yj = class extends Error {
  constructor(t = "Unsupported") {
    super(t);
  }
};
function xl(e) {
  return new Yj(e);
}
function Gj() {
  return this._qualifierModel || { error: xl(`unsupported qualifier ${this.constructor.name}`) };
}
let Kj = class {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return Gj.apply(this);
  }
}, dt = class extends Kj {
  constructor(t, n) {
    super(), this.delimiter = "_", this.key = t, n instanceof Kt ? this.qualifierValue = n : (this.qualifierValue = new Kt(), this.qualifierValue.addValue(n));
  }
  toString() {
    const { key: t, delimiter: n, qualifierValue: r } = this;
    return `${t}${n}${r.toString()}`;
  }
  addValue(t) {
    return this.qualifierValue.addValue(t), this;
  }
}, Ct = class extends dt {
  constructor(t, n) {
    let r;
    n ? r = new Kt([t, `${n}`]).setDelimiter(":") : r = t, super("fl", r), this.flagValue = n;
  }
  toString() {
    return super.toString().replace(/\./g, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
};
function Qj(e, t) {
  const n = Array.from(e.entries());
  return t.forEach((r) => {
    n.push(["fl", r]);
  }), n.sort().map((r) => r[1]);
}
function Xj() {
  var e, t, n;
  const r = this._actionModel && Object.keys(this._actionModel).length, o = (n = (t = (e = this._actionModel) === null || e === void 0 ? void 0 : e.source) === null || t === void 0 ? void 0 : t.transformation) === null || n === void 0 ? void 0 : n.error;
  return o && o instanceof Error ? { error: o } : r ? this._actionModel : { error: xl(`unsupported action ${this.constructor.name}`) };
}
let Zj = class {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return Xj.apply(this);
  }
}, Ao = class extends Zj {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(t) {
    return this.actionTag = t, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), Qj(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(t) {
    if (typeof t == "string") {
      const [n, r] = t.toLowerCase().split("_");
      n === "fl" ? this.flags.push(new Ct(r)) : this.qualifiers.set(n, new dt(n, r));
    } else
      this.qualifiers.set(t.key, t);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(t) {
    return typeof t == "string" ? this.flags.push(new Ct(t)) : t instanceof Ct && this.flags.push(t), this;
  }
  addValueToQualifier(t, n) {
    return this.qualifiers.get(t).addValue(n), this;
  }
};
function ew(e) {
  return e && (e.match(/^#/) ? `rgb:${e.substr(1)}` : e);
}
let tw = class extends Ao {
  constructor(t) {
    super(), this._actionModel = {}, this.addQualifier(new dt("b", new Kt(ew(t)).setDelimiter("_"))), this._actionModel.color = t, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(t) {
    const { color: n } = t;
    return new this(n);
  }
}, Hu = class {
  constructor(t) {
    this.raw = t;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: xl(`unsupported action ${this.constructor.name}`) };
  }
};
function nw(e) {
  const t = e;
  return "error" in t && !!t.error;
}
function rw() {
  return new Ct("ignore_aspect_ratio");
}
function ow() {
  return new Ct("lossy");
}
function aw() {
  return new Ct("preserve_transparency");
}
function iw(e) {
  return new Ct("progressive", e);
}
function sw() {
  return new Ct("region_relative");
}
function lw() {
  return new Ct("relative");
}
let cw = class extends Kt {
  constructor(t) {
    super(t), this.val = t;
  }
  getValue() {
    return this.val;
  }
};
function mr(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[e[n]] = n;
  }), t;
}
const xp = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad",
  autoPad: "auto_pad"
}, uw = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, mw = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, dw = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, pw = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, fw = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, _w = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
};
mr(fw);
mr(_w);
const gw = mr(xp), hw = mr(uw);
mr(mw);
mr(dw);
mr(pw);
let vw = class extends Ao {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(t, n, r) {
    super(), this._actionModel = {};
    let o;
    n instanceof cw ? o = n.getValue() : o = n, this._actionModel.actionType = hw[t], this._actionModel[r] = o, this.addQualifier(new dt(t, n));
  }
}, yw = class extends Ct {
  constructor(t) {
    super("progressive", t);
  }
}, ka = class extends vw {
  constructor(t, n) {
    super(t, n, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(ow()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(t) {
    return t instanceof yw ? (this._actionModel.progressive = { mode: t.getFlagValue() }, this.addFlag(t)) : (this._actionModel.progressive = { mode: t }, this.addFlag(iw(t))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(aw()), this;
  }
  static fromJson(t) {
    const { formatType: n, lossy: r, progressive: o, preserveTransparency: a } = t;
    let i;
    return n ? i = new this("f", n) : i = new this("f"), o && (o.mode ? i.progressive(o.mode) : i.progressive()), r && i.lossy(), a && i.preserveTransparency(), i;
  }
}, bw = class kp {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(t) {
    let n;
    if (typeof t == "string") {
      if (t.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      n = new Hu(t);
    } else
      n = t;
    return this.actions.push(n), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(t) {
    return t instanceof kp ? this.actions = this.actions.concat(t.actions) : this.actions.push(new Hu(t)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((t) => t.toString()).filter((t) => t).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(t) {
    return this.addAction(t);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(t) {
    return this.addAction(t);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(t) {
    return this.addAction(t);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(t) {
    return this.addAction(new ka("q", t)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(t) {
    return this.addAction(new ka("f", t)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(t) {
    return t.setLayerType("u"), this.addAction(t);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(t) {
    return this.addAction(t);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(t) {
    return this.addAction(t);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(t) {
    return this.addAction(t);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(t) {
    return this.addAction(new tw(t));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(t) {
    return this.addAction(t);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(t) {
    const n = new Ao();
    let r = t;
    return typeof t == "string" && (r = new Ct(t)), n.addQualifier(r), this.addAction(n);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(t) {
    return this.addAction(t);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(t) {
    return this.addAction(t);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(t) {
    return this.addAction(t);
  }
  toJson() {
    const t = [];
    for (const n of this.actions) {
      const r = n.toJson();
      if (nw(r))
        return r;
      t.push(r);
    }
    return { actions: t };
  }
};
class zw extends bw {
}
function Ss(e) {
  const t = e.toString();
  return t.match(/[A-Z]/gi) || t.length > 1 && t[0] === "0" ? t : !isNaN(parseFloat(t)) && t.indexOf(":") === -1 && t.indexOf(".") === -1 ? `${t}.0` : t;
}
let jw = class extends Kt {
}, ww = class extends Ao {
  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  constructor(t, n, r) {
    super(), this._actionModel = { dimensions: {} }, this._actionModel.actionType = gw[t] || t, this.addQualifier(new dt("c", t)), n && this.width(n), r && this.height(r);
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  height(t) {
    return this._actionModel.dimensions.height = t, this.addQualifier(new dt("h", t));
  }
  /**
   * @description Sets the width of the resize
   * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  width(t) {
    return this._actionModel.dimensions.width = t, this.addQualifier(new dt("w", t));
  }
  /**
   * @description Sets the aspect ratio of the asset.
   * For a list of supported types see {@link Qualifiers.AspectRatio|
    * AspectRatio values}
   * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
   * @return {this}
   */
  aspectRatio(t) {
    if (t instanceof jw)
      return this._actionModel.dimensions.aspectRatio = `${t}`, this.addQualifier(new dt("ar", t));
    if (typeof t == "number" || typeof t == "string")
      return this._actionModel.dimensions.aspectRatio = Ss(t), this.addQualifier(new dt("ar", Ss(t)));
    if (t instanceof Ct)
      return this._actionModel.dimensions.aspectRatio = `${t.qualifierValue}`, this.addFlag(t);
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
   * @return {this}
   */
  relative() {
    return this._actionModel.relative = !0, this.addFlag(lw());
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
   * @return {this}
   */
  regionRelative() {
    return this._actionModel.regionRelative = !0, this.addFlag(sw());
  }
  static fromJson(t) {
    const { actionType: n, dimensions: r, relative: o, regionRelative: a } = t, { aspectRatio: i, width: s, height: l } = r, c = xp[n] || n, u = new this(c, s, l);
    return i && u.aspectRatio(i === "ignore_aspect_ratio" ? rw() : i), o && u.relative(), a && u.regionRelative(), u;
  }
}, kl = class extends dt {
  /**
   * @param value, an array containing (GravityObject | AutoGravity | string) or a string;
   */
  constructor(t) {
    super("g", new Kt(t));
  }
}, Sp = class extends kl {
  constructor() {
    super("auto");
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */
  autoFocus(...t) {
    return this.addValue(t), this;
  }
}, Ep = class extends kl {
  constructor(t) {
    super(t);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */
  fallbackGravity(t) {
    return this.addValue(t.qualifierValue), this;
  }
}, xw = class extends kl {
  constructor(t) {
    super(t);
  }
};
function Pp(...e) {
  const t = [...e];
  return new Ep(t);
}
function Tp() {
  return new Sp();
}
let Za = class extends Kt {
  constructor(t) {
    super(), this.name = t;
  }
  toString() {
    return this.name;
  }
};
function kw() {
  return new Za("ocr_text");
}
function Sw(e) {
  return e && `${e}`.split(":")[0] === "auto";
}
function Ew(e) {
  const t = Sl(e);
  return ["north", "center", "east", "west", "south", "north_west", "south_east", "south_west", "north_east"].includes(t);
}
function Sl(e) {
  return `${e}`.replace("g_", "");
}
function Pw(e) {
  return {
    compass: Sl(e),
    gravityType: "direction"
  };
}
function Tw(e) {
  return Sl(e) === "ocr_text";
}
function Cw() {
  return {
    gravityType: "ocr"
  };
}
function Aw(e) {
  return `${e.qualifierValue}`.split(":")[0] === "auto";
}
function Ow(e) {
  const n = e.toString().split("_"), r = {
    object: n[0]
  };
  return n.length > 1 && (n[1] === "avoid" ? r.avoid = !0 : r.weight = +n[1]), r;
}
function Cp(e) {
  let t;
  const n = e === "auto" ? new Sp() : e;
  return `${e}`.startsWith("auto:") ? t = `${e}`.split(":").filter((o) => o !== "auto") : t = n.qualifierValue.values.filter((o) => o !== "auto"), {
    gravityType: "auto",
    autoFocus: t.map(Ow)
  };
}
function Iw(e) {
  const t = `${e}`.split(":").includes("auto"), n = e.qualifierValue.values, o = {
    gravityType: "object",
    focusOnObjects: (t ? n.slice(0, n.length - 1) : n).map((a) => `${a}`)
  };
  if (t) {
    const a = n[n.length - 1].values.slice(1), i = Tp().autoFocus(...a);
    o.fallbackGravity = Cp(i);
  }
  return o;
}
function Lw(e) {
  const n = e.split(":").map((r) => new Za(r));
  return new Ep(n);
}
function Nw(e) {
  return Ew(e) ? Pw(e) : Tw(e) ? Cw() : Sw(e) || Aw(e) ? Cp(e) : Iw(typeof e == "string" ? Lw(e) : e);
}
let Mw = class Ap extends Kt {
  constructor(t, n) {
    super(), this._weight = n, this.focusOn = t, this.shouldAvoid = !1;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */
  static focusOn(t, n) {
    return new Ap(t, n);
  }
  shouldAddWeight() {
    return typeof this._weight == "number" || typeof this._weight == "string" || this.shouldAvoid;
  }
  /**
   * @summary qualifier
   * @desc Get the name of the of the object
   */
  getName() {
    return this.focusOn.name;
  }
  /**
   * @summary qualifier
   * @desc Get the weight for the object
   */
  getWeight() {
    return this.shouldAvoid ? "avoid" : this._weight;
  }
  /**
   * @summary qualifier
   * @desc Return the string representation of this QualifierValue
   */
  toString() {
    return this.shouldAddWeight() ? `${this.getName()}_${this.getWeight()}` : `${this.getName()}`;
  }
  /**
   * @summary qualifier
   * @description Sets the importance level of the object within the automatic gravity algorithm
   * @param {numebr} w The focus weight for the object
   * @return {this}
   */
  weight(t) {
    return this._weight = t, this;
  }
  /**
   * @summary qualifier
   * @description Attempts to avoid the detected object in the image
   * @return {this}
   */
  avoid() {
    return this.shouldAvoid = !0, this;
  }
}, Rw = class extends Kt {
  constructor(t) {
    super(), this.val = t;
  }
  toString() {
    return this.val;
  }
};
function $w(e) {
  return e.gravityType === "direction";
}
function Dw(e) {
  return e.gravityType === "ocr";
}
function Fw(e) {
  return e.gravityType === "auto";
}
function Uw(e) {
  const { object: t, weight: n, avoid: r } = e, o = new Mw(new Za(t));
  return (n || n === 0) && o.weight(n), r && o.avoid(), o;
}
function Op(e) {
  const n = (e.autoFocus || []).map(Uw);
  return Tp().autoFocus(...n);
}
function Vw(e) {
  const t = (e.focusOnObjects || []).map((r) => new Za(r)), n = Pp(...t);
  if (e.fallbackGravity) {
    const r = Op(e.fallbackGravity);
    n.fallbackGravity(r);
  }
  return n;
}
function qw(e) {
  return $w(e) ? new xw(new Rw(e.compass)) : Dw(e) ? Pp(kw()) : Fw(e) ? Op(e) : Vw(e);
}
let Hw = class extends ww {
  /**
   * @description Which part of the original image to include.
   * @param {Qualifiers.Gravity} gravity
   */
  gravity(t) {
    this._actionModel.gravity = Nw(t);
    const n = typeof t == "string" ? new dt("g", t) : t;
    return this.addQualifier(n);
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.gravity && n.gravity(qw(t.gravity)), n;
  }
}, Bw = class extends Hw {
  /**
   * @description Absolute X position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} x The x position.
   */
  x(t) {
    return this._actionModel.x = t, this.addQualifier(new dt("x", t));
  }
  /**
   * @description Absolute Y position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} y The y position.
   */
  y(t) {
    return this._actionModel.y = t, this.addQualifier(new dt("y", t));
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.x && n.x(t.x), t.y && n.y(t.y), n;
  }
};
function Jw(e, t) {
  return new Bw("fill", e, t);
}
class Ww extends Ao {
  /**
   * Create a new DeliveryDPRAction
   * @param dprValue
   */
  constructor(t) {
    super(), this._actionModel = { actionType: "dpr" };
    const n = Ss(t);
    this._actionModel.dpr = n, this.addQualifier(new dt("dpr", n));
  }
  static fromJson(t) {
    const { dpr: n } = t;
    return new this(n);
  }
}
function Yw(e) {
  return new Ww(e);
}
function Gw(e) {
  return e.match(/^https?:\//);
}
function Kw(e) {
  return e.indexOf("/") < 0;
}
function Qw(e) {
  return e.match(/^v[0-9]+/);
}
function Xw(e, t) {
  const n = t.secure, r = t.privateCdn, o = t.cname, a = t.secureDistribution;
  return !n && !o ? `http://res.cloudinary.com/${e}` : n && !a && r ? `https://${e}-res.cloudinary.com` : n && !a ? `https://res.cloudinary.com/${e}` : n && a && r ? `https://${a}` : n && a ? `https://${a}/${e}` : !n && o ? `http://${o}/${e}` : "ERROR";
}
function Zw(e) {
  return e || "image";
}
function e1(e) {
  return e || "upload";
}
function t1(e, t, n) {
  const r = n !== !1;
  return t ? `v${t}` : Qw(e) || Gw(e) || Kw(e) ? "" : r ? "v1" : "";
}
function El(e, t, n) {
  let r = t >> 0, o = String(n);
  return e.length > r ? String(e) : (r = r - e.length, r > o.length && (o += n1(o, r / o.length)), o.slice(0, r) + String(e));
}
function n1(e, t) {
  let n = t, r = "";
  for (; n > 0; )
    r += e, n--;
  return r;
}
const r1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Sa = {};
let Bu = 0;
r1.split("").forEach((e) => {
  let t = Bu.toString(2);
  t = El(t, 6, "0"), Sa[t] = e, Bu++;
});
function o1(e) {
  if (e.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return e.split(".").reverse().join(".");
}
function a1(e) {
  if (e.split(".").length < 2)
    throw new Error("invalid semVer, must have at least two segments");
  return e.split(".").map((t) => {
    const n = +t;
    if (isNaN(n) || n < 0)
      throw "Invalid version number provided";
    return El(t, 2, "0");
  }).join(".");
}
function Ju(e) {
  let t = "";
  const r = e.split(".").length * 6, o = o1(e), a = a1(o);
  let s = parseInt(a.split(".").join("")).toString(2);
  if (s = El(s, r, "0"), s.length % 6 !== 0)
    throw "Version must be smaller than 43.21.26)";
  return s.match(/.{1,6}/g).forEach((l) => {
    t += Sa[l];
  }), t;
}
function i1(e) {
  const t = {
    sdkSemver: e.sdkSemver,
    techVersion: e.techVersion,
    sdkCode: e.sdkCode,
    product: e.product,
    feature: "0",
    osType: e.osType,
    osVersion: e.osVersion
  };
  return e.accessibility && (t.feature = "D"), e.lazyload && (t.feature = "C"), e.responsive && (t.feature = "A"), e.placeholder && (t.feature = "B"), t;
}
const s1 = "1.19.0";
function l1(e) {
  const [t, n] = e.split("."), r = parseInt(t).toString(2), o = parseInt(n).toString(2), a = r.padStart(6, "0"), i = o.padStart(6, "0");
  return Sa[a] + Sa[i];
}
function c1() {
  const e = "0.0.0";
  if (typeof window < "u")
    return e;
  try {
    return process.versions.node || e;
  } catch {
    return e;
  }
}
function u1(e) {
  const t = {
    techVersion: c1(),
    sdkCode: "T",
    sdkSemver: s1.split("-")[0],
    product: "A",
    osType: "Z",
    osVersion: "0.0",
    responsive: !1,
    placeholder: !1,
    lazyload: !1,
    accessibility: !1
  };
  return e ? Object.assign(Object.assign({}, t), e) : t;
}
function Wu(e) {
  const t = u1(e), n = i1(t);
  try {
    const r = m1(n.techVersion), o = Ju(n.sdkSemver), a = Ju(r), i = l1(n.osVersion), s = n.feature, l = n.sdkCode, { product: c, osType: u } = n;
    return `D${c}${l}${o}${a}${u}${i}${s}`;
  } catch {
    return "E";
  }
}
function m1(e) {
  const t = e.split(".");
  return `${t[0]}.${t[1]}`;
}
const Yu = {
  "image/upload": "images",
  "image/private": "private_images",
  "image/authenticated": "authenticated_images",
  "raw/upload": "files",
  "video/upload": "videos"
};
class d1 {
  constructor(t, n = {}, r) {
    this.setPublicID(t), this.setCloudConfig(n), this.setURLConfig(r);
  }
  /**
   * @description Sets the URL Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setURLConfig(t) {
    return this.urlConfig = new wl(t), this;
  }
  /**
   * @description Sets the Cloud Config for this asset
   * @param urlConfig
   * @return {this}
   */
  setCloudConfig(t) {
    return this.cloudName = t.cloudName, this.apiKey = t.apiKey, this.apiSecret = t.apiSecret, this.authToken = t.authToken, this;
  }
  /**
   * @description Sets the public ID of the asset.
   * @param {string} publicID The public ID of the asset.
   * @return {this}
   */
  setPublicID(t) {
    return this.publicID = t ? t.toString() : "", this;
  }
  /**
   * @description Sets the delivery type of the asset.
   * @param {DELIVERY_TYPE | string} newType The type of the asset.
   * @return {this}
   */
  setDeliveryType(t) {
    return this.deliveryType = t, this;
  }
  /**
   * @description Sets the URL SEO suffix of the asset.
   * @param {string} newSuffix The SEO suffix.
   * @return {this}
   */
  setSuffix(t) {
    return this.suffix = t, this;
  }
  /**
   * @description Sets the signature of the asset.
   * @param {string} signature The signature.
   * @return {this}
   */
  setSignature(t) {
    return this.signature = t, this;
  }
  /**
   * @description Sets the version of the asset.
   * @param {string} newVersion The version of the asset.
   * @return {this}
   */
  setVersion(t) {
    return t && (this.version = t), this;
  }
  /**
   * @description Sets the asset type.
   * @param {string} newType The type of the asset.
   * @return {this}
   */
  setAssetType(t) {
    return t && (this.assetType = t), this;
  }
  sign() {
    return this;
  }
  /**
   * @description Serializes to URL string
   * @param overwriteOptions
   */
  toURL(t = {}) {
    return this.createCloudinaryURL(null, t.trackedAnalytics);
  }
  /**
   * @description Validate various options before attempting to create a URL
   * The function will throw in case a violation
   * @throws Validation errors
   */
  validateAssetForURLCreation() {
    if (typeof this.cloudName > "u")
      throw "You must supply a cloudName when initializing the asset";
    const t = this.suffix && this.suffix.indexOf(".") >= 0, n = this.suffix && this.suffix.indexOf("/") >= 0;
    if (t || n)
      throw "`suffix`` should not include . or /";
  }
  /**
   * @description return an SEO friendly name for a combination of asset/delivery, some examples:
   * * image/upload -> images
   * * video/upload -> videos
   * If no match is found, return `{asset}/{delivery}`
   */
  getResourceType() {
    const t = Zw(this.assetType), n = e1(this.deliveryType), r = !!this.suffix, o = `${t}/${n}`, a = Yu[`${t}/${n}`], i = this.urlConfig.useRootPath, s = this.urlConfig.shorten;
    if (i) {
      if (o === "image/upload")
        return "";
      throw new Error(`useRootPath can only be used with assetType: 'image' and deliveryType: 'upload'. Provided: ${o} instead`);
    }
    if (s && o === "image/upload")
      return "iu";
    if (r) {
      if (a)
        return a;
      throw new Error(`URL Suffix only supported for ${Object.keys(Yu).join(", ")}, Provided: ${o} instead`);
    }
    return o;
  }
  getSignature() {
    return this.signature ? `s--${this.signature}--` : "";
  }
  /**
   *
   * @description Creates a fully qualified CloudinaryURL
   * @return {string} CloudinaryURL
   * @throws Validation Errors
   */
  createCloudinaryURL(t, n) {
    if (!this.publicID)
      return "";
    this.validateAssetForURLCreation();
    const r = Xw(this.cloudName, this.urlConfig), o = t ? t.toString() : "", a = t1(this.publicID, this.version, this.urlConfig.forceVersion), i = this.publicID;
    if (typeof t == "string")
      return [r, this.getResourceType(), this.getSignature(), o, a, i.replace(/,/g, "%2C"), this.suffix].filter((l) => l).join("/");
    {
      const s = [
        encodeURI(r),
        this.getResourceType(),
        this.getSignature(),
        encodeURI(o),
        a,
        encodeURI(i).replace(/,/g, "%2C"),
        this.suffix && encodeURI(this.suffix)
      ].filter((u) => u).join("/").replace(/\?/g, "%3F").replace(/=/g, "%3D"), l = this.urlConfig.analytics !== !1 && !i.includes("?");
      let c = "";
      if (typeof this.urlConfig.queryParams == "object")
        try {
          const u = new URLSearchParams(this.urlConfig.queryParams);
          l && u.set("_a", Wu(n)), c = u.toString();
        } catch {
          console.error("Error: URLSearchParams is not available so the queryParams object cannot be parsed, please try passing as an already parsed string");
        }
      else
        c = this.urlConfig.queryParams || "", l && (c += `${c.length > 0 ? "&" : ""}_a=${Wu(n)}`);
      return c ? `${s}?${c}` : s;
    }
  }
}
class p1 extends d1 {
  constructor(t, n, r, o) {
    super(t, n, r), this.transformation = o;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Animated} animated
   * @return {this}
   */
  animated(t) {
    return this.transformation.animated(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Border} border
   * @return {this}
   */
  border(t) {
    return this.transformation.border(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Reshape} reshape
   * @return {this}
   */
  reshape(t) {
    return this.transformation.reshape(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Resize} resize
   * @return {this}
   */
  resize(t) {
    return this.transformation.resize(t), this;
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(t) {
    return this.addAction(new ka("q", t)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(t) {
    return this.addAction(new ka("f", t)), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.RoundCorners} roundCorners
   * @return {this}
   */
  roundCorners(t) {
    return this.transformation.roundCorners(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  overlay(t) {
    return this.transformation.overlay(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Variable} variableAction
   * @return {this}
   */
  addVariable(t) {
    return this.transformation.addVariable(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Condition} conditionalAction
   * @return {this}
   */
  conditional(t) {
    return this.transformation.conditional(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Effect} effect
   * @return {this}
   */
  effect(t) {
    return this.transformation.effect(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Adjust} action
   * @return {this}
   */
  adjust(t) {
    return this.transformation.adjust(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Rotate} rotate
   * @return {this}
   */
  rotate(t) {
    return this.transformation.rotate(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(t) {
    return this.transformation.namedTransformation(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Delivery} deliveryAction
   * @return {this}
   */
  delivery(t) {
    return this.transformation.delivery(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.color} color
   * @return {this}
   */
  backgroundColor(t) {
    return this.transformation.backgroundColor(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.PSDTools} action
   * @return {this}
   */
  psdTools(t) {
    return this.transformation.psdTools(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.Extract} action
   * @return {this}
   */
  extract(t) {
    return this.transformation.extract(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(t) {
    return this.transformation.addFlag(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {Actions.CustomFunction} customFunction
   * @return {this}
   */
  customFunction(t) {
    return this.transformation.customFunction(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(t) {
    return this.transformation.addAction(t), this;
  }
  /**
   * @description Extend your transformation with another transformation
   * @param { string | SDK.Transformation } tx
   */
  addTransformation(t) {
    return this.transformation.addTransformation(t), this;
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {string}
   */
  toString() {
    return this.transformation.toString();
  }
  /**
   * @desc A proxy to {@link SDK.Transformation| Transformation} - Calls the same method contained in this.transformation
   * @return {this}
   */
  underlay(t) {
    return this.transformation.underlay(t), this;
  }
  toURL(t = {}) {
    return this.createCloudinaryURL(this.transformation, t?.trackedAnalytics);
  }
}
class Gu extends p1 {
  constructor(t, n, r) {
    super(t, n, r, new zw());
  }
}
var kn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Es = { exports: {} };
(function(e, t) {
  var n = 200, r = "__lodash_hash_undefined__", o = 9007199254740991, a = "[object Arguments]", i = "[object Array]", s = "[object Boolean]", l = "[object Date]", c = "[object Error]", u = "[object Function]", d = "[object GeneratorFunction]", p = "[object Map]", m = "[object Number]", f = "[object Object]", _ = "[object Promise]", y = "[object RegExp]", A = "[object Set]", I = "[object String]", j = "[object Symbol]", S = "[object WeakMap]", T = "[object ArrayBuffer]", z = "[object DataView]", O = "[object Float32Array]", N = "[object Float64Array]", F = "[object Int8Array]", te = "[object Int16Array]", he = "[object Int32Array]", Y = "[object Uint8Array]", me = "[object Uint8ClampedArray]", qe = "[object Uint16Array]", zt = "[object Uint32Array]", Me = /[\\^$.*+?()[\]{}|]/g, Pe = /\w*$/, xe = /^\[object .+?Constructor\]$/, gt = /^(?:0|[1-9]\d*)$/, ye = {};
  ye[a] = ye[i] = ye[T] = ye[z] = ye[s] = ye[l] = ye[O] = ye[N] = ye[F] = ye[te] = ye[he] = ye[p] = ye[m] = ye[f] = ye[y] = ye[A] = ye[I] = ye[j] = ye[Y] = ye[me] = ye[qe] = ye[zt] = !0, ye[c] = ye[u] = ye[S] = !1;
  var Be = typeof kn == "object" && kn && kn.Object === Object && kn, Ye = typeof self == "object" && self && self.Object === Object && self, Xe = Be || Ye || Function("return this")(), Zt = t && !t.nodeType && t, fn = Zt && !0 && e && !e.nodeType && e, nt = fn && fn.exports === Zt;
  function en(v, L) {
    return v.set(L[0], L[1]), v;
  }
  function tn(v, L) {
    return v.add(L), v;
  }
  function _n(v, L) {
    for (var q = -1, oe = v ? v.length : 0; ++q < oe && L(v[q], q, v) !== !1; )
      ;
    return v;
  }
  function jt(v, L) {
    for (var q = -1, oe = L.length, Qe = v.length; ++q < oe; )
      v[Qe + q] = L[q];
    return v;
  }
  function Nn(v, L, q, oe) {
    for (var Qe = -1, lt = v ? v.length : 0; ++Qe < lt; )
      q = L(q, v[Qe], Qe, v);
    return q;
  }
  function b(v, L) {
    for (var q = -1, oe = Array(v); ++q < v; )
      oe[q] = L(q);
    return oe;
  }
  function k(v, L) {
    return v?.[L];
  }
  function R(v) {
    var L = !1;
    if (v != null && typeof v.toString != "function")
      try {
        L = !!(v + "");
      } catch {
      }
    return L;
  }
  function U(v) {
    var L = -1, q = Array(v.size);
    return v.forEach(function(oe, Qe) {
      q[++L] = [Qe, oe];
    }), q;
  }
  function V(v, L) {
    return function(q) {
      return v(L(q));
    };
  }
  function W(v) {
    var L = -1, q = Array(v.size);
    return v.forEach(function(oe) {
      q[++L] = oe;
    }), q;
  }
  var Z = Array.prototype, G = Function.prototype, g = Object.prototype, h = Xe["__core-js_shared__"], E = function() {
    var v = /[^.]+$/.exec(h && h.keys && h.keys.IE_PROTO || "");
    return v ? "Symbol(src)_1." + v : "";
  }(), H = G.toString, K = g.hasOwnProperty, J = g.toString, C = RegExp(
    "^" + H.call(K).replace(Me, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), $ = nt ? Xe.Buffer : void 0, ie = Xe.Symbol, _e = Xe.Uint8Array, Ie = V(Object.getPrototypeOf, Object), ht = Object.create, Nt = g.propertyIsEnumerable, nn = Z.splice, pr = Object.getOwnPropertySymbols, rt = $ ? $.isBuffer : void 0, wt = V(Object.keys, Object), fr = hr(Xe, "DataView"), Dr = hr(Xe, "Map"), _i = hr(Xe, "Promise"), gi = hr(Xe, "Set"), hi = hr(Xe, "WeakMap"), Fr = hr(Object, "create"), s_ = $n(fr), l_ = $n(Dr), c_ = $n(_i), u_ = $n(gi), m_ = $n(hi), Wl = ie ? ie.prototype : void 0, Yl = Wl ? Wl.valueOf : void 0;
  function Mn(v) {
    var L = -1, q = v ? v.length : 0;
    for (this.clear(); ++L < q; ) {
      var oe = v[L];
      this.set(oe[0], oe[1]);
    }
  }
  function d_() {
    this.__data__ = Fr ? Fr(null) : {};
  }
  function p_(v) {
    return this.has(v) && delete this.__data__[v];
  }
  function f_(v) {
    var L = this.__data__;
    if (Fr) {
      var q = L[v];
      return q === r ? void 0 : q;
    }
    return K.call(L, v) ? L[v] : void 0;
  }
  function __(v) {
    var L = this.__data__;
    return Fr ? L[v] !== void 0 : K.call(L, v);
  }
  function g_(v, L) {
    var q = this.__data__;
    return q[v] = Fr && L === void 0 ? r : L, this;
  }
  Mn.prototype.clear = d_, Mn.prototype.delete = p_, Mn.prototype.get = f_, Mn.prototype.has = __, Mn.prototype.set = g_;
  function rn(v) {
    var L = -1, q = v ? v.length : 0;
    for (this.clear(); ++L < q; ) {
      var oe = v[L];
      this.set(oe[0], oe[1]);
    }
  }
  function h_() {
    this.__data__ = [];
  }
  function v_(v) {
    var L = this.__data__, q = Ro(L, v);
    if (q < 0)
      return !1;
    var oe = L.length - 1;
    return q == oe ? L.pop() : nn.call(L, q, 1), !0;
  }
  function y_(v) {
    var L = this.__data__, q = Ro(L, v);
    return q < 0 ? void 0 : L[q][1];
  }
  function b_(v) {
    return Ro(this.__data__, v) > -1;
  }
  function z_(v, L) {
    var q = this.__data__, oe = Ro(q, v);
    return oe < 0 ? q.push([v, L]) : q[oe][1] = L, this;
  }
  rn.prototype.clear = h_, rn.prototype.delete = v_, rn.prototype.get = y_, rn.prototype.has = b_, rn.prototype.set = z_;
  function _r(v) {
    var L = -1, q = v ? v.length : 0;
    for (this.clear(); ++L < q; ) {
      var oe = v[L];
      this.set(oe[0], oe[1]);
    }
  }
  function j_() {
    this.__data__ = {
      hash: new Mn(),
      map: new (Dr || rn)(),
      string: new Mn()
    };
  }
  function w_(v) {
    return $o(this, v).delete(v);
  }
  function x_(v) {
    return $o(this, v).get(v);
  }
  function k_(v) {
    return $o(this, v).has(v);
  }
  function S_(v, L) {
    return $o(this, v).set(v, L), this;
  }
  _r.prototype.clear = j_, _r.prototype.delete = w_, _r.prototype.get = x_, _r.prototype.has = k_, _r.prototype.set = S_;
  function gr(v) {
    this.__data__ = new rn(v);
  }
  function E_() {
    this.__data__ = new rn();
  }
  function P_(v) {
    return this.__data__.delete(v);
  }
  function T_(v) {
    return this.__data__.get(v);
  }
  function C_(v) {
    return this.__data__.has(v);
  }
  function A_(v, L) {
    var q = this.__data__;
    if (q instanceof rn) {
      var oe = q.__data__;
      if (!Dr || oe.length < n - 1)
        return oe.push([v, L]), this;
      q = this.__data__ = new _r(oe);
    }
    return q.set(v, L), this;
  }
  gr.prototype.clear = E_, gr.prototype.delete = P_, gr.prototype.get = T_, gr.prototype.has = C_, gr.prototype.set = A_;
  function O_(v, L) {
    var q = bi(v) || ng(v) ? b(v.length, String) : [], oe = q.length, Qe = !!oe;
    for (var lt in v)
      K.call(v, lt) && !(Qe && (lt == "length" || X_(lt, oe))) && q.push(lt);
    return q;
  }
  function Gl(v, L, q) {
    var oe = v[L];
    (!(K.call(v, L) && Zl(oe, q)) || q === void 0 && !(L in v)) && (v[L] = q);
  }
  function Ro(v, L) {
    for (var q = v.length; q--; )
      if (Zl(v[q][0], L))
        return q;
    return -1;
  }
  function I_(v, L) {
    return v && Kl(L, zi(L), v);
  }
  function vi(v, L, q, oe, Qe, lt, on) {
    var ct;
    if (oe && (ct = lt ? oe(v, Qe, lt, on) : oe(v)), ct !== void 0)
      return ct;
    if (!Do(v))
      return v;
    var nc = bi(v);
    if (nc) {
      if (ct = G_(v), !L)
        return J_(v, ct);
    } else {
      var vr = Rn(v), rc = vr == u || vr == d;
      if (og(v))
        return D_(v, L);
      if (vr == f || vr == a || rc && !lt) {
        if (R(v))
          return lt ? v : {};
        if (ct = K_(rc ? {} : v), !L)
          return W_(v, I_(ct, v));
      } else {
        if (!ye[vr])
          return lt ? v : {};
        ct = Q_(v, vr, vi, L);
      }
    }
    on || (on = new gr());
    var oc = on.get(v);
    if (oc)
      return oc;
    if (on.set(v, ct), !nc)
      var ac = q ? Y_(v) : zi(v);
    return _n(ac || v, function(ji, Fo) {
      ac && (Fo = ji, ji = v[Fo]), Gl(ct, Fo, vi(ji, L, q, oe, Fo, v, on));
    }), ct;
  }
  function L_(v) {
    return Do(v) ? ht(v) : {};
  }
  function N_(v, L, q) {
    var oe = L(v);
    return bi(v) ? oe : jt(oe, q(v));
  }
  function M_(v) {
    return J.call(v);
  }
  function R_(v) {
    if (!Do(v) || eg(v))
      return !1;
    var L = tc(v) || R(v) ? C : xe;
    return L.test($n(v));
  }
  function $_(v) {
    if (!Xl(v))
      return wt(v);
    var L = [];
    for (var q in Object(v))
      K.call(v, q) && q != "constructor" && L.push(q);
    return L;
  }
  function D_(v, L) {
    if (L)
      return v.slice();
    var q = new v.constructor(v.length);
    return v.copy(q), q;
  }
  function yi(v) {
    var L = new v.constructor(v.byteLength);
    return new _e(L).set(new _e(v)), L;
  }
  function F_(v, L) {
    var q = L ? yi(v.buffer) : v.buffer;
    return new v.constructor(q, v.byteOffset, v.byteLength);
  }
  function U_(v, L, q) {
    var oe = L ? q(U(v), !0) : U(v);
    return Nn(oe, en, new v.constructor());
  }
  function V_(v) {
    var L = new v.constructor(v.source, Pe.exec(v));
    return L.lastIndex = v.lastIndex, L;
  }
  function q_(v, L, q) {
    var oe = L ? q(W(v), !0) : W(v);
    return Nn(oe, tn, new v.constructor());
  }
  function H_(v) {
    return Yl ? Object(Yl.call(v)) : {};
  }
  function B_(v, L) {
    var q = L ? yi(v.buffer) : v.buffer;
    return new v.constructor(q, v.byteOffset, v.length);
  }
  function J_(v, L) {
    var q = -1, oe = v.length;
    for (L || (L = Array(oe)); ++q < oe; )
      L[q] = v[q];
    return L;
  }
  function Kl(v, L, q, oe) {
    q || (q = {});
    for (var Qe = -1, lt = L.length; ++Qe < lt; ) {
      var on = L[Qe], ct = void 0;
      Gl(q, on, ct === void 0 ? v[on] : ct);
    }
    return q;
  }
  function W_(v, L) {
    return Kl(v, Ql(v), L);
  }
  function Y_(v) {
    return N_(v, zi, Ql);
  }
  function $o(v, L) {
    var q = v.__data__;
    return Z_(L) ? q[typeof L == "string" ? "string" : "hash"] : q.map;
  }
  function hr(v, L) {
    var q = k(v, L);
    return R_(q) ? q : void 0;
  }
  var Ql = pr ? V(pr, Object) : sg, Rn = M_;
  (fr && Rn(new fr(new ArrayBuffer(1))) != z || Dr && Rn(new Dr()) != p || _i && Rn(_i.resolve()) != _ || gi && Rn(new gi()) != A || hi && Rn(new hi()) != S) && (Rn = function(v) {
    var L = J.call(v), q = L == f ? v.constructor : void 0, oe = q ? $n(q) : void 0;
    if (oe)
      switch (oe) {
        case s_:
          return z;
        case l_:
          return p;
        case c_:
          return _;
        case u_:
          return A;
        case m_:
          return S;
      }
    return L;
  });
  function G_(v) {
    var L = v.length, q = v.constructor(L);
    return L && typeof v[0] == "string" && K.call(v, "index") && (q.index = v.index, q.input = v.input), q;
  }
  function K_(v) {
    return typeof v.constructor == "function" && !Xl(v) ? L_(Ie(v)) : {};
  }
  function Q_(v, L, q, oe) {
    var Qe = v.constructor;
    switch (L) {
      case T:
        return yi(v);
      case s:
      case l:
        return new Qe(+v);
      case z:
        return F_(v, oe);
      case O:
      case N:
      case F:
      case te:
      case he:
      case Y:
      case me:
      case qe:
      case zt:
        return B_(v, oe);
      case p:
        return U_(v, oe, q);
      case m:
      case I:
        return new Qe(v);
      case y:
        return V_(v);
      case A:
        return q_(v, oe, q);
      case j:
        return H_(v);
    }
  }
  function X_(v, L) {
    return L = L ?? o, !!L && (typeof v == "number" || gt.test(v)) && v > -1 && v % 1 == 0 && v < L;
  }
  function Z_(v) {
    var L = typeof v;
    return L == "string" || L == "number" || L == "symbol" || L == "boolean" ? v !== "__proto__" : v === null;
  }
  function eg(v) {
    return !!E && E in v;
  }
  function Xl(v) {
    var L = v && v.constructor, q = typeof L == "function" && L.prototype || g;
    return v === q;
  }
  function $n(v) {
    if (v != null) {
      try {
        return H.call(v);
      } catch {
      }
      try {
        return v + "";
      } catch {
      }
    }
    return "";
  }
  function tg(v) {
    return vi(v, !0, !0);
  }
  function Zl(v, L) {
    return v === L || v !== v && L !== L;
  }
  function ng(v) {
    return rg(v) && K.call(v, "callee") && (!Nt.call(v, "callee") || J.call(v) == a);
  }
  var bi = Array.isArray;
  function ec(v) {
    return v != null && ag(v.length) && !tc(v);
  }
  function rg(v) {
    return ig(v) && ec(v);
  }
  var og = rt || lg;
  function tc(v) {
    var L = Do(v) ? J.call(v) : "";
    return L == u || L == d;
  }
  function ag(v) {
    return typeof v == "number" && v > -1 && v % 1 == 0 && v <= o;
  }
  function Do(v) {
    var L = typeof v;
    return !!v && (L == "object" || L == "function");
  }
  function ig(v) {
    return !!v && typeof v == "object";
  }
  function zi(v) {
    return ec(v) ? O_(v) : $_(v);
  }
  function sg() {
    return [];
  }
  function lg() {
    return !1;
  }
  e.exports = tg;
})(Es, Es.exports);
var Gn = Es.exports, bo = function() {
  return bo = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, bo.apply(this, arguments);
};
function f1(e, t, n, r) {
  function o(a) {
    return a instanceof n ? a : new n(function(i) {
      i(a);
    });
  }
  return new (n || (n = Promise))(function(a, i) {
    function s(u) {
      try {
        c(r.next(u));
      } catch (d) {
        i(d);
      }
    }
    function l(u) {
      try {
        c(r.throw(u));
      } catch (d) {
        i(d);
      }
    }
    function c(u) {
      u.done ? a(u.value) : o(u.value).then(s, l);
    }
    c((r = r.apply(e, [])).next());
  });
}
function _1(e, t) {
  var n = { label: 0, sent: function() {
    if (a[0] & 1) throw a[1];
    return a[1];
  }, trys: [], ops: [] }, r, o, a, i;
  return i = { next: s(0), throw: s(1), return: s(2) }, typeof Symbol == "function" && (i[Symbol.iterator] = function() {
    return this;
  }), i;
  function s(c) {
    return function(u) {
      return l([c, u]);
    };
  }
  function l(c) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; i && (i = 0, c[0] && (n = 0)), n; ) try {
      if (r = 1, o && (a = c[0] & 2 ? o.return : c[0] ? o.throw || ((a = o.return) && a.call(o), 0) : o.next) && !(a = a.call(o, c[1])).done) return a;
      switch (o = 0, a && (c = [c[0] & 2, a.value]), c[0]) {
        case 0:
        case 1:
          a = c;
          break;
        case 4:
          return n.label++, { value: c[1], done: !1 };
        case 5:
          n.label++, o = c[1], c = [0];
          continue;
        case 7:
          c = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (a = n.trys, !(a = a.length > 0 && a[a.length - 1]) && (c[0] === 6 || c[0] === 2)) {
            n = 0;
            continue;
          }
          if (c[0] === 3 && (!a || c[1] > a[0] && c[1] < a[3])) {
            n.label = c[1];
            break;
          }
          if (c[0] === 6 && n.label < a[1]) {
            n.label = a[1], a = c;
            break;
          }
          if (a && n.label < a[2]) {
            n.label = a[2], n.ops.push(c);
            break;
          }
          a[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      c = t.call(e, n);
    } catch (u) {
      c = [6, u], o = 0;
    } finally {
      r = a = 0;
    }
    if (c[0] & 5) throw c[1];
    return { value: c[0] ? c[1] : void 0, done: !0 };
  }
}
function Ea(e, t, n, r, o) {
  return f1(this, void 0, void 0, function() {
    var a, i;
    return _1(this, function(s) {
      switch (s.label) {
        case 0:
          if (n === void 0)
            return [
              2
              /*return*/
            ];
          i = 0, s.label = 1;
        case 1:
          return i < n.length ? [4, n[i](e, t, r, o, n)] : [3, 4];
        case 2:
          if (a = s.sent(), a === "canceled")
            return [3, 4];
          s.label = 3;
        case 3:
          return i++, [3, 1];
        case 4:
          return a !== "canceled" ? [2, a] : [
            2
            /*return*/
          ];
      }
    });
  });
}
var Ps = function(e, t) {
  return t === void 0 && (t = {}), e ? {
    trackedAnalytics: bo({ sdkCode: e.sdkCode, sdkSemver: e.sdkSemver, techVersion: e.techVersion }, t)
  } : null;
}, g1 = (
  /** @class */
  function() {
    function e(t, n, r, o) {
      var a = this;
      this.isMounted = !0, this.imgElement = t, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var i = Gn(n);
      Ea(t, i, r, this.htmlPluginState, o).then(function(s) {
        if (a.isMounted) {
          a.htmlPluginState.pluginEventSubscription.forEach(function(c) {
            c();
          });
          var l = Ps(o, s);
          a.imgElement.setAttribute("src", i.toURL(l));
        }
      });
    }
    return e.prototype.update = function(t, n, r) {
      var o = this, a = Gn(t);
      Ea(this.imgElement, a, n, this.htmlPluginState).then(function(i) {
        if (o.isMounted) {
          var s = Ps(r, i);
          o.imgElement.setAttribute("src", a.toURL(s));
        }
      });
    }, e.prototype.unmount = function() {
      this.isMounted = !1;
    }, e;
  }()
);
class $e {
  /**
   *
   * @param {QualifierValue | QualifierValue[] | any[] | string | number}qualifierValue
   */
  constructor(t) {
    this.values = [], this.delimiter = ":", this.hasValue(t) && this.addValue(t);
  }
  /**
   * @description Joins the provided values with the provided delimiter
   */
  toString() {
    return this.values.join(this.delimiter);
  }
  /**
   * @description Checks if the provided argument has a value
   * @param {any} v
   * @private
   * @return {boolean}
   */
  hasValue(t) {
    return typeof t < "u" && t !== null && t !== "";
  }
  /**
   * @desc Adds a value for the this qualifier instance
   * @param {any} value
   * @return {this}
   */
  addValue(t) {
    return Array.isArray(t) ? this.values = this.values.concat(t) : this.values.push(t), this.values = this.values.filter((n) => this.hasValue(n)), this;
  }
  /**
   * @description Sets the delimiter for this instance
   * @param delimiter
   */
  setDelimiter(t) {
    return this.delimiter = t, this;
  }
}
class h1 extends Error {
  constructor(t = "Unsupported") {
    super(t);
  }
}
function Pl(e) {
  return new h1(e);
}
function v1() {
  return this._qualifierModel || { error: Pl(`unsupported qualifier ${this.constructor.name}`) };
}
class y1 {
  constructor() {
    this._qualifierModel = {};
  }
  toJson() {
    return v1.apply(this);
  }
}
class fe extends y1 {
  constructor(t, n) {
    super(), this.delimiter = "_", this.key = t, n instanceof $e ? this.qualifierValue = n : (this.qualifierValue = new $e(), this.qualifierValue.addValue(n));
  }
  toString() {
    const { key: t, delimiter: n, qualifierValue: r } = this;
    return `${t}${n}${r.toString()}`;
  }
  addValue(t) {
    return this.qualifierValue.addValue(t), this;
  }
}
class At extends fe {
  constructor(t, n) {
    let r;
    n ? r = new $e([t, `${n}`]).setDelimiter(":") : r = t, super("fl", r), this.flagValue = n;
  }
  toString() {
    return super.toString().replace(/\./, "%2E");
  }
  getFlagValue() {
    return this.flagValue;
  }
}
function b1(e, t) {
  const n = Array.from(e.entries());
  return t.forEach((r) => {
    n.push(["fl", r]);
  }), n.sort().map((r) => r[1]);
}
function z1() {
  var e, t, n;
  const r = this._actionModel && Object.keys(this._actionModel).length, o = (n = (t = (e = this._actionModel) === null || e === void 0 ? void 0 : e.source) === null || t === void 0 ? void 0 : t.transformation) === null || n === void 0 ? void 0 : n.error;
  return o && o instanceof Error ? { error: o } : r ? this._actionModel : { error: Pl(`unsupported action ${this.constructor.name}`) };
}
class j1 {
  constructor() {
    this._actionModel = {};
  }
  toJson() {
    return z1.apply(this);
  }
}
class It extends j1 {
  constructor() {
    super(...arguments), this.qualifiers = /* @__PURE__ */ new Map(), this.flags = [], this.delimiter = ",", this.actionTag = "";
  }
  prepareQualifiers() {
  }
  /**
   * @description Returns the custom name tag that was given to this action
   * @return {string}
   */
  getActionTag() {
    return this.actionTag;
  }
  /**
   * @description Sets the custom name tag for this action
   * @return {this}
   */
  setActionTag(t) {
    return this.actionTag = t, this;
  }
  /**
   * @description Calls toString() on all child qualifiers (implicitly by using .join()).
   * @return {string}
   */
  toString() {
    return this.prepareQualifiers(), b1(this.qualifiers, this.flags).join(this.delimiter);
  }
  /**
   * @description Adds the parameter to the action.
   * @param {SDK.Qualifier} qualifier
   * @return {this}
   */
  addQualifier(t) {
    if (typeof t == "string") {
      const [n, r] = t.toLowerCase().split("_");
      n === "fl" ? this.flags.push(new At(r)) : this.qualifiers.set(n, new fe(n, r));
    } else
      this.qualifiers.set(t.key, t);
    return this;
  }
  /**
   * @description Adds a flag to the current action.
   * @param {Qualifiers.Flag} flag
   * @return {this}
   */
  addFlag(t) {
    return typeof t == "string" ? this.flags.push(new At(t)) : t instanceof At && this.flags.push(t), this;
  }
  addValueToQualifier(t, n) {
    return this.qualifiers.get(t).addValue(n), this;
  }
}
class Tl extends It {
  constructor(t) {
    super(), this.regionType = t, this._actionModel.regionType = t;
  }
}
class ei extends Tl {
  constructor() {
    super("custom");
  }
  /**
   * @description The x position in pixels.
   * @param {number | string} x
   */
  x(t) {
    return this._actionModel.x = t, this.addQualifier(new fe("x", t)), this;
  }
  /**
   * @description The y position in pixels.
   * @param {number | string} y
   */
  y(t) {
    return this._actionModel.y = t, this.addQualifier(new fe("y", t)), this;
  }
  /**
   * @description The width of the region in pixels.
   * @param {number | string} width
   */
  width(t) {
    return this._actionModel.width = t, this.addQualifier(new fe("w", t)), this;
  }
  /**
   * @description The height of the region in pixels.
   * @param {number | string} height
   */
  height(t) {
    return this._actionModel.height = t, this.addQualifier(new fe("h", t)), this;
  }
  static fromJson(t) {
    const n = new ei();
    return t.width && n.width(t.width), t.height && n.height(t.height), t.x && n.x(t.x), t.y && n.y(t.y), n;
  }
}
function w1() {
  return new ei();
}
function Ip() {
  return new Tl("faces");
}
function x1() {
  return new Tl("ocr_text");
}
class k1 extends It {
  constructor(t) {
    super(), this._actionModel = {}, this._strength = t, this._actionModel.actionType = "blur", this._actionModel.strength = t;
  }
  /**
   * @description Specifies the region to blur.
   * @param {NamedRegion} blurRegion
   */
  region(t) {
    return this._region = t, this._actionModel.region = t.toJson(), this;
  }
  /**
   * @description Sets the strength of the blur effect.
   * @param {number | string} strength
   */
  strength(t) {
    return this._strength = t, this._actionModel.strength = t, this;
  }
  prepareQualifiers() {
    const t = this._strength ? `:${this._strength}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((r) => this.addQualifier(r)), this._region.regionType === "custom" && this.addQualifier(new fe("e", `blur_region${t}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new fe("e", `blur_region${t}`)), this.addQualifier(new fe("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new fe("e", `blur_faces${t}`))) : this.addQualifier(new fe("e", `blur${t}`));
  }
  static fromJson(t) {
    const { strength: n, region: r } = t, o = new this(n);
    return n && o.strength(n), r && r.regionType === "faces" && o.region(Ip()), r && r.regionType === "ocr_text" && o.region(x1()), r && r.regionType === "custom" && o.region(ei.fromJson(r)), o;
  }
}
function dr(e) {
  const t = {};
  return Object.keys(e).forEach((n) => {
    t[e[n]] = n;
  }), t;
}
const Lp = {
  limitFit: "limit",
  limitFill: "lfill",
  minimumFit: "mfit",
  thumbnail: "thumb",
  limitPad: "lpad",
  minimumPad: "mpad"
}, S1 = {
  colorSpace: "cs",
  dpr: "dpr",
  density: "dn",
  defaultImage: "d",
  format: "f",
  quality: "q"
}, Np = {
  redEye: "redeye",
  advancedRedEye: "adv_redeye",
  oilPaint: "oil_paint",
  unsharpMask: "unsharp_mask",
  makeTransparent: "make_transparent",
  generativeRestore: "gen_restore",
  upscale: "upscale"
}, Mp = {
  autoBest: "auto:best",
  autoEco: "auto:eco",
  autoGood: "auto:good",
  autoLow: "auto:low",
  jpegminiHigh: "jpegmini:1",
  jpegminiMedium: "jpegmini:2",
  jpegminiBest: "jpegmini:0"
}, E1 = {
  fullHd: "full_hd",
  fullHdWifi: "full_hd_wifi",
  fullHdLean: "full_hd_lean",
  hdLean: "hd_lean"
}, Rp = {
  444: "CHROMA_444",
  420: "CHROMA_420"
}, P1 = {
  noCmyk: "no_cmyk",
  keepCmyk: "keep_cmyk",
  tinySrgb: "tinysrgb",
  srgbTrueColor: "srgb:truecolor"
}, T1 = dr(Rp);
dr(P1);
const C1 = dr(Lp), A1 = dr(S1), $p = dr(Np);
dr(Mp);
dr(E1);
class Dp extends It {
  constructor(t, n) {
    super(), this._actionModel = {}, this._actionModel.actionType = $p[t] || t;
    const r = this.createEffectQualifier(t, n);
    this.addQualifier(r);
  }
  createEffectQualifier(t, n) {
    let r;
    return n ? r = new $e([t, `${n}`]).setDelimiter(":") : r = new $e(t), new fe("e", r);
  }
  static fromJson(t) {
    const { actionType: n, level: r, strength: o } = t, a = Np[n] || n;
    return new this(a, r || o);
  }
}
class O1 extends Dp {
  constructor(t, n) {
    super(t, n), this.LEVEL_NAME = "level", this._actionModel = {}, this.effectType = t, this._actionModel.actionType = $p[t] || t, n && this.setLevel(n);
  }
  /**
   *
   * @description Sets the effect level for the action
   * @param {string | number} level - The strength of the effect
   * @protected
   */
  setLevel(t) {
    this._actionModel[this.LEVEL_NAME] = t;
    const n = this.createEffectQualifier(this.effectType, t);
    return this.addQualifier(n), this;
  }
}
function ti(e) {
  return e && (e.match(/^#/) ? `rgb:${e.substr(1)}` : e);
}
class I1 extends It {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "vectorize";
  }
  /**
   * @description The number of colors. (Range: 2 to 30, Server default: 10)
   * @param {number | string} num
   * @return {this}
   */
  numOfColors(t) {
    return this._actionModel.numOfColors = t, this._numOfColors = t, this;
  }
  /**
   * @description The level of detail. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 1000). (Server default: 300)
   * @param {number | string} num
   * @return {this}
   */
  detailsLevel(t) {
    return this._actionModel.detailLevel = t, this._detailsLevel = t, this;
  }
  /**
   * @description The size of speckles to suppress. Specify either a percentage of the original image (Range: 0.0 to 1.0) or an absolute number of pixels (Range: 0 to 100, Server default: 2)
   * @param {number | string} num
   * @return {this}
   */
  despeckleLevel(t) {
    return this._actionModel.despeckleLevel = t, this._despeckleLevel = t, this;
  }
  /**
   * @description The corner threshold. Specify 100 for no smoothing (polygon corners), 0 for completely smooth corners. (Range: 0 to 100, Default: 25)
   * @param {number | string} num
   * @return {this}
   */
  cornersLevel(t) {
    return this._actionModel.cornersLevel = t, this._cornersLevel = t, this;
  }
  /**
   * @description The optimization value. Specify 100 for least optimization and the largest file. (Range: 0 to 100, Server default: 100).
   * @param {number} num
   * @return {this}
   */
  paths(t) {
    return this._actionModel.paths = t, this._paths = t, this;
  }
  prepareQualifiers() {
    let t = "vectorize";
    this._numOfColors && (t += `:${new $e(`colors:${this._numOfColors}`).toString()}`), this._detailsLevel && (t += `:${new $e(`detail:${this._detailsLevel}`).toString()}`), this._despeckleLevel && (t += `:${new $e(`despeckle:${this._despeckleLevel}`).toString()}`), this._paths && (t += `:${new $e(`paths:${this._paths}`).toString()}`), this._cornersLevel && (t += `:${new $e(`corners:${this._cornersLevel}`).toString()}`), this.addQualifier(new fe("e", t));
  }
  static fromJson(t) {
    const { actionType: n, paths: r, cornersLevel: o, despeckleLevel: a, detailLevel: i, numOfColors: s } = t, l = new this();
    return r && l.paths(r), o && l.cornersLevel(o), a && l.despeckleLevel(a), i && l.detailsLevel(i), s && l.numOfColors(s), l;
  }
}
class L1 extends O1 {
  level(t) {
    return this._actionModel.level = t, this.setLevel(t);
  }
}
class N1 extends It {
  constructor() {
    super(), this._actionModel = {}, this._actionModel.actionType = "assistColorblind", this.addQualifier(new fe("e", new $e("assist_colorblind")));
  }
  /**
   * @description Replaces problematic colors with colors that are easier to differentiate.
   * @return {this}
   */
  xray() {
    return this._actionModel.type = "xray", this.addQualifier(new fe("e", new $e(["assist_colorblind", "xray"]).setDelimiter(":")));
  }
  /**
   * @description Applies stripes of the specified intensity to help people with common color blind conditions to differentiate between colors that are similar for them.
   * @param {number | string} strength The intensity of the stripes. (Range: 1 to 100, Server default: 10)
   * @return {this}
   */
  stripesStrength(t) {
    return this._actionModel.type = "stripes", this._actionModel.stripesStrength = t, this.addQualifier(new fe("e", new $e(["assist_colorblind", t]).setDelimiter(":")));
  }
  static fromJson(t) {
    const { actionType: n, type: r, stripesStrength: o } = t, a = new this();
    return r === "xray" && a.xray(), r === "stripes" && o && a.stripesStrength(o), a;
  }
}
class M1 extends L1 {
  /**
   * @description The color to use for colorization. Specify HTML name or RGB hex code. (Server default: gray)
   * @param {string} color HTML name(red, green, etc.) or RGB hex code. (Server default: gray)
   * @return {this}
   */
  color(t) {
    return this._actionModel.color = t, this.addQualifier(new fe("co", new $e(ti(t))));
  }
  static fromJson(t) {
    const { actionType: n, level: r, color: o } = t, a = new this(n, r);
    return o && a.color(o), a;
  }
}
class R1 extends It {
  constructor(t) {
    super(), this._actionModel = {}, this._squareSize = t, this._actionModel.actionType = "pixelate", this._actionModel.squareSize = t;
  }
  /**
   * @description Specifies the region to piexlate.
   * @param {NamedRegion} pixelateRegion
   */
  region(t) {
    return this._region = t, this._actionModel.region = { regionType: this._region.regionType }, this;
  }
  /**
   * @description Sets the squareSize of the pixelate effect.
   * @param {number | string} squareSize
   */
  squareSize(t) {
    return this._squareSize = t, this._actionModel.squareSize = t, this;
  }
  prepareQualifiers() {
    const t = this._squareSize ? `:${this._squareSize}` : "";
    "_region" in this ? (this._region.qualifiers.forEach((r) => this.addQualifier(r)), this._region.regionType === "custom" && this.addQualifier(new fe("e", `pixelate_region${t}`)), this._region.regionType === "ocr_text" && (this.addQualifier(new fe("e", `pixelate_region${t}`)), this.addQualifier(new fe("g", "ocr_text"))), this._region.regionType === "faces" && this.addQualifier(new fe("e", `pixelate_faces${t}`))) : this.addQualifier(new fe("e", `pixelate${t}`));
  }
  static fromJson(t) {
    const { region: n, squareSize: r } = t, o = new this(r);
    return r && o.squareSize(r), n && n.regionType === "faces" && o.region(Ip()), n && n.regionType === "custom" && o.region(w1()), o;
  }
}
function $1(e) {
  return new k1(e);
}
function D1() {
  return new Dp("grayscale");
}
function Ku(e) {
  return new M1("colorize", e);
}
function F1() {
  return new I1();
}
function U1() {
  return new N1();
}
function V1(e) {
  return new R1(e);
}
class q1 extends It {
  constructor(t) {
    super(), this._actionModel = {}, this.addQualifier(new fe("b", new $e(ti(t)).setDelimiter("_"))), this._actionModel.color = t, this._actionModel.actionType = "backgroundColor";
  }
  static fromJson(t) {
    const { color: n } = t;
    return new this(n);
  }
}
class Qu {
  constructor(t) {
    this.raw = t;
  }
  toString() {
    return this.raw;
  }
  toJson() {
    return { error: Pl(`unsupported action ${this.constructor.name}`) };
  }
}
function H1(e) {
  const t = e;
  return "error" in t && !!t.error;
}
function B1() {
  return new At("ignore_aspect_ratio");
}
function J1() {
  return new At("lossy");
}
function W1() {
  return new At("preserve_transparency");
}
function Y1(e) {
  return new At("progressive", e);
}
function G1() {
  return new At("region_relative");
}
function K1() {
  return new At("relative");
}
class Cl extends $e {
  constructor(t) {
    super(t), this.val = t;
  }
  getValue() {
    return this.val;
  }
}
class Fp extends It {
  /**
   * @param {string} deliveryKey A generic Delivery Action Key (such as q, f, dn, etc.)
   * @param {string} deliveryType A Format Qualifiers for the action, such as Quality.auto()
   * @param {string} modelProperty internal model property of the action, for example quality uses `level` while dpr uses `density`
   * @see Visit {@link Actions.Delivery|Delivery} for an example
   */
  constructor(t, n, r) {
    super(), this._actionModel = {};
    let o;
    n instanceof Cl ? o = n.getValue() : o = n, this._actionModel.actionType = A1[t], this._actionModel[r] = o, this.addQualifier(new fe(t, n));
  }
}
class Q1 extends At {
  constructor(t) {
    super("progressive", t);
  }
}
class Ts extends Fp {
  constructor(t, n) {
    super(t, n, "formatType");
  }
  /**
   * @description Uses lossy compression when delivering animated GIF files.
   * @return {this}
   */
  lossy() {
    return this._actionModel.lossy = !0, this.addFlag(J1()), this;
  }
  /**
   * @description Uses progressive compression when delivering JPG file format.
   * @return {this}
   */
  progressive(t) {
    return t instanceof Q1 ? (this._actionModel.progressive = { mode: t.getFlagValue() }, this.addFlag(t)) : (this._actionModel.progressive = { mode: t }, this.addFlag(Y1(t))), this;
  }
  /**
   * @description Ensures that images with a transparency channel are delivered in PNG format.
   */
  preserveTransparency() {
    return this._actionModel.preserveTransparency = !0, this.addFlag(W1()), this;
  }
  static fromJson(t) {
    const { formatType: n, lossy: r, progressive: o, preserveTransparency: a } = t;
    let i;
    return n ? i = new this("f", n) : i = new this("f"), o && (o.mode ? i.progressive(o.mode) : i.progressive()), r && i.lossy(), a && i.preserveTransparency(), i;
  }
}
class Mr {
  constructor() {
    this.actions = [];
  }
  /**
   * @param {SDK.Action | string} action
   * @return {this}
   */
  addAction(t) {
    let n;
    if (typeof t == "string") {
      if (t.indexOf("/") >= 0)
        throw "addAction cannot accept a string with a forward slash in it - /, use .addTransformation() instead";
      n = new Qu(t);
    } else
      n = t;
    return this.actions.push(n), this;
  }
  /**
   * @description Allows the injection of a raw transformation as a string into the transformation, or a Transformation instance that was previously created
   * @param {string | SDK.Transformation} tx
   * @example
   * import {Transformation} from "@cloudinary/url-gen";
   *
   * const transformation = new Transformation();
   * transformation.addTransformation('w_100/w_200/w_300');
   * @return {this}
   */
  addTransformation(t) {
    return t instanceof Mr ? this.actions = this.actions.concat(t.actions) : this.actions.push(new Qu(t)), this;
  }
  /**
   * @return {string}
   */
  toString() {
    return this.actions.map((t) => t.toString()).filter((t) => t).join("/");
  }
  /**
   * @description Delivers an animated GIF.
   * @param {AnimatedAction} animatedAction
   * @return {this}
   */
  animated(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a border around the image.
   * @param {Border} borderAction
   * @return {this}
   */
  border(t) {
    return this.addAction(t);
  }
  /**
   * @description Adjusts the shape of the delivered image. </br>
   * <b>Learn more:</b> {@link https://cloudinary.com/documentation/effects_and_artistic_enhancements#distort|Shape changes and distortion effects}
   * @param {IReshape} reshapeAction
   * @return {this}
   */
  reshape(t) {
    return this.addAction(t);
  }
  /**
   * @description Resize the asset using provided resize action
   * @param {ResizeSimpleAction} resizeAction
   * @return {this}
   */
  resize(t) {
    return this.addAction(t);
  }
  /**
   * @desc An alias to Action Delivery.quality
   * @param {string|number} quality
   * @return {this}
   */
  quality(t) {
    return this.addAction(new Ts("q", t)), this;
  }
  /**
   * @desc An alias to Action Delivery.format
   * @param {string} format
   * @return {this}
   */
  format(t) {
    return this.addAction(new Ts("f", t)), this;
  }
  /**
   * @description Rounds the specified corners of an image.
   * @param roundCornersAction
   * @return {this}
   */
  roundCorners(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an overlay over the base image.
   * @param {LayerAction} overlayAction
   * @return {this}
   */
  overlay(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds an underlay under the base image.
   * @param {LayerAction} underlayAction
   * @return {this}
   */
  underlay(t) {
    return t.setLayerType("u"), this.addAction(t);
  }
  /**
   * @description Defines an new user variable.
   * @param {VariableAction} variableAction
   * @return {this}
   */
  addVariable(t) {
    return this.addAction(t);
  }
  /**
   * @description Specifies a condition to be met before applying a transformation.
   * @param {ConditionalAction} conditionAction
   * @return {this}
   */
  conditional(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a filter or an effect on an asset.
   * @param {SimpleEffectAction} effectAction
   * @return {this}
   */
  effect(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies adjustment effect on an asset.
   * @param action
   * @return {this}
   */
  adjust(t) {
    return this.addAction(t);
  }
  /**
   * @description Rotates the asset by the given angle.
   * @param {RotateAction} rotateAction
   * @return {this}
   */
  rotate(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies a pre-defined named transformation of the given name.
   * @param {NamedTransformation} namedTransformation
   * @return {this}
   */
  namedTransformation(t) {
    return this.addAction(t);
  }
  /**
   * @description Applies delivery action.
   * @param deliveryAction
   * @return {this}
   */
  delivery(t) {
    return this.addAction(t);
  }
  /**
   * @description Sets the color of the background.
   * @param {Qualifiers.Color} color
   * @return {this}
   */
  backgroundColor(t) {
    return this.addAction(new q1(t));
  }
  /**
   * @description Adds a layer in a Photoshop document.
   * @param action
   * @return {this}
   */
  psdTools(t) {
    return this.addAction(t);
  }
  /**
   * @description Extracts an image or a page using an index, a range, or a name from a layered media asset.
   * @param action
   * @return {this}
   */
  extract(t) {
    return this.addAction(t);
  }
  /**
   * @description Adds a flag as a separate action.
   * @param {Qualifiers.Flag | string} flagQualifier
   * @return {this}
   */
  addFlag(t) {
    const n = new It();
    let r = t;
    return typeof t == "string" && (r = new At(t)), n.addQualifier(r), this.addAction(n);
  }
  /**
   * @description Inject a custom function into the image transformation pipeline.
   * @return {this}
   */
  customFunction(t) {
    return this.addAction(t);
  }
  /**
   * Transcodes the video (or audio) to another format.
   * @param {Action} action
   * @return {this}
   */
  transcode(t) {
    return this.addAction(t);
  }
  /**
   * Applies the specified video edit action.
   *
   * @param {videoEditType} action
   * @return {this}
   */
  videoEdit(t) {
    return this.addAction(t);
  }
  toJson() {
    const t = [];
    for (const n of this.actions) {
      const r = n.toJson();
      if (H1(r))
        return r;
      t.push(r);
    }
    return { actions: t };
  }
}
function Xu(e) {
  const t = e.toString();
  return t.match(/[A-Z]/gi) || t.length > 1 && t[0] === "0" ? t : !isNaN(parseFloat(t)) && t.indexOf(":") === -1 && t.indexOf(".") === -1 ? `${t}.0` : t;
}
class X1 extends $e {
}
class Up extends It {
  /**
   * @param {string} cropType
   * @param {number | string} cropWidth The required width of a transformed asset.
   * @param {number | string} cropHeight The required height of a transformed asset.
   */
  constructor(t, n, r) {
    super(), this._actionModel = { dimensions: {} }, this._actionModel.actionType = C1[t] || t, this.addQualifier(new fe("c", t)), n && this.width(n), r && this.height(r);
  }
  /**
   * @description Sets the height of the resize
   * @param {string | number} x The height in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  height(t) {
    return this._actionModel.dimensions.height = t, this.addQualifier(new fe("h", t));
  }
  /**
   * @description Sets the width of the resize
   * @param {string | number} x The width in pixels (if an integer is specified) or as a percentage (if a float is specified).
   */
  width(t) {
    return this._actionModel.dimensions.width = t, this.addQualifier(new fe("w", t));
  }
  /**
   * @description Sets the aspect ratio of the asset.
   * For a list of supported types see {@link Qualifiers.AspectRatio|
    * AspectRatio values}
   * @param {AspectRatioType|number|string} ratio The new aspect ratio, specified as a percentage or ratio.
   * @return {this}
   */
  aspectRatio(t) {
    if (t instanceof X1)
      return this._actionModel.dimensions.aspectRatio = `${t}`, this.addQualifier(new fe("ar", t));
    if (typeof t == "number" || typeof t == "string")
      return this._actionModel.dimensions.aspectRatio = Xu(t), this.addQualifier(new fe("ar", Xu(t)));
    if (t instanceof At)
      return this._actionModel.dimensions.aspectRatio = `${t.qualifierValue}`, this.addFlag(t);
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the containing image instead of the added layer.
   * @return {this}
   */
  relative() {
    return this._actionModel.relative = !0, this.addFlag(K1());
  }
  /**
   * @description Modifies percentage-based width & height parameters of overlays and underlays (e.g., 1.0) to be relative to the overlaid region
   * @return {this}
   */
  regionRelative() {
    return this._actionModel.regionRelative = !0, this.addFlag(G1());
  }
  static fromJson(t) {
    const { actionType: n, dimensions: r, relative: o, regionRelative: a } = t, { aspectRatio: i, width: s, height: l } = r, c = Lp[n] || n, u = new this(c, s, l);
    return i && u.aspectRatio(i === "ignore_aspect_ratio" ? B1() : i), o && u.relative(), a && u.regionRelative(), u;
  }
}
class ni extends fe {
  /**
   * @param value, an array containing (GravityObject | AutoGravity | string) or a string;
   */
  constructor(t) {
    super("g", new $e(t));
  }
}
class Vp extends ni {
  constructor() {
    super("auto");
  }
  /**
   * @description Autofocuses on objects, allowing their priority within the algorithm to be configured.
   * @param {AutoFocus} AutoFocusObjects
   */
  autoFocus(...t) {
    return this.addValue(t), this;
  }
}
class qp extends ni {
  constructor(t) {
    super(t);
  }
  /**
   * @description Specifies the gravity to use if none of the other gravity objects are found.
   * @param {Qualifiers.Gravity.AutoGravity} val
   */
  fallbackGravity(t) {
    return this.addValue(t.qualifierValue), this;
  }
}
class Hp extends ni {
  constructor(t) {
    super(t);
  }
}
function Z1(e) {
  return new Hp(e);
}
function Bp(...e) {
  const t = [...e];
  return new qp(t);
}
function Jp() {
  return new Vp();
}
class ri extends $e {
  constructor(t) {
    super(), this.name = t;
  }
  toString() {
    return this.name;
  }
}
function ex() {
  return new ri("ocr_text");
}
function tx(e) {
  return e && `${e}`.split(":")[0] === "auto";
}
function nx(e) {
  const t = Al(e);
  return ["north", "center", "east", "west", "south", "north_west", "south_east", "south_west", "north_east"].includes(t);
}
function Al(e) {
  return `${e}`.replace("g_", "");
}
function rx(e) {
  return {
    compass: Al(e),
    gravityType: "direction"
  };
}
function ox(e) {
  return Al(e) === "ocr_text";
}
function ax() {
  return {
    gravityType: "ocr"
  };
}
function ix(e) {
  return `${e.qualifierValue}`.split(":")[0] === "auto";
}
function sx(e) {
  const n = e.toString().split("_"), r = {
    object: n[0]
  };
  return n.length > 1 && (n[1] === "avoid" ? r.avoid = !0 : r.weight = +n[1]), r;
}
function Wp(e) {
  let t;
  const n = e === "auto" ? new Vp() : e;
  return `${e}`.startsWith("auto:") ? t = `${e}`.split(":").filter((o) => o !== "auto") : t = n.qualifierValue.values.filter((o) => o !== "auto"), {
    gravityType: "auto",
    autoFocus: t.map(sx)
  };
}
function lx(e) {
  const t = `${e}`.split(":").includes("auto"), n = e.qualifierValue.values, o = {
    gravityType: "object",
    focusOnObjects: (t ? n.slice(0, n.length - 1) : n).map((a) => `${a}`)
  };
  if (t) {
    const a = n[n.length - 1].values.slice(1), i = Jp().autoFocus(...a);
    o.fallbackGravity = Wp(i);
  }
  return o;
}
function cx(e) {
  const n = e.split(":").map((r) => new ri(r));
  return new qp(n);
}
function ux(e) {
  return nx(e) ? rx(e) : ox(e) ? ax() : tx(e) || ix(e) ? Wp(e) : lx(typeof e == "string" ? cx(e) : e);
}
class Ol extends $e {
  constructor(t, n) {
    super(), this._weight = n, this.focusOn = t, this.shouldAvoid = !1;
  }
  /**
   * @summary qualifier
   * @description Specifies the object to focus on automatically
   * Accepts an AutoFocusObject (which is just a wrapper for a FocusOn object, but with extra method: avoid, weight)
   * @param {Qualifiers.FocusOn} obj The object to focus on.
   * @param {number} weight
   */
  static focusOn(t, n) {
    return new Ol(t, n);
  }
  shouldAddWeight() {
    return typeof this._weight == "number" || typeof this._weight == "string" || this.shouldAvoid;
  }
  /**
   * @summary qualifier
   * @desc Get the name of the of the object
   */
  getName() {
    return this.focusOn.name;
  }
  /**
   * @summary qualifier
   * @desc Get the weight for the object
   */
  getWeight() {
    return this.shouldAvoid ? "avoid" : this._weight;
  }
  /**
   * @summary qualifier
   * @desc Return the string representation of this QualifierValue
   */
  toString() {
    return this.shouldAddWeight() ? `${this.getName()}_${this.getWeight()}` : `${this.getName()}`;
  }
  /**
   * @summary qualifier
   * @description Sets the importance level of the object within the automatic gravity algorithm
   * @param {numebr} w The focus weight for the object
   * @return {this}
   */
  weight(t) {
    return this._weight = t, this;
  }
  /**
   * @summary qualifier
   * @description Attempts to avoid the detected object in the image
   * @return {this}
   */
  avoid() {
    return this.shouldAvoid = !0, this;
  }
}
class Yp extends $e {
  constructor(t) {
    super(), this.val = t;
  }
  toString() {
    return this.val;
  }
}
function mx(e) {
  return e.gravityType === "direction";
}
function dx(e) {
  return e.gravityType === "ocr";
}
function px(e) {
  return e.gravityType === "auto";
}
function fx(e) {
  const { object: t, weight: n, avoid: r } = e, o = new Ol(new ri(t));
  return (n || n === 0) && o.weight(n), r && o.avoid(), o;
}
function Gp(e) {
  const n = (e.autoFocus || []).map(fx);
  return Jp().autoFocus(...n);
}
function _x(e) {
  const t = (e.focusOnObjects || []).map((r) => new ri(r)), n = Bp(...t);
  if (e.fallbackGravity) {
    const r = Gp(e.fallbackGravity);
    n.fallbackGravity(r);
  }
  return n;
}
function gx(e) {
  return mx(e) ? new Hp(new Yp(e.compass)) : dx(e) ? Bp(ex()) : px(e) ? Gp(e) : _x(e);
}
class Il extends Up {
  /**
   * @description Which part of the original image to include.
   * @param {Qualifiers.Gravity} gravity
   */
  gravity(t) {
    this._actionModel.gravity = ux(t);
    const n = typeof t == "string" ? new fe("g", t) : t;
    return this.addQualifier(n);
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.gravity && n.gravity(gx(t.gravity)), n;
  }
}
class Oo extends fe {
  constructor(t) {
    super("b"), t && this.addValue(t);
  }
}
const Kp = 100, hx = 0;
class vx extends Oo {
  /**
   * @description Sets the intensity of the blur.
   * @param {number} value - The intensity of the blur.
   */
  intensity(t) {
    return this.intensityLevel = t, this;
  }
  /**
   * @description Sets the brightness of the background.
   * @param {number} value - The brightness of the background.
   */
  brightness(t) {
    return this.brightnessLevel = t, this;
  }
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function
   */
  toString() {
    const t = this.intensityLevel !== void 0 ? `:${this.intensityLevel}` : "", n = this.brightnessLevel !== void 0 ? this.intensityLevel !== void 0 ? `:${this.brightnessLevel}` : `:${Kp}:${this.brightnessLevel}` : "";
    return `b_blurred${t}${n}`;
  }
}
var Qp = vx;
class Ll extends Oo {
  constructor() {
    super(), this._palette = [];
  }
  /**
   * @description Selects the strongest contrasting color to use for padding.
   * @return {this}
   */
  contrast() {
    return this._contrast = !0, this;
  }
  /**
   * @description Defines the custom colors to use when resizing using content-aware padding.
   * @param {...string} colors One or more colors - Example: palette('green', 'red', blue')
   * @return {this}
   */
  palette(...t) {
    return this._palette = t.map((n) => ti(n)), this;
  }
}
class Xp extends Ll {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class Zp extends Ll {
  /**
   *
   * @description Sets the number of predominant colors to use (2 or 4).
   * @param {number} num
   * @return {this}
   */
  gradientColors(t) {
    return this._gradientColors = t, this;
  }
  /**
   * @description Sets the direction for a background gradient fade effect.
   * @param {Qualifiers.GradientDirection | GradientDirectionType | string} direction Use one of these functions
   * provided by {@link Qualifiers.GradientDirection|GradientDirection}
   * @return {this}
   */
  gradientDirection(t) {
    return this._gradientDirection = t, this;
  }
}
class ef extends Zp {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:border_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class tf extends Zp {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant_gradient
    ${this._contrast ? "_contrast" : ""}
    ${this._gradientColors ? `:${this._gradientColors}` : ""}
    ${this._gradientDirection ? `:${this._gradientDirection}` : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class nf extends Ll {
  /**
   * @description
   * Stringify the qualifier
   * BackgroundQualifiers don't have a value, but instead override the toString() function.
   */
  toString() {
    return `
    b_auto:predominant
    ${this._contrast ? "_contrast" : ""}
    ${this._palette.length ? `:palette_${this._palette.join("_")}` : ""}
    `.replace(/\s+/g, "");
  }
}
class rf extends Oo {
  constructor() {
    super("gen_fill"), this._backgroundType = "generativeFill";
  }
  prompt(t) {
    return this._prompt = t, this;
  }
  getPrompt() {
    return this._prompt;
  }
  getBackgroundType() {
    return this._backgroundType;
  }
  /**
   * @description
   * Override the toString() function to explicitly stringify the qualifier.
   */
  toString() {
    return `b_gen_fill${this._prompt ? `:prompt_${this._prompt}` : ""}`;
  }
}
function of(e) {
  return `${e}`.replace("b_", "");
}
function yx() {
  return { backgroundType: "auto" };
}
function bx(e) {
  const { intensityLevel: t, brightnessLevel: n } = e, r = {
    backgroundType: "blurred"
  };
  return (t || t === 0) && (r.intensity = t), (n || n === 0) && (r.brightness = n), r;
}
function Nl(e) {
  const t = e._contrast, n = e._palette, r = {
    backgroundType: ""
  };
  return t && (r.contrast = !0), n && (r.palette = n), r;
}
function zx(e) {
  return Object.assign(Object.assign({}, Nl(e)), { backgroundType: "border" });
}
function af(e) {
  const t = e._gradientColors, n = `${e._gradientDirection}`, r = Nl(e);
  return t && (r.gradientColors = t), n && (r.gradientDirection = n), r;
}
function jx(e) {
  return Object.assign(Object.assign({}, af(e)), { backgroundType: "borderGradient" });
}
function wx(e) {
  return {
    backgroundType: "color",
    color: of(e)
  };
}
function xx(e) {
  return Object.assign(Object.assign({}, Nl(e)), { backgroundType: "predominant" });
}
function kx(e) {
  return Object.assign(Object.assign({}, af(e)), { backgroundType: "predominantGradient" });
}
function Sx(e) {
  return Object.assign({ backgroundType: e.getBackgroundType() }, e.getPrompt() ? { prompt: e.getPrompt() } : {});
}
function Ex(e) {
  return of(e) === "auto" ? yx() : e instanceof Qp ? bx(e) : e instanceof Xp ? zx(e) : e instanceof ef ? jx(e) : e instanceof nf ? xx(e) : e instanceof tf ? kx(e) : e instanceof rf ? Sx(e) : wx(e);
}
function Px() {
  return new Cl("svg");
}
function Ml() {
  return new Cl("auto");
}
function sf() {
  return new Xp();
}
function lf() {
  return new Oo("auto");
}
function cf() {
  return new ef();
}
function uf() {
  return new tf();
}
function mf() {
  return new nf();
}
function df(e) {
  return new Oo(ti(e));
}
function Tx() {
  return new Qp();
}
function pf() {
  return new rf();
}
const ff = {
  auto: lf,
  border: sf,
  borderGradient: cf,
  predominantGradient: uf,
  predominant: mf,
  color: df,
  blurred: Tx,
  generativeFill: pf
};
function Cx(e) {
  const { brightness: t, intensity: n } = e, r = ff.blurred();
  return r.brightness(t ?? hx), r.intensity(n ?? Kp), r;
}
function Zu(e, t) {
  const { gradientColors: n, gradientDirection: r, contrast: o, palette: a } = t;
  return o && e.contrast(), a && e.palette(...a), n && e.gradientColors(+n), r && e.gradientDirection(r), e;
}
function em(e, t) {
  const { contrast: n, palette: r } = t;
  return n && e.contrast(), r && e.palette(...r), e;
}
function Ax(e, t) {
  const { prompt: n } = t;
  return n && e.prompt(n), e;
}
function Ox(e) {
  const { backgroundType: t } = e;
  switch (t) {
    case "auto":
      return lf();
    case "blurred":
      return Cx(e);
    case "border":
      return em(sf(), e);
    case "borderGradient":
      return Zu(cf(), e);
    case "predominant":
      return em(mf(), e);
    case "predominantGradient":
      return Zu(uf(), e);
    case "generativeFill":
      return Ax(pf(), e);
    default:
      return df(e.color);
  }
}
class Ix extends Il {
  /**
   * @description Sets the background.
   * @param {Qualifiers.Background} backgroundQualifier Defines the background color to use instead of
   * transparent background areas or when resizing with padding.
   */
  background(t) {
    return this._actionModel.background = Ex(t), this.addQualifier(t);
  }
  /**
   * @description Horizontal position for custom-coordinates based padding.
   * @param {number} x The x position.
   */
  offsetX(t) {
    return this._actionModel.x = t, this.addQualifier(new fe("x", t));
  }
  /**
   * @description Vertical position for custom-coordinates based padding
   * @param {number} y The y position.
   */
  offsetY(t) {
    return this._actionModel.y = t, this.addQualifier(new fe("y", t));
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.background && n.background(Ox(t.background)), t.x && n.offsetX(t.x), t.y && n.offsetY(t.y), t.zoom && n.zoom(t.zoom), n;
  }
}
class Lx extends Up {
  /**
   * @description Changes the aspect ratio of an image while retaining all important content and avoiding unnatural
   * distortions.
   * @return {this}
   */
  liquidRescaling() {
    return this.addQualifier(new ni("liquid"));
  }
}
class Nx extends Il {
  /**
   * @description Horizontal position for custom-coordinates based cropping.
   * @param {number} x The x position.
   */
  x(t) {
    return this._actionModel.x = t, this.addQualifier(new fe("x", t));
  }
  /**
   * @description Vertical position for custom-coordinates based cropping
   * @param {number} y The y position.
   */
  y(t) {
    return this._actionModel.y = t, this.addQualifier(new fe("y", t));
  }
  /**
   * @description Controls how much of the original image surrounding the face to keep when using either the 'crop' or 'thumb' cropping modes with face detection.
   * @param {number | string} z The zoom factor. (Default: 1.0)
   */
  zoom(t) {
    return this._actionModel.zoom = t, this.addQualifier(new fe("z", t));
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.x && n.x(t.x), t.y && n.y(t.y), t.zoom && n.zoom(t.zoom), n;
  }
}
class Mx extends Il {
  /**
   * @description Absolute X position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} x The x position.
   */
  x(t) {
    return this._actionModel.x = t, this.addQualifier(new fe("x", t));
  }
  /**
   * @description Absolute Y position when used with Gravity.xyCenter {@link Qualifiers.Gravity.GravityQualifier}}
   * @param {number} y The y position.
   */
  y(t) {
    return this._actionModel.y = t, this.addQualifier(new fe("y", t));
  }
  static fromJson(t) {
    const n = super.fromJson.apply(this, [t]);
    return t.x && n.x(t.x), t.y && n.y(t.y), n;
  }
}
function Rx(e, t) {
  return new Lx("scale", e, t);
}
function $x(e, t) {
  return new Nx("crop", e, t);
}
function Dx(e, t) {
  return new Mx("fill", e, t);
}
function Fx(e, t) {
  return new Ix("pad", e, t);
}
class Ux extends Fp {
  /**
   * @param {Qualifiers.Quality} qualityValue a Quality value
   */
  constructor(t) {
    super("q", t.toString(), "level");
  }
  /**
   * Selet the Chroma sub sampling</br>
   * <b>Learn more</b>: {@link https://cloudinary.com/documentation/image_optimization#toggle_chroma_subsampling|Toggling chroma subsampling}
   * @param {420 | 444 | number} type The chroma sub sampling type
   */
  chromaSubSampling(t) {
    this._actionModel.chromaSubSampling = Rp[t];
    const n = new $e([this._actionModel.level, t]);
    return n.setDelimiter(":"), this.addQualifier(new fe("q", n));
  }
  /**
   * Controls the final quality by setting a maximum quantization percentage
   * @param {number} val
   */
  quantization(t) {
    this._actionModel.quantization = t;
    const n = new $e([this._actionModel.level, `qmax_${t}`]).setDelimiter(":");
    return this.addQualifier(new fe("q", n));
  }
  static fromJson(t) {
    const { level: n, chromaSubSampling: r, quantization: o } = t, a = Mp[n] || n, i = new this(a);
    if (r) {
      const s = T1[r.toUpperCase()];
      s && i.chromaSubSampling(+s);
    }
    return o && i.quantization(o), i;
  }
}
function oi(e) {
  return new Ts("f", e);
}
function ai(e) {
  return new Ux(e);
}
function Vx() {
  return new Yp("north_east");
}
Ku(70).color("black"), Ku(40).color("white"), D1(), U1();
new Mr().effect(F1()).delivery(ai("auto")).delivery(oi(Px()));
new Mr().effect(V1()).delivery(ai("auto")).delivery(oi(Ml()));
new Mr().effect($1(2e3)).delivery(ai("auto")).delivery(oi(Ml()));
new Mr().resize(Fx("iw_div_2").aspectRatio(1).background(ff.auto())).resize($x(1, 1).gravity(Z1(Vx()))).resize(Dx().height("ih").width("iw")).delivery(ai("auto")).delivery(oi(Ml()));
var tm = {
  flv: "x-flv",
  "3gp": "3gpp",
  mov: "quicktime",
  mpg: "mpeg",
  avi: "x-msvideo",
  wmv: "x-ms-wmv",
  ogv: "ogg",
  webm: "webm",
  mp4: "mp4"
}, nm = "?_a=", qx = (
  /** @class */
  function() {
    function e(t, n, r, o, a, i, s) {
      var l = this;
      this.mimeType = "video", this.mimeSubTypes = tm, this.videoElement = t, this.originalVideo = n, this.videoOptions = s, this.htmlPluginState = { cleanupCallbacks: [], pluginEventSubscription: [] };
      var c = Gn(n);
      Ea(t, n, o, this.htmlPluginState).then(function() {
        l.htmlPluginState.pluginEventSubscription.forEach(function(u) {
          u();
        }), l.setVideoAttributes(a, i), l.handleSourceToVideo(c, r);
      });
    }
    return e.prototype.handleSourceToVideo = function(t, n) {
      var r = this;
      if (n)
        this.generateUserSources(t, n);
      else {
        var o = ["webm", "mp4", "ogv"];
        o.forEach(function(a) {
          r.appendSourceTag(Gn(t), a);
        });
      }
    }, e.prototype.generateUserSources = function(t, n) {
      var r = this;
      n.map(function(o) {
        var a = o.type, i = o.codecs, s = o.transcode;
        return r.appendSourceTag(Gn(t).transcode(s), a, r.buildMimeType(a, i));
      });
    }, e.prototype.appendSourceTag = function(t, n, r) {
      var o, a = document.createElement("source"), i = (o = this.videoOptions) === null || o === void 0 ? void 0 : o.useFetchFormat;
      i && t.format(n);
      var s = t.toURL(), l = s.split(nm), c = l[1] ? "".concat(nm).concat(l[1]) : "", u = i ? "" : ".".concat(n);
      a.src = "".concat(l[0]).concat(u).concat(c), a.type = r || "video/".concat(tm[n] || n), this.videoElement.appendChild(a);
    }, e.prototype.buildMimeType = function(t, n) {
      var r = "".concat(this.mimeType, "/").concat(this.mimeSubTypes[t] || t);
      return n && (r += "; codecs=" + (Array.isArray(n) ? n.join(", ") : n)), r;
    }, e.prototype.setVideoAttributes = function(t, n) {
      var r;
      if (t === void 0 && (t = {}), n === "auto") {
        var o = Gn(this.originalVideo);
        t.poster = o.quality("auto").format("jpg").addTransformation("so_auto").toURL();
      } else n && (t.poster = (r = n.toURL) === null || r === void 0 ? void 0 : r.call(n));
      for (var a = 0, i = Object.entries(t); a < i.length; a++) {
        var s = i[a], l = s[0], c = s[1];
        c && this.videoElement.setAttribute(l, l === "poster" ? c : "");
      }
    }, e.prototype.update = function(t, n, r, o, a) {
      var i = this;
      if (t !== this.originalVideo) {
        for (var s = this.videoElement.getElementsByTagName("SOURCE"); s[0]; )
          s[0].parentNode.removeChild(s[0]);
        Ea(this.videoElement, t, r, this.htmlPluginState).then(function() {
          i.setVideoAttributes(o, a), i.handleSourceToVideo(t, n), i.videoElement.load();
        });
      }
    }, e;
  }()
), Hx = "Expected a function", rm = NaN, Bx = "[object Symbol]", Jx = /^\s+|\s+$/g, Wx = /^[-+]0x[0-9a-f]+$/i, Yx = /^0b[01]+$/i, Gx = /^0o[0-7]+$/i, Kx = parseInt, Qx = typeof kn == "object" && kn && kn.Object === Object && kn, Xx = typeof self == "object" && self && self.Object === Object && self, Zx = Qx || Xx || Function("return this")(), ek = Object.prototype, tk = ek.toString, nk = Math.max, rk = Math.min, Ui = function() {
  return Zx.Date.now();
};
function ok(e, t, n) {
  var r, o, a, i, s, l, c = 0, u = !1, d = !1, p = !0;
  if (typeof e != "function")
    throw new TypeError(Hx);
  t = om(t) || 0, Cs(n) && (u = !!n.leading, d = "maxWait" in n, a = d ? nk(om(n.maxWait) || 0, t) : a, p = "trailing" in n ? !!n.trailing : p);
  function m(z) {
    var O = r, N = o;
    return r = o = void 0, c = z, i = e.apply(N, O), i;
  }
  function f(z) {
    return c = z, s = setTimeout(A, t), u ? m(z) : i;
  }
  function _(z) {
    var O = z - l, N = z - c, F = t - O;
    return d ? rk(F, a - N) : F;
  }
  function y(z) {
    var O = z - l, N = z - c;
    return l === void 0 || O >= t || O < 0 || d && N >= a;
  }
  function A() {
    var z = Ui();
    if (y(z))
      return I(z);
    s = setTimeout(A, _(z));
  }
  function I(z) {
    return s = void 0, p && r ? m(z) : (r = o = void 0, i);
  }
  function j() {
    s !== void 0 && clearTimeout(s), c = 0, r = l = o = s = void 0;
  }
  function S() {
    return s === void 0 ? i : I(Ui());
  }
  function T() {
    var z = Ui(), O = y(z);
    if (r = arguments, o = this, l = z, O) {
      if (s === void 0)
        return f(l);
      if (d)
        return s = setTimeout(A, t), m(l);
    }
    return s === void 0 && (s = setTimeout(A, t)), i;
  }
  return T.cancel = j, T.flush = S, T;
}
function Cs(e) {
  var t = typeof e;
  return !!e && (t == "object" || t == "function");
}
function ak(e) {
  return !!e && typeof e == "object";
}
function ik(e) {
  return typeof e == "symbol" || ak(e) && tk.call(e) == Bx;
}
function om(e) {
  if (typeof e == "number")
    return e;
  if (ik(e))
    return rm;
  if (Cs(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Cs(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = e.replace(Jx, "");
  var n = Yx.test(e);
  return n || Gx.test(e) ? Kx(e.slice(2), n ? 2 : 8) : Wx.test(e) ? rm : +e;
}
var sk = ok;
function lk(e) {
  return typeof e == "number";
}
function _f() {
  return typeof window < "u";
}
function ck(e) {
  return e instanceof HTMLImageElement;
}
var uk = {
  accessibility: !1,
  lazyload: !1,
  placeholder: !1,
  responsive: !1
}, mk = function(e) {
  return e.replace("bound ", "").replace("Plugin", "");
}, dk = function(e, t) {
  e === void 0 && (e = []);
  var n = e.reduce(function(r, o) {
    var a, i = o.name;
    return bo(bo({}, r), (a = {}, a[mk(i)] = !0, a));
  }, uk);
  return n[t];
};
function pk(e) {
  var t = {}, n = t.steps;
  return fk.bind(null, n);
}
function fk(e, t, n, r, o, a) {
  if (!_f())
    return !0;
  if (ck(t))
    return new Promise(function(i) {
      r.cleanupCallbacks.push(function() {
        window.removeEventListener("resize", c), i("canceled");
      });
      var s = Ps(o, { responsive: !0 });
      n.addAction(new It().setActionTag("responsive"));
      var l = !dk(a, "placeholder");
      l ? am(e, t, n, s) : gf(e, t, n);
      var c;
      r.pluginEventSubscription.push(function() {
        window.addEventListener("resize", c = sk(function() {
          am(e, t, n, s);
        }, 100));
      }), i({ responsive: !0 });
    });
}
function am(e, t, n, r) {
  gf(e, t, n), t.src = n.toURL(r);
}
function gf(e, t, n) {
  var r = t.parentElement.clientWidth;
  if (lk(e)) {
    var o = e;
    r = Math.ceil(r / o) * o;
  } else Array.isArray(e) && (r = e.reduce(function(a, i) {
    return Math.abs(i - r) < Math.abs(a - r) ? i : a;
  }));
  n.transformation.actions.forEach(function(a, i) {
    a instanceof It && a.getActionTag() === "responsive" && (n.transformation.actions[i] = Rx(r).setActionTag("responsive"));
  });
}
function _k(e, t, n) {
  var r = Gn(t);
  if (e)
    for (var o = 0; o < e.length; o++) {
      var a = e[o](null, r);
      if (!a)
        break;
    }
  return r.toURL(n ? { trackedAnalytics: n } : null);
}
function Pa(e) {
  e.cleanupCallbacks.forEach(function(t) {
    t();
  });
}
const Vi = {
  sdkSemver: "1.12.1",
  techVersion: "3.2.37",
  sdkCode: "L"
}, gk = ["src"];
var hf = /* @__PURE__ */ Q({
  __name: "AdvancedImage",
  props: {
    cldImg: { type: null, required: !0 },
    plugins: { type: null, required: !1 }
  },
  setup(e) {
    const t = e, n = ue(null);
    let r;
    const o = () => _k(t.plugins, t.cldImg, Vi);
    return Xt(() => {
      r = new g1(n.value, t.cldImg, t.plugins, Vi);
    }), tl(() => {
      Pa(r.htmlPluginState), r.update(t.cldImg, t.plugins, Vi);
    }), cr(() => {
      Pa(r.htmlPluginState);
    }), (a, i) => X(_f)() ? (w(), P(
      "img",
      {
        key: 0,
        ref_key: "imageRef",
        ref: n
      },
      null,
      512
      /* NEED_PATCH */
    )) : (w(), P("img", {
      key: 1,
      src: o()
    }, null, 8, gk));
  }
});
hf.__file = "src/components/AdvancedImage.vue";
var hk = /* @__PURE__ */ Q({
  __name: "AdvancedVideo",
  props: {
    cldVid: { type: null, required: !0 },
    plugins: { type: null, required: !1 },
    sources: { type: null, required: !1 },
    cldPoster: { type: null, required: !1 }
  },
  setup(e) {
    const t = e, n = ue(null);
    let r;
    return Xt(() => {
      r = new qx(n.value, t.cldVid, t.sources, t.plugins, void 0, t.cldPoster);
    }), tl(() => {
      Pa(r.htmlPluginState), r.update(t.cldVid, t.sources, t.plugins, void 0, t.cldPoster);
    }), cr(() => {
      Pa(r.htmlPluginState);
    }), (o, a) => (w(), P(
      "video",
      {
        ref_key: "videoRef",
        ref: n
      },
      null,
      512
      /* NEED_PATCH */
    ));
  }
});
hk.__file = "src/components/AdvancedVideo.vue";
const vk = ["src", "alt"], im = "nomadic", st = /* @__PURE__ */ Q({
  __name: "NomadicImage",
  props: {
    src: { type: String },
    alt: { type: String },
    width: { type: [String, Number] },
    height: { type: [String, Number] },
    steps: { type: Number },
    minWidth: { type: Number },
    minHeight: { type: Number }
  },
  setup(e) {
    function t(s = !1) {
      s = s ?? !0;
      let l = (typeof window < "u" && window !== null ? window.devicePixelRatio : void 0) || 1;
      s && (l = Math.ceil(l)), (l <= 0 || l === NaN) && (l = 1);
      let c = l.toString();
      return c.match(/^\d+$/) && (c += ".0"), c;
    }
    const n = e, r = (s) => {
      const l = "res.cloudinary.com", c = ["c_", "h_", "w_", "q_", "f_", "g_"];
      return s?.includes(l) && c.some((u) => s.includes(u));
    }, o = (s) => new URL(s).pathname.substring(1), a = ee(() => {
      if (!n.src) return null;
      const s = n.src;
      if (r(s))
        return;
      let l;
      s.includes("res.cloudinary.com") ? l = new Gu(o(s), {
        cloudName: im
      }) : l = new Gu(n.src, {
        cloudName: im
      }).setDeliveryType("fetch");
      const c = n.minWidth || 480, u = n.minHeight || 320;
      return n.width || n.height ? l.resize(
        Jw().width(Math.max(Number(n.width) || c, c)).height(Math.max(Number(n.height) || u, u))
      ) : l.addAction(Yw(t())), l;
    }), i = ee(() => [pk()]);
    return (s, l) => r(s.src) ? (w(), P("img", {
      key: 0,
      src: s.src,
      alt: s.alt
    }, null, 8, vk)) : (w(), ge(X(hf), {
      key: 1,
      "cld-img": a.value,
      plugins: i.value,
      alt: s.alt
    }, null, 8, ["cld-img", "plugins", "alt"]));
  }
});
let yk = Symbol("headlessui.useid"), bk = 0;
function qi() {
  return Gt(yk, () => `${++bk}`)();
}
function be(e) {
  var t;
  if (e == null || e.value == null) return null;
  let n = (t = e.value.$el) != null ? t : e.value;
  return n instanceof Node ? n : null;
}
function or(e, t, ...n) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...n) : o;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, or), r;
}
var zk = Object.defineProperty, jk = (e, t, n) => t in e ? zk(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, sm = (e, t, n) => (jk(e, typeof t != "symbol" ? t + "" : t, n), n);
let wk = class {
  constructor() {
    sm(this, "current", this.detect()), sm(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
}, ii = new wk();
function si(e) {
  if (ii.isServer) return null;
  if (e instanceof Node) return e.ownerDocument;
  if (e != null && e.hasOwnProperty("value")) {
    let t = be(e);
    if (t) return t.ownerDocument;
  }
  return document;
}
let As = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Kr = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(Kr || {}), Os = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(Os || {}), xk = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(xk || {});
function Rl(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(As)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var $l = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))($l || {});
function vf(e, t = 0) {
  var n;
  return e === ((n = si(e)) == null ? void 0 : n.body) ? !1 : or(t, { 0() {
    return e.matches(As);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(As)) return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var kk = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(kk || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
let Sk = ["textarea", "input"].join(",");
function Ek(e) {
  var t, n;
  return (n = (t = e?.matches) == null ? void 0 : t.call(e, Sk)) != null ? n : !1;
}
function Pk(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let o = t(n), a = t(r);
    if (o === null || a === null) return 0;
    let i = o.compareDocumentPosition(a);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function Xo(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: o = [] } = {}) {
  var a;
  let i = (a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e?.ownerDocument) != null ? a : document, s = Array.isArray(e) ? n ? Pk(e) : e : Rl(e);
  o.length > 0 && s.length > 1 && (s = s.filter((f) => !o.includes(f))), r = r ?? i.activeElement;
  let l = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), c = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, s.indexOf(r)) - 1;
    if (t & 4) return Math.max(0, s.indexOf(r)) + 1;
    if (t & 8) return s.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, d = 0, p = s.length, m;
  do {
    if (d >= p || d + p <= 0) return 0;
    let f = c + d;
    if (t & 16) f = (f + p) % p;
    else {
      if (f < 0) return 3;
      if (f >= p) return 1;
    }
    m = s[f], m?.focus(u), d += l;
  } while (m !== i.activeElement);
  return t & 6 && Ek(m) && m.select(), 2;
}
function Tk() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function Ck() {
  return /Android/gi.test(window.navigator.userAgent);
}
function Ak() {
  return Tk() || Ck();
}
function Zo(e, t, n) {
  ii.isServer || So((r) => {
    document.addEventListener(e, t, n), r(() => document.removeEventListener(e, t, n));
  });
}
function yf(e, t, n) {
  ii.isServer || So((r) => {
    window.addEventListener(e, t, n), r(() => window.removeEventListener(e, t, n));
  });
}
function Ok(e, t, n = ee(() => !0)) {
  function r(a, i) {
    if (!n.value || a.defaultPrevented) return;
    let s = i(a);
    if (s === null || !s.getRootNode().contains(s)) return;
    let l = function c(u) {
      return typeof u == "function" ? c(u()) : Array.isArray(u) || u instanceof Set ? u : [u];
    }(e);
    for (let c of l) {
      if (c === null) continue;
      let u = c instanceof HTMLElement ? c : be(c);
      if (u != null && u.contains(s) || a.composed && a.composedPath().includes(u)) return;
    }
    return !vf(s, $l.Loose) && s.tabIndex !== -1 && a.preventDefault(), t(a, s);
  }
  let o = ue(null);
  Zo("pointerdown", (a) => {
    var i, s;
    n.value && (o.value = ((s = (i = a.composedPath) == null ? void 0 : i.call(a)) == null ? void 0 : s[0]) || a.target);
  }, !0), Zo("mousedown", (a) => {
    var i, s;
    n.value && (o.value = ((s = (i = a.composedPath) == null ? void 0 : i.call(a)) == null ? void 0 : s[0]) || a.target);
  }, !0), Zo("click", (a) => {
    Ak() || o.value && (r(a, () => o.value), o.value = null);
  }, !0), Zo("touchend", (a) => r(a, () => a.target instanceof HTMLElement ? a.target : null), !0), yf("blur", (a) => r(a, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
var Is = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Is || {}), Ik = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Ik || {});
function Dl({ visible: e = !0, features: t = 0, ourProps: n, theirProps: r, ...o }) {
  var a;
  let i = zf(r, n), s = Object.assign(o, { props: i });
  if (e || t & 2 && i.static) return Hi(s);
  if (t & 1) {
    let l = (a = i.unmount) == null || a ? 0 : 1;
    return or(l, { 0() {
      return null;
    }, 1() {
      return Hi({ ...o, props: { ...i, hidden: !0, style: { display: "none" } } });
    } });
  }
  return Hi(s);
}
function Hi({ props: e, attrs: t, slots: n, slot: r, name: o }) {
  var a, i;
  let { as: s, ...l } = Lk(e, ["unmount", "static"]), c = (a = n.default) == null ? void 0 : a.call(n, r), u = {};
  if (r) {
    let d = !1, p = [];
    for (let [m, f] of Object.entries(r)) typeof f == "boolean" && (d = !0), f === !0 && p.push(m);
    d && (u["data-headlessui-state"] = p.join(" "));
  }
  if (s === "template") {
    if (c = bf(c ?? []), Object.keys(l).length > 0 || Object.keys(t).length > 0) {
      let [d, ...p] = c ?? [];
      if (!Nk(d) || p.length > 0) throw new Error(['Passing props on "template"!', "", `The current component <${o} /> is rendering a "template".`, "However we need to passthrough the following props:", Object.keys(l).concat(Object.keys(t)).map((_) => _.trim()).filter((_, y, A) => A.indexOf(_) === y).sort((_, y) => _.localeCompare(y)).map((_) => `  - ${_}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "template".', "Render a single element as the child so that we can forward the props onto that element."].map((_) => `  - ${_}`).join(`
`)].join(`
`));
      let m = zf((i = d.props) != null ? i : {}, l, u), f = mn(d, m, !0);
      for (let _ in m) _.startsWith("on") && (f.props || (f.props = {}), f.props[_] = m[_]);
      return f;
    }
    return Array.isArray(c) && c.length === 1 ? c[0] : c;
  }
  return pt(s, Object.assign({}, l, u), { default: () => c });
}
function bf(e) {
  return e.flatMap((t) => t.type === se ? bf(t.children) : [t]);
}
function zf(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, n = {};
  for (let r of e) for (let o in r) o.startsWith("on") && typeof r[o] == "function" ? (n[o] != null || (n[o] = []), n[o].push(r[o])) : t[o] = r[o];
  if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n) Object.assign(t, { [r](o, ...a) {
    let i = n[r];
    for (let s of i) {
      if (o instanceof Event && o.defaultPrevented) return;
      s(o, ...a);
    }
  } });
  return t;
}
function Lk(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t) r in n && delete n[r];
  return n;
}
function Nk(e) {
  return e == null ? !1 : typeof e.type == "string" || typeof e.type == "object" || typeof e.type == "function";
}
var Ta = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Ta || {});
let Ls = /* @__PURE__ */ Q({ name: "Hidden", props: { as: { type: [Object, String], default: "div" }, features: { type: Number, default: 1 } }, setup(e, { slots: t, attrs: n }) {
  return () => {
    var r;
    let { features: o, ...a } = e, i = { "aria-hidden": (o & 2) === 2 ? !0 : (r = a["aria-hidden"]) != null ? r : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(o & 4) === 4 && (o & 2) !== 2 && { display: "none" } } };
    return Dl({ ourProps: i, theirProps: a, slot: {}, attrs: n, slots: t, name: "Hidden" });
  };
} }), jf = Symbol("Context");
var zo = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(zo || {});
function Mk() {
  return Gt(jf, null);
}
function Rk(e) {
  tr(jf, e);
}
var wf = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(wf || {});
function $k(e, t, n, r) {
  ii.isServer || So((o) => {
    e = e ?? window, e.addEventListener(t, n, r), o(() => e.removeEventListener(t, n, r));
  });
}
var Qr = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Qr || {});
function Dk() {
  let e = ue(0);
  return yf("keydown", (t) => {
    t.key === "Tab" && (e.value = t.shiftKey ? 1 : 0);
  }), e;
}
function Fk({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  let r = ue(null), o = si(r);
  function a() {
    var i, s, l;
    let c = [];
    for (let u of e) u !== null && (u instanceof HTMLElement ? c.push(u) : "value" in u && u.value instanceof HTMLElement && c.push(u.value));
    if (t != null && t.value) for (let u of t.value) c.push(u);
    for (let u of (i = o?.querySelectorAll("html > *, body > *")) != null ? i : []) u !== document.body && u !== document.head && u instanceof HTMLElement && u.id !== "headlessui-portal-root" && (u.contains(be(r)) || u.contains((l = (s = be(r)) == null ? void 0 : s.getRootNode()) == null ? void 0 : l.host) || c.some((d) => u.contains(d)) || c.push(u));
    return c;
  }
  return { resolveContainers: a, contains(i) {
    return a().some((s) => s.contains(i));
  }, mainTreeNodeRef: r, MainTreeNode() {
    return n != null ? null : pt(Ls, { features: Ta.Hidden, ref: r });
  } };
}
let lm = Symbol("PortalParentContext");
function Uk() {
  let e = Gt(lm, null), t = ue([]);
  function n(a) {
    return t.value.push(a), e && e.register(a), () => r(a);
  }
  function r(a) {
    let i = t.value.indexOf(a);
    i !== -1 && t.value.splice(i, 1), e && e.unregister(a);
  }
  let o = { register: n, unregister: r, portals: t };
  return [t, /* @__PURE__ */ Q({ name: "PortalWrapper", setup(a, { slots: i }) {
    return tr(lm, o), () => {
      var s;
      return (s = i.default) == null ? void 0 : s.call(i);
    };
  } })];
}
var Vk = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Vk || {});
let xf = Symbol("PopoverContext");
function kf(e) {
  let t = Gt(xf, null);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <${Sf.name} /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, kf), n;
  }
  return t;
}
let qk = Symbol("PopoverGroupContext");
function Hk() {
  return Gt(qk, null);
}
let Bk = Symbol("PopoverPanelContext"), Sf = /* @__PURE__ */ Q({ name: "Popover", inheritAttrs: !1, props: { as: { type: [Object, String], default: "div" } }, setup(e, { slots: t, attrs: n, expose: r }) {
  var o;
  let a = ue(null);
  r({ el: a, $el: a });
  let i = ue(1), s = ue(null), l = ue(null), c = ue(null), u = ue(null), d = ee(() => si(a)), p = ee(() => {
    var T, z;
    if (!be(s) || !be(u)) return !1;
    for (let me of document.querySelectorAll("body > *")) if (Number(me?.contains(be(s))) ^ Number(me?.contains(be(u)))) return !0;
    let O = Rl(), N = O.indexOf(be(s)), F = (N + O.length - 1) % O.length, te = (N + 1) % O.length, he = O[F], Y = O[te];
    return !((T = be(u)) != null && T.contains(he)) && !((z = be(u)) != null && z.contains(Y));
  }), m = { popoverState: i, buttonId: ue(null), panelId: ue(null), panel: u, button: s, isPortalled: p, beforePanelSentinel: l, afterPanelSentinel: c, togglePopover() {
    i.value = or(i.value, { 0: 1, 1: 0 });
  }, closePopover() {
    i.value !== 1 && (i.value = 1);
  }, close(T) {
    m.closePopover();
    let z = T ? T instanceof HTMLElement ? T : T.value instanceof HTMLElement ? be(T) : be(m.button) : be(m.button);
    z?.focus();
  } };
  tr(xf, m), Rk(ee(() => or(i.value, { 0: zo.Open, 1: zo.Closed })));
  let f = { buttonId: m.buttonId, panelId: m.panelId, close() {
    m.closePopover();
  } }, _ = Hk(), y = _?.registerPopover, [A, I] = Uk(), j = Fk({ mainTreeNodeRef: _?.mainTreeNodeRef, portals: A, defaultContainers: [s, u] });
  function S() {
    var T, z, O, N;
    return (N = _?.isFocusWithinPopoverGroup()) != null ? N : ((T = d.value) == null ? void 0 : T.activeElement) && (((z = be(s)) == null ? void 0 : z.contains(d.value.activeElement)) || ((O = be(u)) == null ? void 0 : O.contains(d.value.activeElement)));
  }
  return So(() => y?.(f)), $k((o = d.value) == null ? void 0 : o.defaultView, "focus", (T) => {
    var z, O;
    T.target !== window && T.target instanceof HTMLElement && i.value === 0 && (S() || s && u && (j.contains(T.target) || (z = be(m.beforePanelSentinel)) != null && z.contains(T.target) || (O = be(m.afterPanelSentinel)) != null && O.contains(T.target) || m.closePopover()));
  }, !0), Ok(j.resolveContainers, (T, z) => {
    var O;
    m.closePopover(), vf(z, $l.Loose) || (T.preventDefault(), (O = be(s)) == null || O.focus());
  }, ee(() => i.value === 0)), () => {
    let T = { open: i.value === 0, close: m.close };
    return pt(se, [pt(I, {}, () => Dl({ theirProps: { ...e, ...n }, ourProps: { ref: a }, slot: T, slots: t, attrs: n, name: "Popover" })), pt(j.MainTreeNode)]);
  };
} }), Jk = /* @__PURE__ */ Q({ name: "PopoverPanel", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, focus: { type: Boolean, default: !1 }, id: { type: String, default: null } }, inheritAttrs: !1, setup(e, { attrs: t, slots: n, expose: r }) {
  var o;
  let a = (o = e.id) != null ? o : `headlessui-popover-panel-${qi()}`, { focus: i } = e, s = kf("PopoverPanel"), l = ee(() => si(s.panel)), c = `headlessui-focus-sentinel-before-${qi()}`, u = `headlessui-focus-sentinel-after-${qi()}`;
  r({ el: s.panel, $el: s.panel }), Xt(() => {
    s.panelId.value = a;
  }), cr(() => {
    s.panelId.value = null;
  }), tr(Bk, s.panelId), So(() => {
    var I, j;
    if (!i || s.popoverState.value !== 0 || !s.panel) return;
    let S = (I = l.value) == null ? void 0 : I.activeElement;
    (j = be(s.panel)) != null && j.contains(S) || Xo(be(s.panel), Kr.First);
  });
  let d = Mk(), p = ee(() => d !== null ? (d.value & zo.Open) === zo.Open : s.popoverState.value === 0);
  function m(I) {
    var j, S;
    switch (I.key) {
      case wf.Escape:
        if (s.popoverState.value !== 0 || !be(s.panel) || l.value && !((j = be(s.panel)) != null && j.contains(l.value.activeElement))) return;
        I.preventDefault(), I.stopPropagation(), s.closePopover(), (S = be(s.button)) == null || S.focus();
        break;
    }
  }
  function f(I) {
    var j, S, T, z, O;
    let N = I.relatedTarget;
    N && be(s.panel) && ((j = be(s.panel)) != null && j.contains(N) || (s.closePopover(), ((T = (S = be(s.beforePanelSentinel)) == null ? void 0 : S.contains) != null && T.call(S, N) || (O = (z = be(s.afterPanelSentinel)) == null ? void 0 : z.contains) != null && O.call(z, N)) && N.focus({ preventScroll: !0 })));
  }
  let _ = Dk();
  function y() {
    let I = be(s.panel);
    if (!I) return;
    function j() {
      or(_.value, { [Qr.Forwards]: () => {
        var S;
        Xo(I, Kr.First) === Os.Error && ((S = be(s.afterPanelSentinel)) == null || S.focus());
      }, [Qr.Backwards]: () => {
        var S;
        (S = be(s.button)) == null || S.focus({ preventScroll: !0 });
      } });
    }
    j();
  }
  function A() {
    let I = be(s.panel);
    if (!I) return;
    function j() {
      or(_.value, { [Qr.Forwards]: () => {
        let S = be(s.button), T = be(s.panel);
        if (!S) return;
        let z = Rl(), O = z.indexOf(S), N = z.slice(0, O + 1), F = [...z.slice(O + 1), ...N];
        for (let te of F.slice()) if (te.dataset.headlessuiFocusGuard === "true" || T != null && T.contains(te)) {
          let he = F.indexOf(te);
          he !== -1 && F.splice(he, 1);
        }
        Xo(F, Kr.First, { sorted: !1 });
      }, [Qr.Backwards]: () => {
        var S;
        Xo(I, Kr.Previous) === Os.Error && ((S = be(s.button)) == null || S.focus());
      } });
    }
    j();
  }
  return () => {
    let I = { open: s.popoverState.value === 0, close: s.close }, { focus: j, ...S } = e, T = { ref: s.panel, id: a, onKeydown: m, onFocusout: i && s.popoverState.value === 0 ? f : void 0, tabIndex: -1 };
    return Dl({ ourProps: T, theirProps: { ...t, ...S }, attrs: t, slot: I, slots: { ...n, default: (...z) => {
      var O;
      return [pt(se, [p.value && s.isPortalled.value && pt(Ls, { id: c, ref: s.beforePanelSentinel, features: Ta.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: y }), (O = n.default) == null ? void 0 : O.call(n, ...z), p.value && s.isPortalled.value && pt(Ls, { id: u, ref: s.afterPanelSentinel, features: Ta.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: A })])];
    } }, features: Is.RenderStrategy | Is.Static, visible: p.value, name: "PopoverPanel" });
  };
} });
const Wk = { class: "content" }, Yk = { class: "profile-popover-name" }, Gk = ["href"], Kk = /* @__PURE__ */ Q({
  __name: "ProfilePopover",
  props: {
    name: {
      type: String,
      required: !1
    },
    profile: {
      type: Object,
      required: !1
    },
    profileId: {
      type: String,
      required: !1
    },
    imgURL: {
      type: String,
      required: !0
    }
  },
  emits: ["update:open", "preventHide"],
  setup(e, { emit: t }) {
    const n = e, r = ee(() => `/profile/${n.profileId}`), o = t;
    function a(c) {
      o("preventHide", c);
    }
    Xt(() => {
      window.addEventListener("keydown", i);
    });
    function i(c) {
      c.key === "Escape" && a(!1);
    }
    function s() {
      a(!0);
    }
    function l() {
      window.homeActionHandler("route", r.value);
    }
    return (c, u) => (w(), ge(X(Sf), { class: "popover" }, {
      default: Oe(() => [
        B(X(Jk), {
          class: "panel",
          static: "",
          focus: !0,
          open: !0
        }, {
          default: Oe(() => [
            x("div", {
              class: "profile-popover",
              onMouseenter: u[1] || (u[1] = (d) => a(!0)),
              onMouseleave: u[2] || (u[2] = (d) => a(!1))
            }, [
              x("div", Wk, [
                B(st, {
                  src: e.imgURL,
                  alt: "profile picture"
                }, null, 8, ["src"]),
                x("div", Yk, D(e.name), 1),
                x("ul", null, [
                  (w(!0), P(se, null, De(e.profile, (d) => (w(), P("li", {
                    key: d.name
                  }, D(d.value), 1))), 128))
                ]),
                x("a", {
                  onFocus: s,
                  onBlur: u[0] || (u[0] = (d) => a(!1)),
                  href: r.value,
                  onClick: Or(l, ["prevent"])
                }, "View Profile", 40, Gk)
              ])
            ], 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), Qk = '.panel[data-v-6deb42e3]{position:absolute;background:#fff;border:1px solid #e5e5e5;border-radius:.65rem;filter:drop-shadow(0px 1px 23px rgba(0,0,0,.25));z-index:999999;min-width:13rem;left:50%;top:calc(100% + .5rem);opacity:0;transform:translateY(3rem) translate(-50%);animation:fadeIn-6deb42e3 .2s ease-in-out forwards}.panel[data-v-6deb42e3] :after{content:"";position:absolute;top:-.9rem;left:50%;transform:translate(-50%);border:.5rem solid transparent;border-bottom-color:#fff;opacity:1}@keyframes fadeIn-6deb42e3{to{opacity:1;transform:translateY(0) translate(-50%)}}.profile-popover .content[data-v-6deb42e3]{display:flex;flex-direction:column;align-items:center;gap:.5rem;padding:1.5rem 1rem 1rem}.profile-popover .content img[data-v-6deb42e3]{width:4rem;height:4rem;border-radius:50%;margin-bottom:.5rem}.profile-popover .content .profile-popover-name[data-v-6deb42e3]{font-weight:650;line-height:1.5rem;color:#000;margin-bottom:.25rem}.profile-popover .content ul[data-v-6deb42e3]{list-style:none;padding:0;margin:0}.profile-popover .content ul li[data-v-6deb42e3]{font-weight:450;color:#252525;opacity:.8;text-align:center;padding:.25rem .5rem}.profile-popover .content .profile-popover-role[data-v-6deb42e3]{font-weight:500;line-height:1rem;color:#767676;margin-bottom:.25rem}.profile-popover .content .profile-popover-location[data-v-6deb42e3]{font-weight:450;color:#7b7b7b;margin-bottom:1rem;opacity:.8}.profile-popover .content a[data-v-6deb42e3]{font-weight:450;color:#000;opacity:.8;text-decoration:none;transition:all .2s ease-in-out;padding:.25rem .5rem}.profile-popover .content a[data-v-6deb42e3]:hover{color:#000;text-decoration:underline;opacity:1}', Ef = /* @__PURE__ */ ae(Kk, [["styles", [Qk]], ["__scopeId", "data-v-6deb42e3"]]), Xk = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ef
}, Symbol.toStringTag, { value: "Module" })), Zk = ["tabindex"], eS = ["src"], cm = "https://res.cloudinary.com/nomadic/image/fetch/w_52,h_52,c_fill,f_auto/https%3A%2F%2Fmedia-live.nomadic.fm%2Fstatic%2Fdashboard%2Fcore%2Fimg%2Ficons%2Fuser_default_nomadic.png", tS = /* @__PURE__ */ Q({
  __name: "ProfileAvatar",
  props: {
    imgURL: {
      type: String,
      required: !1
    },
    name: {
      type: String,
      required: !1
    },
    size: {
      type: String,
      required: !1,
      default: "medium"
    },
    profile: {
      type: Object,
      required: !1
    },
    id: {
      type: Number,
      required: !1
    }
  },
  setup(e) {
    const t = e, n = ue(!0), r = t.imgURL || cm, o = t.size === "medium", a = ue(!1), i = ue(!1);
    function s(f) {
      f === "show" ? a.value = !0 : a.value = !1;
    }
    const l = ue();
    function c(f) {
      if (f === "show")
        a.value = !0;
      else {
        if (i.value === !0)
          return;
        a.value = !1;
      }
    }
    function u() {
      l.value && clearTimeout(l.value), c("show");
    }
    function d(f) {
      l.value = setTimeout(() => {
        c("hide");
      }, f);
    }
    function p(f) {
      i.value = f, a.value = f;
    }
    function m() {
      document.getElementById("profile-popover");
    }
    return (f, _) => (w(), P("button", {
      tabindex: o ? 0 : -1,
      class: Ce(["profile-avatar", e.size]),
      onMouseover: _[2] || (_[2] = () => {
        u(), m();
      }),
      onMouseleave: _[3] || (_[3] = (y) => d(0)),
      onBlur: _[4] || (_[4] = (y) => d(0)),
      onClick: _[5] || (_[5] = (y) => a.value ? s("hide") : s("show"))
    }, [
      x("img", {
        class: "profile-avatar-img",
        src: n.value ? cm : X(r),
        onLoad: _[0] || (_[0] = (y) => n.value = !1),
        onError: _[1] || (_[1] = (y) => n.value = !0),
        alt: "profile picture"
      }, null, 40, eS),
      B(ol, {
        name: "fade",
        appear: ""
      }, {
        default: Oe(() => [
          a.value && o ? (w(), ge(Ef, {
            key: 0,
            "onUpdate:open": s,
            onPreventHide: p,
            id: "profile-popover",
            "profile-id": e.id?.toString(),
            name: e.name,
            profile: e.profile,
            imgURL: X(r)
          }, null, 8, ["profile-id", "name", "profile", "imgURL"])) : re("", !0)
        ]),
        _: 1
      })
    ], 42, Zk));
  }
}), nS = ".profile-avatar[data-v-ae355ab5]{position:relative;display:flex;border-radius:50%;border:1px solid transparent;cursor:pointer}.profile-avatar.mini[data-v-ae355ab5]{width:2.15rem;height:2.15rem}.profile-avatar.small[data-v-ae355ab5]{width:2.5rem;height:2.5rem}.profile-avatar.medium[data-v-ae355ab5]{width:3.15rem;height:3.15rem}.profile-avatar img[data-v-ae355ab5]{width:100%;height:100%;object-fit:contain;overflow:hidden;border-radius:50%;background:url(https://res.cloudinary.com/nomadic/image/fetch/w_52,h_52,c_fill,f_auto/https%3A%2F%2Fmedia-live.nomadic.fm%2Fstatic%2Fdashboard%2Fcore%2Fimg%2Ficons%2Fuser_default_nomadic.png) no-repeat center center;background-size:cover}button[data-v-ae355ab5]{padding:unset;border:unset;cursor:pointer;margin:unset}.popup-container[data-v-ae355ab5]{position:relative;top:0;left:0;z-index:1000;padding:1rem;background:red}", rS = ".fade-enter-active,.fade-leave-active{transition:opacity 2s ease}.fade-enter-from,.fade-leave-to{opacity:0}", Qt = /* @__PURE__ */ ae(tS, [["styles", [nS, rS]], ["__scopeId", "data-v-ae355ab5"]]), oS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Qt
}, Symbol.toStringTag, { value: "Module" })), aS = { class: "author" }, iS = { class: "author-meta" }, sS = { class: "author-name" }, lS = {
  key: 0,
  class: "date"
}, cS = /* @__PURE__ */ Q({
  __name: "CommentAuthor",
  props: {
    author: { type: Object }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("div", aS, [
      B(Qt, {
        imgURL: n.author.picture,
        name: n.author.name,
        profile: n.author.profile,
        id: n.author.id
      }, null, 8, ["imgURL", "name", "profile", "id"]),
      x("div", iS, [
        x("span", sS, D(n.author.name), 1),
        n.author.posted ? (w(), P("span", lS, D(X(Uj)(n.author.posted, { addSuffix: !0 })), 1)) : re("", !0)
      ])
    ]));
  }
}), uS = ".author{display:flex;gap:1rem;align-items:center}.author .author-meta{display:flex;flex-direction:column;gap:.2rem;height:fit-content}.author .author-meta .author-name{font-weight:600}", Fl = /* @__PURE__ */ ae(cS, [["styles", [uS]]]), mS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Fl
}, Symbol.toStringTag, { value: "Module" })), dS = ["onClick"], pS = /* @__PURE__ */ Q({
  __name: "TileFeedLoader",
  props: {
    tile: { type: null },
    customTileComponentConfig: { type: null },
    customPropsConfig: { type: null },
    clearRow: { type: Boolean }
  },
  setup(e) {
    const t = e, {
      homepageTileTitle: n,
      showTile: r,
      defaultTileComponentConfig: o,
      getLinkWithReferer: a
    } = Ln(t), i = ee(() => t.customTileComponentConfig || o);
    function s(m, f) {
      return f && f.subType == "happening-now" && m == "program" ? i.value.program_details.component : i.value[m].component;
    }
    const l = ee(() => {
      const m = i.value;
      return Object.keys(m).filter((_) => t.tile[_] && !t.tile[_]?.hide).sort((_, y) => m[_].order - m[y].order);
    }), c = {
      program: (m) => ({
        program: m.program
      }),
      video: (m) => ({ tile: m }),
      progress: (m) => ({ tile: m }),
      image: (m) => ({ tile: m }),
      resourceList: (m) => ({ breakdown: m?.resourceList }),
      group_activity: (m) => ({
        profiles: m?.group_activity?.profiles,
        action: `${m?.type}-${m?.group_activity?.action}`,
        context: m.video?.title ?? n(),
        contextLink: m.continue_link,
        excludeYou: m?.group_activity?.exclude_you,
        profile_count: m?.group_activity?.profile_count,
        flipped: !0
      }),
      replySummary: (m) => ({
        authors: m?.replySummary?.authors,
        comment_count: m?.replySummary?.count,
        reaction_count: m?.replySummary?.reactionCount,
        unread: m?.replySummary?.unread,
        reactions: m?.replySummary?.reactions
      }),
      certificate: (m) => ({
        certificate: m?.certificate
      }),
      summaryLeaderboard: (m) => ({
        summaryLeaderboard: m?.summaryLeaderboard,
        link: a(
          `/leaders?groupselect=${m.program.group_id}`,
          "leaderboard"
        )
      }),
      page: (m) => ({
        page: m.page,
        link: a(m?.continue_link, "page")
      }),
      summaryPollResults: (m) => ({
        summaryPollResults: m.summaryPollResults,
        link: a(m?.continue_link, "pollResults")
      }),
      summaryNewPoll: (m) => ({
        summaryNewPoll: m.summaryNewPoll,
        link: a(m?.continue_link, "newPoll")
      })
      // Add other types as needed
    }, u = (m, f, _ = {}) => {
      const y = c[m];
      if (!y)
        return { [m]: f[m] };
      const A = y(f), I = _[m];
      return I ? { ...A, ...I(f) } : A;
    }, d = (m, f) => {
      const _ = ["row"];
      switch (t.clearRow && t.clearRow === !0 && _.push("clear"), m) {
        case "image":
          _.push("image");
          break;
        case "discussions":
          break;
        case "topics":
          _.push("topics");
          break;
        case "posts":
          _.push("clear");
          break;
        case "communityPost":
          f.communityPost.discussion == null && _.push("clear");
          break;
        case "resourceList":
          f.resourceList != null && _.push("clear");
          break;
        case "event":
          _.push("event");
          break;
        case "programs":
          _.push("programs");
          break;
        case "group_activity":
          t.tile.type == "program" && t.tile.subType == "in-progress" && _.push("clear");
          break;
        case "replySummary":
          f.link && _.push("linked");
      }
      return _;
    };
    function p(m, f) {
      m === "replySummary" && f.link && window.homeActionHandler("route", f.link);
    }
    return (m, f) => (w(!0), P(se, null, De(l.value, (_) => (w(), P(se, {
      key: `${_}-${i.value[_]}`
    }, [
      X(r)(m.tile, _) && i.value[_].hide !== !0 ? (w(), P("div", {
        key: 0,
        class: Ce(d(_, m.tile)),
        onClick: (y) => p(_, m.tile)
      }, [
        (w(), ge(er(
          /* @__PURE__ */ cd(
            () => Yd(/* @__PURE__ */ Object.assign({ "./tile-components/AttachmentItem.vue": () => Promise.resolve().then(() => HC), "./tile-components/AttachmentLoader.vue": () => Promise.resolve().then(() => WC), "./tile-components/BrightcoveVideo.vue": () => Promise.resolve().then(() => yT), "./tile-components/CommentAuthor.vue": () => Promise.resolve().then(() => mS), "./tile-components/CommentGroup.vue": () => Promise.resolve().then(() => u2), "./tile-components/CommentTile.vue": () => Promise.resolve().then(() => j2), "./tile-components/CommunityPost.vue": () => Promise.resolve().then(() => L2), "./tile-components/CommunityPostsProgress.vue": () => Promise.resolve().then(() => D2), "./tile-components/ExploreCommunity.vue": () => Promise.resolve().then(() => H2), "./tile-components/ExploreJourneys.vue": () => Promise.resolve().then(() => eA), "./tile-components/ExplorePrograms.vue": () => Promise.resolve().then(() => lA), "./tile-components/ExploreResources.vue": () => Promise.resolve().then(() => _A), "./tile-components/GroupActivity.vue": () => Promise.resolve().then(() => bA), "./tile-components/JourneyCard.vue": () => Promise.resolve().then(() => sE), "./tile-components/JourneyEvent.vue": () => Promise.resolve().then(() => CA), "./tile-components/JourneyEventPreviewImage.vue": () => Promise.resolve().then(() => kA), "./tile-components/MultipleProfiles.vue": () => Promise.resolve().then(() => ZC), "./tile-components/NomadicProgress.vue": () => Promise.resolve().then(() => WS), "./tile-components/ProfileAvatar.vue": () => Promise.resolve().then(() => oS), "./tile-components/ProfilePopover.vue": () => Promise.resolve().then(() => Xk), "./tile-components/ProgramCard.vue": () => Promise.resolve().then(() => UA), "./tile-components/ProgramCertificate.vue": () => Promise.resolve().then(() => KA), "./tile-components/ProgramDetails.vue": () => Promise.resolve().then(() => aO), "./tile-components/ProgramDiscussion.vue": () => Promise.resolve().then(() => fO), "./tile-components/ProgramInProgressCard.vue": () => Promise.resolve().then(() => nE), "./tile-components/ProgramInProgressCardWithJourney.vue": () => Promise.resolve().then(() => mE), "./tile-components/ProgramInProgressDiscussion.vue": () => Promise.resolve().then(() => OO), "./tile-components/ProgressBreakdown.vue": () => Promise.resolve().then(() => RO), "./tile-components/ProgressCardWrapper.vue": () => Promise.resolve().then(() => ZS), "./tile-components/ResourceProgress.vue": () => Promise.resolve().then(() => VO), "./tile-components/SummaryLeaderboard.vue": () => Promise.resolve().then(() => YO), "./tile-components/SummaryNewPoll.vue": () => Promise.resolve().then(() => t5), "./tile-components/SummaryPage.vue": () => Promise.resolve().then(() => m5), "./tile-components/SummaryPollResults.vue": () => Promise.resolve().then(() => j5), "./tile-components/SummaryProgress.vue": () => Promise.resolve().then(() => N5), "./tile-components/TheWebinar.vue": () => Promise.resolve().then(() => U5), "./tile-components/TileActions.vue": () => Promise.resolve().then(() => Bj), "./tile-components/TileDescription.vue": () => Promise.resolve().then(() => nb), "./tile-components/TileImage.vue": () => Promise.resolve().then(() => uI), "./tile-components/TileMainTitle.vue": () => Promise.resolve().then(() => hS), "./tile-components/TileProgress.vue": () => Promise.resolve().then(() => hI), "./tile-components/TileTitle.vue": () => Promise.resolve().then(() => x0), "./tile-components/TopicSnapshot.vue": () => Promise.resolve().then(() => SI) }), `./tile-components/${s(_, m.tile)}.vue`, 3)
          )
        ), yg(kd(u(_, m.tile, m.customPropsConfig))), null, 16))
      ], 10, dS)) : re("", !0)
    ], 64))), 128));
  }
}), fS = ".homepage-tile-wrapper[data-v-685d426b]{display:flex;max-width:1140px;width:100%;flex-direction:column;--tile-theme-color: #0072ef;box-sizing:border-box}.tile-header[data-v-685d426b]{font-size:1.5rem;font-weight:700;margin-top:0}.homepage-tile[data-v-685d426b]{border-radius:18px;padding:1.5rem;display:flex;flex-wrap:wrap;gap:1.5rem;width:100%;outline:1px solid transparent;box-sizing:border-box}.homepage-tile .homepage-tile__info[data-v-685d426b]{display:flex;flex-direction:column;gap:1rem;color:#fff;width:100%}.homepage-tile .homepage-tile__info h2[data-v-685d426b]{margin:0;font-size:1.5rem;padding:0}.homepage-tile .homepage-tile__info p[data-v-685d426b]{color:#fff;line-height:22px;margin:0}@media (min-width: 640px){.homepage-tile .homepage-tile__info[data-v-685d426b]{max-width:27rem;min-width:20rem}}.homepage-tile.clear .homepage-tile__info[data-v-685d426b]{max-width:50%}@media (max-width: 900px){.homepage-tile.clear .homepage-tile__info[data-v-685d426b]{max-width:unset}}.homepage-tile .homepage-tile__feed[data-v-685d426b]{display:flex;flex-direction:column;gap:.5rem;border-radius:18px;flex:1;box-sizing:border-box}@media (min-width: 640px){.homepage-tile .homepage-tile__feed[data-v-685d426b]{min-width:25rem}}.row[data-v-685d426b]{display:flex;flex-direction:column;border-radius:10px;background:#e4ecf4;color:#000;padding:1.2rem 1.5rem;gap:.5rem;outline:1px solid transparent;align-self:flex-end;width:100%;box-sizing:border-box}.row.image[data-v-685d426b]{background:none;padding:0}.row.shadow[data-v-685d426b]{box-shadow:0 2px 24px #00000040}.row.clear[data-v-685d426b]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.row.event[data-v-685d426b]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.programs[data-v-685d426b]{max-width:unset}.row.topics[data-v-685d426b]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.linked[data-v-685d426b]{cursor:pointer}.row.linked[data-v-685d426b]:hover{background-color:#dae3ed!important}.vertical[data-v-685d426b]{flex-direction:column;width:100%}.program[data-v-685d426b]{background:#0072ef}.program .tile-title strong[data-v-685d426b]{color:#fff!important}.resource[data-v-685d426b],.explore[data-v-685d426b],.journey_step[data-v-685d426b],.resource .homepage-tile__info[data-v-685d426b],.explore .homepage-tile__info[data-v-685d426b],.journey_step .homepage-tile__info[data-v-685d426b],.resource .homepage-tile__info p[data-v-685d426b],.explore .homepage-tile__info p[data-v-685d426b],.journey_step .homepage-tile__info p[data-v-685d426b]{color:#000}.resource .homepage-tile__info .tile-title[data-v-685d426b],.explore .homepage-tile__info .tile-title[data-v-685d426b],.journey_step .homepage-tile__info .tile-title[data-v-685d426b]{color:#4d4d4d!important}.resource .homepage-tile__feed .row[data-v-685d426b],.explore .homepage-tile__feed .row[data-v-685d426b],.journey_step .homepage-tile__feed .row[data-v-685d426b]{background:#e4ecf4}.journeys[data-v-685d426b],.journey[data-v-685d426b]{background:#212121;color:#fff}.journeys .homepage-tile__info[data-v-685d426b],.journey .homepage-tile__info[data-v-685d426b]{color:#fff}.journeys .homepage-tile__feed .row[data-v-685d426b],.journey .homepage-tile__feed .row[data-v-685d426b]{background:#3d3d3d;color:#fff}.community[data-v-685d426b]{background:#fff;color:#000;box-shadow:0 2px 13px #00000014}.community .homepage-tile__info[data-v-685d426b],.community .homepage-tile__info p[data-v-685d426b]{color:#000}.community .homepage-tile__feed .row[data-v-685d426b]{background:#e4ecf4}.explore .homepage-tile__feed[data-v-685d426b]{max-width:unset;width:100%}.explore .homepage-tile__feed .row[data-v-685d426b]{padding:0;background:none}.custom-theme[data-v-685d426b]{background:var(--tile-theme-color)}.clear[data-v-685d426b]{background:none!important;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.clear .homepage-tile__info[data-v-685d426b],.clear .homepage-tile__info p[data-v-685d426b]{color:#000}@media screen and (max-width: 600px){.homepage-tile .homepage-tile__info[data-v-685d426b]{max-width:100%;min-width:100%}}", Io = /* @__PURE__ */ ae(pS, [["styles", [fS]], ["__scopeId", "data-v-685d426b"]]), _S = /* @__PURE__ */ Q({
  __name: "TileMainTitle",
  props: {
    tile: { type: null },
    additionalVars: { default: {}, type: null },
    customStringKey: { type: String },
    level: { default: 3, type: Number }
  },
  setup(e) {
    const t = e, { homepageTileType: n, homepageTileTitle: r, getLocStringKey: o, t: a, te: i } = Ln(t), s = ue(t.customStringKey || n), l = ee(() => {
      const d = o(s.value);
      return t.tile.title ? t.tile.title : i(d) ? a(d, {
        name: r(),
        ...t.additionalVars
      }) : `MISSING: ${d}`;
    }), c = ee(() => `h${t.level}`);
    function u() {
      t.tile.link && window.homeActionHandler("route", t.tile.link);
    }
    return (d, p) => l.value ? (w(), ge(er(c.value), {
      key: 0,
      onClick: u,
      class: Ce(["heading", { linked: !!d.tile.link }])
    }, {
      default: Oe(() => [
        Ee(D(l.value), 1)
      ]),
      _: 1
    }, 8, ["class"])) : re("", !0);
  }
}), gS = ".heading[data-v-c9a036b7]{margin:0;font-size:1.5rem}.linked[data-v-c9a036b7]{cursor:pointer}.linked[data-v-c9a036b7]:hover,.linked[data-v-c9a036b7]:focus{text-decoration:underline}", ar = /* @__PURE__ */ ae(_S, [["styles", [gS]], ["__scopeId", "data-v-c9a036b7"]]), hS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ar
}, Symbol.toStringTag, { value: "Module" })), vS = { class: "homepage-tile__info" }, yS = { class: "actions" }, bS = { class: "homepage-tile__feed" }, zS = /* @__PURE__ */ Q({
  __name: "DefaultTileLayout",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const t = e, { t: n } = ve(), { useTileEmits: r } = Ln(t), o = ee(() => {
      if (t.tile.type === "announcement" && t.tile.subType === "community")
        return n("community-announcement");
      if (t.tile.type === "journey") {
        const i = t.tile.subType === "invited" ? "start-today" : "journey-update";
        return n(i);
      }
      return null;
    });
    r({ tileHeader: o });
    const a = ee(() => t.tile.type === "announcement" && t.tile.subType === "community" ? "mdi:megaphone" : null);
    return r({ tileHeader: o, tileHeaderIcon: a }), (i, s) => (w(), P("div", {
      class: Ce(["homepage-tile", [i.tile.type, i.tile.subType]])
    }, [
      x("div", vS, [
        i.tile.author ? (w(), ge(Fl, {
          key: 0,
          author: i.tile.author
        }, null, 8, ["author"])) : re("", !0),
        B(vp, { tile: i.tile }, null, 8, ["tile"]),
        B(ar, { tile: i.tile }, null, 8, ["tile"]),
        B(Ir, { tile: i.tile }, null, 8, ["tile"]),
        x("div", yS, [
          B(rr, { tile: i.tile }, null, 8, ["tile"])
        ])
      ]),
      x("div", bS, [
        B(Io, { tile: i.tile }, null, 8, ["tile"])
      ])
    ], 2));
  }
}), jS = ".homepage-tile-wrapper[data-v-e2e21859]{display:flex;max-width:1140px;width:100%;flex-direction:column;--tile-theme-color: #0072ef;box-sizing:border-box}.tile-header[data-v-e2e21859]{font-size:1.5rem;font-weight:700;margin-top:0}.homepage-tile[data-v-e2e21859]{border-radius:18px;padding:1.5rem;display:flex;flex-wrap:wrap;gap:1.5rem;width:100%;outline:1px solid transparent;box-sizing:border-box}.homepage-tile .homepage-tile__info[data-v-e2e21859]{display:flex;flex-direction:column;gap:1rem;color:#fff;width:100%}.homepage-tile .homepage-tile__info h2[data-v-e2e21859]{margin:0;font-size:1.5rem;padding:0}.homepage-tile .homepage-tile__info p[data-v-e2e21859]{color:#fff;line-height:22px;margin:0}@media (min-width: 640px){.homepage-tile .homepage-tile__info[data-v-e2e21859]{max-width:27rem;min-width:20rem}}.homepage-tile.clear .homepage-tile__info[data-v-e2e21859]{max-width:50%}@media (max-width: 900px){.homepage-tile.clear .homepage-tile__info[data-v-e2e21859]{max-width:unset}}.homepage-tile .homepage-tile__feed[data-v-e2e21859]{display:flex;flex-direction:column;gap:.5rem;border-radius:18px;flex:1;box-sizing:border-box}@media (min-width: 640px){.homepage-tile .homepage-tile__feed[data-v-e2e21859]{min-width:25rem}}.row[data-v-e2e21859]{display:flex;flex-direction:column;border-radius:10px;background:#e4ecf4;color:#000;padding:1.2rem 1.5rem;gap:.5rem;outline:1px solid transparent;align-self:flex-end;width:100%;box-sizing:border-box}.row.image[data-v-e2e21859]{background:none;padding:0}.row.shadow[data-v-e2e21859]{box-shadow:0 2px 24px #00000040}.row.clear[data-v-e2e21859]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.row.event[data-v-e2e21859]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.programs[data-v-e2e21859]{max-width:unset}.row.topics[data-v-e2e21859]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.linked[data-v-e2e21859]{cursor:pointer}.row.linked[data-v-e2e21859]:hover{background-color:#dae3ed!important}.vertical[data-v-e2e21859]{flex-direction:column;width:100%}.program[data-v-e2e21859]{background:#0072ef}.program .tile-title strong[data-v-e2e21859]{color:#fff!important}.resource[data-v-e2e21859],.explore[data-v-e2e21859],.journey_step[data-v-e2e21859],.resource .homepage-tile__info[data-v-e2e21859],.explore .homepage-tile__info[data-v-e2e21859],.journey_step .homepage-tile__info[data-v-e2e21859],.resource .homepage-tile__info p[data-v-e2e21859],.explore .homepage-tile__info p[data-v-e2e21859],.journey_step .homepage-tile__info p[data-v-e2e21859]{color:#000}.resource .homepage-tile__info .tile-title[data-v-e2e21859],.explore .homepage-tile__info .tile-title[data-v-e2e21859],.journey_step .homepage-tile__info .tile-title[data-v-e2e21859]{color:#4d4d4d!important}.resource .homepage-tile__feed .row[data-v-e2e21859],.explore .homepage-tile__feed .row[data-v-e2e21859],.journey_step .homepage-tile__feed .row[data-v-e2e21859]{background:#e4ecf4}.journeys[data-v-e2e21859],.journey[data-v-e2e21859]{background:#212121;color:#fff}.journeys .homepage-tile__info[data-v-e2e21859],.journey .homepage-tile__info[data-v-e2e21859]{color:#fff}.journeys .homepage-tile__feed .row[data-v-e2e21859],.journey .homepage-tile__feed .row[data-v-e2e21859]{background:#3d3d3d;color:#fff}.community[data-v-e2e21859]{background:#fff;color:#000;box-shadow:0 2px 13px #00000014}.community .homepage-tile__info[data-v-e2e21859],.community .homepage-tile__info p[data-v-e2e21859]{color:#000}.community .homepage-tile__feed .row[data-v-e2e21859]{background:#e4ecf4}.explore .homepage-tile__feed[data-v-e2e21859]{max-width:unset;width:100%}.explore .homepage-tile__feed .row[data-v-e2e21859]{padding:0;background:none}.custom-theme[data-v-e2e21859]{background:var(--tile-theme-color)}.clear[data-v-e2e21859]{background:none!important;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.clear .homepage-tile__info[data-v-e2e21859],.clear .homepage-tile__info p[data-v-e2e21859]{color:#000}@media screen and (max-width: 600px){.homepage-tile .homepage-tile__info[data-v-e2e21859]{max-width:100%;min-width:100%}}", wS = /* @__PURE__ */ ae(zS, [["styles", [jS]], ["__scopeId", "data-v-e2e21859"]]), xS = { class: "homepage-tile__info" }, kS = { class: "actions" }, SS = { class: "homepage-tile__feed" }, ES = /* @__PURE__ */ Q({
  __name: "ExploreTileLayout",
  props: {
    tile: { type: null }
  },
  setup(e) {
    return (t, n) => (w(), P("div", {
      class: Ce(["homepage-tile clear", [t.tile.type, t.tile.subType]])
    }, [
      x("div", xS, [
        t.tile.author ? (w(), ge(Fl, {
          key: 0,
          author: t.tile.author
        }, null, 8, ["author"])) : re("", !0),
        B(ar, {
          tile: t.tile,
          level: 2
        }, null, 8, ["tile"]),
        B(Ir, { tile: t.tile }, null, 8, ["tile"]),
        x("div", kS, [
          B(rr, { tile: t.tile }, null, 8, ["tile"])
        ])
      ]),
      x("div", SS, [
        B(Io, { tile: t.tile }, null, 8, ["tile"])
      ])
    ], 2));
  }
}), PS = ".homepage-tile-wrapper[data-v-48d4e5bb]{display:flex;max-width:1140px;width:100%;flex-direction:column;--tile-theme-color: #0072ef;box-sizing:border-box}.tile-header[data-v-48d4e5bb]{font-size:1.5rem;font-weight:700;margin-top:0}.homepage-tile[data-v-48d4e5bb]{border-radius:18px;padding:1.5rem;display:flex;flex-wrap:wrap;gap:1.5rem;width:100%;outline:1px solid transparent;box-sizing:border-box}.homepage-tile .homepage-tile__info[data-v-48d4e5bb]{display:flex;flex-direction:column;gap:1rem;color:#fff;width:100%}.homepage-tile .homepage-tile__info h2[data-v-48d4e5bb]{margin:0;font-size:1.5rem;padding:0}.homepage-tile .homepage-tile__info p[data-v-48d4e5bb]{color:#fff;line-height:22px;margin:0}@media (min-width: 640px){.homepage-tile .homepage-tile__info[data-v-48d4e5bb]{max-width:27rem;min-width:20rem}}.homepage-tile.clear .homepage-tile__info[data-v-48d4e5bb]{max-width:50%}@media (max-width: 900px){.homepage-tile.clear .homepage-tile__info[data-v-48d4e5bb]{max-width:unset}}.homepage-tile .homepage-tile__feed[data-v-48d4e5bb]{display:flex;flex-direction:column;gap:.5rem;border-radius:18px;flex:1;box-sizing:border-box}@media (min-width: 640px){.homepage-tile .homepage-tile__feed[data-v-48d4e5bb]{min-width:25rem}}.row[data-v-48d4e5bb]{display:flex;flex-direction:column;border-radius:10px;background:#e4ecf4;color:#000;padding:1.2rem 1.5rem;gap:.5rem;outline:1px solid transparent;align-self:flex-end;width:100%;box-sizing:border-box}.row.image[data-v-48d4e5bb]{background:none;padding:0}.row.shadow[data-v-48d4e5bb]{box-shadow:0 2px 24px #00000040}.row.clear[data-v-48d4e5bb]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.row.event[data-v-48d4e5bb]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.programs[data-v-48d4e5bb]{max-width:unset}.row.topics[data-v-48d4e5bb]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.linked[data-v-48d4e5bb]{cursor:pointer}.row.linked[data-v-48d4e5bb]:hover{background-color:#dae3ed!important}.vertical[data-v-48d4e5bb]{flex-direction:column;width:100%}.program[data-v-48d4e5bb]{background:#0072ef}.program .tile-title strong[data-v-48d4e5bb]{color:#fff!important}.resource[data-v-48d4e5bb],.explore[data-v-48d4e5bb],.journey_step[data-v-48d4e5bb],.resource .homepage-tile__info[data-v-48d4e5bb],.explore .homepage-tile__info[data-v-48d4e5bb],.journey_step .homepage-tile__info[data-v-48d4e5bb],.resource .homepage-tile__info p[data-v-48d4e5bb],.explore .homepage-tile__info p[data-v-48d4e5bb],.journey_step .homepage-tile__info p[data-v-48d4e5bb]{color:#000}.resource .homepage-tile__info .tile-title[data-v-48d4e5bb],.explore .homepage-tile__info .tile-title[data-v-48d4e5bb],.journey_step .homepage-tile__info .tile-title[data-v-48d4e5bb]{color:#4d4d4d!important}.resource .homepage-tile__feed .row[data-v-48d4e5bb],.explore .homepage-tile__feed .row[data-v-48d4e5bb],.journey_step .homepage-tile__feed .row[data-v-48d4e5bb]{background:#e4ecf4}.journeys[data-v-48d4e5bb],.journey[data-v-48d4e5bb]{background:#212121;color:#fff}.journeys .homepage-tile__info[data-v-48d4e5bb],.journey .homepage-tile__info[data-v-48d4e5bb]{color:#fff}.journeys .homepage-tile__feed .row[data-v-48d4e5bb],.journey .homepage-tile__feed .row[data-v-48d4e5bb]{background:#3d3d3d;color:#fff}.community[data-v-48d4e5bb]{background:#fff;color:#000;box-shadow:0 2px 13px #00000014}.community .homepage-tile__info[data-v-48d4e5bb],.community .homepage-tile__info p[data-v-48d4e5bb]{color:#000}.community .homepage-tile__feed .row[data-v-48d4e5bb]{background:#e4ecf4}.explore .homepage-tile__feed[data-v-48d4e5bb]{max-width:unset;width:100%}.explore .homepage-tile__feed .row[data-v-48d4e5bb]{padding:0;background:none}.custom-theme[data-v-48d4e5bb]{background:var(--tile-theme-color)}.clear[data-v-48d4e5bb]{background:none!important;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.clear .homepage-tile__info[data-v-48d4e5bb],.clear .homepage-tile__info p[data-v-48d4e5bb]{color:#000}@media screen and (max-width: 600px){.homepage-tile .homepage-tile__info[data-v-48d4e5bb]{max-width:100%;min-width:100%}}.explore[data-v-48d4e5bb]{flex-direction:column;align-items:flex-start}", TS = /* @__PURE__ */ ae(ES, [["styles", [PS]], ["__scopeId", "data-v-48d4e5bb"]]), CS = { class: "columns" }, AS = { class: "program-info" }, OS = { class: "artwork-container" }, IS = { class: "description" }, LS = { class: "wide-actions" }, NS = { class: "mobile-actions" }, MS = { class: "feed" }, RS = {
  key: 0,
  class: "row"
}, $S = /* @__PURE__ */ Q({
  __name: "ProgramNotStartedTileLayout",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const t = e, n = ue(!0), { t: r, defaultTileComponentConfig: o, useTileEmits: a } = Ln(t), i = ee(() => {
      if (t.tile.subType == "not_started") {
        const m = so(t.tile.program?.group?.start_date) ? "start-today" : "your-program-is-starting-soon";
        return r(m);
      }
      return r("program-update");
    }), s = {
      ...o,
      program: {
        hide: !0
      }
    };
    function l(m) {
      return c(
        m.program?.session?.id,
        so(m.program?.session?.start_date),
        m.program?.session?.launched,
        m.program?.group?.id,
        m.program?.group?.always_on,
        so(m.program?.group?.start_date)
      );
    }
    function c(m, f, _, y, A, I) {
      return m ? f && _ && y && I ? "started-session" : "enrolled" : y ? A ? I ? "started" : "enrolled" : "added" : "unknown";
    }
    const u = ee(() => {
      if (!t.tile.program?.session)
        return null;
      const m = Et(t.tile.program.session.start_date, "MMMM do"), f = Et(t.tile.program.session.end_date, "MMMM do");
      return `${m} - ${f}`;
    }), d = ee(() => {
      let m = "";
      const f = t.tile.program?.group, _ = t.tile.program?.session, y = f?.start_date ?? _?.start_date, A = f?.end_date ?? _?.end_date;
      if (Di(y))
        if (Fi(y))
          m += r("homepage-program-not-started.program_starts_today", {
            time: Et(y, "h:mm bbb")
          });
        else {
          const I = ao(y, /* @__PURE__ */ new Date());
          m += r("homepage-program-not-started.program_starts_in_days", {
            days: I
          });
        }
      else if (A) {
        if (Di(A))
          if (Fi(A))
            m += r("homepage-program-not-started.program_ends_today", {
              time: Et(A, "h:mm bbb")
            });
          else {
            const I = ao(A, /* @__PURE__ */ new Date());
            m += r(
              "homepage-program-not-started.program_ends_in_days",
              { days: I }
            );
          }
      } else if (f)
        if (Fi(y))
          m += r(
            "homepage-program-not-started.program_started_today"
          );
        else {
          const I = ao(
            /* @__PURE__ */ new Date(),
            y
          );
          m += r(
            "homepage-program-not-started.program_started_days_ago",
            { days: I }
          );
        }
      return (f?.notify_launch || _?.notify_launch) && (!f || Di(f.start_date)) && (m += r("homepage-program-not-started.program_reminder")), m;
    }), p = ee(() => t.tile.subType == "completed" || t.tile.subType == "ending" || t.tile.subType == "happening-now" ? `${t.tile.type}-${t.tile.subType}` : `${t.tile.type}-${t.tile.subType}.${l(t.tile)}`);
    return a({ tileHeader: i, setCustomBackground: n }), (m, f) => (w(), P("div", {
      class: Ce(["homepage-tile", [
        m.tile.type,
        m.tile.subType,
        { "custom-theme": n.value },
        m.tile.forcedSize
      ]])
    }, [
      B(ar, {
        class: "mobile-title",
        tile: m.tile,
        additionalVars: {
          date: u.value
        },
        "custom-string-key": p.value
      }, null, 8, ["tile", "additionalVars", "custom-string-key"]),
      x("div", CS, [
        x("div", AS, [
          x("div", OS, [
            m.tile.program?.image ? (w(), ge(st, {
              key: 0,
              class: "artwork",
              src: m.tile.program.image,
              alt: m.tile.program.title
            }, null, 8, ["src", "alt"])) : re("", !0)
          ]),
          x("div", IS, [
            B(ar, {
              class: "wide-title",
              tile: m.tile,
              additionalVars: {
                date: u.value
              },
              "custom-string-key": p.value
            }, null, 8, ["tile", "additionalVars", "custom-string-key"]),
            B(Ir, {
              tile: m.tile,
              "clamp-limit": 6
            }, null, 8, ["tile"]),
            x("div", LS, [
              B(rr, {
                tile: m.tile,
                flipped: !0
              }, null, 8, ["tile"])
            ])
          ])
        ]),
        x("div", NS, [
          B(rr, {
            tile: m.tile,
            flipped: !0
          }, null, 8, ["tile"])
        ]),
        x("div", MS, [
          d.value ? (w(), P("div", RS, D(d.value), 1)) : re("", !0),
          B(Io, {
            class: "row",
            tile: m.tile,
            "custom-tile-component-config": s,
            "custom-props-config": {
              group_activity: (_) => ({
                flipped: !0
              }),
              certificate: (_) => ({
                downloadText: "Download Certificate"
              })
            }
          }, null, 8, ["tile"])
        ])
      ])
    ], 2));
  }
}), DS = ".homepage-tile[data-v-1a0ba81b]{color:#fff}.homepage-tile .columns[data-v-1a0ba81b]{display:flex;flex-direction:column;gap:1.5rem;width:100%}.homepage-tile .program-info[data-v-1a0ba81b]{display:flex;gap:1.5rem}.homepage-tile .program-info .artwork-container[data-v-1a0ba81b]{height:100%;max-height:400px;max-width:295px;width:100%;aspect-ratio:1 / 1.3;flex:1 0 30%}.homepage-tile .program-info .artwork-container .artwork[data-v-1a0ba81b]{height:100%;width:100%;border-radius:10px;object-fit:cover}.homepage-tile .program-info .description[data-v-1a0ba81b]{flex-grow:1;display:flex;flex-direction:column;gap:1rem}.homepage-tile .feed[data-v-1a0ba81b]{display:flex;flex-direction:column;gap:.5rem}.homepage-tile .feed .row[data-v-1a0ba81b]{border-radius:10px;background:#e4ecf4;color:#000;padding:1.2rem 1.5rem;outline:1px solid transparent}.homepage-tile h2[data-v-1a0ba81b]{margin:0;padding:0;font-size:1.5rem}.homepage-tile .mobile-actions[data-v-1a0ba81b] .tile-actions{width:100%}.homepage-tile .mobile-actions[data-v-1a0ba81b] .tile-actions a,.homepage-tile .mobile-actions[data-v-1a0ba81b] .tile-actions button{width:100%;box-sizing:border-box}@media (min-width: 1080px){.homepage-tile .columns[data-v-1a0ba81b]{flex-direction:row}.homepage-tile .feed[data-v-1a0ba81b]{flex:1 0 350px}}@media (max-width: 800px){.homepage-tile .wide-title[data-v-1a0ba81b]{display:none}}@media (min-width: 801px){.homepage-tile .mobile-title[data-v-1a0ba81b]{display:none}.homepage-tile .description[data-v-1a0ba81b]{max-width:500px}}@media (max-width: 640px){.homepage-tile .wide-actions[data-v-1a0ba81b]{display:none}}@media (min-width: 641px){.homepage-tile .mobile-actions[data-v-1a0ba81b]{display:none}}.medium .columns[data-v-1a0ba81b]{flex-direction:column}.medium .feed[data-v-1a0ba81b]{flex:1 0 fit-content}", FS = /* @__PURE__ */ ae($S, [["styles", [DS]], ["__scopeId", "data-v-1a0ba81b"]]), US = { class: "nomadic-progress" }, VS = {
  key: 0,
  class: "nomadic-progress__bar"
}, qS = {
  key: 1,
  class: "nomadic-progress__steps"
}, HS = { class: "visually-hidden" }, BS = /* @__PURE__ */ Q({
  __name: "NomadicProgress",
  props: {
    label: {
      type: String,
      required: !1
    },
    progress: {
      type: Number,
      required: !0,
      default: 0
    },
    steps: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    return (t, n) => (w(), P("div", US, [
      e.steps ? re("", !0) : (w(), P("div", VS, [
        x("div", {
          class: "nomadic-progress__bar__progress",
          style: Ut({
            width: `${e.progress > 100 ? 100 : e.progress}%`
          })
        }, null, 4)
      ])),
      e.steps ? (w(), P("div", qS, [
        (w(!0), P(se, null, De(e.steps, (r, o) => (w(), P("div", {
          class: Ce(["nomadic-progress__steps__step", {
            current: o + 1 === e.steps.completed
          }]),
          key: r
        }, [
          x("div", {
            class: "progress",
            style: Ut({
              width: `${r.progress > 100 ? 100 : r.progress}%`
            })
          }, null, 4)
        ], 2))), 128))
      ])) : re("", !0),
      x("label", null, [
        x("span", HS, D(e.label), 1),
        Ha(t.$slots, "default", {}, void 0)
      ])
    ]));
  }
}), JS = '.nomadic-progress[data-v-0e64ec63]{display:flex;flex-direction:column}.nomadic-progress__bar[data-v-0e64ec63]{width:100%;height:.3rem;background:#7aa3cc5c;border-radius:.25rem;position:relative;outline:1px solid transparent}.nomadic-progress__bar__progress[data-v-0e64ec63]{position:absolute;top:0;left:0;height:100%;background-color:#0072ef;border-radius:.25rem}@media (forced-colors: active){.nomadic-progress__bar__progress[data-v-0e64ec63]{forced-color-adjust:none;background-color:#fff}}.nomadic-progress__steps[data-v-0e64ec63]{display:flex;justify-content:space-between;height:.3rem;gap:.25rem}.nomadic-progress__steps__step[data-v-0e64ec63]{background-color:#acacac;border-radius:.25rem;overflow:hidden;flex:1;outline:1px solid transparent}.nomadic-progress__steps__step .progress[data-v-0e64ec63]{height:100%;background-color:#0072ef;border-radius:.25rem}@media (forced-colors: active){.nomadic-progress__steps__step .progress[data-v-0e64ec63]{forced-color-adjust:none;background-color:#fff}}.nomadic-progress__steps__step.completed[data-v-0e64ec63]{background-color:#0072ef}.nomadic-progress__steps__step.current[data-v-0e64ec63]{position:relative;background-color:#acacac}.nomadic-progress__steps__step.current[data-v-0e64ec63]:after{content:"";position:absolute;width:101%;height:100%;background-color:#0072ef;animation:pulse-0e64ec63 3s infinite;transform-origin:left;border-radius:.25rem}.nomadic-progress p[data-v-0e64ec63],.nomadic-progress label[data-v-0e64ec63]{margin:0;margin-top:.5rem}@keyframes pulse-0e64ec63{0%{transform:scaleX(0);opacity:100}50%{transform:scaleX(1);opacity:100}}', Cn = /* @__PURE__ */ ae(BS, [["styles", [JS]], ["__scopeId", "data-v-0e64ec63"]]), WS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Cn
}, Symbol.toStringTag, { value: "Module" }));
function dn(e) {
  return ao(e, /* @__PURE__ */ new Date());
}
function li(e, t) {
  return e.replace(
    /<link>(.*?)<\/link>/g,
    `<a href="${t}">$1</a>`
  );
}
const YS = { class: "info" }, GS = { class: "header" }, KS = ["id", "inert"], QS = /* @__PURE__ */ Q({
  __name: "ProgressCardWrapper",
  props: {
    title: { type: String },
    image: { type: String },
    forceSmall: { type: Boolean, default: !1 },
    background: { type: [Boolean, null], default: null }
  },
  emits: ["titleClick"],
  setup(e, { emit: t }) {
    const n = e, r = t, o = Math.random().toString(36).substring(7), a = ee(() => n.image ? `https://res.cloudinary.com/nomadic/image/fetch/w_295,h_400,c_fill,f_auto,q_60/${encodeURIComponent(
      n.image
    )}` : ""), i = ee(() => n.background === null ? {
      role: "presentation"
    } : {
      tabindex: "0",
      role: "button",
      "aria-controls": o,
      "aria-expanded": n.background ? "false" : "true"
    });
    function s() {
      n.background !== null && r("titleClick");
    }
    return (l, c) => (w(), P("div", {
      onClick: s,
      class: Ce(["in-progress-card", { small: l.forceSmall, "not-small": !l.forceSmall }])
    }, [
      l.image ? (w(), ge(st, {
        key: 0,
        class: "artwork",
        src: a.value,
        alt: ""
      }, null, 8, ["src"])) : re("", !0),
      x("div", YS, [
        x("div", GS, [
          x("p", null, [
            x("a", Er({
              class: "title",
              href: ""
            }, i.value, {
              onClick: Or(s, ["prevent"])
            }), D(l.title), 17)
          ])
        ]),
        x("div", {
          id: X(o),
          class: "content",
          inert: !!l.background
        }, [
          Ha(l.$slots, "default", {}, void 0)
        ], 8, KS)
      ])
    ], 2));
  }
}), XS = ".in-progress-card[data-v-edf1623f]{position:relative;display:flex;gap:1rem;background:#fff;box-shadow:0 1px 21px #00000012;padding:1rem;border-radius:.75rem;max-width:420px;width:100%;box-sizing:border-box}.in-progress-card .artwork[data-v-edf1623f]{max-height:190px;max-width:143px;aspect-ratio:1 / 1.3;border-radius:10px;object-fit:cover}.in-progress-card .info[data-v-edf1623f]{display:flex;flex-direction:column;justify-content:space-between;gap:2rem;padding-top:.25rem;padding-bottom:.25rem;margin-right:.5rem;width:100%}.in-progress-card .info .header[data-v-edf1623f]{display:flex;flex-shrink:0;gap:1rem}.in-progress-card .info .header p[data-v-edf1623f]{padding:0;margin:0}.in-progress-card .info .header p .title[data-v-edf1623f]{margin:0;padding:0;color:inherit;text-decoration:none;font-weight:700;cursor:inherit}.in-progress-card .info .content[data-v-edf1623f]{display:flex;flex-direction:column;justify-content:space-between;gap:2rem}.in-progress-card.small[data-v-edf1623f]{background:var(--tile-theme-color);color:#fff}@media (min-width: 1024px){.in-progress-card.not-small[data-v-edf1623f]{padding:0;color:#fff;height:420px;align-items:flex-end;box-shadow:none;max-width:unset;background:none}.in-progress-card.not-small .artwork[data-v-edf1623f]{position:absolute;top:0;max-height:400px;max-width:295px}.in-progress-card.not-small .info[data-v-edf1623f]{margin-left:1rem;background:var(--tile-theme-color);padding:1rem;border-radius:.75rem;z-index:1;max-width:300px;box-sizing:border-box;box-shadow:0 1px 21px 2px #00000012;height:fit-content;gap:1rem}.in-progress-card.not-small .info .header p strong[data-v-edf1623f]{font-size:1rem}}@media (max-width: 1023px){.in-progress-card.not-small[data-v-edf1623f]{background:var(--tile-theme-color);color:#fff}}", Ul = /* @__PURE__ */ ae(QS, [["styles", [XS]], ["__scopeId", "data-v-edf1623f"]]), ZS = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ul
}, Symbol.toStringTag, { value: "Module" })), eE = /* @__PURE__ */ Q({
  __name: "ProgramInProgressCard",
  props: {
    program: { type: null },
    tile: { default: {}, type: null },
    forceSmall: { type: Boolean, default: !1 },
    background: { type: [Boolean, null], default: null }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const { t: n } = ve(), r = e, o = t;
    return ee(() => `https://res.cloudinary.com/nomadic/image/fetch/w_295,h_400,c_fill,f_auto,q_60/${encodeURIComponent(
      r.program.image
    )}`), (a, i) => (w(), ge(Ul, {
      tile: r.tile,
      title: r.program.session?.name || r.program.title,
      image: r.program.image,
      forceSmall: r.forceSmall,
      background: r.background,
      onTitleClick: i[0] || (i[0] = (s) => o("click"))
    }, {
      default: Oe(() => [
        B(Cn, {
          progress: a.program.progress
        }, {
          default: Oe(() => [
            x("span", null, [
              Ee(D(X(n)("homepage-progress.standard", {
                progress: a.program.progress.toFixed(0)
              })) + " ", 1),
              a.program.endDate ? (w(), P(se, { key: 0 }, [
                Ee(" - " + D(X(n)("days_remaining", {
                  n: X(dn)(a.program.endDate)
                })), 1)
              ], 64)) : re("", !0)
            ])
          ]),
          _: 1
        }, 8, ["progress"]),
        B(rr, {
          class: "actions",
          tile: a.tile
        }, null, 8, ["tile"])
      ]),
      _: 1
    }, 8, ["tile", "title", "image", "forceSmall", "background"]));
  }
}), tE = ".actions[data-v-ee27fe2e]{width:100%}.actions[data-v-ee27fe2e] .primary{width:100%!important;margin-top:0}.actions[data-v-ee27fe2e] .primary.primary{background:#fff;color:#000}[data-v-ee27fe2e] .nomadic-progress .nomadic-progress__bar{background:#f2f2f224}[data-v-ee27fe2e] .nomadic-progress .nomadic-progress__bar__progress{background:#f2f2f2}", Ca = /* @__PURE__ */ ae(eE, [["styles", [tE]], ["__scopeId", "data-v-ee27fe2e"]]), nE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Ca
}, Symbol.toStringTag, { value: "Module" })), rE = { key: 0 }, oE = { key: 1 }, aE = /* @__PURE__ */ Q({
  __name: "JourneyCard",
  props: {
    tile: { default: {}, type: null },
    background: { type: [Boolean, null], default: null }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const { t: n } = ve(), r = e, o = t, a = ee(() => r.tile?.journey || r.tile), i = ee(() => r.tile?.program?.endDate || r.tile?.journey?.endDate || r.tile?.program?.journey?.endDate || r.tile?.endDate);
    function s() {
      window.homeActionHandler("openJourneyPanel", a.value.journeyId);
    }
    function l() {
      r.background !== null && o("click");
    }
    return (c, u) => (w(), ge(Ul, {
      class: "journey-in-progress-card",
      title: `Journey: ${a.value?.journeyTitle}`,
      background: r.background,
      onTitleClick: l,
      "force-small": ""
    }, {
      default: Oe(() => [
        a.value.progress ? (w(), ge(Cn, {
          key: 0,
          progress: a.value.progress,
          steps: a.value.progress.steps
        }, {
          default: Oe(() => [
            x("span", null, D(X(n)(
              `homepage-progress.${a.value?.progress?.steps ? "steps" : "standard"}`,
              {
                progress: a.value?.progress?.myProgress?.toFixed(0),
                maxSteps: a.value?.progress?.steps?.length,
                currentStep: a.value?.progress?.steps?.filter(
                  (d) => d.progress == 100
                ).length
              }
            )), 1),
            X(dn)(i.value) < 0 ? (w(), P("span", rE, " - " + D(X(n)("homepage-progress.program_closed")), 1)) : i.value ? (w(), P("span", oE, " - " + D(X(n)("days_remaining", {
              n: X(dn)(i.value)
            })), 1)) : re("", !0)
          ]),
          _: 1
        }, 8, ["progress", "steps"])) : re("", !0),
        B(bt, {
          variant: "dark",
          onClick: s
        }, {
          default: Oe(() => [
            Ee(D(X(n)("view-all-journey-steps")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "background"]));
  }
}), iE = `.journey-in-progress-card[data-v-b6c87f68]{--tile-theme-color: #212121}.journey-in-progress-card[data-v-b6c87f68] .title:after{display:inline-block;margin:auto;content:"";background-image:url("data:image/svg+xml,%3Csvg width='18' height='19' viewBox='0 0 18 19' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.3226 7.26112L9 0.874023L6.3871 7.26112L0 9.87402L6.3871 12.4869L9 18.874L11.6129 12.4869L18 9.87402L11.3226 7.26112Z' fill='%230072EF'/%3E%3C/svg%3E%0A");background-repeat:no-repeat;background-size:contain;width:.9rem;height:.9rem;margin-left:.25rem;vertical-align:middle}`, Aa = /* @__PURE__ */ ae(aE, [["styles", [iE]], ["__scopeId", "data-v-b6c87f68"]]), sE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Aa
}, Symbol.toStringTag, { value: "Module" })), lE = { class: "combined-card" }, cE = /* @__PURE__ */ Q({
  __name: "ProgramInProgressCardWithJourney",
  props: {
    program: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    tile: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, n = ue("program");
    ue();
    const r = ee(() => n.value === "program" ? "journey" : "program"), o = ee(() => n.value === "program" ? Ca : Aa), a = ee(() => n.value === "program" ? Aa : Ca);
    function i(l) {
      return l === "program" ? {
        program: t.program,
        forceSmall: !0
      } : {
        class: "journey-card"
      };
    }
    function s(l) {
      l !== n.value && (n.value = l);
    }
    return (l, c) => (w(), P("div", lE, [
      (w(), ge(er(a.value), Er({
        tile: e.tile,
        class: "back",
        onClick: c[0] || (c[0] = (u) => s(r.value)),
        background: !0
      }, i(r.value)), null, 16, ["tile"])),
      (w(), ge(er(o.value), Er({
        tile: e.tile,
        class: "front",
        onClick: c[1] || (c[1] = (u) => s(n.value)),
        background: !1
      }, i(n.value)), null, 16, ["tile"]))
    ]));
  }
}), uE = ".combined-card[data-v-ef25104b]{position:relative;padding:0;color:#fff;align-items:flex-end;box-shadow:none;max-width:unset}.combined-card>div[data-v-ef25104b]{width:320px;padding:.5rem}[data-v-ef25104b] .info{max-width:none!important}[data-v-ef25104b] .artwork{max-width:100px!important;max-height:140px!important}.journey-card.back[data-v-ef25104b] .info{max-height:180px;padding-left:.25rem;padding-right:.25rem}.journey-card.back[data-v-ef25104b] .info .header{height:1.4em;overflow:hidden}.back[data-v-ef25104b]{top:0;left:0;z-index:0;cursor:pointer;user-select:none;max-height:180px}.front[data-v-ef25104b]{position:absolute!important;top:2.7rem!important;left:.75rem!important;z-index:2!important;cursor:pointer}", Pf = /* @__PURE__ */ ae(cE, [["styles", [uE]], ["__scopeId", "data-v-ef25104b"]]), mE = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Pf
}, Symbol.toStringTag, { value: "Module" })), dE = { class: "program-info" }, pE = { class: "homepage-tile__info" }, fE = { class: "homepage-tile__feed" }, _E = { class: "in-progress-wrapper" }, gE = { key: 0 }, hE = { key: 0 }, vE = /* @__PURE__ */ Q({
  __name: "ProgramInProgressTileLayout",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const t = e, { t: n, te: r, defaultTileComponentConfig: o } = Ln(t), a = {
      ...o,
      group_activity: {
        order: 99,
        component: "GroupActivity"
      },
      video: {
        order: 100,
        component: "BrightcoveVideo"
      },
      program: {
        hide: !0
      },
      progress: {
        hide: !0
      },
      discussions: { component: "ProgramInProgressDiscussion", order: 4 },
      page: { component: "SummaryPage", order: 1 }
    }, i = ee(() => t.tile.summaryLeaderboard ? "leaderboard" : t.tile.discussions?.length > 1 ? "discussions" : t.tile.discussions?.length === 1 ? "commenting" : t.tile.page ? "page" : t.tile.summaryNewPoll ? "new_poll" : t.tile.summaryProgress ? "progress" : ""), s = ee(() => {
      switch (i.value) {
        case "leaderboard":
          return n("leaderboard");
        case "discussions":
        case "commenting":
          return n("happening-now");
      }
      return null;
    });
    function l(c) {
      return !!(c.video || c.discussions?.length > 1 || c.page);
    }
    return (c, u) => (w(), P(se, null, [
      x("div", dE, [
        B(ar, {
          tile: c.tile,
          level: 2
        }, null, 8, ["tile"]),
        B(Ir, { tile: c.tile }, null, 8, ["tile"])
      ]),
      x("div", {
        class: Ce(["homepage-tile clear", [c.tile.type, c.tile.subType]])
      }, [
        x("div", pE, [
          c.tile.journey ? (w(), ge(Pf, {
            key: 0,
            class: "card",
            tile: c.tile,
            program: c.tile.program
          }, null, 8, ["tile", "program"])) : (w(), ge(Ca, {
            key: 1,
            class: "card",
            tile: c.tile,
            program: c.tile.program
          }, null, 8, ["tile", "program"]))
        ]),
        x("div", fE, [
          x("div", _E, [
            X(r)(
              `homepage-tile-program_in_progress_description.${i.value}`
            ) ? (w(), P("p", gE, [
              s.value ? (w(), P("strong", hE, D(s.value) + " – ", 1)) : re("", !0),
              Ee(" " + D(X(n)(
                `homepage-tile-program_in_progress_description.${i.value}`
              )), 1)
            ])) : re("", !0),
            B(Io, {
              tile: c.tile,
              "custom-tile-component-config": a,
              "clear-row": l(c.tile),
              I: ""
            }, null, 8, ["tile", "clear-row"])
          ])
        ])
      ], 2)
    ], 64));
  }
}), yE = ".program-info[data-v-f2e95f50]{margin-top:0;margin-bottom:1.5rem;max-width:700px;display:flex;flex-direction:column}.homepage-tile[data-v-f2e95f50]{gap:1.5rem;width:100%;box-sizing:border-box;display:flex}.homepage-tile .homepage-tile__info[data-v-f2e95f50]{display:flex;flex-direction:column;gap:1rem}.homepage-tile .homepage-tile__info h2[data-v-f2e95f50]{margin:0;font-size:1.5rem;padding:0}.homepage-tile .homepage-tile__info p[data-v-f2e95f50]{margin:0}.homepage-tile .homepage-tile__feed[data-v-f2e95f50]{display:flex;flex-direction:column;gap:.5rem;border-radius:18px;flex:1;width:100%;box-sizing:border-box}.homepage-tile .homepage-tile__feed .row.image[data-v-f2e95f50]{background:none;padding:0}.homepage-tile .homepage-tile__feed .row.shadow[data-v-f2e95f50]{box-shadow:0 2px 24px #00000040}.homepage-tile .homepage-tile__feed .row.clear[data-v-f2e95f50]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.homepage-tile .homepage-tile__feed .row.event[data-v-f2e95f50]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.homepage-tile .homepage-tile__feed .row.programs[data-v-f2e95f50]{max-width:unset}.homepage-tile .homepage-tile__feed .row.topics[data-v-f2e95f50]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}@media (min-width: 1024px){.homepage-tile .homepage-tile__info[data-v-f2e95f50]{max-width:27rem;min-width:20rem}}@media (max-width: 1023px){.homepage-tile[data-v-f2e95f50]{flex-direction:column}.homepage-tile .homepage-tile__info[data-v-f2e95f50]{flex-direction:row}}@media (max-width: 767px){.homepage-tile .homepage-tile__info[data-v-f2e95f50]{flex-direction:column}}.in-progress-wrapper[data-v-f2e95f50]{display:flex;flex-direction:column;align-items:start;gap:1rem;width:100%;background:#fff;padding:1.25rem 1rem 1rem;border-radius:.5rem;box-shadow:0 1px 21px #00000012;box-sizing:border-box}.in-progress-wrapper p[data-v-f2e95f50]{margin:0;padding:0;line-height:1.2rem;margin-bottom:.25rem}[data-v-f2e95f50] .row{align-self:flex-start;width:100%;max-width:100%!important}[data-v-f2e95f50] .row:hover{background:#dae3ed;cursor:pointer}[data-v-f2e95f50] .row.clear:hover{background:none}", bE = /* @__PURE__ */ ae(vE, [["styles", [yE]], ["__scopeId", "data-v-f2e95f50"]]), Tf = (e) => (xo("data-v-db8b9242"), e = e(), ko(), e), zE = { class: "program-info" }, jE = ["innerHTML"], wE = { class: "homepage-tile__info" }, xE = {
  key: 1,
  class: "homepage-tile__feed"
}, kE = { class: "in-progress-wrapper" }, SE = { key: 0 }, EE = /* @__PURE__ */ Tf(() => /* @__PURE__ */ x("br", null, null, -1)), PE = /* @__PURE__ */ Tf(() => /* @__PURE__ */ x("br", null, null, -1)), TE = /* @__PURE__ */ Q({
  __name: "JourneyTileLayout",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const t = e, { t: n, defaultTileComponentConfig: r } = Ln(t), o = ee(() => t.tile.subType !== "program_enrol"), a = {
      ...r,
      group_activity: {
        order: 99,
        component: "GroupActivity",
        hide: !o.value
      },
      video: {
        order: 100,
        component: "BrightcoveVideo"
      },
      progress: {
        hide: !0
      },
      discussions: { component: "ProgramInProgressDiscussion", order: 4 },
      page: { component: "SummaryPage", order: 1 }
    };
    function i(c) {
      return !!(c.webinar || c.video || c.discussions?.length > 1 || c.page || c.group_activity || c.program);
    }
    const s = ee(() => {
      const c = t.tile.subType.startsWith("program") ? "incomplete-program-step-message" : "incomplete-step-message";
      return li(n(c), "");
    });
    function l(c) {
      c.preventDefault(), c.target.tagName === "A" && window.homeActionHandler("openJourneyPanel", t.tile.journeyId);
    }
    return (c, u) => (w(), P(se, null, [
      x("div", zE, [
        B(ar, {
          tile: c.tile,
          level: 2
        }, null, 8, ["tile"]),
        x("p", {
          onClick: l,
          innerHTML: s.value
        }, null, 8, jE)
      ]),
      x("div", {
        class: Ce(["homepage-tile clear", [c.tile.type, c.tile.subType]])
      }, [
        x("div", wE, [
          B(Aa, {
            class: "card",
            tile: c.tile,
            program: c.tile.program
          }, null, 8, ["tile", "program"])
        ]),
        c.tile.program_tile ? (w(), ge(Cf, {
          key: 0,
          "show-header": !1,
          tile: { ...c.tile.program_tile, forcedSize: "medium" }
        }, null, 8, ["tile"])) : (w(), P("div", xE, [
          x("div", kE, [
            o.value ? (w(), P("p", SE, [
              x("strong", null, D(c.tile.stepTitle), 1),
              Ee(),
              EE,
              PE,
              B(Ir, { tile: c.tile }, null, 8, ["tile"])
            ])) : re("", !0),
            B(Io, {
              tile: c.tile,
              "clear-row": i(c.tile),
              "custom-tile-component-config": a,
              "custom-props-config": {
                program: (d) => ({
                  tile: d,
                  program: d.program
                })
              },
              I: ""
            }, null, 8, ["tile", "clear-row", "custom-props-config"]),
            c.tile.subType == "honor_system" ? (w(), ge(rr, {
              key: 1,
              tile: c.tile,
              actions: c.tile.actions
            }, null, 8, ["tile", "actions"])) : re("", !0)
          ])
        ]))
      ], 2)
    ], 64));
  }
}), CE = ".program-info[data-v-db8b9242]{margin:0;max-width:750px;display:flex;flex-direction:column;gap:.75rem;margin-bottom:2rem}.program-info h2[data-v-db8b9242],.program-info p[data-v-db8b9242]{margin:0;padding:0}.program-info p[data-v-db8b9242] a,.program-info a[data-v-db8b9242]{color:inherit}.homepage-tile[data-v-db8b9242]{gap:1rem;width:100%;box-sizing:border-box;display:flex}.homepage-tile .homepage-tile__info[data-v-db8b9242]{display:flex;flex-direction:column;gap:1rem}.homepage-tile .homepage-tile__info h2[data-v-db8b9242]{margin:0;font-size:1.5rem;padding:0}.homepage-tile .homepage-tile__info p[data-v-db8b9242]{margin:0}.homepage-tile .homepage-tile__feed[data-v-db8b9242]{display:flex;flex-direction:column;gap:1.5rem;border-radius:18px;flex:1;width:100%;box-sizing:border-box}.homepage-tile .homepage-tile__feed .row.image[data-v-db8b9242]{background:none;padding:0}.homepage-tile .homepage-tile__feed .row.shadow[data-v-db8b9242]{box-shadow:0 2px 24px #00000040}.homepage-tile .homepage-tile__feed .row.clear[data-v-db8b9242]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.homepage-tile .homepage-tile__feed .row.event[data-v-db8b9242]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.homepage-tile .homepage-tile__feed .row.programs[data-v-db8b9242]{max-width:unset}.homepage-tile .homepage-tile__feed .row.topics[data-v-db8b9242]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}@media (min-width: 1024px){.homepage-tile .homepage-tile__info[data-v-db8b9242]{max-width:27rem;min-width:20rem}}@media (max-width: 1023px){.homepage-tile[data-v-db8b9242]{flex-direction:column}.homepage-tile .homepage-tile__info[data-v-db8b9242]{flex-direction:row}}@media (max-width: 767px){.homepage-tile .homepage-tile__info[data-v-db8b9242]{flex-direction:column}}.in-progress-wrapper[data-v-db8b9242]{display:flex;flex-direction:column;align-items:start;gap:1.25rem;width:100%;background:#fff;padding:1.75rem;border-radius:.75rem;box-shadow:0 1px 21px #00000012;box-sizing:border-box}.in-progress-wrapper p[data-v-db8b9242]{margin:0;padding:0;line-height:1.2rem;margin-bottom:.25rem}", AE = /* @__PURE__ */ ae(TE, [["styles", [CE]], ["__scopeId", "data-v-db8b9242"]]), OE = {
  key: 0,
  class: "tile-header"
}, IE = /* @__PURE__ */ Q({
  __name: "TileLayoutLoader",
  props: {
    tile: Object,
    showHeader: {
      type: Boolean,
      default: () => !0
    }
  },
  setup(e) {
    const t = e, n = ue(), r = ue(), o = ue(t.tile?.program?.color), a = ue(!1), i = ue(), s = ee(() => t.tile?.type == "program" && t.tile?.subType != "in-progress" ? FS : t.tile?.type == "program" && t.tile?.subType == "in-progress" ? bE : t.tile?.type == "explore" ? TS : t.tile?.type == "journey_step" ? AE : wS), l = ee(() => ({
      "--tile-theme-color": o.value
    }));
    return (c, u) => (w(), P("div", {
      class: "homepage-tile-wrapper",
      style: Ut(l.value)
    }, [
      e.showHeader && n.value ? (w(), P("h2", OE, [
        r.value ? (w(), ge(X(dl), {
          key: 0,
          icon: r.value,
          height: "20",
          width: "20"
        }, null, 8, ["icon"])) : re("", !0),
        Ee(" " + D(n.value), 1)
      ])) : re("", !0),
      (w(), ge(er(s.value), {
        onUpdateTileHeader: u[0] || (u[0] = (d) => n.value = d),
        onUpdateTileHeaderIcon: u[1] || (u[1] = (d) => r.value = d),
        onUpdateTileThemeColor: u[2] || (u[2] = (d) => o.value = d),
        onUpdateSetCustomBackground: u[3] || (u[3] = (d) => a.value = d),
        onUpdateVariant: u[4] || (u[4] = (d) => i.value = d),
        tile: e.tile
      }, null, 40, ["tile"]))
    ], 4));
  }
}), LE = ".homepage-tile-wrapper[data-v-a35f972d]{display:flex;max-width:1140px;width:100%;flex-direction:column;--tile-theme-color: #0072ef;box-sizing:border-box}.tile-header[data-v-a35f972d]{font-size:1.5rem;font-weight:700;margin-top:0}.homepage-tile[data-v-a35f972d]{border-radius:18px;padding:1.5rem;display:flex;flex-wrap:wrap;gap:1.5rem;width:100%;outline:1px solid transparent;box-sizing:border-box}.homepage-tile .homepage-tile__info[data-v-a35f972d]{display:flex;flex-direction:column;gap:1rem;color:#fff;width:100%}.homepage-tile .homepage-tile__info h2[data-v-a35f972d]{margin:0;font-size:1.5rem;padding:0}.homepage-tile .homepage-tile__info p[data-v-a35f972d]{color:#fff;line-height:22px;margin:0}@media (min-width: 640px){.homepage-tile .homepage-tile__info[data-v-a35f972d]{max-width:27rem;min-width:20rem}}.homepage-tile.clear .homepage-tile__info[data-v-a35f972d]{max-width:50%}@media (max-width: 900px){.homepage-tile.clear .homepage-tile__info[data-v-a35f972d]{max-width:unset}}.homepage-tile .homepage-tile__feed[data-v-a35f972d]{display:flex;flex-direction:column;gap:.5rem;border-radius:18px;flex:1;box-sizing:border-box}@media (min-width: 640px){.homepage-tile .homepage-tile__feed[data-v-a35f972d]{min-width:25rem}}.row[data-v-a35f972d]{display:flex;flex-direction:column;border-radius:10px;background:#e4ecf4;color:#000;padding:1.2rem 1.5rem;gap:.5rem;outline:1px solid transparent;align-self:flex-end;width:100%;box-sizing:border-box}.row.image[data-v-a35f972d]{background:none;padding:0}.row.shadow[data-v-a35f972d]{box-shadow:0 2px 24px #00000040}.row.clear[data-v-a35f972d]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.row.event[data-v-a35f972d]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.programs[data-v-a35f972d]{max-width:unset}.row.topics[data-v-a35f972d]{background:none;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible;gap:.5rem}.row.linked[data-v-a35f972d]{cursor:pointer}.row.linked[data-v-a35f972d]:hover{background-color:#dae3ed!important}.vertical[data-v-a35f972d]{flex-direction:column;width:100%}.program[data-v-a35f972d]{background:#0072ef}.program .tile-title strong[data-v-a35f972d]{color:#fff!important}.resource[data-v-a35f972d],.explore[data-v-a35f972d],.journey_step[data-v-a35f972d],.resource .homepage-tile__info[data-v-a35f972d],.explore .homepage-tile__info[data-v-a35f972d],.journey_step .homepage-tile__info[data-v-a35f972d],.resource .homepage-tile__info p[data-v-a35f972d],.explore .homepage-tile__info p[data-v-a35f972d],.journey_step .homepage-tile__info p[data-v-a35f972d]{color:#000}.resource .homepage-tile__info .tile-title[data-v-a35f972d],.explore .homepage-tile__info .tile-title[data-v-a35f972d],.journey_step .homepage-tile__info .tile-title[data-v-a35f972d]{color:#4d4d4d!important}.resource .homepage-tile__feed .row[data-v-a35f972d],.explore .homepage-tile__feed .row[data-v-a35f972d],.journey_step .homepage-tile__feed .row[data-v-a35f972d]{background:#e4ecf4}.journeys[data-v-a35f972d],.journey[data-v-a35f972d]{background:#212121;color:#fff}.journeys .homepage-tile__info[data-v-a35f972d],.journey .homepage-tile__info[data-v-a35f972d]{color:#fff}.journeys .homepage-tile__feed .row[data-v-a35f972d],.journey .homepage-tile__feed .row[data-v-a35f972d]{background:#3d3d3d;color:#fff}.community[data-v-a35f972d]{background:#fff;color:#000;box-shadow:0 2px 13px #00000014}.community .homepage-tile__info[data-v-a35f972d],.community .homepage-tile__info p[data-v-a35f972d]{color:#000}.community .homepage-tile__feed .row[data-v-a35f972d]{background:#e4ecf4}.explore .homepage-tile__feed[data-v-a35f972d]{max-width:unset;width:100%}.explore .homepage-tile__feed .row[data-v-a35f972d]{padding:0;background:none}.custom-theme[data-v-a35f972d]{background:var(--tile-theme-color)}.clear[data-v-a35f972d]{background:none!important;padding:0;box-shadow:none;box-sizing:border-box;overflow:visible}.clear .homepage-tile__info[data-v-a35f972d],.clear .homepage-tile__info p[data-v-a35f972d]{color:#000}@media screen and (max-width: 600px){.homepage-tile .homepage-tile__info[data-v-a35f972d]{max-width:100%;min-width:100%}}", Cf = /* @__PURE__ */ ae(IE, [["styles", [LE]], ["__scopeId", "data-v-a35f972d"]]);
function Af(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: NE } = Object.prototype, { getPrototypeOf: Vl } = Object, ci = /* @__PURE__ */ ((e) => (t) => {
  const n = NE.call(t);
  return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), qt = (e) => (e = e.toLowerCase(), (t) => ci(t) === e), ui = (e) => (t) => typeof t === e, { isArray: Rr } = Array, jo = ui("undefined");
function ME(e) {
  return e !== null && !jo(e) && e.constructor !== null && !jo(e.constructor) && yt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Of = qt("ArrayBuffer");
function RE(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Of(e.buffer), t;
}
const $E = ui("string"), yt = ui("function"), If = ui("number"), mi = (e) => e !== null && typeof e == "object", DE = (e) => e === !0 || e === !1, sa = (e) => {
  if (ci(e) !== "object")
    return !1;
  const t = Vl(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}, FE = qt("Date"), UE = qt("File"), VE = qt("Blob"), qE = qt("FileList"), HE = (e) => mi(e) && yt(e.pipe), BE = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || yt(e.append) && ((t = ci(e)) === "formdata" || // detect form-data instance
  t === "object" && yt(e.toString) && e.toString() === "[object FormData]"));
}, JE = qt("URLSearchParams"), [WE, YE, GE, KE] = ["ReadableStream", "Request", "Response", "Headers"].map(qt), QE = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Lo(e, t, { allOwnKeys: n = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, o;
  if (typeof e != "object" && (e = [e]), Rr(e))
    for (r = 0, o = e.length; r < o; r++)
      t.call(null, e[r], r, e);
  else {
    const a = n ? Object.getOwnPropertyNames(e) : Object.keys(e), i = a.length;
    let s;
    for (r = 0; r < i; r++)
      s = a[r], t.call(null, e[s], s, e);
  }
}
function Lf(e, t) {
  t = t.toLowerCase();
  const n = Object.keys(e);
  let r = n.length, o;
  for (; r-- > 0; )
    if (o = n[r], t === o.toLowerCase())
      return o;
  return null;
}
const Kn = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Nf = (e) => !jo(e) && e !== Kn;
function Ns() {
  const { caseless: e } = Nf(this) && this || {}, t = {}, n = (r, o) => {
    const a = e && Lf(t, o) || o;
    sa(t[a]) && sa(r) ? t[a] = Ns(t[a], r) : sa(r) ? t[a] = Ns({}, r) : Rr(r) ? t[a] = r.slice() : t[a] = r;
  };
  for (let r = 0, o = arguments.length; r < o; r++)
    arguments[r] && Lo(arguments[r], n);
  return t;
}
const XE = (e, t, n, { allOwnKeys: r } = {}) => (Lo(t, (o, a) => {
  n && yt(o) ? e[a] = Af(o, n) : e[a] = o;
}, { allOwnKeys: r }), e), ZE = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), eP = (e, t, n, r) => {
  e.prototype = Object.create(t.prototype, r), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), n && Object.assign(e.prototype, n);
}, tP = (e, t, n, r) => {
  let o, a, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (o = Object.getOwnPropertyNames(e), a = o.length; a-- > 0; )
      i = o[a], (!r || r(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = n !== !1 && Vl(e);
  } while (e && (!n || n(e, t)) && e !== Object.prototype);
  return t;
}, nP = (e, t, n) => {
  e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
  const r = e.indexOf(t, n);
  return r !== -1 && r === n;
}, rP = (e) => {
  if (!e) return null;
  if (Rr(e)) return e;
  let t = e.length;
  if (!If(t)) return null;
  const n = new Array(t);
  for (; t-- > 0; )
    n[t] = e[t];
  return n;
}, oP = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Vl(Uint8Array)), aP = (e, t) => {
  const r = (e && e[Symbol.iterator]).call(e);
  let o;
  for (; (o = r.next()) && !o.done; ) {
    const a = o.value;
    t.call(e, a[0], a[1]);
  }
}, iP = (e, t) => {
  let n;
  const r = [];
  for (; (n = e.exec(t)) !== null; )
    r.push(n);
  return r;
}, sP = qt("HTMLFormElement"), lP = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(n, r, o) {
    return r.toUpperCase() + o;
  }
), um = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), cP = qt("RegExp"), Mf = (e, t) => {
  const n = Object.getOwnPropertyDescriptors(e), r = {};
  Lo(n, (o, a) => {
    let i;
    (i = t(o, a, e)) !== !1 && (r[a] = i || o);
  }), Object.defineProperties(e, r);
}, uP = (e) => {
  Mf(e, (t, n) => {
    if (yt(e) && ["arguments", "caller", "callee"].indexOf(n) !== -1)
      return !1;
    const r = e[n];
    if (yt(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + n + "'");
      });
    }
  });
}, mP = (e, t) => {
  const n = {}, r = (o) => {
    o.forEach((a) => {
      n[a] = !0;
    });
  };
  return Rr(e) ? r(e) : r(String(e).split(t)), n;
}, dP = () => {
}, pP = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function fP(e) {
  return !!(e && yt(e.append) && e[Symbol.toStringTag] === "FormData" && e[Symbol.iterator]);
}
const _P = (e) => {
  const t = new Array(10), n = (r, o) => {
    if (mi(r)) {
      if (t.indexOf(r) >= 0)
        return;
      if (!("toJSON" in r)) {
        t[o] = r;
        const a = Rr(r) ? [] : {};
        return Lo(r, (i, s) => {
          const l = n(i, o + 1);
          !jo(l) && (a[s] = l);
        }), t[o] = void 0, a;
      }
    }
    return r;
  };
  return n(e, 0);
}, gP = qt("AsyncFunction"), hP = (e) => e && (mi(e) || yt(e)) && yt(e.then) && yt(e.catch), Rf = ((e, t) => e ? setImmediate : t ? ((n, r) => (Kn.addEventListener("message", ({ source: o, data: a }) => {
  o === Kn && a === n && r.length && r.shift()();
}, !1), (o) => {
  r.push(o), Kn.postMessage(n, "*");
}))(`axios@${Math.random()}`, []) : (n) => setTimeout(n))(
  typeof setImmediate == "function",
  yt(Kn.postMessage)
), vP = typeof queueMicrotask < "u" ? queueMicrotask.bind(Kn) : typeof process < "u" && process.nextTick || Rf, M = {
  isArray: Rr,
  isArrayBuffer: Of,
  isBuffer: ME,
  isFormData: BE,
  isArrayBufferView: RE,
  isString: $E,
  isNumber: If,
  isBoolean: DE,
  isObject: mi,
  isPlainObject: sa,
  isReadableStream: WE,
  isRequest: YE,
  isResponse: GE,
  isHeaders: KE,
  isUndefined: jo,
  isDate: FE,
  isFile: UE,
  isBlob: VE,
  isRegExp: cP,
  isFunction: yt,
  isStream: HE,
  isURLSearchParams: JE,
  isTypedArray: oP,
  isFileList: qE,
  forEach: Lo,
  merge: Ns,
  extend: XE,
  trim: QE,
  stripBOM: ZE,
  inherits: eP,
  toFlatObject: tP,
  kindOf: ci,
  kindOfTest: qt,
  endsWith: nP,
  toArray: rP,
  forEachEntry: aP,
  matchAll: iP,
  isHTMLForm: sP,
  hasOwnProperty: um,
  hasOwnProp: um,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Mf,
  freezeMethods: uP,
  toObjectSet: mP,
  toCamelCase: lP,
  noop: dP,
  toFiniteNumber: pP,
  findKey: Lf,
  global: Kn,
  isContextDefined: Nf,
  isSpecCompliantForm: fP,
  toJSONObject: _P,
  isAsyncFn: gP,
  isThenable: hP,
  setImmediate: Rf,
  asap: vP
};
function de(e, t, n, r, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), n && (this.config = n), r && (this.request = r), o && (this.response = o, this.status = o.status ? o.status : null);
}
M.inherits(de, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: M.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const $f = de.prototype, Df = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Df[e] = { value: e };
});
Object.defineProperties(de, Df);
Object.defineProperty($f, "isAxiosError", { value: !0 });
de.from = (e, t, n, r, o, a) => {
  const i = Object.create($f);
  return M.toFlatObject(e, i, function(l) {
    return l !== Error.prototype;
  }, (s) => s !== "isAxiosError"), de.call(i, e.message, t, n, r, o), i.cause = e, i.name = e.name, a && Object.assign(i, a), i;
};
const yP = null;
function Ms(e) {
  return M.isPlainObject(e) || M.isArray(e);
}
function Ff(e) {
  return M.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function mm(e, t, n) {
  return e ? e.concat(t).map(function(o, a) {
    return o = Ff(o), !n && a ? "[" + o + "]" : o;
  }).join(n ? "." : "") : t;
}
function bP(e) {
  return M.isArray(e) && !e.some(Ms);
}
const zP = M.toFlatObject(M, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function di(e, t, n) {
  if (!M.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), n = M.toFlatObject(n, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(_, y) {
    return !M.isUndefined(y[_]);
  });
  const r = n.metaTokens, o = n.visitor || u, a = n.dots, i = n.indexes, l = (n.Blob || typeof Blob < "u" && Blob) && M.isSpecCompliantForm(t);
  if (!M.isFunction(o))
    throw new TypeError("visitor must be a function");
  function c(f) {
    if (f === null) return "";
    if (M.isDate(f))
      return f.toISOString();
    if (!l && M.isBlob(f))
      throw new de("Blob is not supported. Use a Buffer instead.");
    return M.isArrayBuffer(f) || M.isTypedArray(f) ? l && typeof Blob == "function" ? new Blob([f]) : Buffer.from(f) : f;
  }
  function u(f, _, y) {
    let A = f;
    if (f && !y && typeof f == "object") {
      if (M.endsWith(_, "{}"))
        _ = r ? _ : _.slice(0, -2), f = JSON.stringify(f);
      else if (M.isArray(f) && bP(f) || (M.isFileList(f) || M.endsWith(_, "[]")) && (A = M.toArray(f)))
        return _ = Ff(_), A.forEach(function(j, S) {
          !(M.isUndefined(j) || j === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? mm([_], S, a) : i === null ? _ : _ + "[]",
            c(j)
          );
        }), !1;
    }
    return Ms(f) ? !0 : (t.append(mm(y, _, a), c(f)), !1);
  }
  const d = [], p = Object.assign(zP, {
    defaultVisitor: u,
    convertValue: c,
    isVisitable: Ms
  });
  function m(f, _) {
    if (!M.isUndefined(f)) {
      if (d.indexOf(f) !== -1)
        throw Error("Circular reference detected in " + _.join("."));
      d.push(f), M.forEach(f, function(A, I) {
        (!(M.isUndefined(A) || A === null) && o.call(
          t,
          A,
          M.isString(I) ? I.trim() : I,
          _,
          p
        )) === !0 && m(A, _ ? _.concat(I) : [I]);
      }), d.pop();
    }
  }
  if (!M.isObject(e))
    throw new TypeError("data must be an object");
  return m(e), t;
}
function dm(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function ql(e, t) {
  this._pairs = [], e && di(e, this, t);
}
const Uf = ql.prototype;
Uf.append = function(t, n) {
  this._pairs.push([t, n]);
};
Uf.toString = function(t) {
  const n = t ? function(r) {
    return t.call(this, r, dm);
  } : dm;
  return this._pairs.map(function(o) {
    return n(o[0]) + "=" + n(o[1]);
  }, "").join("&");
};
function jP(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function Vf(e, t, n) {
  if (!t)
    return e;
  const r = n && n.encode || jP;
  M.isFunction(n) && (n = {
    serialize: n
  });
  const o = n && n.serialize;
  let a;
  if (o ? a = o(t, n) : a = M.isURLSearchParams(t) ? t.toString() : new ql(t, n).toString(r), a) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return e;
}
class pm {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, n, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: n,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    M.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const qf = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, wP = typeof URLSearchParams < "u" ? URLSearchParams : ql, xP = typeof FormData < "u" ? FormData : null, kP = typeof Blob < "u" ? Blob : null, SP = {
  isBrowser: !0,
  classes: {
    URLSearchParams: wP,
    FormData: xP,
    Blob: kP
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Hl = typeof window < "u" && typeof document < "u", Rs = typeof navigator == "object" && navigator || void 0, EP = Hl && (!Rs || ["ReactNative", "NativeScript", "NS"].indexOf(Rs.product) < 0), PP = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", TP = Hl && window.location.href || "http://localhost", CP = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Hl,
  hasStandardBrowserEnv: EP,
  hasStandardBrowserWebWorkerEnv: PP,
  navigator: Rs,
  origin: TP
}, Symbol.toStringTag, { value: "Module" })), et = {
  ...CP,
  ...SP
};
function AP(e, t) {
  return di(e, new et.classes.URLSearchParams(), Object.assign({
    visitor: function(n, r, o, a) {
      return et.isNode && M.isBuffer(n) ? (this.append(r, n.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, t));
}
function OP(e) {
  return M.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function IP(e) {
  const t = {}, n = Object.keys(e);
  let r;
  const o = n.length;
  let a;
  for (r = 0; r < o; r++)
    a = n[r], t[a] = e[a];
  return t;
}
function Hf(e) {
  function t(n, r, o, a) {
    let i = n[a++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = a >= n.length;
    return i = !i && M.isArray(o) ? o.length : i, l ? (M.hasOwnProp(o, i) ? o[i] = [o[i], r] : o[i] = r, !s) : ((!o[i] || !M.isObject(o[i])) && (o[i] = []), t(n, r, o[i], a) && M.isArray(o[i]) && (o[i] = IP(o[i])), !s);
  }
  if (M.isFormData(e) && M.isFunction(e.entries)) {
    const n = {};
    return M.forEachEntry(e, (r, o) => {
      t(OP(r), o, n, 0);
    }), n;
  }
  return null;
}
function LP(e, t, n) {
  if (M.isString(e))
    try {
      return (t || JSON.parse)(e), M.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (n || JSON.stringify)(e);
}
const No = {
  transitional: qf,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(t, n) {
    const r = n.getContentType() || "", o = r.indexOf("application/json") > -1, a = M.isObject(t);
    if (a && M.isHTMLForm(t) && (t = new FormData(t)), M.isFormData(t))
      return o ? JSON.stringify(Hf(t)) : t;
    if (M.isArrayBuffer(t) || M.isBuffer(t) || M.isStream(t) || M.isFile(t) || M.isBlob(t) || M.isReadableStream(t))
      return t;
    if (M.isArrayBufferView(t))
      return t.buffer;
    if (M.isURLSearchParams(t))
      return n.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
    let s;
    if (a) {
      if (r.indexOf("application/x-www-form-urlencoded") > -1)
        return AP(t, this.formSerializer).toString();
      if ((s = M.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
        const l = this.env && this.env.FormData;
        return di(
          s ? { "files[]": t } : t,
          l && new l(),
          this.formSerializer
        );
      }
    }
    return a || o ? (n.setContentType("application/json", !1), LP(t)) : t;
  }],
  transformResponse: [function(t) {
    const n = this.transitional || No.transitional, r = n && n.forcedJSONParsing, o = this.responseType === "json";
    if (M.isResponse(t) || M.isReadableStream(t))
      return t;
    if (t && M.isString(t) && (r && !this.responseType || o)) {
      const i = !(n && n.silentJSONParsing) && o;
      try {
        return JSON.parse(t);
      } catch (s) {
        if (i)
          throw s.name === "SyntaxError" ? de.from(s, de.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    }
    return t;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: et.classes.FormData,
    Blob: et.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
M.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  No.headers[e] = {};
});
const NP = M.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), MP = (e) => {
  const t = {};
  let n, r, o;
  return e && e.split(`
`).forEach(function(i) {
    o = i.indexOf(":"), n = i.substring(0, o).trim().toLowerCase(), r = i.substring(o + 1).trim(), !(!n || t[n] && NP[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
  }), t;
}, fm = Symbol("internals");
function Yr(e) {
  return e && String(e).trim().toLowerCase();
}
function la(e) {
  return e === !1 || e == null ? e : M.isArray(e) ? e.map(la) : String(e);
}
function RP(e) {
  const t = /* @__PURE__ */ Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = n.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const $P = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Bi(e, t, n, r, o) {
  if (M.isFunction(r))
    return r.call(this, t, n);
  if (o && (t = n), !!M.isString(t)) {
    if (M.isString(r))
      return t.indexOf(r) !== -1;
    if (M.isRegExp(r))
      return r.test(t);
  }
}
function DP(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, n, r) => n.toUpperCase() + r);
}
function FP(e, t) {
  const n = M.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + n, {
      value: function(o, a, i) {
        return this[r].call(this, t, o, a, i);
      },
      configurable: !0
    });
  });
}
let ft = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, n, r) {
    const o = this;
    function a(s, l, c) {
      const u = Yr(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = M.findKey(o, u);
      (!d || o[d] === void 0 || c === !0 || c === void 0 && o[d] !== !1) && (o[d || l] = la(s));
    }
    const i = (s, l) => M.forEach(s, (c, u) => a(c, u, l));
    if (M.isPlainObject(t) || t instanceof this.constructor)
      i(t, n);
    else if (M.isString(t) && (t = t.trim()) && !$P(t))
      i(MP(t), n);
    else if (M.isHeaders(t))
      for (const [s, l] of t.entries())
        a(l, s, r);
    else
      t != null && a(n, t, r);
    return this;
  }
  get(t, n) {
    if (t = Yr(t), t) {
      const r = M.findKey(this, t);
      if (r) {
        const o = this[r];
        if (!n)
          return o;
        if (n === !0)
          return RP(o);
        if (M.isFunction(n))
          return n.call(this, o, r);
        if (M.isRegExp(n))
          return n.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, n) {
    if (t = Yr(t), t) {
      const r = M.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!n || Bi(this, this[r], r, n)));
    }
    return !1;
  }
  delete(t, n) {
    const r = this;
    let o = !1;
    function a(i) {
      if (i = Yr(i), i) {
        const s = M.findKey(r, i);
        s && (!n || Bi(r, r[s], s, n)) && (delete r[s], o = !0);
      }
    }
    return M.isArray(t) ? t.forEach(a) : a(t), o;
  }
  clear(t) {
    const n = Object.keys(this);
    let r = n.length, o = !1;
    for (; r--; ) {
      const a = n[r];
      (!t || Bi(this, this[a], a, t, !0)) && (delete this[a], o = !0);
    }
    return o;
  }
  normalize(t) {
    const n = this, r = {};
    return M.forEach(this, (o, a) => {
      const i = M.findKey(r, a);
      if (i) {
        n[i] = la(o), delete n[a];
        return;
      }
      const s = t ? DP(a) : String(a).trim();
      s !== a && delete n[a], n[s] = la(o), r[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const n = /* @__PURE__ */ Object.create(null);
    return M.forEach(this, (r, o) => {
      r != null && r !== !1 && (n[o] = t && M.isArray(r) ? r.join(", ") : r);
    }), n;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, n]) => t + ": " + n).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...n) {
    const r = new this(t);
    return n.forEach((o) => r.set(o)), r;
  }
  static accessor(t) {
    const r = (this[fm] = this[fm] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function a(i) {
      const s = Yr(i);
      r[s] || (FP(o, i), r[s] = !0);
    }
    return M.isArray(t) ? t.forEach(a) : a(t), this;
  }
};
ft.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
M.reduceDescriptors(ft.prototype, ({ value: e }, t) => {
  let n = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[n] = r;
    }
  };
});
M.freezeMethods(ft);
function Ji(e, t) {
  const n = this || No, r = t || n, o = ft.from(r.headers);
  let a = r.data;
  return M.forEach(e, function(s) {
    a = s.call(n, a, o.normalize(), t ? t.status : void 0);
  }), o.normalize(), a;
}
function Bf(e) {
  return !!(e && e.__CANCEL__);
}
function $r(e, t, n) {
  de.call(this, e ?? "canceled", de.ERR_CANCELED, t, n), this.name = "CanceledError";
}
M.inherits($r, de, {
  __CANCEL__: !0
});
function Jf(e, t, n) {
  const r = n.config.validateStatus;
  !n.status || !r || r(n.status) ? e(n) : t(new de(
    "Request failed with status code " + n.status,
    [de.ERR_BAD_REQUEST, de.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
    n.config,
    n.request,
    n
  ));
}
function UP(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function VP(e, t) {
  e = e || 10;
  const n = new Array(e), r = new Array(e);
  let o = 0, a = 0, i;
  return t = t !== void 0 ? t : 1e3, function(l) {
    const c = Date.now(), u = r[a];
    i || (i = c), n[o] = l, r[o] = c;
    let d = a, p = 0;
    for (; d !== o; )
      p += n[d++], d = d % e;
    if (o = (o + 1) % e, o === a && (a = (a + 1) % e), c - i < t)
      return;
    const m = u && c - u;
    return m ? Math.round(p * 1e3 / m) : void 0;
  };
}
function qP(e, t) {
  let n = 0, r = 1e3 / t, o, a;
  const i = (c, u = Date.now()) => {
    n = u, o = null, a && (clearTimeout(a), a = null), e.apply(null, c);
  };
  return [(...c) => {
    const u = Date.now(), d = u - n;
    d >= r ? i(c, u) : (o = c, a || (a = setTimeout(() => {
      a = null, i(o);
    }, r - d)));
  }, () => o && i(o)];
}
const Oa = (e, t, n = 3) => {
  let r = 0;
  const o = VP(50, 250);
  return qP((a) => {
    const i = a.loaded, s = a.lengthComputable ? a.total : void 0, l = i - r, c = o(l), u = i <= s;
    r = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: a,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, n);
}, _m = (e, t) => {
  const n = e != null;
  return [(r) => t[0]({
    lengthComputable: n,
    total: e,
    loaded: r
  }), t[1]];
}, gm = (e) => (...t) => M.asap(() => e(...t)), HP = et.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (n) => (n = new URL(n, et.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(
  new URL(et.origin),
  et.navigator && /(msie|trident)/i.test(et.navigator.userAgent)
) : () => !0, BP = et.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, n, r, o, a) {
      const i = [e + "=" + encodeURIComponent(t)];
      M.isNumber(n) && i.push("expires=" + new Date(n).toGMTString()), M.isString(r) && i.push("path=" + r), M.isString(o) && i.push("domain=" + o), a === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function JP(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function WP(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Wf(e, t, n) {
  let r = !JP(t);
  return e && r || n == !1 ? WP(e, t) : t;
}
const hm = (e) => e instanceof ft ? { ...e } : e;
function ir(e, t) {
  t = t || {};
  const n = {};
  function r(c, u, d, p) {
    return M.isPlainObject(c) && M.isPlainObject(u) ? M.merge.call({ caseless: p }, c, u) : M.isPlainObject(u) ? M.merge({}, u) : M.isArray(u) ? u.slice() : u;
  }
  function o(c, u, d, p) {
    if (M.isUndefined(u)) {
      if (!M.isUndefined(c))
        return r(void 0, c, d, p);
    } else return r(c, u, d, p);
  }
  function a(c, u) {
    if (!M.isUndefined(u))
      return r(void 0, u);
  }
  function i(c, u) {
    if (M.isUndefined(u)) {
      if (!M.isUndefined(c))
        return r(void 0, c);
    } else return r(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return r(c, u);
    if (d in e)
      return r(void 0, c);
  }
  const l = {
    url: a,
    method: a,
    data: a,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => o(hm(c), hm(u), d, !0)
  };
  return M.forEach(Object.keys(Object.assign({}, e, t)), function(u) {
    const d = l[u] || o, p = d(e[u], t[u], u);
    M.isUndefined(p) && d !== s || (n[u] = p);
  }), n;
}
const Yf = (e) => {
  const t = ir({}, e);
  let { data: n, withXSRFToken: r, xsrfHeaderName: o, xsrfCookieName: a, headers: i, auth: s } = t;
  t.headers = i = ft.from(i), t.url = Vf(Wf(t.baseURL, t.url), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  );
  let l;
  if (M.isFormData(n)) {
    if (et.hasStandardBrowserEnv || et.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if ((l = i.getContentType()) !== !1) {
      const [c, ...u] = l ? l.split(";").map((d) => d.trim()).filter(Boolean) : [];
      i.setContentType([c || "multipart/form-data", ...u].join("; "));
    }
  }
  if (et.hasStandardBrowserEnv && (r && M.isFunction(r) && (r = r(t)), r || r !== !1 && HP(t.url))) {
    const c = o && a && BP.read(a);
    c && i.set(o, c);
  }
  return t;
}, YP = typeof XMLHttpRequest < "u", GP = YP && function(e) {
  return new Promise(function(n, r) {
    const o = Yf(e);
    let a = o.data;
    const i = ft.from(o.headers).normalize();
    let { responseType: s, onUploadProgress: l, onDownloadProgress: c } = o, u, d, p, m, f;
    function _() {
      m && m(), f && f(), o.cancelToken && o.cancelToken.unsubscribe(u), o.signal && o.signal.removeEventListener("abort", u);
    }
    let y = new XMLHttpRequest();
    y.open(o.method.toUpperCase(), o.url, !0), y.timeout = o.timeout;
    function A() {
      if (!y)
        return;
      const j = ft.from(
        "getAllResponseHeaders" in y && y.getAllResponseHeaders()
      ), T = {
        data: !s || s === "text" || s === "json" ? y.responseText : y.response,
        status: y.status,
        statusText: y.statusText,
        headers: j,
        config: e,
        request: y
      };
      Jf(function(O) {
        n(O), _();
      }, function(O) {
        r(O), _();
      }, T), y = null;
    }
    "onloadend" in y ? y.onloadend = A : y.onreadystatechange = function() {
      !y || y.readyState !== 4 || y.status === 0 && !(y.responseURL && y.responseURL.indexOf("file:") === 0) || setTimeout(A);
    }, y.onabort = function() {
      y && (r(new de("Request aborted", de.ECONNABORTED, e, y)), y = null);
    }, y.onerror = function() {
      r(new de("Network Error", de.ERR_NETWORK, e, y)), y = null;
    }, y.ontimeout = function() {
      let S = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const T = o.transitional || qf;
      o.timeoutErrorMessage && (S = o.timeoutErrorMessage), r(new de(
        S,
        T.clarifyTimeoutError ? de.ETIMEDOUT : de.ECONNABORTED,
        e,
        y
      )), y = null;
    }, a === void 0 && i.setContentType(null), "setRequestHeader" in y && M.forEach(i.toJSON(), function(S, T) {
      y.setRequestHeader(T, S);
    }), M.isUndefined(o.withCredentials) || (y.withCredentials = !!o.withCredentials), s && s !== "json" && (y.responseType = o.responseType), c && ([p, f] = Oa(c, !0), y.addEventListener("progress", p)), l && y.upload && ([d, m] = Oa(l), y.upload.addEventListener("progress", d), y.upload.addEventListener("loadend", m)), (o.cancelToken || o.signal) && (u = (j) => {
      y && (r(!j || j.type ? new $r(null, e, y) : j), y.abort(), y = null);
    }, o.cancelToken && o.cancelToken.subscribe(u), o.signal && (o.signal.aborted ? u() : o.signal.addEventListener("abort", u)));
    const I = UP(o.url);
    if (I && et.protocols.indexOf(I) === -1) {
      r(new de("Unsupported protocol " + I + ":", de.ERR_BAD_REQUEST, e));
      return;
    }
    y.send(a || null);
  });
}, KP = (e, t) => {
  const { length: n } = e = e ? e.filter(Boolean) : [];
  if (t || n) {
    let r = new AbortController(), o;
    const a = function(c) {
      if (!o) {
        o = !0, s();
        const u = c instanceof Error ? c : this.reason;
        r.abort(u instanceof de ? u : new $r(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, a(new de(`timeout ${t} of ms exceeded`, de.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(a) : c.removeEventListener("abort", a);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", a));
    const { signal: l } = r;
    return l.unsubscribe = () => M.asap(s), l;
  }
}, QP = function* (e, t) {
  let n = e.byteLength;
  if (n < t) {
    yield e;
    return;
  }
  let r = 0, o;
  for (; r < n; )
    o = r + t, yield e.slice(r, o), r = o;
}, XP = async function* (e, t) {
  for await (const n of ZP(e))
    yield* QP(n, t);
}, ZP = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: n, value: r } = await t.read();
      if (n)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, vm = (e, t, n, r) => {
  const o = XP(e, t);
  let a = 0, i, s = (l) => {
    i || (i = !0, r && r(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await o.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (n) {
          let p = a += d;
          n(p);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, pi = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", Gf = pi && typeof ReadableStream == "function", eT = pi && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((e) => (t) => e.encode(t))(new TextEncoder()) : async (e) => new Uint8Array(await new Response(e).arrayBuffer())), Kf = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, tT = Gf && Kf(() => {
  let e = !1;
  const t = new Request(et.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type");
  return e && !t;
}), ym = 64 * 1024, $s = Gf && Kf(() => M.isReadableStream(new Response("").body)), Ia = {
  stream: $s && ((e) => e.body)
};
pi && ((e) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((t) => {
    !Ia[t] && (Ia[t] = M.isFunction(e[t]) ? (n) => n[t]() : (n, r) => {
      throw new de(`Response type '${t}' is not supported`, de.ERR_NOT_SUPPORT, r);
    });
  });
})(new Response());
const nT = async (e) => {
  if (e == null)
    return 0;
  if (M.isBlob(e))
    return e.size;
  if (M.isSpecCompliantForm(e))
    return (await new Request(et.origin, {
      method: "POST",
      body: e
    }).arrayBuffer()).byteLength;
  if (M.isArrayBufferView(e) || M.isArrayBuffer(e))
    return e.byteLength;
  if (M.isURLSearchParams(e) && (e = e + ""), M.isString(e))
    return (await eT(e)).byteLength;
}, rT = async (e, t) => {
  const n = M.toFiniteNumber(e.getContentLength());
  return n ?? nT(t);
}, oT = pi && (async (e) => {
  let {
    url: t,
    method: n,
    data: r,
    signal: o,
    cancelToken: a,
    timeout: i,
    onDownloadProgress: s,
    onUploadProgress: l,
    responseType: c,
    headers: u,
    withCredentials: d = "same-origin",
    fetchOptions: p
  } = Yf(e);
  c = c ? (c + "").toLowerCase() : "text";
  let m = KP([o, a && a.toAbortSignal()], i), f;
  const _ = m && m.unsubscribe && (() => {
    m.unsubscribe();
  });
  let y;
  try {
    if (l && tT && n !== "get" && n !== "head" && (y = await rT(u, r)) !== 0) {
      let T = new Request(t, {
        method: "POST",
        body: r,
        duplex: "half"
      }), z;
      if (M.isFormData(r) && (z = T.headers.get("content-type")) && u.setContentType(z), T.body) {
        const [O, N] = _m(
          y,
          Oa(gm(l))
        );
        r = vm(T.body, ym, O, N);
      }
    }
    M.isString(d) || (d = d ? "include" : "omit");
    const A = "credentials" in Request.prototype;
    f = new Request(t, {
      ...p,
      signal: m,
      method: n.toUpperCase(),
      headers: u.normalize().toJSON(),
      body: r,
      duplex: "half",
      credentials: A ? d : void 0
    });
    let I = await fetch(f);
    const j = $s && (c === "stream" || c === "response");
    if ($s && (s || j && _)) {
      const T = {};
      ["status", "statusText", "headers"].forEach((F) => {
        T[F] = I[F];
      });
      const z = M.toFiniteNumber(I.headers.get("content-length")), [O, N] = s && _m(
        z,
        Oa(gm(s), !0)
      ) || [];
      I = new Response(
        vm(I.body, ym, O, () => {
          N && N(), _ && _();
        }),
        T
      );
    }
    c = c || "text";
    let S = await Ia[M.findKey(Ia, c) || "text"](I, e);
    return !j && _ && _(), await new Promise((T, z) => {
      Jf(T, z, {
        data: S,
        headers: ft.from(I.headers),
        status: I.status,
        statusText: I.statusText,
        config: e,
        request: f
      });
    });
  } catch (A) {
    throw _ && _(), A && A.name === "TypeError" && /fetch/i.test(A.message) ? Object.assign(
      new de("Network Error", de.ERR_NETWORK, e, f),
      {
        cause: A.cause || A
      }
    ) : de.from(A, A && A.code, e, f);
  }
}), Ds = {
  http: yP,
  xhr: GP,
  fetch: oT
};
M.forEach(Ds, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const bm = (e) => `- ${e}`, aT = (e) => M.isFunction(e) || e === null || e === !1, Qf = {
  getAdapter: (e) => {
    e = M.isArray(e) ? e : [e];
    const { length: t } = e;
    let n, r;
    const o = {};
    for (let a = 0; a < t; a++) {
      n = e[a];
      let i;
      if (r = n, !aT(n) && (r = Ds[(i = String(n)).toLowerCase()], r === void 0))
        throw new de(`Unknown adapter '${i}'`);
      if (r)
        break;
      o[i || "#" + a] = r;
    }
    if (!r) {
      const a = Object.entries(o).map(
        ([s, l]) => `adapter ${s} ` + (l === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let i = t ? a.length > 1 ? `since :
` + a.map(bm).join(`
`) : " " + bm(a[0]) : "as no adapter specified";
      throw new de(
        "There is no suitable adapter to dispatch the request " + i,
        "ERR_NOT_SUPPORT"
      );
    }
    return r;
  },
  adapters: Ds
};
function Wi(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new $r(null, e);
}
function zm(e) {
  return Wi(e), e.headers = ft.from(e.headers), e.data = Ji.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Qf.getAdapter(e.adapter || No.adapter)(e).then(function(r) {
    return Wi(e), r.data = Ji.call(
      e,
      e.transformResponse,
      r
    ), r.headers = ft.from(r.headers), r;
  }, function(r) {
    return Bf(r) || (Wi(e), r && r.response && (r.response.data = Ji.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = ft.from(r.response.headers))), Promise.reject(r);
  });
}
const Xf = "1.8.2", fi = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  fi[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const jm = {};
fi.transitional = function(t, n, r) {
  function o(a, i) {
    return "[Axios v" + Xf + "] Transitional option '" + a + "'" + i + (r ? ". " + r : "");
  }
  return (a, i, s) => {
    if (t === !1)
      throw new de(
        o(i, " has been removed" + (n ? " in " + n : "")),
        de.ERR_DEPRECATED
      );
    return n && !jm[i] && (jm[i] = !0, console.warn(
      o(
        i,
        " has been deprecated since v" + n + " and will be removed in the near future"
      )
    )), t ? t(a, i, s) : !0;
  };
};
fi.spelling = function(t) {
  return (n, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function iT(e, t, n) {
  if (typeof e != "object")
    throw new de("options must be an object", de.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let o = r.length;
  for (; o-- > 0; ) {
    const a = r[o], i = t[a];
    if (i) {
      const s = e[a], l = s === void 0 || i(s, a, e);
      if (l !== !0)
        throw new de("option " + a + " must be " + l, de.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (n !== !0)
      throw new de("Unknown option " + a, de.ERR_BAD_OPTION);
  }
}
const ca = {
  assertOptions: iT,
  validators: fi
}, Bt = ca.validators;
let Zn = class {
  constructor(t) {
    this.defaults = t, this.interceptors = {
      request: new pm(),
      response: new pm()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, n) {
    try {
      return await this._request(t, n);
    } catch (r) {
      if (r instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const a = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          r.stack ? a && !String(r.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (r.stack += `
` + a) : r.stack = a;
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, n) {
    typeof t == "string" ? (n = n || {}, n.url = t) : n = t || {}, n = ir(this.defaults, n);
    const { transitional: r, paramsSerializer: o, headers: a } = n;
    r !== void 0 && ca.assertOptions(r, {
      silentJSONParsing: Bt.transitional(Bt.boolean),
      forcedJSONParsing: Bt.transitional(Bt.boolean),
      clarifyTimeoutError: Bt.transitional(Bt.boolean)
    }, !1), o != null && (M.isFunction(o) ? n.paramsSerializer = {
      serialize: o
    } : ca.assertOptions(o, {
      encode: Bt.function,
      serialize: Bt.function
    }, !0)), n.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? n.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : n.allowAbsoluteUrls = !0), ca.assertOptions(n, {
      baseUrl: Bt.spelling("baseURL"),
      withXsrfToken: Bt.spelling("withXSRFToken")
    }, !0), n.method = (n.method || this.defaults.method || "get").toLowerCase();
    let i = a && M.merge(
      a.common,
      a[n.method]
    );
    a && M.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete a[f];
      }
    ), n.headers = ft.concat(i, a);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(_) {
      typeof _.runWhen == "function" && _.runWhen(n) === !1 || (l = l && _.synchronous, s.unshift(_.fulfilled, _.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(_) {
      c.push(_.fulfilled, _.rejected);
    });
    let u, d = 0, p;
    if (!l) {
      const f = [zm.bind(this), void 0];
      for (f.unshift.apply(f, s), f.push.apply(f, c), p = f.length, u = Promise.resolve(n); d < p; )
        u = u.then(f[d++], f[d++]);
      return u;
    }
    p = s.length;
    let m = n;
    for (d = 0; d < p; ) {
      const f = s[d++], _ = s[d++];
      try {
        m = f(m);
      } catch (y) {
        _.call(this, y);
        break;
      }
    }
    try {
      u = zm.call(this, m);
    } catch (f) {
      return Promise.reject(f);
    }
    for (d = 0, p = c.length; d < p; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = ir(this.defaults, t);
    const n = Wf(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Vf(n, t.params, t.paramsSerializer);
  }
};
M.forEach(["delete", "get", "head", "options"], function(t) {
  Zn.prototype[t] = function(n, r) {
    return this.request(ir(r || {}, {
      method: t,
      url: n,
      data: (r || {}).data
    }));
  };
});
M.forEach(["post", "put", "patch"], function(t) {
  function n(r) {
    return function(a, i, s) {
      return this.request(ir(s || {}, {
        method: t,
        headers: r ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: i
      }));
    };
  }
  Zn.prototype[t] = n(), Zn.prototype[t + "Form"] = n(!0);
});
let sT = class Zf {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let n;
    this.promise = new Promise(function(a) {
      n = a;
    });
    const r = this;
    this.promise.then((o) => {
      if (!r._listeners) return;
      let a = r._listeners.length;
      for (; a-- > 0; )
        r._listeners[a](o);
      r._listeners = null;
    }), this.promise.then = (o) => {
      let a;
      const i = new Promise((s) => {
        r.subscribe(s), a = s;
      }).then(o);
      return i.cancel = function() {
        r.unsubscribe(a);
      }, i;
    }, t(function(a, i, s) {
      r.reason || (r.reason = new $r(a, i, s), n(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const n = this._listeners.indexOf(t);
    n !== -1 && this._listeners.splice(n, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), n = (r) => {
      t.abort(r);
    };
    return this.subscribe(n), t.signal.unsubscribe = () => this.unsubscribe(n), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Zf(function(o) {
        t = o;
      }),
      cancel: t
    };
  }
};
function lT(e) {
  return function(n) {
    return e.apply(null, n);
  };
}
function cT(e) {
  return M.isObject(e) && e.isAxiosError === !0;
}
const Fs = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Fs).forEach(([e, t]) => {
  Fs[t] = e;
});
function e_(e) {
  const t = new Zn(e), n = Af(Zn.prototype.request, t);
  return M.extend(n, Zn.prototype, t, { allOwnKeys: !0 }), M.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(o) {
    return e_(ir(e, o));
  }, n;
}
const Fe = e_(No);
Fe.Axios = Zn;
Fe.CanceledError = $r;
Fe.CancelToken = sT;
Fe.isCancel = Bf;
Fe.VERSION = Xf;
Fe.toFormData = di;
Fe.AxiosError = de;
Fe.Cancel = Fe.CanceledError;
Fe.all = function(t) {
  return Promise.all(t);
};
Fe.spread = lT;
Fe.isAxiosError = cT;
Fe.mergeConfig = ir;
Fe.AxiosHeaders = ft;
Fe.formToJSON = (e) => Hf(M.isHTMLForm(e) ? new FormData(e) : e);
Fe.getAdapter = Qf.getAdapter;
Fe.HttpStatusCode = Fs;
Fe.default = Fe;
const {
  Axios: ZI,
  AxiosError: eL,
  CanceledError: tL,
  isCancel: nL,
  CancelToken: rL,
  VERSION: oL,
  all: aL,
  Cancel: iL,
  isAxiosError: sL,
  spread: lL,
  toFormData: cL,
  AxiosHeaders: uL,
  HttpStatusCode: mL,
  formToJSON: dL,
  getAdapter: pL,
  mergeConfig: fL
} = Fe, uT = ".video_container[data-v-a6e4c528]{position:relative;width:100%;height:0;padding-bottom:56.25%;overflow:hidden;background-color:#000;border-radius:.5rem}.video_container .video_aspect[data-v-a6e4c528],.video_container .video_box[data-v-a6e4c528]{position:absolute;top:0;left:0;width:100%;height:100%}.video_container .video-js[data-v-a6e4c528]{width:100%;height:100%}", mT = {
  props: {
    tile: {
      type: Object,
      required: !0
    },
    video: {
      type: Object,
      required: !1
    },
    autoplay: {
      default: !1
    }
  },
  data() {
    return {
      videoEl: null
    };
  },
  mounted() {
    this.videoEl = this.$refs.videoElement;
    let e = bc(this.videoEl, { techOrder: ["html5"] });
    e.on("ended", () => {
      this.$emit("ended", this.videoEl.currentTime);
    }), e.on("play", () => {
      if (this.$emit("play", this.videoEl.currentTime), this.tile?.video?.record_progress) {
        const t = new FormData();
        t.append("video_id", this.tile.video.record_progress.video_id), Fe.post(
          `/recordactivity/video?groupselect=${this.tile.video.record_progress.group_id}`,
          t
        );
      }
    }), e.on("seek", () => {
      this.$emit("seek", this.videoEl.currentTime);
    }), e.on("pause", () => {
      this.$emit("pause", this.videoEl.currentTime);
    }), e.on("timeupdate", () => {
      this.$emit("timeupdate", this.videoEl.currentTime);
    }), this.autoplay && e.play();
  },
  beforeUnmount() {
    this.$emit("ended", this.videoEl.currentTime);
  }
}, dT = (e) => (xo("data-v-a6e4c528"), e = e(), ko(), e), pT = { class: "videoplayer" }, fT = { class: "video_container" }, _T = /* @__PURE__ */ dT(() => /* @__PURE__ */ x("div", { class: "video_aspect" }, null, -1)), gT = { class: "video_box" }, hT = ["data-video-id"];
function vT(e, t, n, r, o, a) {
  return w(), P("div", pT, [
    x("div", fT, [
      _T,
      x("div", gT, [
        n.video?.ref || n.tile.video?.brightcove_id ? (w(), P("video", {
          key: 0,
          "data-account": "3326885378001",
          "data-player": "rkuNCi7ll",
          "data-embed": "default",
          "data-application-id": "",
          ref: "videoElement",
          class: "video-js intro-video",
          "data-video-id": n.video?.ref || n.tile.video?.brightcove_id,
          controls: ""
        }, null, 8, hT)) : re("", !0)
      ])
    ])
  ]);
}
const t_ = /* @__PURE__ */ ae(mT, [["render", vT], ["styles", [uT]], ["__scopeId", "data-v-a6e4c528"]]), yT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: t_
}, Symbol.toStringTag, { value: "Module" })), bT = { class: "content" }, zT = { class: "content" }, jT = { id: "welcome-modal-title" }, wT = { class: "below" }, xT = { class: "welcome-message" }, kT = ["innerHTML"], ST = {
  key: 0,
  class: "logo-circle"
}, ET = ["innerHTML"], PT = ["innerHTML"], TT = /* @__PURE__ */ Q({
  __name: "WelcomeTile",
  props: {
    tile: { type: null },
    showExpanded: { type: Boolean }
  },
  emits: ["update:showExpanded"],
  setup(e, { emit: t }) {
    Ad((p) => ({
      "8953ef4c": l.value
    }));
    const { t: n } = ve(), r = e, o = t, a = ue(), i = ue(), s = ue(!1), l = ee(() => `url(${r.tile.welcome.videoPlaceholder})`);
    un(
      () => r.showExpanded,
      (p) => {
        p ? c() : u();
      },
      { immediate: !0 }
    );
    function c() {
      if (!a.value) return;
      window.scrollTo(0, 0);
      const p = a.value.querySelector(
        "#welcome-tile-collapsed"
      ), m = a.value.querySelector(
        "#welcome-tile-expanded"
      ), f = a.value.querySelector(".welcome-modal"), y = a.value.querySelector(".content").offsetTop - p.offsetTop, A = m.offsetLeft, I = m.offsetTop, j = p.offsetLeft, S = p.offsetTop, T = I - S;
      m.style.paddingTop = `${y - T}px`;
      const z = m.clientHeight, O = m.clientWidth, N = p.clientHeight, F = p.clientWidth;
      m.style.paddingTop = `${y}px`, m.style.position = "fixed", m.style.top = `${S}px`, m.style.left = `${j}px`, m.style.width = `${F}px`, m.style.height = `${N}px`, m.style.visibility = "visible", p.style.visibility = "hidden";
      function te(he) {
        he.target === m && (m.style.position = "relative", m.style.removeProperty("top"), m.style.removeProperty("left"), m.style.removeProperty("width"), m.style.removeProperty("height"), m.style.removeProperty("transition"), m.removeEventListener("transitionend", te));
      }
      setTimeout(() => {
        m.style.transition = "all 0.8s cubic-bezier(0.32, 0.94, 0.82, 1.28)", m.addEventListener("transitionend", te), f.style.visibility = "visible", f.classList.add("visible"), m.style.top = `${I}px`, m.style.left = `${A}px`, m.style.width = `${O}px`, m.style.height = `${z}px`, m.style.paddingTop = `${y - T}px`, i.value?.focus();
      }, 10), s.value = !0;
    }
    function u() {
      if (!a.value) return;
      window.scrollTo(0, 0);
      const p = a.value.querySelector(
        "#welcome-tile-collapsed"
      ), m = a.value.querySelector(
        "#welcome-tile-expanded"
      ), f = a.value.querySelector(".welcome-modal"), _ = a.value.querySelector(".content");
      f.classList.add("visible"), f.style.visibility = "visible", p.style.visibility = "hidden";
      const y = _.offsetTop - p.offsetTop, A = m.offsetLeft, I = m.offsetTop - f.scrollTop, j = p.offsetLeft, S = p.offsetTop, T = m.clientHeight, z = m.clientWidth, O = p.clientHeight, N = p.clientWidth;
      m.style.position = "fixed", m.style.top = `${I}px`, m.style.left = `${A}px`, m.style.width = `${z}px`, m.style.height = `${T}px`;
      function F(te) {
        te.target === m && (m.style.position = "relative", m.style.removeProperty("top"), m.style.removeProperty("left"), m.style.removeProperty("width"), m.style.removeProperty("height"), m.style.removeProperty("transition"), m.removeEventListener("transitionend", F), f.style.visibility = "hidden", p.style.visibility = "visible", m.style.visibility = "hidden");
      }
      setTimeout(() => {
        m.style.transition = "all 0.8s cubic-bezier(0.32, 0.94, 0.82, 1.28)", m.addEventListener("transitionend", F), f.classList.remove("visible"), m.style.top = `${S}px`, m.style.left = `${j}px`, m.style.width = `${N}px`, m.style.height = `${O}px`, m.style.paddingTop = `${y}px`;
      }, 10), s.value = !1;
    }
    function d(p) {
      p.target.closest(".homepage-tile") || o("update:showExpanded", !1);
    }
    return Xt(() => {
      r.showExpanded && !s.value && c();
      function p(m) {
        m.key === "Escape" && o("update:showExpanded", !1);
      }
      return document.addEventListener("keydown", p), () => {
        document.removeEventListener("keydown", p);
      };
    }), (p, m) => (w(), P("div", {
      ref_key: "welcomeRoot",
      ref: a,
      class: "outer"
    }, [
      x("div", {
        class: Ce(["welcome-tile", { "dark-text": p.tile.welcome.darkText }]),
        id: "welcome-tile-collapsed"
      }, [
        x("div", bT, [
          x("h1", null, D(p.tile.welcome.introTitle), 1),
          ph(B(bt, {
            onClick: m[0] || (m[0] = (f) => o("update:showExpanded", !0)),
            variant: "white"
          }, {
            default: Oe(() => [
              Ee(D(X(n)("learn-more")), 1)
            ]),
            _: 1
          }, 512), [
            [dv, !p.showExpanded]
          ])
        ])
      ], 2),
      x("div", {
        class: "welcome-modal",
        onClick: d
      }, [
        x("div", {
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": "welcome-modal-title",
          class: Ce(["homepage-tile welcome-tile", { "dark-text": p.tile.welcome.darkText }]),
          id: "welcome-tile-expanded"
        }, [
          x("div", zT, [
            x("button", {
              ref_key: "closeButton",
              ref: i,
              class: "close",
              onClick: m[1] || (m[1] = (f) => o("update:showExpanded", !1)),
              "aria-label": "Close"
            }, " × ", 512),
            x("h1", jT, D(p.tile.welcome.introTitle), 1),
            x("div", wT, [
              x("div", xT, [
                p.tile.welcome.introduction ? (w(), P("p", {
                  key: 0,
                  innerHTML: p.tile.welcome.introduction
                }, null, 8, kT)) : re("", !0),
                x("div", {
                  class: Ce(["personal-intro", { "has-image": p.tile.welcome.introLogo }])
                }, [
                  p.tile.welcome.introLogo ? (w(), P("div", ST, [
                    B(st, {
                      src: p.tile.welcome.introLogo
                    }, null, 8, ["src"])
                  ])) : re("", !0),
                  x("p", {
                    innerHTML: p.tile.welcome.headerTitle
                  }, null, 8, ET)
                ], 2),
                p.tile.welcome.introductionPostscript ? (w(), P("div", {
                  key: 1,
                  innerHTML: p.tile.welcome.introductionPostscript
                }, null, 8, PT)) : re("", !0)
              ]),
              p.tile.welcome.introVideoRef ? (w(), ge(t_, {
                key: 0,
                video: { ref: p.tile.welcome.introVideoRef }
              }, null, 8, ["video"])) : re("", !0),
              B(bt, {
                variant: "white",
                onClick: m[2] || (m[2] = (f) => o("update:showExpanded", !1))
              }, {
                default: Oe(() => [
                  Ee(D(X(n)("get-started")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ], 2)
      ])
    ], 512));
  }
}), CT = ".outer[data-v-6019705e]{margin:1.5rem}@media (max-width: 600px){.outer[data-v-6019705e]{margin:.75rem}}.close[data-v-6019705e]{position:absolute;top:1rem;right:1rem;height:3rem;width:3rem;line-height:2rem;font-size:2.5rem;color:#fffc;background:#00000080;border:none;border-radius:9999px;cursor:pointer;opacity:0;transition:opacity .5s ease-in-out}.welcome-modal[data-v-6019705e]{visibility:hidden;position:fixed;z-index:10000;width:100%;height:100vh;top:0;left:0;overflow-y:auto;padding:75px 1.5rem;align-items:center;box-sizing:border-box;transition:background-color .5s ease-in-out}@media (max-width: 799px){.welcome-modal[data-v-6019705e]{padding-top:1.5rem}}@media (max-width: 600px){.welcome-modal[data-v-6019705e]{padding-left:.75rem;padding-right:.75rem}}.welcome-modal .welcome-tile[data-v-6019705e]{padding-top:100px;padding-bottom:100px;max-width:1280px}.welcome-modal .below[data-v-6019705e]{opacity:0;transition:opacity 1s ease-in-out;display:flex;flex-direction:column;gap:2rem;align-items:start}.welcome-modal.visible[data-v-6019705e]{opacity:1;background:#000000e6}.welcome-modal.visible .below[data-v-6019705e],.welcome-modal.visible .close[data-v-6019705e]{opacity:1}#welcome-tile-expanded[data-v-6019705e]{overflow:hidden;align-items:start}.welcome-tile[data-v-6019705e]{font-family:myriad-pro,Helvetica,Arial,sans-serif;min-height:200px;max-width:1140px;flex-grow:1;margin:auto;border-radius:18px;padding:1.5rem;outline:1px solid transparent;box-sizing:border-box;color:#fff;background-color:#000;background-image:var(--8953ef4c);background-size:cover;background-position:center;display:flex;align-items:center;justify-content:center}@media (max-width: 799px){.welcome-tile[data-v-6019705e]{min-height:30vh}}.welcome-tile .content[data-v-6019705e]{flex-grow:1;max-width:600px;display:flex;flex-direction:column;gap:2rem;align-items:start}.welcome-tile h1[data-v-6019705e]{font-size:1.5rem;margin:0}.welcome-tile[data-v-6019705e] .welcome-message p,.welcome-tile[data-v-6019705e] .welcome-message .personal-intro{text-shadow:0 0 5px rgba(0,0,0,.6)}.welcome-tile[data-v-6019705e] .welcome-message .personal-intro.has-image{position:relative;padding-left:57px}.welcome-tile[data-v-6019705e] .welcome-message .logo-circle{margin:0;position:absolute;left:0}.welcome-tile[data-v-6019705e] .welcome-message .logo-circle img{height:45px;width:45px;border-radius:999px}.welcome-tile[data-v-6019705e] .welcome-message p{color:#fff;line-height:145%;padding-bottom:8px;font-size:1em;-webkit-text-size-adjust:none}.welcome-tile[data-v-6019705e] .welcome-message p a{color:#fff;text-decoration:underline}.welcome-tile[data-v-6019705e] .welcome-message p strong{font-weight:700}.welcome-tile[data-v-6019705e] .welcome-message p em{font-size:italic}.welcome-tile .videoplayer[data-v-6019705e]{width:100%}.welcome-tile.dark-text h1[data-v-6019705e],.welcome-tile.dark-text[data-v-6019705e] p,.welcome-tile.dark-text[data-v-6019705e] p a{color:#565656!important;text-shadow:none!important}", AT = /* @__PURE__ */ ae(TT, [["styles", [CT]], ["__scopeId", "data-v-6019705e"]]), OT = (e) => (xo("data-v-fe5251f8"), e = e(), ko(), e), IT = {
  key: 1,
  class: "tiles"
}, LT = /* @__PURE__ */ OT(() => /* @__PURE__ */ x("div", { class: "error" }, [
  /* @__PURE__ */ x("h1", null, "Oops!"),
  /* @__PURE__ */ x("p", null, "Unable to load Homepage content.")
], -1)), NT = [
  LT
], MT = {
  key: 2,
  class: "skeleton-tiles"
}, RT = ["inert"], $T = /* @__PURE__ */ Q({
  __name: "HomePage",
  props: {
    initialWelcomeOpen: { type: Boolean }
  },
  setup(e) {
    const t = e, n = ue(), r = ue(), o = ue(!0), a = ue(!1), i = ue(!1);
    function s(f) {
      return new Promise((_) => setTimeout(_, f));
    }
    async function l() {
      o.value = !0, i.value = !1;
      let f = "/api/v1/home/content";
      t.initialWelcomeOpen && (f += "?show_welcome=true");
      const _ = Fe.get(f.toString()), y = s(500);
      try {
        const [A, I] = await Promise.all([_, y]);
        c(A.data);
      } catch {
        i.value = !0, c([]);
      }
      o.value = !1;
    }
    function c(f) {
      r.value = f.find((_) => _.type === "welcome"), n.value = f.filter((_) => _.type !== "welcome"), r.value && !r.value.welcome.seen && (sessionStorage.getItem("shownExpandedWelcome") || (sessionStorage.setItem("shownExpandedWelcome", "true"), m(!0)));
    }
    const u = ue([]), d = (f) => u.value.includes(f);
    Xt(() => {
      window.reloadHomeContent = l;
    }), l();
    function p() {
      Fe.get("/api/v1/home/content?category=welcome&show_welcome=true").then((f) => {
        r.value = f.data[0];
      });
    }
    un(
      () => t.initialWelcomeOpen,
      (f) => {
        f && !r.value && p();
      }
    );
    function m(f) {
      f ? window.homeActionHandler("route", { name: "home", hash: "#welcome" }) : window.homeActionHandler("route", { name: "home" });
    }
    return (f, _) => (w(), P(se, null, [
      x("div", {
        class: Ce([{ show: a.value }, "refresh-indicator"])
      }, [
        B(Vy)
      ], 2),
      r.value ? (w(), ge(AT, {
        key: 0,
        tile: r.value,
        showExpanded: f.initialWelcomeOpen,
        "onUpdate:showExpanded": m
      }, null, 8, ["tile", "showExpanded"])) : re("", !0),
      i.value ? (w(), P("div", IT, NT)) : re("", !0),
      o.value ? (w(), P("div", MT, [
        (w(), P(se, null, De(10, (y) => B(Gy, { key: y })), 64))
      ])) : (w(), P("div", {
        key: 3,
        class: "tiles",
        inert: f.initialWelcomeOpen
      }, [
        (w(!0), P(se, null, De(n.value, (y, A) => (w(), ge(Cf, {
          key: y.key,
          "data-index": A,
          tile: y,
          class: Ce({ "in-view": d(A) }),
          ref_for: !0,
          ref: "tileRefs"
        }, null, 8, ["data-index", "tile", "class"]))), 128))
      ], 8, RT))
    ], 64));
  }
}), DT = '.vjs-svg-icon{display:inline-block;background-repeat:no-repeat;background-position:center;fill:currentColor;height:1.8em;width:1.8em}.vjs-svg-icon:before{content:none!important}.vjs-control:focus .vjs-svg-icon,.vjs-svg-icon:hover{filter:drop-shadow(0 0 .25em #fff)}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-modal-dialog,.vjs-button>.vjs-icon-placeholder:before,.vjs-modal-dialog .vjs-modal-dialog-content{position:absolute;top:0;left:0;width:100%;height:100%}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.vjs-button>.vjs-icon-placeholder:before{text-align:center}@font-face{font-family:VideoJS;src:url(data:application/font-woff;charset=utf-8;base64,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) format("woff");font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder,.vjs-icon-play{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-big-play-button .vjs-icon-placeholder:before,.video-js .vjs-play-control .vjs-icon-placeholder:before,.vjs-icon-play:before{content:""}.vjs-icon-play-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-play-circle:before{content:""}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder,.vjs-icon-pause{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-playing .vjs-icon-placeholder:before,.vjs-icon-pause:before{content:""}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder,.vjs-icon-volume-mute{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-0 .vjs-icon-placeholder:before,.vjs-icon-volume-mute:before{content:""}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder,.vjs-icon-volume-low{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-1 .vjs-icon-placeholder:before,.vjs-icon-volume-low:before{content:""}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder,.vjs-icon-volume-mid{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control.vjs-vol-2 .vjs-icon-placeholder:before,.vjs-icon-volume-mid:before{content:""}.video-js .vjs-mute-control .vjs-icon-placeholder,.vjs-icon-volume-high{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-mute-control .vjs-icon-placeholder:before,.vjs-icon-volume-high:before{content:""}.video-js .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-enter{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-enter:before{content:""}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder,.vjs-icon-fullscreen-exit{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.vjs-fullscreen .vjs-fullscreen-control .vjs-icon-placeholder:before,.vjs-icon-fullscreen-exit:before{content:""}.vjs-icon-spinner{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-spinner:before{content:""}.video-js .vjs-subs-caps-button .vjs-icon-placeholder,.video-js .vjs-subtitles-button .vjs-icon-placeholder,.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder,.vjs-icon-subtitles{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js .vjs-subtitles-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-AU) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-GB) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-IE) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js.video-js:lang(en-NZ) .vjs-subs-caps-button .vjs-icon-placeholder:before,.vjs-icon-subtitles:before{content:""}.video-js .vjs-captions-button .vjs-icon-placeholder,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder,.vjs-icon-captions{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-captions-button .vjs-icon-placeholder:before,.video-js:lang(en) .vjs-subs-caps-button .vjs-icon-placeholder:before,.video-js:lang(fr-CA) .vjs-subs-caps-button .vjs-icon-placeholder:before,.vjs-icon-captions:before{content:""}.vjs-icon-hd{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-hd:before{content:""}.video-js .vjs-chapters-button .vjs-icon-placeholder,.vjs-icon-chapters{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-chapters-button .vjs-icon-placeholder:before,.vjs-icon-chapters:before{content:""}.vjs-icon-downloading{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-downloading:before{content:""}.vjs-icon-file-download{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-file-download:before{content:""}.vjs-icon-file-download-done{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-file-download-done:before{content:""}.vjs-icon-file-download-off{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-file-download-off:before{content:""}.vjs-icon-share{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-share:before{content:""}.vjs-icon-cog{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-cog:before{content:""}.vjs-icon-square{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-square:before{content:""}.video-js .vjs-play-progress,.video-js .vjs-volume-level,.vjs-icon-circle,.vjs-seek-to-live-control .vjs-icon-placeholder{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-progress:before,.video-js .vjs-volume-level:before,.vjs-icon-circle:before,.vjs-seek-to-live-control .vjs-icon-placeholder:before{content:""}.vjs-icon-circle-outline{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-outline:before{content:""}.vjs-icon-circle-inner-circle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-circle-inner-circle:before{content:""}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder,.vjs-icon-cancel{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-control.vjs-close-button .vjs-icon-placeholder:before,.vjs-icon-cancel:before{content:""}.vjs-icon-repeat{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-repeat:before{content:""}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder,.vjs-icon-replay{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-play-control.vjs-ended .vjs-icon-placeholder:before,.vjs-icon-replay:before{content:""}.video-js .vjs-skip-backward-5 .vjs-icon-placeholder,.vjs-icon-replay-5{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-skip-backward-5 .vjs-icon-placeholder:before,.vjs-icon-replay-5:before{content:""}.video-js .vjs-skip-backward-10 .vjs-icon-placeholder,.vjs-icon-replay-10{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-skip-backward-10 .vjs-icon-placeholder:before,.vjs-icon-replay-10:before{content:""}.video-js .vjs-skip-backward-30 .vjs-icon-placeholder,.vjs-icon-replay-30{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-skip-backward-30 .vjs-icon-placeholder:before,.vjs-icon-replay-30:before{content:""}.video-js .vjs-skip-forward-5 .vjs-icon-placeholder,.vjs-icon-forward-5{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-skip-forward-5 .vjs-icon-placeholder:before,.vjs-icon-forward-5:before{content:""}.video-js .vjs-skip-forward-10 .vjs-icon-placeholder,.vjs-icon-forward-10{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-skip-forward-10 .vjs-icon-placeholder:before,.vjs-icon-forward-10:before{content:""}.video-js .vjs-skip-forward-30 .vjs-icon-placeholder,.vjs-icon-forward-30{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-skip-forward-30 .vjs-icon-placeholder:before,.vjs-icon-forward-30:before{content:""}.video-js .vjs-audio-button .vjs-icon-placeholder,.vjs-icon-audio{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-audio-button .vjs-icon-placeholder:before,.vjs-icon-audio:before{content:""}.vjs-icon-next-item{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-next-item:before{content:""}.vjs-icon-previous-item{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-previous-item:before{content:""}.vjs-icon-shuffle{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-shuffle:before{content:""}.vjs-icon-cast{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-cast:before{content:""}.video-js .vjs-picture-in-picture-control .vjs-icon-placeholder,.vjs-icon-picture-in-picture-enter{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-picture-in-picture-control .vjs-icon-placeholder:before,.vjs-icon-picture-in-picture-enter:before{content:""}.video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder,.vjs-icon-picture-in-picture-exit{font-family:VideoJS;font-weight:400;font-style:normal}.video-js.vjs-picture-in-picture .vjs-picture-in-picture-control .vjs-icon-placeholder:before,.vjs-icon-picture-in-picture-exit:before{content:""}.vjs-icon-facebook{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-facebook:before{content:""}.vjs-icon-linkedin{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-linkedin:before{content:""}.vjs-icon-twitter{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-twitter:before{content:""}.vjs-icon-tumblr{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-tumblr:before{content:""}.vjs-icon-pinterest{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-icon-pinterest:before{content:""}.video-js .vjs-descriptions-button .vjs-icon-placeholder,.vjs-icon-audio-description{font-family:VideoJS;font-weight:400;font-style:normal}.video-js .vjs-descriptions-button .vjs-icon-placeholder:before,.vjs-icon-audio-description:before{content:""}.video-js{display:inline-block;vertical-align:top;box-sizing:border-box;color:#fff;background-color:#000;position:relative;padding:0;font-size:10px;line-height:1;font-weight:400;font-style:normal;font-family:Arial,Helvetica,sans-serif;word-break:initial}.video-js:-moz-full-screen{position:absolute}.video-js:-webkit-full-screen{width:100%!important;height:100%!important}.video-js[tabindex="-1"]{outline:0}.video-js *,.video-js :after,.video-js :before{box-sizing:inherit}.video-js ul{font-family:inherit;font-size:inherit;line-height:inherit;list-style-position:outside;margin:0}.video-js.vjs-1-1,.video-js.vjs-16-9,.video-js.vjs-4-3,.video-js.vjs-9-16,.video-js.vjs-fluid{width:100%;max-width:100%}.video-js.vjs-1-1:not(.vjs-audio-only-mode),.video-js.vjs-16-9:not(.vjs-audio-only-mode),.video-js.vjs-4-3:not(.vjs-audio-only-mode),.video-js.vjs-9-16:not(.vjs-audio-only-mode),.video-js.vjs-fluid:not(.vjs-audio-only-mode){height:0}.video-js.vjs-16-9:not(.vjs-audio-only-mode){padding-top:56.25%}.video-js.vjs-4-3:not(.vjs-audio-only-mode){padding-top:75%}.video-js.vjs-9-16:not(.vjs-audio-only-mode){padding-top:177.7777777778%}.video-js.vjs-1-1:not(.vjs-audio-only-mode){padding-top:100%}.video-js.vjs-fill:not(.vjs-audio-only-mode){width:100%;height:100%}.video-js .vjs-tech{position:absolute;top:0;left:0;width:100%;height:100%}.video-js.vjs-audio-only-mode .vjs-tech{display:none}body.vjs-full-window,body.vjs-pip-window{padding:0;margin:0;height:100%}.vjs-full-window .video-js.vjs-fullscreen,body.vjs-pip-window .video-js{position:fixed;overflow:hidden;z-index:1000;inset:0}.video-js.vjs-fullscreen:not(.vjs-ios-native-fs),body.vjs-pip-window .video-js{width:100%!important;height:100%!important;padding-top:0!important;display:block}.video-js.vjs-fullscreen.vjs-user-inactive{cursor:none}.vjs-pip-container .vjs-pip-text{position:absolute;bottom:10%;font-size:2em;background-color:#000000b3;padding:.5em;text-align:center;width:100%}.vjs-layout-small.vjs-pip-container .vjs-pip-text,.vjs-layout-tiny.vjs-pip-container .vjs-pip-text,.vjs-layout-x-small.vjs-pip-container .vjs-pip-text{bottom:0;font-size:1.4em}.vjs-hidden{display:none!important}.vjs-disabled{opacity:.5;cursor:default}.video-js .vjs-offscreen{height:1px;left:-9999px;position:absolute;top:0;width:1px}.vjs-lock-showing{display:block!important;opacity:1!important;visibility:visible!important}.vjs-no-js{padding:20px;color:#fff;background-color:#000;font-size:18px;font-family:Arial,Helvetica,sans-serif;text-align:center;width:300px;height:150px;margin:0 auto}.vjs-no-js a,.vjs-no-js a:visited{color:#66a8cc}.video-js .vjs-big-play-button{font-size:3em;line-height:1.5em;height:1.63332em;width:3em;display:block;position:absolute;top:50%;left:50%;padding:0;margin-top:-.81666em;margin-left:-1.5em;cursor:pointer;opacity:1;border:.06666em solid #fff;background-color:#2b333f;background-color:#2b333fb3;border-radius:.3em;transition:all .4s}.vjs-big-play-button .vjs-svg-icon{width:1em;height:1em;position:absolute;top:50%;left:50%;line-height:1;transform:translate(-50%,-50%)}.video-js .vjs-big-play-button:focus,.video-js:hover .vjs-big-play-button{border-color:#fff;background-color:#73859f;background-color:#73859f80;transition:all 0s}.vjs-controls-disabled .vjs-big-play-button,.vjs-error .vjs-big-play-button,.vjs-has-started .vjs-big-play-button,.vjs-using-native-controls .vjs-big-play-button{display:none}.vjs-has-started.vjs-paused.vjs-show-big-play-button-on-pause:not(.vjs-seeking,.vjs-scrubbing,.vjs-error) .vjs-big-play-button{display:block}.video-js button{background:0 0;border:none;color:inherit;display:inline-block;font-size:inherit;line-height:inherit;text-transform:none;text-decoration:none;transition:none;-webkit-appearance:none;-moz-appearance:none;appearance:none}.vjs-control .vjs-button{width:100%;height:100%}.video-js .vjs-control.vjs-close-button{cursor:pointer;height:3em;position:absolute;right:0;top:.5em;z-index:2}.video-js .vjs-modal-dialog{background:#000c;background:linear-gradient(180deg,#000c,#fff0);overflow:auto}.video-js .vjs-modal-dialog>*{box-sizing:border-box}.vjs-modal-dialog .vjs-modal-dialog-content{font-size:1.2em;line-height:1.5;padding:20px 24px;z-index:1}.vjs-menu-button{cursor:pointer}.vjs-menu-button.vjs-disabled{cursor:default}.vjs-workinghover .vjs-menu-button.vjs-disabled:hover .vjs-menu{display:none}.vjs-menu .vjs-menu-content{display:block;padding:0;margin:0;font-family:Arial,Helvetica,sans-serif;overflow:auto}.vjs-menu .vjs-menu-content>*{box-sizing:border-box}.vjs-scrubbing .vjs-control.vjs-menu-button:hover .vjs-menu{display:none}.vjs-menu li{display:flex;justify-content:center;list-style:none;margin:0;padding:.2em 0;line-height:1.4em;font-size:1.2em;text-align:center;text-transform:lowercase}.js-focus-visible .vjs-menu li.vjs-menu-item:hover,.vjs-menu li.vjs-menu-item:focus,.vjs-menu li.vjs-menu-item:hover{background-color:#73859f;background-color:#73859f80}.js-focus-visible .vjs-menu li.vjs-selected:hover,.vjs-menu li.vjs-selected,.vjs-menu li.vjs-selected:focus,.vjs-menu li.vjs-selected:hover{background-color:#fff;color:#2b333f}.js-focus-visible .vjs-menu li.vjs-selected:hover .vjs-svg-icon,.vjs-menu li.vjs-selected .vjs-svg-icon,.vjs-menu li.vjs-selected:focus .vjs-svg-icon,.vjs-menu li.vjs-selected:hover .vjs-svg-icon{fill:#000}.js-focus-visible .vjs-menu :not(.vjs-selected):focus:not(.focus-visible),.video-js .vjs-menu :not(.vjs-selected):focus:not(:focus-visible){background:0 0}.vjs-menu li.vjs-menu-title{text-align:center;text-transform:uppercase;font-size:1em;line-height:2em;padding:0;margin:0 0 .3em;font-weight:700;cursor:default}.vjs-menu-button-popup .vjs-menu{display:none;position:absolute;bottom:0;width:10em;left:-3em;height:0;margin-bottom:1.5em;border-top-color:#2b333fb3}.vjs-pip-window .vjs-menu-button-popup .vjs-menu{left:unset;right:1em}.vjs-menu-button-popup .vjs-menu .vjs-menu-content{background-color:#2b333f;background-color:#2b333fb3;position:absolute;width:100%;bottom:1.5em;max-height:15em}.vjs-layout-tiny .vjs-menu-button-popup .vjs-menu .vjs-menu-content,.vjs-layout-x-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:5em}.vjs-layout-small .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:10em}.vjs-layout-medium .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:14em}.vjs-layout-huge .vjs-menu-button-popup .vjs-menu .vjs-menu-content,.vjs-layout-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content,.vjs-layout-x-large .vjs-menu-button-popup .vjs-menu .vjs-menu-content{max-height:25em}.vjs-menu-button-popup .vjs-menu.vjs-lock-showing,.vjs-workinghover .vjs-menu-button-popup.vjs-hover .vjs-menu{display:block}.video-js .vjs-menu-button-inline{transition:all .4s;overflow:hidden}.video-js .vjs-menu-button-inline:before{width:2.222222222em}.video-js .vjs-menu-button-inline.vjs-slider-active,.video-js .vjs-menu-button-inline:focus,.video-js .vjs-menu-button-inline:hover{width:12em}.vjs-menu-button-inline .vjs-menu{opacity:0;height:100%;width:auto;position:absolute;left:4em;top:0;padding:0;margin:0;transition:all .4s}.vjs-menu-button-inline.vjs-slider-active .vjs-menu,.vjs-menu-button-inline:focus .vjs-menu,.vjs-menu-button-inline:hover .vjs-menu{display:block;opacity:1}.vjs-menu-button-inline .vjs-menu-content{width:auto;height:100%;margin:0;overflow:hidden}.video-js .vjs-control-bar{display:none;width:100%;position:absolute;bottom:0;left:0;right:0;height:3em;background-color:#2b333f;background-color:#2b333fb3}.video-js:not(.vjs-controls-disabled,.vjs-using-native-controls,.vjs-error) .vjs-control-bar.vjs-lock-showing{display:flex!important}.vjs-audio-only-mode .vjs-control-bar,.vjs-has-started .vjs-control-bar{display:flex;visibility:visible;opacity:1;transition:visibility .1s,opacity .1s}.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{visibility:visible;opacity:0;pointer-events:none;transition:visibility 1s,opacity 1s}.vjs-controls-disabled .vjs-control-bar,.vjs-error .vjs-control-bar,.vjs-using-native-controls .vjs-control-bar{display:none!important}.vjs-audio-only-mode.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar,.vjs-audio.vjs-has-started.vjs-user-inactive.vjs-playing .vjs-control-bar{opacity:1;visibility:visible;pointer-events:auto}.video-js .vjs-control{position:relative;text-align:center;margin:0;padding:0;height:100%;width:4em;flex:none}.video-js .vjs-control.vjs-visible-text{width:auto;padding-left:1em;padding-right:1em}.vjs-button>.vjs-icon-placeholder:before{font-size:1.8em;line-height:1.67}.vjs-button>.vjs-icon-placeholder{display:block}.vjs-button>.vjs-svg-icon{display:inline-block}.video-js .vjs-control:focus,.video-js .vjs-control:focus:before,.video-js .vjs-control:hover:before{text-shadow:0 0 1em #fff}.video-js :not(.vjs-visible-text)>.vjs-control-text{border:0;clip:rect(0 0 0 0);height:1px;overflow:hidden;padding:0;position:absolute;width:1px}.video-js .vjs-custom-control-spacer{display:none}.video-js .vjs-progress-control{cursor:pointer;flex:auto;display:flex;align-items:center;min-width:4em;touch-action:none}.video-js .vjs-progress-control.disabled{cursor:default}.vjs-live .vjs-progress-control{display:none}.vjs-liveui .vjs-progress-control{display:flex;align-items:center}.video-js .vjs-progress-holder{flex:auto;transition:all .2s;height:.3em}.video-js .vjs-progress-control .vjs-progress-holder{margin:0 10px}.video-js .vjs-progress-control:hover .vjs-progress-holder{font-size:1.6666666667em}.video-js .vjs-progress-control:hover .vjs-progress-holder.disabled{font-size:1em}.video-js .vjs-progress-holder .vjs-load-progress,.video-js .vjs-progress-holder .vjs-load-progress div,.video-js .vjs-progress-holder .vjs-play-progress{position:absolute;display:block;height:100%;margin:0;padding:0;width:0}.video-js .vjs-play-progress{background-color:#fff}.video-js .vjs-play-progress:before{font-size:.9em;position:absolute;right:-.5em;line-height:.35em;z-index:1}.vjs-svg-icons-enabled .vjs-play-progress:before{content:none!important}.vjs-play-progress .vjs-svg-icon{position:absolute;top:-.35em;right:-.4em;width:.9em;height:.9em;pointer-events:none;line-height:.15em;z-index:1}.video-js .vjs-load-progress{background:#73859f80}.video-js .vjs-load-progress div{background:#73859fbf}.video-js .vjs-time-tooltip{background-color:#fff;background-color:#fffc;border-radius:.3em;color:#000;float:right;font-family:Arial,Helvetica,sans-serif;font-size:1em;padding:6px 8px 8px;pointer-events:none;position:absolute;top:-3.4em;visibility:hidden;z-index:1}.video-js .vjs-progress-holder:focus .vjs-time-tooltip{display:none}.video-js .vjs-progress-control:hover .vjs-progress-holder:focus .vjs-time-tooltip,.video-js .vjs-progress-control:hover .vjs-time-tooltip{display:block;font-size:.6em;visibility:visible}.video-js .vjs-progress-control.disabled:hover .vjs-time-tooltip{font-size:1em}.video-js .vjs-progress-control .vjs-mouse-display{display:none;position:absolute;width:1px;height:100%;background-color:#000;z-index:1}.video-js .vjs-progress-control:hover .vjs-mouse-display{display:block}.video-js.vjs-user-inactive .vjs-progress-control .vjs-mouse-display{visibility:hidden;opacity:0;transition:visibility 1s,opacity 1s}.vjs-mouse-display .vjs-time-tooltip{color:#fff;background-color:#000;background-color:#000c}.video-js .vjs-slider{position:relative;cursor:pointer;padding:0;margin:0 .45em;-webkit-touch-callout:none;-webkit-user-select:none;-moz-user-select:none;user-select:none;background-color:#73859f;background-color:#73859f80}.video-js .vjs-slider.disabled{cursor:default}.video-js .vjs-slider:focus{text-shadow:0 0 1em #fff;box-shadow:0 0 1em #fff}.video-js .vjs-mute-control{cursor:pointer;flex:none}.video-js .vjs-volume-control{cursor:pointer;margin-right:1em;display:flex}.video-js .vjs-volume-control.vjs-volume-horizontal{width:5em}.video-js .vjs-volume-panel .vjs-volume-control{visibility:visible;opacity:0;width:1px;height:1px;margin-left:-1px}.video-js .vjs-volume-panel{transition:width 1s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active,.video-js .vjs-volume-panel .vjs-volume-control:active,.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control,.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control,.video-js .vjs-volume-panel:active .vjs-volume-control,.video-js .vjs-volume-panel:focus .vjs-volume-control{visibility:visible;opacity:1;position:relative;transition:visibility .1s,opacity .1s,height .1s,width .1s,left 0s,top 0s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-horizontal,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-horizontal,.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-horizontal,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-horizontal{width:5em;height:3em;margin-right:0}.video-js .vjs-volume-panel .vjs-volume-control.vjs-slider-active.vjs-volume-vertical,.video-js .vjs-volume-panel .vjs-volume-control:active.vjs-volume-vertical,.video-js .vjs-volume-panel.vjs-hover .vjs-mute-control~.vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel.vjs-hover .vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel:active .vjs-volume-control.vjs-volume-vertical,.video-js .vjs-volume-panel:focus .vjs-volume-control.vjs-volume-vertical{left:-3.5em;transition:left 0s}.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js .vjs-volume-panel.vjs-volume-panel-horizontal:active{width:10em;transition:width .1s}.video-js .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-mute-toggle-only{width:4em}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-vertical{height:8em;width:3em;left:-3000em;transition:visibility 1s,opacity 1s,height 1s 1s,width 1s 1s,left 1s 1s,top 1s 1s}.video-js .vjs-volume-panel .vjs-volume-control.vjs-volume-horizontal{transition:visibility 1s,opacity 1s,height 1s 1s,width 1s,left 1s 1s,top 1s 1s}.video-js .vjs-volume-panel{display:flex}.video-js .vjs-volume-bar{margin:1.35em .45em}.vjs-volume-bar.vjs-slider-horizontal{width:5em;height:.3em}.vjs-volume-bar.vjs-slider-vertical{width:.3em;height:5em;margin:1.35em auto}.video-js .vjs-volume-level{position:absolute;bottom:0;left:0;background-color:#fff}.video-js .vjs-volume-level:before{position:absolute;font-size:.9em;z-index:1}.vjs-slider-vertical .vjs-volume-level{width:.3em}.vjs-slider-vertical .vjs-volume-level:before{top:-.5em;left:-.3em;z-index:1}.vjs-svg-icons-enabled .vjs-volume-level:before{content:none}.vjs-volume-level .vjs-svg-icon{position:absolute;width:.9em;height:.9em;pointer-events:none;z-index:1}.vjs-slider-horizontal .vjs-volume-level{height:.3em}.vjs-slider-horizontal .vjs-volume-level:before{line-height:.35em;right:-.5em}.vjs-slider-horizontal .vjs-volume-level .vjs-svg-icon{right:-.3em;transform:translateY(-50%)}.vjs-slider-vertical .vjs-volume-level .vjs-svg-icon{top:-.55em;transform:translate(-50%)}.video-js .vjs-volume-panel.vjs-volume-panel-vertical{width:4em}.vjs-volume-bar.vjs-slider-vertical .vjs-volume-level{height:100%}.vjs-volume-bar.vjs-slider-horizontal .vjs-volume-level{width:100%}.video-js .vjs-volume-vertical{width:3em;height:8em;bottom:8em;background-color:#2b333f;background-color:#2b333fb3}.video-js .vjs-volume-horizontal .vjs-menu{left:-2em}.video-js .vjs-volume-tooltip{background-color:#fff;background-color:#fffc;border-radius:.3em;color:#000;float:right;font-family:Arial,Helvetica,sans-serif;font-size:1em;padding:6px 8px 8px;pointer-events:none;position:absolute;top:-3.4em;visibility:hidden;z-index:1}.video-js .vjs-volume-control:hover .vjs-progress-holder:focus .vjs-volume-tooltip,.video-js .vjs-volume-control:hover .vjs-volume-tooltip{display:block;font-size:1em;visibility:visible}.video-js .vjs-volume-vertical:hover .vjs-progress-holder:focus .vjs-volume-tooltip,.video-js .vjs-volume-vertical:hover .vjs-volume-tooltip{left:1em;top:-12px}.video-js .vjs-volume-control.disabled:hover .vjs-volume-tooltip{font-size:1em}.video-js .vjs-volume-control .vjs-mouse-display{display:none;position:absolute;width:100%;height:1px;background-color:#000;z-index:1}.video-js .vjs-volume-horizontal .vjs-mouse-display{width:1px;height:100%}.video-js .vjs-volume-control:hover .vjs-mouse-display{display:block}.video-js.vjs-user-inactive .vjs-volume-control .vjs-mouse-display{visibility:hidden;opacity:0;transition:visibility 1s,opacity 1s}.vjs-mouse-display .vjs-volume-tooltip{color:#fff;background-color:#000;background-color:#000c}.vjs-poster{background-size:cover;display:inline-block;vertical-align:middle;cursor:pointer;margin:0;padding:0;position:absolute;inset:0;height:100%}.vjs-has-started .vjs-poster,.vjs-using-native-controls .vjs-poster{display:none}.vjs-audio.vjs-has-started .vjs-poster,.vjs-has-started.vjs-audio-poster-mode .vjs-poster,.vjs-pip-container.vjs-has-started .vjs-poster{display:block}.vjs-poster img{width:100%;height:100%;-o-object-fit:contain;object-fit:contain}.video-js .vjs-live-control{display:flex;align-items:flex-start;flex:auto;font-size:1em;line-height:3em}.video-js.vjs-liveui .vjs-live-control,.video-js:not(.vjs-live) .vjs-live-control{display:none}.video-js .vjs-seek-to-live-control{align-items:center;cursor:pointer;flex:none;display:inline-flex;height:100%;padding-left:.5em;padding-right:.5em;font-size:1em;line-height:3em;width:auto;min-width:4em}.video-js.vjs-live:not(.vjs-liveui) .vjs-seek-to-live-control,.video-js:not(.vjs-live) .vjs-seek-to-live-control{display:none}.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge{cursor:auto}.vjs-seek-to-live-control .vjs-icon-placeholder{margin-right:.5em;color:#888}.vjs-svg-icons-enabled .vjs-seek-to-live-control{line-height:0}.vjs-seek-to-live-control .vjs-svg-icon{width:1em;height:1em;pointer-events:none;fill:#888}.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-icon-placeholder{color:red}.vjs-seek-to-live-control.vjs-control.vjs-at-live-edge .vjs-svg-icon{fill:red}.video-js .vjs-time-control{flex:none;font-size:1em;line-height:3em;min-width:2em;width:auto;padding-left:1em;padding-right:1em}.video-js .vjs-current-time,.video-js .vjs-duration,.vjs-live .vjs-time-control,.vjs-live .vjs-time-divider{display:none}.vjs-time-divider{display:none;line-height:3em}.video-js .vjs-play-control{cursor:pointer}.video-js .vjs-play-control .vjs-icon-placeholder{flex:none}.vjs-text-track-display{position:absolute;inset:0 0 3em;pointer-events:none}.vjs-error .vjs-text-track-display{display:none}.video-js.vjs-controls-disabled .vjs-text-track-display,.video-js.vjs-user-inactive.vjs-playing .vjs-text-track-display{bottom:1em}.video-js .vjs-text-track{font-size:1.4em;text-align:center;margin-bottom:.1em}.vjs-subtitles{color:#fff}.vjs-captions{color:#fc6}.vjs-tt-cue{display:block}video::-webkit-media-text-track-display{transform:translateY(-3em)}.video-js.vjs-controls-disabled video::-webkit-media-text-track-display,.video-js.vjs-user-inactive.vjs-playing video::-webkit-media-text-track-display{transform:translateY(-1.5em)}.video-js .vjs-picture-in-picture-control{cursor:pointer;flex:none}.video-js.vjs-audio-only-mode .vjs-picture-in-picture-control,.vjs-pip-window .vjs-picture-in-picture-control{display:none}.video-js .vjs-fullscreen-control{cursor:pointer;flex:none}.video-js.vjs-audio-only-mode .vjs-fullscreen-control,.vjs-pip-window .vjs-fullscreen-control{display:none}.vjs-playback-rate .vjs-playback-rate-value,.vjs-playback-rate>.vjs-menu-button{position:absolute;top:0;left:0;width:100%;height:100%}.vjs-playback-rate .vjs-playback-rate-value{pointer-events:none;font-size:1.5em;line-height:2;text-align:center}.vjs-playback-rate .vjs-menu{width:4em;left:0}.vjs-error .vjs-error-display .vjs-modal-dialog-content{font-size:1.4em;text-align:center}.vjs-loading-spinner{display:none;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);opacity:.85;text-align:left;border:.6em solid rgba(43,51,63,.7);box-sizing:border-box;background-clip:padding-box;width:5em;height:5em;border-radius:50%;visibility:hidden}.vjs-seeking .vjs-loading-spinner,.vjs-waiting .vjs-loading-spinner{display:flex;justify-content:center;align-items:center;animation:vjs-spinner-show 0s linear .3s forwards}.vjs-error .vjs-loading-spinner{display:none}.vjs-loading-spinner:after,.vjs-loading-spinner:before{content:"";position:absolute;box-sizing:inherit;width:inherit;height:inherit;border-radius:inherit;opacity:1;border:inherit;border-color:transparent;border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:before{animation:vjs-spinner-spin 1.1s cubic-bezier(.6,.2,0,.8) infinite,vjs-spinner-fade 1.1s linear infinite}.vjs-seeking .vjs-loading-spinner:before,.vjs-waiting .vjs-loading-spinner:before{border-top-color:#fff}.vjs-seeking .vjs-loading-spinner:after,.vjs-waiting .vjs-loading-spinner:after{border-top-color:#fff;animation-delay:.44s}@keyframes vjs-spinner-show{to{visibility:visible}}@keyframes vjs-spinner-spin{to{transform:rotate(360deg)}}@keyframes vjs-spinner-fade{0%{border-top-color:#73859f}20%{border-top-color:#73859f}35%{border-top-color:#fff}60%{border-top-color:#73859f}to{border-top-color:#73859f}}.video-js.vjs-audio-only-mode .vjs-captions-button{display:none}.vjs-chapters-button .vjs-menu ul{width:24em}.video-js.vjs-audio-only-mode .vjs-descriptions-button{display:none}.vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-svg-icon{width:1.5em;height:1.5em}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder{vertical-align:middle;display:inline-block;margin-bottom:-.1em}.video-js .vjs-subs-caps-button+.vjs-menu .vjs-captions-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before{font-family:VideoJS;content:"";font-size:1.5em;line-height:inherit}.video-js.vjs-audio-only-mode .vjs-subs-caps-button{display:none}.video-js .vjs-audio-button+.vjs-menu .vjs-description-menu-item .vjs-menu-item-text .vjs-icon-placeholder,.video-js .vjs-audio-button+.vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder{vertical-align:middle;display:inline-block;margin-bottom:-.1em}.video-js .vjs-audio-button+.vjs-menu .vjs-description-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before,.video-js .vjs-audio-button+.vjs-menu .vjs-main-desc-menu-item .vjs-menu-item-text .vjs-icon-placeholder:before{font-family:VideoJS;content:" ";font-size:1.5em;line-height:inherit}.video-js.vjs-layout-small .vjs-current-time,.video-js.vjs-layout-small .vjs-duration,.video-js.vjs-layout-small .vjs-playback-rate,.video-js.vjs-layout-small .vjs-remaining-time,.video-js.vjs-layout-small .vjs-time-divider,.video-js.vjs-layout-small .vjs-volume-control,.video-js.vjs-layout-tiny .vjs-current-time,.video-js.vjs-layout-tiny .vjs-duration,.video-js.vjs-layout-tiny .vjs-playback-rate,.video-js.vjs-layout-tiny .vjs-remaining-time,.video-js.vjs-layout-tiny .vjs-time-divider,.video-js.vjs-layout-tiny .vjs-volume-control,.video-js.vjs-layout-x-small .vjs-current-time,.video-js.vjs-layout-x-small .vjs-duration,.video-js.vjs-layout-x-small .vjs-playback-rate,.video-js.vjs-layout-x-small .vjs-remaining-time,.video-js.vjs-layout-x-small .vjs-time-divider,.video-js.vjs-layout-x-small .vjs-volume-control{display:none}.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js.vjs-layout-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js.vjs-layout-tiny .vjs-volume-panel.vjs-volume-panel-horizontal:hover,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-hover,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal.vjs-slider-active,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:active,.video-js.vjs-layout-x-small .vjs-volume-panel.vjs-volume-panel-horizontal:hover{width:auto;width:initial}.video-js.vjs-layout-tiny .vjs-progress-control,.video-js.vjs-layout-x-small .vjs-progress-control{display:none}.video-js.vjs-layout-x-small .vjs-custom-control-spacer{flex:auto;display:block}.vjs-modal-dialog.vjs-text-track-settings{background-color:#2b333f;background-color:#2b333fbf;color:#fff;height:70%}.vjs-error .vjs-text-track-settings{display:none}.vjs-text-track-settings .vjs-modal-dialog-content{display:table}.vjs-text-track-settings .vjs-track-settings-colors,.vjs-text-track-settings .vjs-track-settings-controls,.vjs-text-track-settings .vjs-track-settings-font{display:table-cell}.vjs-text-track-settings .vjs-track-settings-controls{text-align:right;vertical-align:bottom}@supports (display: grid){.vjs-text-track-settings .vjs-modal-dialog-content{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr;padding:20px 24px 0}.vjs-track-settings-controls .vjs-default-button{margin-bottom:20px}.vjs-text-track-settings .vjs-track-settings-controls{grid-column:1/-1}.vjs-layout-small .vjs-text-track-settings .vjs-modal-dialog-content,.vjs-layout-tiny .vjs-text-track-settings .vjs-modal-dialog-content,.vjs-layout-x-small .vjs-text-track-settings .vjs-modal-dialog-content{grid-template-columns:1fr}}.vjs-text-track-settings select{font-size:inherit}.vjs-track-setting>select{margin-right:1em;margin-bottom:.5em}.vjs-text-track-settings fieldset{margin:10px;border:none}.vjs-text-track-settings fieldset span{display:inline-block;padding:0 .6em .8em}.vjs-text-track-settings fieldset span>select{max-width:7.3em}.vjs-text-track-settings legend{color:#fff;font-weight:700;font-size:1.2em}.vjs-text-track-settings .vjs-label{margin:0 .5em .5em 0}.vjs-track-settings-controls button:active,.vjs-track-settings-controls button:focus{outline-style:solid;outline-width:medium;background-image:linear-gradient(0deg,#fff 88%,#73859f)}.vjs-track-settings-controls button:hover{color:#2b333fbf}.vjs-track-settings-controls button{background-color:#fff;background-image:linear-gradient(-180deg,#fff 88%,#73859f);color:#2b333f;cursor:pointer;border-radius:2px}.vjs-track-settings-controls .vjs-default-button{margin-right:1em}.vjs-title-bar{background:#000000e6;background:linear-gradient(180deg,#000000e6 0,#000000b3 60%,#0000);font-size:1.2em;line-height:1.5;transition:opacity .1s;padding:.666em 1.333em 4em;pointer-events:none;position:absolute;top:0;width:100%}.vjs-error .vjs-title-bar{display:none}.vjs-title-bar-description,.vjs-title-bar-title{margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.vjs-title-bar-title{font-weight:700;margin-bottom:.333em}.vjs-playing.vjs-user-inactive .vjs-title-bar{opacity:0;transition:opacity 1s}.video-js .vjs-skip-forward-5,.video-js .vjs-skip-forward-10,.video-js .vjs-skip-forward-30,.video-js .vjs-skip-backward-5,.video-js .vjs-skip-backward-10,.video-js .vjs-skip-backward-30{cursor:pointer}@media print{.video-js>:not(.vjs-tech):not(.vjs-poster){visibility:hidden}}.vjs-resize-manager{position:absolute;top:0;left:0;width:100%;height:100%;border:none;z-index:-1000}.js-focus-visible .video-js :focus:not(.focus-visible){outline:0}.video-js :focus:not(:focus-visible){outline:0}.bc-player-rkuNCi7ll_default *,.bc-player-rkuNCi7ll_default *:before,.bc-player-rkuNCi7ll_default *:after{box-sizing:inherit;font-size:inherit;color:inherit;line-height:inherit}.bc-player-rkuNCi7ll_default{font-size:14px;overflow:hidden}.bc-player-rkuNCi7ll_default.vjs-fluid:not(.vjs-audio-only-mode),.bc-player-rkuNCi7ll_default.vjs-fluid.vjs-16-9:not(.vjs-audio-only-mode){padding-top:56.25%}.bc-player-rkuNCi7ll_default.vjs-fluid.vjs-4-3:not(.vjs-audio-only-mode){padding-top:75%}.bc-player-rkuNCi7ll_default.vjs-fill:not(.vjs-audio-only-mode){width:100%;height:100%}.bc-iframe,.bc-iframe body,.bc-player-rkuNCi7ll_default,.bc-player-rkuNCi7ll_default .vjs-poster{background-color:#151b17}.bc-iframe,.bc-iframe body,.bc-iframe .bc-player-rkuNCi7ll_default{margin:0;width:100%;height:100%;overflow:hidden}.bc-player-rkuNCi7ll_default.vjs-fullscreen,.bc-player-rkuNCi7ll_default.vjs-fullscreen .vjs-tech{width:100%!important;height:100%!important}.bc-player-rkuNCi7ll_default .vjs-track-setting select{color:#000;background-color:#fff}.bc-player-rkuNCi7ll_default .vjs-chapters-button .vjs-menu-item,.bc-player-rkuNCi7ll_default .vjs-descriptions-button .vjs-menu-item,.bc-player-rkuNCi7ll_default .vjs-subs-caps-button .vjs-menu-item,.bc-player-rkuNCi7ll_default .vjs-audio-button .vjs-menu-item{text-transform:none}.bc-player-rkuNCi7ll_default.vjs-waiting-for-autoplay .vjs-big-play-button{opacity:0}.bc-player-rkuNCi7ll_default .vjs-progress-control .vjs-mouse-display{z-index:2}/*! @name @brightcove/player-core @version 2.7.4 @license UNLICENSED */.vjs-download-button{cursor:pointer}.vjs-download-button.has-icon-downloading{cursor:wait}.vjs-download-button .vjs-icon-placeholder{font-family:VideoJS;font-weight:400;font-style:normal}.vjs-download-button.has-icon-file-download .vjs-icon-placeholder:before{content:""}.vjs-download-button.has-icon-downloading .vjs-icon-placeholder:before{content:""}.vjs-download-button.has-icon-file-download-off .vjs-icon-placeholder:before{content:""}.vjs-modal-dialog.vjs-player-info-modal{background:#000000e6}.vjs-modal-dialog.vjs-player-info-modal .vjs-modal-dialog-content{overflow:auto;display:grid;grid-template-columns:1fr 1fr;grid-gap:1em}@media screen and (max-width: 640px){.vjs-modal-dialog.vjs-player-info-modal .vjs-modal-dialog-content{grid-template-columns:1fr}}.vjs-modal-dialog.vjs-player-info-modal h2{font-size:1.1667em;margin:0 0 .4286em}.vjs-modal-dialog.vjs-player-info-modal table{border-bottom:1px solid #333;border-collapse:collapse;border-top:1px solid #333;margin-bottom:1.5em;width:100%}.vjs-modal-dialog.vjs-player-info-modal table.vjs-two td,.vjs-modal-dialog.vjs-player-info-modal table.vjs-two th{width:50%}.vjs-modal-dialog.vjs-player-info-modal table.vjs-three td,.vjs-modal-dialog.vjs-player-info-modal table.vjs-three th{width:33.333%}.vjs-modal-dialog.vjs-player-info-modal th{font-weight:400;text-align:left}.vjs-modal-dialog.vjs-player-info-modal td{border-bottom:1px solid #333;opacity:.5}.vjs-modal-dialog.vjs-player-info-modal tr:last-child td{border-bottom:0}.vjs-modal-dialog.vjs-player-info-modal tr:hover td{opacity:1}/*! @name videojs-contextmenu-ui @version 7.0.0 @license Apache-2.0 */.vjs-contextmenu-ui-menu{position:absolute}.vjs-contextmenu-ui-menu .vjs-menu-content{background-color:#2b333f;background-color:#2b333fb3;border-radius:.3em;padding:.25em}.vjs-contextmenu-ui-menu .vjs-menu-item{border-radius:.3em;cursor:pointer;margin:0 0 1px;padding:.5em 1em;font-size:1em;line-height:1.2;text-transform:none}.vjs-contextmenu-ui-menu .vjs-menu-item:active,.vjs-contextmenu-ui-menu .vjs-menu-item:hover{background-color:#00000080;text-shadow:0 0 1em #fff}/*! @name videojs-errors @version 6.1.0 @license Apache-2.0 */.vjs-error-display{color:#fff;display:none;font-family:Helvetica,Arial,sans serif;font-size:16px;line-height:1.428}.vjs-error .vjs-error-display{display:block;position:absolute;inset:0;background:#00000080}.vjs-error .vjs-error-display .vjs-modal-dialog-content{font-size:14px}.vjs-errors-dialog{text-align:left;border:1px #999 solid;overflow:hidden;position:absolute;inset:2% 5%;padding-left:1%;padding-right:1%;background:#181818cc}.vjs-errors-details{margin-top:15px}.vjs-errors-message{border:1px #999 solid;background-color:#2c2c2c;overflow:auto;margin-top:15px;padding:15px}.vjs-errors-ok-button-container{display:block;position:absolute;bottom:15px;left:15px;right:15px;text-align:center}.vjs-errors-ok-button,.vjs-errors-timeout-button-container button{display:block;height:36px;background-color:#000;border:1px #999 solid;border-radius:5px;color:#999;font-size:14px;cursor:pointer}.vjs-errors-ok-button{margin:0 auto;width:80px}.vjs-errors-ok-button:hover,.vjs-errors-timeout-button-container button:hover{border:1px #fff solid;color:#ccc}.vjs-errors-timeout-button-container{display:flex;flex-direction:row;justify-content:center;gap:10px;position:absolute;bottom:15px;left:15px;right:15px;text-align:center}.vjs-errors-timeout-button-container button{width:120px}.vjs-errors-content-container{overflow:auto;position:absolute;padding-bottom:15px;inset:0 15px 61px}.vjs-errors-headline{font-size:14px;font-weight:700;padding-right:3em}.vjs-errors-dialog .vjs-control.vjs-close-button{width:3em;height:3em;top:0}.vjs-xs.vjs-error-display{font-size:14px;background-color:#000}.vjs-xs.vjs-error-display .vjs-errors-details,.vjs-xs.vjs-error-display .vjs-errors-message{display:none}.vjs-xs .vjs-errors-content-container{top:0}.vjs-xs .vjs-errors-headline{font-size:16px;font-weight:700}.vjs-xs .vjs-errors-dialog{border:0;inset:0}@media (max-width: 600px),(max-height: 250px){.vjs-error-display{font-size:14px;background-color:#000}.vjs-error-display .vjs-errors-details,.vjs-error-display .vjs-errors-message{display:none}.vjs-error-display .vjs-errors-content-container{top:15px}.vjs-error-display .vjs-errors-headline{font-size:16px;font-weight:700}.vjs-error-display .vjs-errors-dialog{border:0;inset:0}}.vjs-errors-ref-id{color:#ffffff80;font-size:.75em;margin:.5em 0 0}.bc-player-rkuNCi7ll_default .vjs-control-bar{background-color:#0009;color:#fff}.bc-player-rkuNCi7ll_default .vjs-control{color:inherit}.bc-player-rkuNCi7ll_default .vjs-mouse-display:after,.bc-player-rkuNCi7ll_default .vjs-play-progress:after{border-radius:0}.bc-player-rkuNCi7ll_default.vjs-no-flex .vjs-menu-button-inline,.bc-player-rkuNCi7ll_default .vjs-menu-button-inline:hover{width:8.35em}.bc-player-rkuNCi7ll_default .vjs-control:focus:before,.bc-player-rkuNCi7ll_default .vjs-control:hover:before{text-shadow:0em 0em 1em white,0em 0em 1em white,0em 0em 1em white}.bc-player-rkuNCi7ll_default .vjs-spacer{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-flex:1 1 auto;-moz-box-flex:1 1 auto;-webkit-flex:1 1 auto;-ms-flex:1 1 auto;flex:1 1 auto}.bc-player-rkuNCi7ll_default .vjs-time-control{display:-webkit-box;display:-moz-box;display:-ms-flexbox;display:-webkit-flex;display:flex;-webkit-box-flex:0 1 auto;-moz-box-flex:0 1 auto;-webkit-flex:0 1 auto;-ms-flex:0 1 auto;flex:0 1 auto;width:auto}.bc-player-rkuNCi7ll_default .vjs-time-control.vjs-time-divider{width:14px}.bc-player-rkuNCi7ll_default .vjs-time-control.vjs-time-divider div{width:100%;text-align:center}.bc-player-rkuNCi7ll_default .vjs-time-control.vjs-current-time{margin-left:1em}.bc-player-rkuNCi7ll_default .vjs-time-control .vjs-current-time-display,.bc-player-rkuNCi7ll_default .vjs-time-control .vjs-duration-display{width:100%}.bc-player-rkuNCi7ll_default .vjs-time-control .vjs-current-time-display{text-align:right}.bc-player-rkuNCi7ll_default .vjs-time-control .vjs-duration-display{text-align:left}.bc-player-rkuNCi7ll_default .vjs-remaining-time,.bc-player-rkuNCi7ll_default.vjs-no-flex .vjs-time-control.vjs-remaining-time{display:none}.bc-player-rkuNCi7ll_default .vjs-play-progress,.bc-player-rkuNCi7ll_default .vjs-volume-level{background-color:#08088c}.bc-player-rkuNCi7ll_default.vjs-ad-playing .vjs-play-progress,.bc-player-rkuNCi7ll_default.vjs-ad-playing .vjs-volume-level{background-color:#ffe400}.bc-player-rkuNCi7ll_default .vjs-play-progress:before,.bc-player-rkuNCi7ll_default .vjs-volume-level:before{display:none}.bc-player-rkuNCi7ll_default .vjs-volume-level:after{display:none}.bc-player-rkuNCi7ll_default .vjs-progress-control{position:absolute;left:0;right:0;width:100%;height:1.5em;top:-1.5em}.bc-player-rkuNCi7ll_default .vjs-progress-control .vjs-play-progress,.bc-player-rkuNCi7ll_default .vjs-progress-control .vjs-load-progress,.bc-player-rkuNCi7ll_default .vjs-progress-control .vjs-progress-holder{height:100%}.bc-player-rkuNCi7ll_default .vjs-progress-control .vjs-progress-holder{margin:0}.bc-player-rkuNCi7ll_default .vjs-progress-control:hover{height:1.5em;top:-1.5em}.bc-player-rkuNCi7ll_default .vjs-control-bar:not(.vjs-focus-within){-webkit-transition:-webkit-transform .1s ease 0s;-moz-transition:-moz-transform .1s ease 0s;-ms-transition:-ms-transform .1s ease 0s;-o-transition:-o-transform .1s ease 0s;transition:transform .1s ease 0s}.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-active .vjs-control-bar:not(.vjs-focus-within):not(.vjs-control-bar-visible),.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-active .vjs-control-bar:not(.vjs-focus-within):not(.vjs-control-bar-visible),.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-control-bar:not(.vjs-focus-within):not(.vjs-control-bar-visible),.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar:not(.vjs-focus-within):not(.vjs-control-bar-visible),.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar:not(.vjs-focus-within):not(.vjs-control-bar-visible),.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-paused.vjs-ad-playing.vjs-user-inactive .vjs-control-bar{visibility:visible;opacity:1;-webkit-backface-visibility:hidden;-webkit-transform:translateY(3em);-moz-transform:translateY(3em);-ms-transform:translateY(3em);-o-transform:translateY(3em);transform:translateY(3em);-webkit-transition:-webkit-transform 1s ease 0s;-moz-transition:-moz-transform 1s ease 0s;-ms-transition:-ms-transform 1s ease 0s;-o-transition:-o-transform 1s ease 0s;transition:transform 1s ease 0s}.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-active:not(.vjs-audio-only-mode) .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-active:not(.vjs-audio-only-mode) .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-inactive:not(.vjs-audio-only-mode) .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-inactive:not(.vjs-audio-only-mode) .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-playing.vjs-user-inactive:not(.vjs-audio-only-mode) .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-paused.vjs-ad-playing.vjs-user-inactive:not(.vjs-audio-only-mode) .vjs-progress-control{height:.3em;top:-.3em;pointer-events:none;-webkit-transition:height 1s,top 1s;-moz-transition:height 1s,top 1s;-ms-transition:height 1s,top 1s;-o-transition:height 1s,top 1s;transition:height 1s,top 1s}.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-active.vjs-fullscreen .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-active.vjs-fullscreen .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-inactive.vjs-fullscreen .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-playing.vjs-user-inactive.vjs-fullscreen .vjs-progress-control,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-active .vjs-volume-vertical,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-active .vjs-volume-vertical,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-volume-vertical,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-volume-vertical,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-volume-vertical,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-paused.vjs-ad-playing.vjs-user-inactive .vjs-volume-vertical,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-active .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-active .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-paused.vjs-ad-playing.vjs-user-inactive .vjs-menu{opacity:0;-webkit-transition:opacity 1s;-moz-transition:opacity 1s;-ms-transition:opacity 1s;-o-transition:opacity 1s;transition:opacity 1s}.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-active .vjs-control-bar-visible .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-active .vjs-control-bar-visible .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-paused.vjs-user-inactive .vjs-control-bar-visible .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-hide-controls.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar-visible .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-playing.vjs-user-inactive .vjs-control-bar-visible .vjs-menu,.bc-player-rkuNCi7ll_default.vjs-has-started.vjs-paused.vjs-ad-playing.vjs-user-inactive .vjs-control-bar-visible .vjs-menu-item{opacity:1}.bc-player-rkuNCi7ll_default.vjs-live .vjs-live-control{margin-left:1em}.bc-player-rkuNCi7ll_default.vjs-live .vjs-time-control.vjs-current-time,.bc-player-rkuNCi7ll_default.vjs-live .vjs-time-control.vjs-time-divider,.bc-player-rkuNCi7ll_default.vjs-live .vjs-time-control.vjs-duration{display:none}.bc-player-rkuNCi7ll_default .vjs-big-play-button{top:50%;left:50%;margin-left:-1em;margin-top:-1em;width:2em;height:2em;line-height:2em;border:none;border-radius:50%;font-size:3.5em;background-color:#00000073;color:#fff;-webkit-transition:border-color .4s,outline .4s,background-color .4s;-moz-transition:border-color .4s,outline .4s,background-color .4s;-ms-transition:border-color .4s,outline .4s,background-color .4s;-o-transition:border-color .4s,outline .4s,background-color .4s;transition:border-color .4s,outline .4s,background-color .4s}.bc-player-rkuNCi7ll_default:hover .vjs-big-play-button,.bc-player-rkuNCi7ll_default:active .vjs-big-play-button,.bc-player-rkuNCi7ll_default .vjs-big-play-button:active,.bc-player-rkuNCi7ll_default .vjs-big-play-button:focus{background-color:#08088c}.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu{left:-3em}.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-content{width:12em;left:-1em;padding:.2em .5em .5em;border-radius:.25em .25em 0 0}.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-title,.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-item{background-color:#151b17;margin:.3em 0;padding:.5em;border-radius:.3em}.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected{background-color:#08088c;color:#fff}.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-item:active,.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-item:focus,.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-item:hover{text-shadow:0em 0em 1em white,0em 0em 1em white,0em 0em 1em white;color:#fff}.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-item:focus:not(.vjs-selected){background-color:#151b17}.bc-player-rkuNCi7ll_default.vjs-ad-playing .vjs-mouse-display,.bc-player-rkuNCi7ll_default.vjs-ad-playing .vjs-mouse-display:after{display:none}.bc-player-rkuNCi7ll_default.vjs-ad-playing.vjs-ad-playing .vjs-progress-control:after{pointer-events:auto;width:100%;height:100%;position:absolute;left:0;bottom:0;content:" ";-ms-user-select:none;-moz-user-select:none;-webkit-user-select:none;user-select:none}.bc-player-rkuNCi7ll_default.vjs-ad-playing .vjs-picture-in-picture-control{display:none}.bc-player-rkuNCi7ll_default.vjs-no-flex .vjs-spacer{display:table-cell}.bc-player-rkuNCi7ll_default.vjs-no-flex .vjs-time-control{display:table-cell;width:4em}.bc-player-rkuNCi7ll_default.vjs-no-flex .vjs-remaining-time{display:none}.vjs-mouse.bc-player-rkuNCi7ll_default .vjs-control-bar{font-size:10px}.vjs-mouse.bc-player-rkuNCi7ll_default .vjs-progress-control{height:.5em;top:-.5em}.vjs-mouse.bc-player-rkuNCi7ll_default .vjs-progress-control:hover{height:1.5em;top:-1.5em}.bc-player-rkuNCi7ll_default select{width:inherit}.bc-player-rkuNCi7ll_default.video-js:not(.vjs-fullscreen).vjs-layout-x-small.vjs-liveui .vjs-progress-control,.bc-player-rkuNCi7ll_default.video-js:not(.vjs-fullscreen).vjs-layout-tiny .vjs-progress-control{display:block}.bc-player-rkuNCi7ll_default .vjs-title-bar{line-height:1.5;padding-top:1em}.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-glow:hover .vjs-big-play-button,.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-glow:active .vjs-big-play-button,.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-glow .vjs-big-play-button:active,.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-glow .vjs-big-play-button:focus{box-shadow:0 0 15px 3px #fff;background-color:#00000073}.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-darken:hover .vjs-big-play-button,.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-darken:active .vjs-big-play-button,.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-darken .vjs-big-play-button:active,.bc-player-rkuNCi7ll_default.video-js.vjs-play-button-hover-darken .vjs-big-play-button:focus{background-color:#000000d9}.bc-player-rkuNCi7ll_default.vjs-play-button-shape-square .vjs-big-play-button{border-radius:11px;height:2em;width:2em;margin-left:-1em;margin-top:-1em}.bc-player-rkuNCi7ll_default.vjs-play-button-shape-rectangle .vjs-big-play-button{border-radius:21px;height:2em;width:3em;margin-left:-1.5em;margin-top:-1em}.bc-player-rkuNCi7ll_default.vjs-play-button-position-top-left .vjs-big-play-button{margin:0;left:17px;top:17px}.bc-player-rkuNCi7ll_default.vjs-play-button-position-top-right .vjs-big-play-button{margin:0;right:17px;left:auto;top:17px}.bc-player-rkuNCi7ll_default .vjs-control-bar,.bc-player-rkuNCi7ll_default .vjs-big-play-button,.bc-player-rkuNCi7ll_default .vjs-big-play-state.vjs-play-control.vjs-control{background-color:#00000073}.bc-player-rkuNCi7ll_default .vjs-control-bar,.bc-player-rkuNCi7ll_default .vjs-big-play-button,.bc-player-rkuNCi7ll_default .vjs-big-play-state{color:#fff}.bc-player-rkuNCi7ll_default .vjs-play-progress,.bc-player-rkuNCi7ll_default .vjs-volume-level,.bc-player-rkuNCi7ll_default:hover .vjs-big-play-button,.bc-player-rkuNCi7ll_default:active .vjs-big-play-button,.bc-player-rkuNCi7ll_default .vjs-big-play-button:active,.bc-player-rkuNCi7ll_default .vjs-big-play-button:focus,.bc-player-rkuNCi7ll_default .vjs-menu-button-popup .vjs-menu .vjs-menu-item.vjs-selected,.bc-iframe .vjs-playlist-sidebar .vjs-playlist-show-hide button:hover{background-color:#248cd5}.bc-player-rkuNCi7ll_default.vjs-audio-mode.vjs-has-started.vjs-focus-within.video-js.video-js.video-js .vjs-control-bar,.bc-player-rkuNCi7ll_default.vjs-audio-mode.vjs-has-started.vjs-user-inactive.video-js.video-js.video-js .vjs-control-bar,.bc-player-rkuNCi7ll_default.vjs-audio-mode.vjs-has-started.vjs-user-active.video-js.video-js.video-js .vjs-control-bar:not(.vjs-focus-within){opacity:1;visibility:visible;transform:none}.bc-player-rkuNCi7ll_default.vjs-audio-only-mode .vjs-poster{display:none}.bc-player-rkuNCi7ll_default.vjs-audio-only-mode .vjs-progress-control{height:1.5em;top:-1.5em}.vjs-bumper-video .vjs-play-progress.vjs-play-progress-resetting{transition:width 0s linear}.vjs-bumper-video .vjs-dock-text{display:none}body{background:#fafafa}', FT = ".tiles[data-v-fe5251f8]{font-family:myriad-pro,Helvetica,Arial,sans-serif;display:flex;flex-direction:column;gap:5rem;padding:1.5rem 1.5rem 12rem;margin:auto;width:100%;align-items:center;scroll-behavior:smooth;box-sizing:border-box;transition:all .3s ease-in-out}.refresh-indicator[data-v-fe5251f8]{position:fixed;background:#0073efb9;backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);z-index:100;left:50%;transform:translate(-50%,-1rem);transition:all .3s ease-in-out;border-radius:2rem;box-sizing:border-box;padding:.5rem 1rem;box-shadow:0 20px 25px -5px #1f4cff1a,0 8px 10px -6px #0051ff1a;opacity:0;visibility:hidden}.refresh-indicator.show[data-v-fe5251f8]{opacity:1;visibility:visible;transform:translate(-50%)}@media screen and (max-width: 600px){.tiles[data-v-fe5251f8]{padding:.75rem}}.homepage-tile-wrapper[data-v-fe5251f8]{opacity:1;visibility:visible}.homepage-tile-wrapper.first-load[data-v-fe5251f8]{opacity:1;visibility:hidden;height:0}.skeleton-tiles[data-v-fe5251f8],.animation-tiles[data-v-fe5251f8]{display:flex;flex-direction:column;gap:1rem;padding:1.5rem;margin:auto;width:100%;scroll-behavior:smooth;box-sizing:border-box;justify-content:center;align-items:center}", wm = /* @__PURE__ */ ae($T, [["styles", [DT, FT]], ["__scopeId", "data-v-fe5251f8"]]), UT = Symbol("editionId"), Yi = (e) => e && typeof e == "object" && !Array.isArray(e), Us = (e, ...t) => {
  if (!t.length) return e;
  const n = t.shift();
  if (Yi(e) && Yi(n))
    for (const r in n)
      Yi(n[r]) ? (e[r] || Object.assign(e, { [r]: {} }), Us(e[r], n[r])) : Object.assign(e, { [r]: n[r] });
  return Us(e, ...t);
}, VT = Us(
  {},
  { de: {
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["Schließen Sie diesen Schritt in Ihrer Lernreise ab"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Ihr Programm hat gestartet: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["Machen Sie weiter Fortschritte in Ihrem Programm"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["Erkunden Sie bedarfsgerechte Ressourcen"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["Community-Ankündigung"]);
    },
    "homepage-tile-description": {
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(['"Du hast diesen Lernweg abgeschlossen, ', n(r("name")), '. Ein Abschlusszertifikat ist nun in <link>deinem Profil</link> sichtbar."']);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Diese Lernreise, ", n(r("title")), ", endet mit ", n(r("daysRemaining")), " auf ", n(r("endDate")), ". Beenden Sie die letzten Schritte."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Diese Learner Journey ", n(r("title")), " ist beendet."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["Sie wurden eingeladen, an dieser Learner Journey teilzunehmen. Sie können jederzeit <link>alle Schritte</link> in dieser Journey ansehen."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["Entdecken Sie alle Learner Journeys, die Ihnen zur Verfügung stehen."]);
        }
      },
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Die Community ermöglicht es jedem, Ideen, Inhalte und Fachwissen auszutauschen, Talente und Erfolge zu präsentieren, Fragen zu stellen und praktische Hilfe von Gleichgesinnten und Experten zu erhalten."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Wir haben für Sie die aktivsten Diskussionen des Tages aus der gesamten Community zusammengestellt. Sie können auch die neuesten Beiträge auf der <link>Community-Seite</link> einsehen."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Ressourcen sind häppchengroße Lerninhalte, auf die Sie jederzeit zugreifen können. Sie umfassen Tools und Frameworks, die Sie in wenigen Minuten verdauen und anwenden können."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Hier sind die heute am meisten gelesenen und am häufigsten diskutierten Ressourcen. Sie können auch alle unsere häppchengroße Lerninhalte in der <link>Ressourcenbibliothek</link> durchsuchen."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["Learner Journeys sind kuratierte Führer zu unseren Lernerfahrungen. Sie kombinieren zeitgebundene Programme mit On-Demand-Ressourcen zu den wichtigsten Themen von heute."]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["Stöbern Sie in unserer Programmbibliothek, melden Sie sich für kommende Veranstaltungen an oder suchen Sie nach Programmen, an denen Sie teilnehmen können. Sobald Sie angefangen haben, können Sie Ihr Team kennenlernen, in der Rangliste aufsteigen und sich Ihr Abschlusszertifikat verdienen."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["Dies ist für die Journey Step Community. Dies ist für die Journey Step Community."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["Es gibt neue Kommentare in einer Diskussion, an der Sie teilgenommen haben. Werfen Sie einen Blick darauf und beteiligen Sie sich an der Unterhaltung."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Zur Erinnerung: Das Programm wird in ", n(r("daysRemaining")), " abgeschlossen und die durchschnittliche Fertigstellung Ihres Teams beträgt ", n(r("teamProgress")), "%."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["Sehen Sie sich die neuesten Aktivitäten Ihres Teams an und steigen Sie wieder in das Gespräch ein."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Nehmen Sie noch heute an einem Live-Webinar teil. Wir werden über die Zukunft der hybriden Arbeit diskutieren. Wir planen auch eine Q&A-Sitzung am Ende des Webinars. <br /><br /><strong>Datum:</strong> ", n(r("date")), " <br /><strong>Zeit:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["Verbinden Sie sich mit der globalen Nomadic-Community und teilen Sie mit, was Sie bisher über hybride Arbeit gelernt haben und wohin sie sich Ihrer Meinung nach entwickeln wird."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["Diese Ressource ist heute vorhanden. Sie können jederzeit <link>alle Schritte</link> in dieser Ressource ansehen."]);
        }
      }
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(['"An Reise teilnehmen" or "Reise mitmachen"']);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["Reise starten"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["Ressource teilen"]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["Sei der Erste, der einen Kommentar hinterlässt und reagiert."]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["Lernreise-Update"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["und andere"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["Du"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["Du und"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["Umfrageergebnisse"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["Zur Umfragefrage"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " Punkt"]), t([n(r("count")), " Punkte"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Anmelden für ", n(r("name")), " Sitzung"]);
    },
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["Ausstehende Benutzer"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["Suchen"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["Geben Sie eine E-Mail-Adresse ein ..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["Suche nach einem Benutzer anhand der E-Mail-Adresse"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["Eine Einladung wurde an die folgenden E-Mail-Adressen verschickt. Wenn sie sich erfolgreich registrieren, erhalten sie eine Lizenz. Sie können die Einladung erneut senden, sie stornieren oder ihnen ein ", n(r(0)), " schicken."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["Abonnement-Beitrittslink"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["Namen und E-Mail anonymisieren"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["RSC-Kommentare löschen"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["Community-Beiträge löschen"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["Erwähnungen anonymisieren"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["Profilfelder löschen"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["RSC-Reflexionen löschen"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["Community-Kommentare löschen"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["Profilfeld beibehalten"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["FM-Kommentare löschen"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["FM private Notizen löschen"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["Programmunterhaltungen löschen"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["Benutzer"]), t(["Benutzer"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["war"]), t(["waren"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["Zeile: ", n(r("rowList"))]), t(["Zeilen: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["Datei erfolgreich hochgeladen, eine gültige Zeile entdeckt"]), t(["Datei erfolgreich hochgeladen, ", n(r("n")), " gültige Zeilen entdeckt"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["Upload-Fehler."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Struktur der Datei: 1 Spalte muss in der Kopfzeile „E-Mail“ enthalten"]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Struktur der Datei: 1 Spalte muss in der Kopfzeile „E-Mail“ enthalten. Die Spalte „SSO-ID“ kann optional angegeben werden."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["Hochgeladene Datei fehlt"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["Datei nicht im .xlsx-Format"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["Die Datei enthält keine Spalte mit „E-Mail“ in der Überschrift"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["Es wurden keine Benutzer in der hochgeladenen Datei gefunden"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["Ein oder mehrere Benutzer sind bereits mit SSO verbunden"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["Eine oder mehrere Zeilen enthalten ungültige E-Mail-Adressen"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["Eine oder mehrere Zeilen enthalten ungültige SSO-IDs"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["Eine oder mehrere Zeilen enthalten keine E-Mail-Adresse"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["Ein oder mehrere Benutzer haben mehrere SSO-Anbieter"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["Ein oder mehrere Benutzer haben keine SSO-ID"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["Ein oder mehrere Benutzer haben keinen SSO-Anbieter"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["Eine oder mehrere E-Mail-Adressen stimmen nicht mit einem bestehenden Benutzer überein"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["Ressourcen"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["Programme"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["Einsatzleitfäden"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["Learner Journeys"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["Schritte der Learner Journey"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["Kopieren Sie alle Programme (und ihre Tags und Typen)"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["Kopieren Sie den Namen der Programmüberschrift (z. B. Power Skills in Nomadic Academy)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["Tags vom Typ Ressourcenbibliothek kopieren"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["Kopieren Sie alle Ressourcen und Themen-Tags"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["Community-Tags kopieren"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["Profil"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["Admin-Dashboard"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["Zurück zu Academy"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Mindestabmessungen des Bildes: ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Maximalabmessungen des Bildes: ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " verbleibender Tag"]), t([n(r("n")), " verbleibende Tage"])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " Tag"]), t([n(r("n")), " Tage"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["weniger als ein Tag"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " noch zu erledigender Tag ", n(r("name"))]), t([n(r("n")), " noch zu erledigende Tage ", n(r("name"))])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["Ihr Programm beginnt bald"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["Beginn heute"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["Programm-Update"]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Sie sind zu einer Learner Journey eingeladen: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Diese Learner Journey ist bald zu Ende: ", n(r("name")), " "]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Herzlichen Glückwunsch! Sie haben diese Journey abgeschlossen, ", n(r("name"))]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["Schließen Sie den nächsten Schritt in Ihrer Journey ab"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["Ihr nächster Schritt auf Ihrer Journey: Für dieses Programm anmelden"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " ist beendet"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " endet bald"]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Sie haben Ihr Programm abgeschlossen: ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Sie haben sich in ", n(r("name")), " (", n(r("date")), ") eingeschrieben"]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Ihr Programm hat begonnen: ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Sie wurden zu einem neuen Programm hinzugefügt: ", n(r("name"))]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Melden Sie sich für die nächste Sitzung von ", n(r("name")), " an"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["Finden Sie ein Programm für Sie"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Erkunden Sie Learner Journeys"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["Werden Sie Mitglied der Community"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["Findet gerade statt in der Community"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Hier ist ein unvollständiger Schritt aus Ihrer aktiven Learner Journey. Sie können auch <link>alle Schritte</link> in dieser Journey ansehen."]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Der Abschluss dieses Programms ist ein Schritt auf Ihrer Learner Journey. Sie können jederzeit <link>alle Schritte</link> in dieser Journey ansehen."]);
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["Anfangen"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["Programm überprüfen"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["Journey Details"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["Die Journey fortsetzen"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["Anmelden"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["Programm starten"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["Programm öffnen"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["Programm fortsetzen"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["Eingeschrieben"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["Programmdetails"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["Als abgeschlossen markieren"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["Mich später erinnern"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["Webinar starten"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["Alle Programme erkunden"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Erkunden Sie alle Learner Journeys"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["Ressourcenbibliothek"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["Community aufrufen"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["Community beitreten"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["hat bereits begonnen."]), t(["haben bereits begonnen."])]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["hat ", n(r("name")), " abgeschlossen."]), t(["hat ", n(r("name")), " abgeschlossen."])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["eingeschrieben in ", n(r("name")), "."]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["wurden eingeladen, an dieser Learner Journey teilzunehmen"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Diese Learner Journey ist bald zu Ende", n(r("name")), " "]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["haben diese Learner Journey abgeschlossen"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["hat begonnen mit ", n(r("name"))]), t(["haben begonnen mit ", n(r("name")), "."])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["macht Fortschritte in dieser Learner Journey"]), t(["macht Fortschritte in dieser Learner Journey"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["haben begonnen am ", n(r("name")), "."]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["haben sich in ", n(r("name")), " eingeschrieben."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["haben ", n(r("name")), " abgeschlossen."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["hat den Schritt abgeschlossen."]), t(["haben den Schritt abgeschlossen."])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["in der Community gepostet hat"]), t(["in der Community gepostet haben."])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Findet jetzt statt in ", n(r("name"))]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["haben gerade das Programm abgeschlossen und ihre Zertifikate erhalten."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["haben sich in ", n(r("name")), " eingeschrieben"]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["aus Ihrem Team hat bereits begonnen."]), t(["aus Ihrem Team haben bereits begonnen."])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["wurde zu einem neuen Programm hinzugefügt: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["haben diese Umfrage in ", n(r("name")), " beantwortet"]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['haben dieses Video gesehen - <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["haben diesen Abschnitt gelesen"]);
      }
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["Findet gerade statt in Ressourcen"]);
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["Findet gerade statt"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["Bestenliste"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["Ihr Team nimmt an einer Diskussion in diesem Programm teil. Werfen Sie einen Blick darauf und tragen Sie Ihre Gedanken zur Diskussion bei. "]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["Ihr Team ist an mehreren Diskussionen in diesem Programm beteiligt. Werfen Sie einen Blick darauf und tragen Sie Ihre Gedanken zur Diskussion bei."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["Ihr Team macht Fortschritte und sammelt Punkte. Hier ist die aktuelle Spitze der Programm-Rangliste. Haben Sie die Top 10 geknackt? Überprüfen Sie die Rangliste, um Ihre aktuelle Position zu sehen."]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["Lesen Sie dort weiter, wo Sie aufgehört haben."]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["Der nächste Abschnitt, den Sie in Ihrem Programm ausfüllen müssen, ist eine Umfrage."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["Hier sehen Sie, wie der durchschnittliche Fortschritt Ihres Teams im Vergleich zu Ihrem Fortschritt aussieht."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Das Programm beginnt heute um ", n(r("time")), "."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Das Programm beginnt heute um ", n(r("days")), "."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Das Programm endet heute um ", n(r("time")), "."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Das Programm endet heute um ", n(r("days")), "."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["Das Programm hat heute begonnen."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Das Programm hat vor ", n(r("days")), " Tagen begonnen."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t([" Wir werden Ihnen eine E-Mail senden, wenn es losgeht."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), " % abgeschlossen"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " von ", n(r("maxSteps")), " Schritten abgeschlossen"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " von ", n(r("required")), " Community-Posten abgeschlossen"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["Programm geschlossen"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " Kommentar"]), t([n(r("count")), " Kommentare"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " Reaktion"]), t([n(r("count")), " Reaktionen"])]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["Ihr Fortschritt"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["Team-Durchschnitt"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% abgeschlossen"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["Mehr erfahren"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["Jetzt starten"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " von ", n(r(1)), " Ressourcen abgeschlossen"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["Alle Schritte der Journey anzeigen"]);
    }
  } },
  { en: {
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["pending  users"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["search"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["Enter an email address..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["Search for a user by email address"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["An invitation has been sent to the following email addresses. When they successfully register they will consume a license. You can resend their invite, cancel it, or send them a ", n(r(0)), "."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["subscription join link"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["Anonymize names and email"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["Delete RSC comments"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["Delete community posts"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["Anonymize mentions"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["Delete profile fields"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["Delete RSC reflections"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["Delete community comments"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["Preserve profile field"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["Delete FM comments"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["Delete FM private notes"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["Delete program conversations"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["user"]), t(["users"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["was"]), t(["were"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["row: ", n(r("rowList"))]), t(["rows: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["File uploaded successfully, one valid row detected"]), t(["File uploaded successfully, ", n(r("n")), " valid rows detected"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["Upload error."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["File structure: 1 column must have “Email” in the header"]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["File structure: 1 column must have “Email” in the header. Optional “SSO ID” column may be provided."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["Uploaded file missing"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["File not .xlsx format"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["File doesn’t contain a column with ‘email’ in the header"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["No users were found in the uploaded file"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["One or more users are already connected to SSO"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["One or more rows contain invalid email addresses"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["One or more rows contain invalid SSO IDs"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["One or more rows doesn’t contain an email address"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["One or more users have multiple SSO providers"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["One or more users do not have an SSO ID"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["One or more users do not have an SSO provider"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["One or more email addresses doesn’t match an existing user"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["Resources"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["Programs"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["Field Manuals"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["Learner Journeys"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["Learner Journey Steps"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["Copy all Programs (and their tags and types)"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["Copy Program tag heading name (e.g. Power Skills in Nomadic Academy)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["Copy Resource Library type tags"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["Copy all Resources and topic tags"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["Copy Community tags"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["Profile"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["Admin Dashboard"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["Back to Academy"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Minimum image dimensions: ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Maximum image dimensions: ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " day remaining"]), t([n(r("n")), " days remaining"])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["today"]), t(["in ", n(r("n")), " day"]), t(["in ", n(r("n")), " days"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["less than a day"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " day left to complete ", n(r("name"))]), t([n(r("n")), " days left to complete ", n(r("name"))])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["Your Program is starting soon"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["Program Update"]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["Complete the next step in your Journey"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["Coming up in your Journey: Enroll in this Program"]);
    },
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["Complete this step in your Journey"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " has ended"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " is ending soon"]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Enroll for the next session of ", n(r("name"))]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["You're invited to a Learner Journey: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["This Learner Journey is ending soon: ", n(r("name")), " "]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Congratulations! You Completed this Journey, ", n(r("name"))]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["You Completed your Program: ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["You've enrolled in ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Your Program has started: ", n(r("name"))]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Your Program has started: ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["You've been added to a new Program: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["Keep making progress in your Program"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["Explore on-demand Resources"]);
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["Happening now in Resources"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["Find a Program for you"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Explore Learner Journeys"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["Happening now in Community"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["Join the Community"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["Community Announcement"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Here’s an incomplete step from your active Learner Journey. You can also <link>view all steps</link> in this Journey."]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Completing this Program is a step in your Learner Journey. You can always <link>view all steps</link> in this Journey."]);
    },
    "homepage-tile-description": {
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Community allows everyone to share ideas, content and expertise; showcase talents and achievements; ask questions; and get practical help from peers and experts."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["We’ve rounded up the day’s most active discussions from across Community. You can also browse all the latest posts on the <link>Community page</link>."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Resources are bite-sized pieces of learning you can access any time. They cover tools and frameworks you can digest and apply in minutes."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Here are today’s most read and discussed Resources. You can also browse all of our bite-size learning in the <link>Resource Library</link>."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["Learner Journeys are curated guides to our learning experiences. They group time-bound Programs with on-demand Resources about today’s most critical topics."]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["Explore our library of Programs, enroll in upcoming sessions, or find Programs that are ready to join. Once you start, you can get to know your team, climb the leaderboard, and earn your completion certificate."]);
        }
      },
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["You’ve completed this learner journey, ", n(r("name")), ". A record of completion is now visible in <link>your profile</link>."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["This Learner Journey, ", n(r("title")), ", ends ", n(r("in_x_days")), ". Finish up the last few steps."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["This Learner Journey, ", n(r("title")), " has ended."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["You’ve been invited to participate in this Learner Journey. You can always <link>view all steps</link> in this Journey."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["Explore all the Learner Journeys available to you."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["This is for journey step community. This is for journey step community."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["There are some new comments in a discussion you’ve participated in. Take a look and jump in to the conversation."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["As a reminder, the Program closes in ", n(r("daysRemaining")), " and your team’s average completion is ", n(r("teamProgress")), "%."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["Take a look at the latest activity from your team and jump back into the conversation."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Join us for a live webinar today. We will be discussing the future of hybrid work. We also plan to have a Q&A session at the end of the webinar. <br /><br /><strong>Date:</strong> ", n(r("date")), " <br /><strong>Time:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["Connect with the global Nomadic community and share what you’ve learned so far about hybrid work and where you think its going."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["This Resource is happening today. You can always <link>view all steps</link> in this Resource."]);
        }
      }
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["Get started"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["Continue Program"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["Start Program"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["Review Program"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["Program Details"]);
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["Join Journey"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["Journey Details"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["Continue Journey"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["Start Journey"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["Launch Webinar"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["Open Community"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["Share Resource"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["Remind me later"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["Explore All Programs"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Explore all Learner Journeys"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["Resource Library"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["Join Community"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["Enroll"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["Open Program"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["Enrolled"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["Mark as Complete"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["has already gotten started."]), t(["have already gotten started."])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["enrolled in ", n(r("name")), "."]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["has completed ", n(r("name")), "."]), t(["have completed ", n(r("name")), "."])]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["have been invited to participate in this Learner Journey"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["This Learner Journey is ending soon", n(r("name")), " "]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["have finished this Learner Journey"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["has started ", n(r("name"))]), t(["have started ", n(r("name")), "."])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["is making progress in this Learner Journey"]), t(["are making progress in this Learner Journey"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["have started ", n(r("name")), "."]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["have enrolled in ", n(r("name")), "."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["have completed ", n(r("name")), "."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["has completed the step."]), t(["have completed the step."])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["has posted in the community"]), t(["have posted in the community."])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Happening now in ", n(r("name"))]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["have just finished the Program and gotten their certificates."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["have enrolled in ", n(r("name"))]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["from your team has already gotten started."]), t(["from your team have already gotten started."])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["has been added to a new Program: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["have answered this poll question in ", n(r("name"))]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['have watched this video - <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["have read this section"]);
      }
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["Happening now"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["Leaderboard"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["Your team is commenting in a discussion in this Program. Take a look and add your thoughts to the conversation. "]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["Your team is active in several discussions in this Program. Take a look and add your thoughts to the conversation."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["Your team is making progress and earning points. Here’s the current top of Program Leaderboard. Have you cracked the top 10? Check the Leaderboard to see your current position."]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["Continue reading from your last stopping point."]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["The next section to complete in your Program is a poll."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["Here’s how your team’s average progress compares to yours."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program starts today at ", n(r("time")), "."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program starts in ", n(r("days")), " days."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program ends today at ", n(r("time")), "."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program ends in ", n(r("days")), " days."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["Program started today."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program started ", n(r("days")), " days ago."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t([" We'll send you a reminder email when it's set to begin."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), "% Complete"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " of ", n(r("maxSteps")), " steps complete"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " of ", n(r("required")), " Community posts complete"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["Program closed"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " comment"]), t([n(r("count")), " comments"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " reaction"]), t([n(r("count")), " reactions"])]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["Be the first to comment and react"]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["Your Progress"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["Team Average"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% Complete"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["Learn More"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["Start Now"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " of ", n(r(1)), " resources completed"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["View all Journey Steps"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["Start Today"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["Journey Update"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["and others"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["You"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["You and"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["Poll Results"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["Go to poll question:"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " point"]), t([n(r("count")), " points"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Enroll in ", n(r("name")), " session"]);
    }
  } },
  { es: {
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["Complete este paso en su Viaje"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Su Programa ha comenzado: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["Siga avanzando en su Programa"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["Explora Recursos a Demanda"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["Anuncio de la Comunidad"]);
    },
    "homepage-tile-description": {
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Ha completado este viaje de aprendizaje, ", n(r("name")), ". Un registro de finalización ahora es visible en <link>su perfil</link>."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["El recorrido de aprendizaje ", n(r("title")), " termina en ", n(r("daysRemaining")), " el ", n(r("endDate")), ". Finalice los últimos pasos."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Este recorrido de aprendizaje ", n(r("title")), " ya finalizó."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["Ha sido invitado a participar en este recorrido de aprendizaje. Siempre puede <link>ver todos los pasos</link> de este recorrido."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["Explore todos los recorridos de aprendizaje disponibles para usted."]);
        }
      },
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["La comunidad permite a todos compartir ideas, contenido y experiencia; mostrar talentos y logros; hacer preguntas; y obtener ayuda práctica de compañeros y expertos."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Reunimos los debates más activos del día de toda la comunidad. También puede explorar todas las publicaciones más recientes en la <link>página de la Comunidad</link>."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Los recursos son pequeñas unidades de aprendizaje a las que puede acceder en cualquier momento. Cubren herramientas y marcos que puede asimilar y aplicar en minutos."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Estos son los recursos más leídos y analizados de hoy. También puede explorar todas las pequeñas unidades de aprendizaje en la <link>biblioteca de recursos</link>."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["Los recorridos de aprendizaje son guías seleccionadas para nuestras experiencias de aprendizaje. Agrupan programas de tiempo limitado con recursos a pedido sobre los temas actuales más críticos."]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["Explore nuestra biblioteca de programas, inscríbase en las próximas sesiones o encuentre programas ya listos a los que puede unirse. Una vez que comience, puede conocer a su equipo, subir en la tabla de clasificación y obtener su certificado de finalización."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["Esto es para los pasos de recorrido de la comunidad. Esto es para los pasos de recorrido de la comunidad."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["Hay algunos comentarios nuevos en una conversación en la que usted participó. Eche un vistazo y comience la conversación."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Le recordamos que el programa se cierra el ", n(r("daysRemaining")), " y la finalización promedio de su equipo es del ", n(r("teamProgress")), " %."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["Eche un vistazo a la última actividad de su equipo y vuelva a la conversación."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Acompáñenos en un seminario web en vivo hoy mismo. Analizaremos el futuro del trabajo híbrido. También planeamos tener una sesión de preguntas y respuestas al final del seminario web. <br /><br /><strong>Fecha:</strong> ", n(r("date")), " <br /><strong>Hora:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["Conéctese con la comunidad global de Nomadic y comparta lo que ha aprendido hasta ahora sobre el trabajo híbrido y qué cree que pasará con este."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["Este recurso ocurre ahora mismo. Siempre puede <link>ver todos los pasos</link> de este recurso."]);
        }
      }
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(['"Únase al Viaje"']);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["Inicie Viaje"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["Compartir Recurso"]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["Sea el primero en comentar y reaccionar"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["Actualización del Viaje"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["y otros"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["Usted"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(['"Tú y"']);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["Resultados de la Encuesta"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["Ir a la pregunta de la encuesta"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " punto"]), t([n(r("count")), " puntos"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Inscribirse en la sesión de ", n(r("name"))]);
    },
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["usuarios pendientes"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["buscar"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["Ingresar una dirección de correo electrónico..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["Buscar un usuario por dirección de correo electrónico"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["Se envió una invitación a las siguientes direcciones de correo electrónico. Cuando se registren correctamente, consumirán una licencia. Puede reenviar la invitación, cancelarla o enviarle un ", n(r(0)), "."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["enlace de suscripción"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["Anonimizar nombres y el correo electrónico"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar comentarios del RSC"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar publicaciones de la comunidad"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["Anonimizar menciones"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar campos de perfil"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar reflexiones del RSC"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar comentarios de la comunidad"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["Conservar campo de perfil"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar comentarios del FM"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar notas privadas del FM"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["Eliminar conversaciones del programa"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["usuario"]), t(["usuarios"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["era"]), t(["eran"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["fila: ", n(r("rowList"))]), t(["filas: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["El archivo se cargó correctamente, se detectó una fila válida"]), t(["El archivo se cargó correctamente, se detectaron ", n(r("n")), " filas válidas"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["Error al cargar."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Estructura del archivo: 1 columna debe tener “Correo electrónico” en el encabezado"]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Estructura del archivo: 1 columna debe tener “Correo electrónico” en el encabezado. Se puede proporcionar la columna opcional de “ID de SSO”."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["Falta el archivo cargado"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["El archivo no está en formato .xlsx"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["El archivo no contiene una columna con “correo electrónico” en el encabezado"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["No se encontraron usuarios en el archivo cargado"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["Uno o más usuarios ya están conectados al SSO"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["Una o más filas contienen direcciones de correo electrónico no válidas"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["Una o más filas contienen ID de SSO no válidas"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["Una o más filas no contienen una dirección de correo electrónico"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["Uno o más usuarios tienen múltiples proveedores de SSO"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["Uno o más usuarios no tienen una ID de SSO"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["Uno o más usuarios no tienen un proveedor de SSO"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["Una o más direcciones de correo electrónico no coinciden con un usuario existente"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["Recursos"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["Programas"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["Manuales de campo"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["Recorridos de aprendizaje"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["Pasos del recorrido de aprendizaje"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["Copiar todos los programas (y sus etiquetas y tipos)"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["Copiar el nombre del encabezado de la etiqueta del programa (por ejemplo, power skills en Nomadic Academy)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["Copiar etiquetas de tipo de la biblioteca de recursos"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["Copiar todos los recursos y etiquetas de tema"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["Copiar etiquetas de comunidad"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["Perfil"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["Panel de administrador"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["Volver a la Academia"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Dimensiones mínimas de la imagen: ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Dimensiones máximas de la imagen: ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " día restante"]), t([n(r("n")), " días restantes"])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " día"]), t([n(r("n")), " días"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["menos de un día"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " día restante para completar ", n(r("name"))]), t([n(r("n")), " días restantes para completar ", n(r("name"))])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["Su programa comenzará pronto"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["Comenzar hoy mismo"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["Actualización del programa"]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Lo invitamos a un recorrido de aprendizaje: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Este recorrido de aprendizaje finalizará pronto: ", n(r("name")), " "]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["¡Felicitaciones! Completó este recorrido, ", n(r("name"))]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["Complete el siguiente paso en su recorrido"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["Próximamente en su recorrido: inscribirse en este programa"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " finalizó"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " finalizará pronto"]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Completó su programa: ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Se inscribió en ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Su programa ya comenzó: ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Ha sido agregado a un nuevo programa: ", n(r("name"))]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Inscríbase en la próxima sesión de ", n(r("name"))]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["Encontrar un programa para usted"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Explorar el recorrido de aprendizaje"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["Unirse a la comunidad"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["Lo que ocurre ahora en la comunidad"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Este es un paso incompleto de su recorrido de aprendizaje activo. También puede <link>ver todos los pasos</link> de este recorrido."]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Completar este programa es un paso en su recorrido de aprendizaje. Siempre puede <link>ver todos los pasos</link> de este recorrido."]);
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["Comenzar"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["Repasar el programa"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["Detalles del recorrido"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["Continuar el recorrido"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["Inscribirse"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["Iniciar el programa"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["Programa abierto"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["Continuar con el programa"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["Inscrito"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["Detalles del programa"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["Marcar como completado"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["Recordarme más tarde"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["Iniciar seminario web"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["Explorar todos los programas"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Explorar todos los recorridos de aprendizaje"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["Biblioteca de recursos"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["Comunidad abierta"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["Unirse a la comunidad"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["ya comenzó."]), t(["ya comenzaron."])]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["completó ", n(r("name")), "."]), t(["completaron ", n(r("name")), "."])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["inscrito en ", n(r("name")), "."]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["han sido invitados a participar en este recorrido de aprendizaje"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Este recorrido de aprendizaje finalizará pronto", n(r("name")), " "]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["terminó este recorrido de aprendizaje"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["comenzó ", n(r("name"))]), t(["comenzaron ", n(r("name")), "."])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["está progresando en este recorrido de aprendizaje"]), t(["están progresando en este recorrido de aprendizaje"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["comenzaron ", n(r("name")), "."]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["se inscribieron en ", n(r("name")), "."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["completaron ", n(r("name")), "."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["completó el paso."]), t(["completaron el paso."])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["publicó en la comunidad"]), t(["publicaron en la comunidad."])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Lo que ocurre ahora en ", n(r("name"))]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["acaban de terminar el programa y de obtener sus certificados."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["se inscribieron en ", n(r("name"))]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["de su equipo ya comenzó."]), t(["de su equipo ya comenzaron."])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["se agregó a un nuevo programa: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["han respondió esta pregunta de la encuesta en ", n(r("name"))]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['vieron este video: <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["leyeron esta sección"]);
      }
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["Lo que ocurre ahora en recursos"]);
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["Lo que ocurre ahora"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["Tabla de puntuaciones"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["Su equipo está comentando en un debate en este programa. Eche un vistazo y aporte su opinión a la conversación. "]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["Su equipo está activo en varias discusiones en este programa. Eche un vistazo y aporte su opinión a la conversación."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["Su equipo está progresando y ganando puntos. Esta es la parte superior actual de la tabla de clasificación del programa. ¿Está entre los diez primeros? Revise la tabla de clasificación para ver su posición actual."]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["Continúe leyendo desde su última interrupción."]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["La siguiente sección que debe completar en su programa es una encuesta."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["Así es como el progreso promedio de su equipo se compara con el suyo."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["El programa comienza hoy a las ", n(r("time")), "."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["El programa comienza en ", n(r("days")), " días."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["El programa finaliza hoy a las ", n(r("time")), "."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["El programa finaliza en ", n(r("days")), " días."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["El programa comenzó hoy."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["El programa comenzó hace ", n(r("days")), " días."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t([" Le enviaremos un correo electrónico recordatorio cuando esté listo para comenzar."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), " % completado"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " de ", n(r("maxSteps")), " pasos completados"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " de ", n(r("required")), " publicaciones de la comunidad completadas"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["Programa cerrado"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " comentario"]), t([n(r("count")), " comentarios"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " reacción"]), t([n(r("count")), " reacciones"])]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["Su progreso"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["Promedio del equipo"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " % completado"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["Más información"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["Comenzar ahora"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " de ", n(r(1)), " recursos completados"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["Ver todos los pasos del recorrido"]);
    }
  } },
  { fr: {
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["Complétez cette étape de votre parcours"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Votre Programme a commencé : ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["Continue à progresser dans votre Programme"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["Explorez les Ressources à la demande"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["Annonce de la Communauté"]);
    },
    "homepage-tile-description": {
      journey: {
        completed: (e) => {
          const { normalize: t } = e;
          return t(["Une attestation d'achèvement est maintenant visible dans <link>votre profil</link>."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Ce Parcours de l’apprenant, ", n(r("title")), ", se termine à ", n(r("daysRemaining")), " le ", n(r("endDate")), ". Terminez les dernières étapes."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Ce Parcours de l’apprenant ", n(r("title")), " est terminé."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["Vous avez été invité à participer à ce Parcours de l’apprenant. Vous pouvez toujours <link>voir toutes les étapes</link> de ce parcours."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["Explorez tous les Parcours de l’apprenant auxquels vous avez accès."]);
        }
      },
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["La communauté permet à chacun de partager des idées, du contenu et son expertise, de présenter ses talents et réussites, de poser des questions et d’obtenir une aide pratique de la part de pairs et d’experts."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Nous avons rassemblé les discussions les plus suivies de la journée dans la communauté. Vous pouvez également parcourir toutes les dernières publications sur la page <link>Communauté </link>."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Les ressources sont des granules pédagogiques auxquelles vous pouvez accéder à tout moment. Elles incluent les outils et cadres que vous pouvez maîtriser et appliquer en quelques minutes."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Voici les ressources les plus lues et discutées aujourd’hui. Vous pouvez également parcourir toutes nos granules pédagogiques dans la <link>bibliothèque de ressources</link>."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["Les Parcours de l’apprenant sont des guides organisés pour nos expériences d’apprentissage. Ils regroupent des programmes limités dans le temps avec des ressources à la demande sur les sujets les plus critiques d’aujourd’hui."]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["Explorez notre bibliothèque de programmes, inscrivez-vous aux prochaines sessions ou trouvez des programmes accessibles dès maintenant. Une fois que vous avez commencé, vous pouvez faire connaissance avec votre équipe, grimper dans le classement et obtenir votre certificat d’achèvement."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["C’est pour l’étape du parcours communauté. C’est pour l’étape du parcours communauté."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["Une discussion à laquelle vous avez participé a reçu de nouveaux commentaires. Jetez un coup d’œil à la conversation."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Pour rappel, le programme se termine dans ", n(r("daysRemaining")), " et les membres de votre équipe ont terminé en moyenne ", n(r("teamProgress")), " % du programme."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["Jetez un coup d’œil à la dernière activité de votre équipe et revenez à la conversation."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Rejoignez-nous dès aujourd’hui pour un webinaire en direct. Nous discuterons de l’avenir du travail hybride. Nous avons également prévu une session de questions-réponses à la fin du webinaire. <br /><br /><strong>Date :</strong> ", n(r("date")), " <br /><strong>Heure :</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["Connectez-vous à la communauté mondiale Nomadic et partagez ce que vous avez appris jusqu’à présent sur le travail hybride et ce que vous pensez de son avenir."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["Cette ressource est accessible aujourd’hui. Vous pouvez toujours <link>voir toutes les étapes</link> dans cette ressource."]);
        }
      }
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["Rejoignez le Parcours"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["Commencer le Parcours"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["Partager la Ressource"]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["Soyez le premier à commenter et réagir"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["Mise à Jour du Parcours"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["et les autres"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["Vous"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["Vous et"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["Résultats du sondage"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["Aller à la question du sondage"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " point"]), t([n(r("count")), " points"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["S'inscrire à la session de ", n(r("name"))]);
    },
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["utilisateurs en attente"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["rechercher"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["Saisissez une adresse e-mail…"]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["Rechercher un utilisateur par adresse e-mail"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["Une invitation a été envoyée aux adresses e-mail suivantes. Une fois inscrits, ils consomment une licence. Vous pouvez renvoyer leur invitation, l’annuler ou leur envoyer un ", n(r(0)), "."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["lien pour rejoindre l’abonnement"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["Anonymiser les noms et les e-mails"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les commentaires RSC"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les publications de la communauté"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["Anonymiser les mentions"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les champs de profil"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les réflexions RSC"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les commentaires de la communauté"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["Conserver le champ de profil"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les commentaires FM"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les notes privées FM"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["Supprimer les conversations du programme"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["utilisateur"]), t(["utilisateurs"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["était"]), t(["étaient"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["ligne : ", n(r("rowList"))]), t(["lignes : ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["Fichier chargé avec succès, une ligne valide détectée"]), t(["Fichier chargé avec succès, ", n(r("n")), " lignes valides détectées"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["Erreur de chargement."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Structure du fichier : 1 colonne doit avoir « E-mail » dans l’en-tête"]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Structure du fichier : 1 colonne doit avoir « E-mail » dans l’en-tête. Une colonne « ID SSO » facultative peut être fournie."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["Fichier chargé manquant"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["Fichier non au format .xlsx"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["Le fichier ne contient pas de colonne avec « e-mail » dans l’en-tête"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["Aucun utilisateur n’a été trouvé dans le fichier chargé"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["Un ou plusieurs utilisateurs sont déjà connectés à SSO"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["Une ou plusieurs lignes contiennent des adresses e-mail non valides"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["Une ou plusieurs lignes contiennent des identifiants SSO non valides"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["Une ou plusieurs lignes ne contiennent pas d’adresse e-mail"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["Un ou plusieurs utilisateurs ont plusieurs fournisseurs SSO"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["Un ou plusieurs utilisateurs n’ont pas d’ID SSO"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["Un ou plusieurs utilisateurs n’ont pas de fournisseur SSO"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["Une ou plusieurs adresses e-mail ne correspondent pas à un utilisateur existant"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["Ressources"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["Programmes"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["Manuels de service"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["Parcours de l’apprenant"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["Étapes du Parcours de l’apprenant"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["Copier tous les programmes (et leurs balises et types)"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["Copier le nom de l’en-tête de la balise du programme (p. ex. Power Skills dans Nomadic Academy)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["Copier les balises de type de bibliothèque de ressources"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["Copier toutes les ressources et les balises de sujet"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["Copier les balises de la communauté"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["Profil"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["Tableau de bord admin"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["Retour à l’Académie"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Dimensions minimales de l’image : ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Dimensions maximales de l’image : ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " jour restant"]), t([n(r("n")), " jours restants"])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " jour"]), t([n(r("n")), " jours"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["moins d’un jour"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["il reste ", n(r("n")), " jour pour terminer ", n(r("name"))]), t(["il reste ", n(r("n")), " jours pour terminer ", n(r("name"))])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["Votre programme commence bientôt"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["Commencez dès aujourd’hui"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["Mise à jour du programme"]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Vous êtes invité à rejoindre un Parcours de l’apprenant : ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Ce Parcours de l’apprenant se termine bientôt : ", n(r("name")), " "]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Félicitations ! Vous avez terminé ce parcours, ", n(r("name"))]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["Passez à l’étape suivante de votre parcours"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["Prochainement dans votre parcours : S’inscrire à ce programme"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " est terminé"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " se termine bientôt"]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Vous avez terminé votre programme : ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Vous êtes inscrit à ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Votre programme a commencé : ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Vous avez été ajouté à un nouveau programme : ", n(r("name"))]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Inscrivez-vous à la prochaine session de ", n(r("name"))]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["Trouvez un programme pour vous"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Découvrez les Parcours de l’apprenant"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["Rejoindre la communauté"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["En ce moment dans la communauté"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Vous n’avez pas terminé cette étape de votre Parcours de l’apprenant actif. Vous pouvez également <link>voir toutes les étapes</link> de ce parcours."]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Ce programme est une étape de votre Parcours de l’apprenant. Vous pouvez toujours <link>voir toutes les étapes</link> de ce parcours."]);
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["Commencer"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["Revoir le programme"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["Détails du parcours"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["Poursuivre le parcours"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["S’inscrire"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["Démarrer le programme"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["Ouvrir le programme"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["Poursuivre le programme"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["Inscrit"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["Détails du programme"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["Marquer comme terminé"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["Me le rappeler plus tard"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["Lancer le webinaire"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["Découvrir tous les programmes"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Découvrir tous les Parcours de l’apprenant"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["Bibliothèque de ressources"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["Ouvrir la communauté"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["Rejoindre la communauté"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["a déjà commencé."]), t(["ont déjà commencé."])]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["a terminé ", n(r("name")), "."]), t(["ont terminé ", n(r("name")), "."])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["inscrit à ", n(r("name")), "."]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["ont été invités à participer à ce Parcours de l’apprenant"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Ce Parcours de l’apprenant se termine bientôt", n(r("name")), " "]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["ont terminé ce Parcours de l’apprenant"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["a commencé ", n(r("name"))]), t(["ont commencé ", n(r("name")), "."])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["avance dans ce parcours de l’apprenant"]), t(["avancent dans ce parcours de l’apprenant"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ont commencé ", n(r("name")), "."]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["se sont inscrits à ", n(r("name")), "."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ont terminé ", n(r("name")), "."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["a terminé l’étape."]), t(["ont terminé l’étape."])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["a publié dans la communauté"]), t(["ont publié dans la communauté."])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["En ce moment dans ", n(r("name"))]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["viennent de terminer le programme et d’obtenir leurs certificats."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["se sont inscrits à ", n(r("name"))]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["de votre équipe a déjà commencé."]), t(["de votre équipe ont déjà commencé."])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["a été ajouté à un nouveau programme : ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ont répondu à cette question dans ", n(r("name"))]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['ont regardé cette vidéo - <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["ont lu cette section"]);
      }
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["En ce moment dans les ressources"]);
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["En ce moment"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["Tableau de classement"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["Votre équipe participe à une discussion dans ce programme. Jetez-y un œil et participez à la conversation. "]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["Votre équipe participe activement à plusieurs discussions dans ce programme. Jetez-y un œil et participez à la conversation."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["Votre équipe avance et gagne des points. Voici le haut du classement du programme pour le moment. Êtes-vous dans les 10 premiers ? Consultez le classement pour voir votre position actuelle."]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["Reprenez votre lecture là où vous vous êtes arrêté la dernière fois."]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["La section suivante de votre programme est un sondage."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["Voici la progression moyenne de votre équipe par rapport à la vôtre."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Le programme commence aujourd’hui à ", n(r("time")), "."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Le programme commence dans ", n(r("days")), " jours."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Le programme se termine aujourd’hui à ", n(r("time")), "."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Le programme se termine dans ", n(r("days")), " jours."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["Le programme a commencé aujourd’hui."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Le programme a commencé il y a ", n(r("days")), " jours."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t([" Nous vous enverrons un e-mail de rappel lorsque le programme sera en passe de commencer."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), " % terminé"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " sur ", n(r("maxSteps")), " étapes terminées"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " sur ", n(r("required")), " des publications de la communauté terminées"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["Programme clos"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " commentaire"]), t([n(r("count")), " commentaires"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " réaction"]), t([n(r("count")), " réactions"])]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["Votre progression"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["Moyenne de l’équipe"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " % terminé"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["En savoir plus"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["Commencer maintenant"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " sur ", n(r(1)), " ressources terminées"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["Voir toutes les étapes du parcours"]);
    }
  } },
  { it: {
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["utenti in attesa"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["Cerca"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["Inserisci un indirizzo email..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["Cerca un utente tramite indirizzo email"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["È stato inviato un invito ai seguenti indirizzi email. Quando si registrano con successo consumeranno una licenza. Puoi inviare nuovamente il loro invito, annullarlo o inviare loro un ", n(r(0)), "."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["link per abbonarsi"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["Anonymizza nomi e email"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["Elimina i commenti RSC"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["Elimina i post della community"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["Anonymizza menzioni"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["Elimina campi del profilo"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["Elimina riflessioni RSC"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["Elimina i commenti della community"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["Conserva campo del profilo"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["Elimina commenti dei MO"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["Elimina note private MO"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["Elimina conversazioni del programma"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["utente"]), t(["utenti"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["era"]), t(["erano"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["REVISIONE: riga: ", n(r("rowList"))]), t(["righe: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["File caricato con successo, una riga valida rilevata"]), t(["File caricato con successo, ", n(r("n")), " righe valide rilevate"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["Errore durante il caricamento."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["La struttura del file: 1 colonna deve avere “Email” nell’intestazione."]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["La struttura del file: 1 colonna deve avere “Email” nell’intestazione. Una colonna opzionale “ID SSO” può essere fornita."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["File caricato mancante."]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["File non in formato .xlsx"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["Il file non contiene una colonna con ‘email’ nell’intestazione"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["Nessun utente trovato nel file caricato"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["Uno o più utenti sono già connessi a SSO"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["Una o più righe contengono indirizzi email non validi"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["Una o più righe contengono ID SSO non validi"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["Una o più righe non contengono un indirizzo email"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["Uno o più utenti hanno fornitori SSO multipli."]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["Uno o più utenti non hanno un ID SSO"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["Uno o più utenti non hanno un fornitore SSO"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["Uno o più indirizzi email non corrispondono a un utente esistente"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["Risorsa"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["Corsi"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["Manuali operativi"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["Percorsi di apprendimento"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["Fasi del Percorso di Apprendimento"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["Copia tutti i Corsi (e i loro tag e tipi)"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["Copia il nome del tag del corso (es. Competenze trasversali in Accademia Nomadica)."]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["Copia i tag dei tipi di libreria delle Risorse"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["Copia tutte le Risorse e i tag degli argomenti"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["Copia i tag della Community"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["Profilo"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["Cruscotto Amministratore"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["Ritorna all'Accademia"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Dimensioni minime dell'immagine: ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Massime dimensioni dell'immagine: ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " giorno rimanente"]), t([n(r("n")), " giorni rimanenti"])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["oggi"]), t(["tra ", n(r("n")), " giorno"]), t(["tra ", n(r("n")), " giorni"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["meno di un giorno"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(['"', n(r("n")), " giorno rimasto per completare ", n(r("name"))]), t([n(r("n")), " giorni rimasti per completare ", n(r("name")), '"'])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["Il tuo corso sta per iniziare"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["Aggiornamento del corso"]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["Completa il prossimo passo del tuo percorso di apprendimento"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["Prossima tappa del tuo percorso: Iscriviti a questo corso"]);
    },
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["Completa questa fase del tuo percorso"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(['"', n(r("name")), ' è finito"']);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " sta per finire"]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Iscriviti per la prossima lezione di ", n(r("name"))]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Sei invitato a un Percorso di Apprendimento: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Questo Percorso di Apprendimento sta per finire: ", n(r("name"))]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Congratulazioni! Hai completato questo Percorso, ", n(r("name"))]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Hai completato il tuo Corso: ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Ti sei iscritto/a a ", n(r("name")), " (", n(r("data")), ")"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Il tuo Corso è iniziato: ", n(r("name"))]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Il tuo Corso è iniziato: ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Sei stato aggiunto a un nuovo Corso: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["Continua a fare progressi nel tuo Corso"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["Esplora le Risorse su richiesta"]);
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["In corso nelle Risorse"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["Trova un Corso per te"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Esplora i Percorsi di Apprendimento"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["In corso ora nella Community"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["Unisciti alla Community"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["Annuncio alla Community"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Ecco una fase incompleta del tuo Percorso di Apprendimento attivo. Puoi anche <link>visualizzare tutte le fasi</link> di questo Percorso."]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(['"Completare questo Corso è una fase del tuo Percorso. Puoi sempre <link>visualizzare tutte le fasi</link> di questo Percorso."']);
    },
    "homepage-tile-description": {
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Community permette a tutti di condividere idee, contenuti e competenze; mostrare talenti e successi; fare domande e ottenere aiuto pratico da colleghi ed esperti."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Abbiamo raccolto le discussioni più attive della giornata dalla Community. Puoi anche sfogliare tutti i post più recenti nella <link>pagina della Community</link>."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Le risorse sono piccoli segmenti di apprendimento a cui puoi accedere in qualsiasi momento. Coprono strumenti e framework che puoi assimilare e applicare in pochi minuti."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Ecco le risorse più lette e discusse di oggi. Puoi anche sfogliare tutto il nostro apprendimento in pillole nella <link>libreria Risorse</link>."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(['"I percorsi di apprendimento sono guide curate delle nostre esperienze di apprendimento. Raggruppano Corsi con Risorse on-demand sui temi più critici di oggi."']);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["Esplora la nostra libreria di Corsi, iscriviti alle prossime lezioni o trova Corsi pronti per essere seguiti. Una volta iniziato, puoi conoscere il tuo team, scalare la classifica e ottenere il tuo certificato di completamento."]);
        }
      },
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Hai completato questo percorso formativo, ", n(r("name")), ". Un record di completamento è ora visibile nel <link>tuo profilo</link>."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Questo Percorso di Apprendimento, ", n(r("title")), ", termina tra ", n(r("in_x_days")), ". Completa gli ultimi passi."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Questo Percorso di Apprendimento, ", n(r("title")), ", è terminato."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["Sei stato invitato a partecipare a questo Percorso di Apprendimento. Puoi sempre <link>visualizzare tutte le fasi</link> di questo Percorso."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["Esplora tutti i Percorsi di Apprendimento a tua disposizione."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(['"Questo è per la fase del percorso Community. Questo è per la fase del percorso Community."']);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["Ci sono nuovi commenti in una discussione a cui hai partecipato. Dai un'occhiata e partecipa alla conversazione."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Come promemoria, il Corso chiude in ", n(r("daysRemaining")), " giorni e la media di completamento del tuo team è del ", n(r("teamProgress")), "%."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["Dai un'occhiata alle ultime attività del tuo Team e torna nella conversazione."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Unisciti a noi per un webinar dal vivo oggi. Discuteremo del futuro del lavoro ibrido. Prevediamo inoltre una sessione di domande e risposte al termine del webinar. <br /><br /><strong>Data:</strong> ", n(r("date")), " <br /><strong>Ora:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["Connettiti con la comunità globale dei Nomadi e condividi ciò che hai imparato finora sul lavoro ibrido e dove pensi che stia andando."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["Questa Risorsa si svolge oggi. Puoi sempre <link>vedere tutte le fasi</link> di questa Risorsa."]);
        }
      }
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["Iniziare"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["Continua Corso"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["Inizia Corso"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["Corso di Recensione"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["Dettagli del Corso"]);
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["Unisciti al Percorso"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["Dettagli del Percorso"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["Continua il Percorso"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["Inizia il Percorso"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["Lancia il Webinar"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["Comunità Aperta"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["Condividi Risorsa"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["Ricordamelo più tardi"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["Esplora Tutti i Corsi"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Esplora Tutti i Percorsi"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["Biblioteca Risorse"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["Entra nella Community"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["Iscriviti"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["Apri il Corso"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["Iscritto"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["Segna come completato"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["è già iniziato."]), t(["hanno già iniziato."])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["iscritto al/alla programma/corso di ", n(r("name"))]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ha completato ", n(r("name")), "."]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["sei stato invitato a partecipare a questo Percorso di Apprendimento"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Questo Percorso di Apprendimento sta per terminare presto", n(r("name"))]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["Ha completato questo percorso di apprendimento."]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"Ha iniziato ', n(r("name")), '"']);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["sta facendo progressi in questo Percorso di Apprendimento"]), t(["stanno facendo progressi in questo Percorso di Apprendimento"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"Hanno iniziato con ', n(r("name")), '"']);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["si è iscritto a ", n(r("name")), "."]), t(["si sono iscritti a ", n(r("name")), "."])]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["abbiamo completato ", n(r("name")), "."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t } = e;
        return t(['"ha completato la fase."']);
      },
      "journey_step-posted": (e) => {
        const { normalize: t } = e;
        return t(["ha pubblicato nella community"]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"In corso adesso a ', n(r("name")), '"']);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["hanno appena terminato il Corso e ottenuto i loro certificati."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Si sono iscritti a ", n(r("name"))]);
      },
      "program-started": (e) => {
        const { normalize: t } = e;
        return t([`1. "Il vostro team ha già iniziato."
2. "I membri del vostro team hanno già iniziato."`]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["è stato aggiunto a un nuovo programma: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["hanno risposto a questa domanda del sondaggio in ", n(r("name"))]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['Hai guardato questo video - <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["Hanno letto questa sezione"]);
      }
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["Sta succedendo ora"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["Classifica"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t([`"Il tuo team sta commentando in una discussione in questo Corso. Dai un'occhiata e aggiungi i tuoi pensieri alla discussione."`]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["Il tuo team è attivo in diverse discussioni in questo Corso. Dai un'occhiata e aggiungi i tuoi pensieri alla conversazione."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["Il tuo team sta facendo progressi e guadagnando punti. Ecco i primi posti della classifica del Corso. Hai raggiunto la top 10? Controlla la classifica per vedere la tua posizione attuale."]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["Continua a leggere dal punto in cui ti sei fermato l'ultima volta."]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["La prossima sezione da completare nel tuo Corso è un sondaggio."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["Ecco come il progresso medio del tuo team si confronta con il tuo."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"Il corso inizia oggi alle ', n(r("time")), '."']);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Il corso inizia tra ", n(r("days")), " giorni."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Il programma termina oggi alle ", n(r("time")), "."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Il corso termina tra ", n(r("days")), " giorni."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["Il corso è iniziato oggi."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Il corso è iniziato ", n(r("days")), " giorni fa."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t(["Ti invieremo un'email di promemoria quando sarà il momento di iniziare."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), "% completato"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " di ", n(r("maxSteps")), " fasi completate"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " di ", n(r("required")), " post della Community"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["Corso terminato"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " commento"]), t([n(r("count")), " commenti"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " reazione"]), t([n(r("count")), " reazioni"])]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["Sii il primo a commentare e reagire"]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["I tuoi progressi"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["Media di squadra"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(['"', n(r(0)), '% Completo"']);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["Scopri di più"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["Inizia ora"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " di ", n(r(1)), " risorse completate"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["Visualizza tutte le fasi del percorso"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["Inizia oggi"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["Aggiornamento del percorso"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["e altri"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["Tu"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["Tu e io"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["Risultati del sondaggio"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["Vai alla domanda del sondaggio"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " punto"]), t([n(r("count")), " punti"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Iscriviti alla sessione di ", n(r("name"))]);
    }
  } },
  { ja: {
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["保留中の利用者"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["検索"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["メールアドレスを入力してください"]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["メールアドレスでユーザーを検索"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["次のメールアドレスに招待を送信しました。彼らが無事に登録すると、ライセンスが消費されます。招待を再送したり、キャンセルしたり、", n(r(0)), "を送信したりできます。"]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["定期購読登録リンク"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["名前とメールアドレスを匿名にする"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["RSC のコメントを削除"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["コミュニティ投稿を削除"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["メンションを匿名化する"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["プロフィールフィールドを削除"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["RSC リフレクションを削除"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["コミュニティのコメントを削除"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["プロフィールフィールドを保持"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["フィールドマニュアルのコメントを削除"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["FM (フィールドマニュアル)プライベートメモを削除"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["プログラムの会話を削除"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["ユーザー"]), t(["複数ユーザー"])]);
    },
    were: (e) => {
      const { normalize: t } = e;
      return t(["だった"]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["列: ", n(r("rowList"))]), t(["複数の列: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["ファイルが正常にアップロードされました。1件の有効な行が検出されました"]), t(["ファイルが正常にアップロードされました。", n(r("n")), "件の有効な行が検出されました"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["アップロードエラー"]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["ファイル構造: 1列目のヘッダーに「メール」を含める必要があります"]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["ファイル構造: 1列目に「メール」をヘッダーとして含める必要があります。オプションで「SSO ID」列を含めることができます。"]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["アップロードされたファイルが見つかりません"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["ファイルは.xlsx形式ではありません。"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["ファイルに「メールアドレス」のヘッダーを含む列がありません"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["アップロードされたファイルにユーザーが見つかりません"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["SSOに既に1人以上接続されています"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["1つ以上の行に無効なメールアドレスが含まれています"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["1行以上に無効なSSO IDが含まれています。"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["1行以上にメールアドレスが含まれていない行があります。"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["1人以上のユーザーが複数のSSOプロバイダーを持っています"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["1人以上のユーザーがSSO IDを持っていません"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["1人以上のユーザーがSSOプロバイダーを持っていません"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["既存のユーザーと一致しないメールアドレスがあります"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["リソース"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["プログラム"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["フィールドマニュアル"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["学習過程"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["学習過程のステップ"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["プログラム（およびそのタグやタイプを含む）をすべてコピー"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["プログラムのタグ見出し名をコピーする (例: ノマディックアカデミーのパワースキル)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["リソースライブラリのタイプタグをコピー"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["リソースとトピックタグをすべてコピー"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["コミュニティのタグをコピー"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["プロフィール"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["管理ダッシュボード"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["学園に戻る"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["最小画像サイズ: ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["最大画像サイズ: ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("n")), " 日残り"]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["今日"]), t(["1日後"]), t([n(r("n")), " 日後"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["1日未満"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " の完了まであと ", n(r("n")), " 日"]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["まもなくプログラムが始まります"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["プログラム更新"]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["あなたの学習過程の次のステップを完了する"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["まもなく学習過程: このプログラムに登録しましょう"]);
    },
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["このステップをあなたの学習の旅で完了して下さい。"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "が終了しました"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "はもうすぐ終わります"]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t } = e;
      return t(["次のセッションに登録する"]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["あなたは学習過程に招待されています、", n(r("name")), "さん"]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["この学習過程はまもなく終了します: ", n(r("name"))]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["おめでとうございます！", n(r("name")), "さん、あなたはこの学習過程を完了しました。"]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["プログラムが完了しました： ", n(r("name")), "さん"]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "に登録しました (", n(r("date")), ")"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["プログラムが開始されました：", n(r("name"))]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["プログラムが開始されました: ", n(r("name")), "（", n(r("date")), "）"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["あなたは新しいプログラムに追加されました: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["プログラムで進歩し続けてください"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["オンデマンドリソースを探す"]);
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["リソースの最新情報"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["あなたにぴったりのプログラムを探す"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["学習者の旅程を探る"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["今コミュニティで起きていること"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["コミュニティに参加"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["コミュニティのお知らせ"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["こちらはアクティブな学習過程の未完了ステップです。すべてのステップを<リンク>この過程で確認</リンク>できます。"]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["このプログラムの完了はあなたの学習過程の一環です。この過程のすべてのステップを常に確認することができます。"]);
    },
    "homepage-tile-description": {
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["コミュニティでは、全員がアイデア、コンテンツ、専門知識を共有し、才能や成果を披露し、質問したり、仲間や専門家から実践的な助けを得ることができます。"]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["コミュニティで最も活発なディスカッションを一日のまとめとしてご紹介します。最新の投稿は<link>コミュニティページ</link>でご覧いただけます。"]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["リソースは、いつでもアクセス可能な短い学習コンテンツです。ツールやフレームワークについて、短時間で理解し、応用できるように構成されています。"]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["今日は最も読まれ、議論されたリソースをお届けします。<link>リソースライブラリ</link>から、すべての短編学習コンテンツを閲覧することもできます。"]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["学習過程は私たちの学習体験を案内するためのキュレーションガイドです。今日の最も重要なトピックに関する時間制限のあるプログラムとオンデマンドのリソースをまとめています。"]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["プログラムのライブラリを探索し、新しいセッションに登録したり、今後のセッションに登録したり、すぐに参加できるプログラムを見つけたりしましょう。開始したら、チームとの交流、リーダーボードの上昇、そして完了証明書の獲得ができます。"]);
        }
      },
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["この学習過程を完了しました、", n(r("name")), " さん。<link>あなたのプロフィール</link>に完了記録が表示されます。"]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["この学習過程、", n(r("title")), "、", n(r("in_x_days")), " 内に完了します。残りのステップを仕上げましょう。"]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["この学習過程「", n(r("title")), "」は終了しました。"]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["あなたはこの学習ジャーニーへの参加招待を受けました。常にこのジャーニーのすべてのステップを<link>表示することができます</link>。"]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["利用可能なすべての学習過程を探索しましょう。"]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["これはジャーニーステップコミュニティのためのものです。これはジャーニーステップコミュニティのためのものです。"]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["新しいコメントがあなたの参加しているディスカッションに追加されました。確認して会話に参加しましょう。"]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["プログラムは", n(r("daysRemaining")), "日後に終了しますので、ご確認ください。チームの平均完了率は", n(r("teamProgress")), "%です。"]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["チームの最新の活動を確認して、会話に戻りましょう。"]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["今日のライブウェビナーにご参加ください。ハイブリッドワークの未来について議論します。また、ウェビナーの最後にはQ&Aセッションを予定しています。<br /><br /><strong>日付:</strong> ", n(r("date")), " <br /><strong>時間:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["グローバルなノマドコミュニティとつながり、ハイブリッドワークについてこれまで学んだことや今後の展望を共有しましょう。"]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["このリソースは本日提供されます。いつでもこれまでのすべてのステップを<link>確認できます</link>。"]);
        }
      }
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["始めましょう"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["プログラムを続ける"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["プログラムを開始"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["プログラムレビュー"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["プログラム詳細"]);
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["旅に参加"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["学習の詳細"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["学習の旅を続ける"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["旅程を開始"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["ウェビナーを開始"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["オープンコミュニティ"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["リソースを共有"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["後で知らせて"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["すべてのプログラムを見る"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["すべての学習過程を探る"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["リソースライブラリ"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["コミュニティに参加"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["登録"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["プログラムを開く"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["登録完了"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["完了にする"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["既に開始されています。"]), t(["既に開始しました。"])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "に登録しました。"]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "を完了しました。"]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["参加するように招待されました。"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["この学習過程はもうすぐ終了します", n(r("name"))]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["この学習過程を終了しました"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["has started ", n(r("name"))]), t(["have started ", n(r("name")), `
`, n(r("name")), "を開始しました"]), t([n(r("name")), "を開始しました"])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["この学習過程で進捗中です。"]), t(["この学習過程で進捗中です。"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "を始めました。"]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "に登録しました。"]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "を完了しました。"]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t } = e;
        return t(["ステップを完了しました。"]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t } = e;
        return t(["コミュニティに投稿しました。"]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "で今開催中です"]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["プログラムをちょうど完了し、証明書を取得しました。"]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "に登録しました"]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["from your team has already gotten started."]), t([`from your team have already gotten started.
あなたのチームはすでに開始しています。`])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["新しいプログラムに", n(r("name")), "が追加されました。"]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["「", n(r("name")), "の投票質問に回答しました。」"]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"このビデオを見ました：<a href="', n(r("link")), '">', n(r("name")), '</a>"']);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["このセクションを読み終えました"]);
      }
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["進行中"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["リーダーボード"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["あなたのチームがこのプログラム内のディスカッションでコメントしています。見て、会話にあなたの考えを追加してください。"]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["あなたのチームはこのプログラム内の複数のディスカッションに参加しています。見て、ディスカッションにあなたの意見を追加してください。"]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["あなたのチームは進展中でポイントを獲得中です。こちらが現在のプログラム・リーダーボードのトップです。トップ10に入っていますか？リーダーボードであなたの現在の位置を確認してください。"]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["前回止めた場所から読み続けてください。"]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["プログラムで次に完了するセクションは投票です。"]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["あなたのチームの平均進捗状況とあなたの進捗状況を比較しましょう。"]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["プログラムは今日", n(r("time")), "に開始します。"]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("days")), " 日後にプログラムが開始します。"]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["プログラムは今日", n(r("time")), "に終了します。"]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["プログラムは", n(r("days")), "日後に終了します。"]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["プログラムは今日開始しました。"]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["プログラムは", n(r("days")), "日前に開始しました。"]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t(["開始時にリマインダーメールをお送りいたします。"]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), "% 完了"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " ステップのうち ", n(r("maxSteps")), " ステップが完了しました"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " 件の", n(r("required")), `件のコミュニティ投稿が完了

`]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["プログラム終了"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(['"', n(r("count")), ' 件のコメント"']);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " リアクション"]), t([n(r("count")), " リアクションズ"])]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["最初にコメントやリアクションをする"]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["進行状況"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["チーム平均"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% 完了しました"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["詳しく見る"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["今すぐ開始"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " / ", n(r(1)), " リソースが完了しました"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["学習過程の全ステップを表示"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["今日から始めよう"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["学習過程の更新"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["その他"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["あなた"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["あなたと"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["投票結果"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["投票の質問へ進む"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " ポイント"]), t([n(r("count")), " ポイント"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "セッションに登録する"]);
    }
  } },
  { ko: {
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["여정의 이 단계를 완료하세요"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Your Program has started: ", n(r("name")), " - 프로그램이 시작되었습니다: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["프로그램에서 계속 진보하세요"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["주문형 자료 탐색"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["커뮤니티 공지사항"]);
    },
    "homepage-tile-description": {
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t([n(r("name")), "님, 여정을 완료하였습니다. <link>프로필</link>에서 완료 증빙을 확인할 수 있습니다."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["이 학습자 여정 ", n(r("title")), "은(는) ", n(r("daysRemaining")), "일 후 ", n(r("endDate")), "에 종료됩니다. 마지막 몇 단계를 마칩니다."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["이 학습자 여정 ", n(r("title")), "은(는) 종료되었습니다."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["귀하는 이 학습자 여정에 참여하도록 초대되었습니다. 항상 이 여정의 <link>모든 단계를 볼</link> 수 있습니다."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["이용 가능한 모든 학습자 여정을 살펴보세요."]);
        }
      },
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["커뮤니티를 통해 모든 사람이 아이디어, 콘텐츠 및 전문성을 공유하고, 재능과 성과를 보여주고, 질문을 하고, 동료와 전문가로부터 실질적인 도움을 받을 수 있습니다."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["커뮤니티 전체에서 그날의 가장 활발한 토론을 모았습니다. <link>커뮤니티 페이지</link>에서 모든 최신 게시물을 찾아볼 수도 있습니다."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["자료는 언제든지 액세스할 수 있는 작은 학습 내용입니다. 몇 분 안에 소화하고 적용할 수 있는 도구와 프레임워크를 포함하고 있습니다."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["오늘 가장 많이 읽고 토론한 자료는 다음과 같습니다. <link>자료 라이브러리</link>에서 모든 작은 학습을 찾아볼 수도 있습니다."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["학습자 여정은 학습 경험을 엄선하여 제공하는 가이드입니다. 이들은 오늘의 가장 중요한 주제에 대한 주문형 자료와 시간이 제한된 프로그램을 함께 그룹화합니다."]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["프로그램 라이브러리를 탐색하거나 예정된 세션에 등록하거나 가입할 준비가 된 프로그램을 찾아보세요. 시작하면 팀을 알아가고 리더보드에 오르며 수료증을 받을 수 있습니다."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["이는 여정 단계 커뮤니티를 위한 것입니다. 이는 여정 단계 커뮤니티를 위한 것입니다."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["귀하가 참여한 토론에 새로운 의견이 몇 가지 있습니다. 둘러보고 대화로 넘어가세요."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["다시 한 번 말씀드리지만, 프로그램이 ", n(r("daysRemaining")), "일 후에 종료되고 팀의 평균 완료율은 ", n(r("teamProgress")), "%입니다."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["팀의 최신 활동을 살펴보고 다시 대화로 돌아가세요."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["지금 라이브 웨비나에 참여하세요.  하이브리드 작업의 미래에 대해 논의할 것입니다. 또한 웨비나가 끝날 무렵 Q&A 세션을 가질 계획입니다. <br /><br /><strong>날짜:</strong> ", n(r("date")), " <br /><strong>시간:</strong> ", n(r("time")), n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["글로벌 Nomadic 커뮤니티와 연결하고 지금까지 하이브리드 작업에 대해 배운 내용과 그 진행 상황을 공유하세요."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["이 자료는 현재 진행 중입니다. 항상 이 자료의 <link>모든 단계를 볼</link> 수 있습니다."]);
        }
      }
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["여정에 참여하기"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["여정 시작"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["자료 공유하기"]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["첫 번째로 의견 남기고 반응하기"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["여정 업데이트"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["기타"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["당신"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["당신과"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["여론 조사 결과"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["투표 질문으로 이동"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(['"', n(r("count")), "점"]), t([n(r("count")), '점"'])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " 세션 등록"]);
    },
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["보류 중인 사용자"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["검색"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["이메일 주소 입력..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["이메일 주소로 사용자 검색"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["다음 이메일 주소로 초대장이 전송되었습니다. 성공적으로 등록하면 하나의 라이선스를 소비하게 됩니다. 초대를 다시 보내거나 취소하거나 ", n(r(0)), "을(를) 보낼 수 있습니다."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["구독 가입 링크"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["이름 및 이메일 익명화"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["RSC 의견 삭제"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["커뮤니티 게시물 삭제"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["멘션 익명화"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["프로필 필드 삭제"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["RSC 반영 삭제"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["커뮤니티 의견 삭제"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["프로필 필드 보존"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["FM 의견 삭제"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["FM 개인 메모 삭제"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["프로그램 대화 삭제"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["사용자"]), t(["사용자"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["였음"]), t(["~였음"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["행: ", n(r("rowList"))]), t(["행: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["파일이 성공적으로 업로드되었습니다. 하나의 유효한 행이 감지되었습니다"]), t(["파일이 성공적으로 업로드되었습니다. ", n(r("n")), "개의 유효한 행이 감지되었습니다."])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["업로드 오류."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["파일 구조: 헤더에서 1개의 열에는 ‘이메일’이 있어야 합니다."]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["파일 구조: 헤더에서 1개의 열에는 ‘이메일’이 있어야 합니다. 선택적으로 ‘SSO ID’ 열이 제공될 수 있습니다."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["업로드된 파일 누락"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["파일이 .xlsx 형식이 아닙니다"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["파일은 헤더에 ‘이메일’이 있는 열이 없습니다."]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["업로드된 파일에서 사용자를 찾을 수 없습니다."]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["한 명 이상의 사용자가 SSO에 이미 연결되어 있습니다."]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["하나 이상의 행에 잘못된 이메일 주소가 포함되어 있습니다."]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["하나 이상의 행에 잘못된 SSO ID가 있습니다."]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["하나 이상의 행에 이메일 주소가 포함되어 있지 않습니다"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["한 명 이상의 사용자에게 여러 SSO 공급자가 있습니다."]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["한 명 이상의 사용자에게 SSO ID가 없습니다."]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["한 명 이상의 사용자에게 SSO 공급자가 없습니다."]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["하나 이상의 이메일 주소가 기존 사용자와 일치하지 않습니다."]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["자료"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["프로그램"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["현장 매뉴얼"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["학습자 여정"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["학습자 여정 단계"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["모든 프로그램(및 태그와 유형) 복사"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["프로그램 태그 제목 이름 복사(예: Nomadic Academy의 Power Skills)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["자료 라이브러리 유형 태그 복사"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["모든 자료 및 주제 태그 복사"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["커뮤니티 태그 복사"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["프로필"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["관리자 대시보드"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["아카데미로 돌아가기"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["최소 이미지 크기: ", n(r("width")), "x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["최대 이미지 크기: ", n(r("width")), "x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), "일 남음"]), t([n(r("n")), "일 남음"])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), "일"]), t([n(r("n")), "일"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["하루 미만"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("name")), " 완료까지 ", n(r("n")), "일 남음"]), t([n(r("name")), "완료까지 ", n(r("n")), "일 남음"])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["프로그램이 곧 시작됩니다."]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["오늘 시작"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["프로그램 업데이트"]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["귀하는 학습자 여정에 초대를 받았습니다: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["이 학습자 여정은 곧 종료됩니다: ", n(r("name")), " "]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["축하합니다! 이 여정을 완료하셨습니다: ", n(r("name"))]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["여정의 다음 단계를 완료하세요"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["곧 여정에 나타남: 이 프로그램에 등록"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "이(가) 종료되었습니다"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "이(가) 곧 종료됩니다"]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["프로그램을 완료하셨습니다: ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "(", n(r("date")), ")에 등록되었습니다"]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["프로그램이 시작되었습니다: ", n(r("name")), "(", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["새 프로그램에 추가되었습니다: ", n(r("name"))]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["다음 ", n(r("name")), " 세션에 등록"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["사용자를 위한 프로그램 찾기"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["학습자 여정 탐색"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["커뮤니티 가입"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["커뮤니티에서 지금 일어나는 일"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["실행 중인 학습자 여정에서 미완료 단계입니다. 이 여정의 <link>모든 단계를 볼</link> 수도 있습니다."]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["이 프로그램을 완료하는 것은 학습자 여정에서 하나의 단계입니다. 항상 이 여정의 <link>모든 단계를 볼</link> 수 있습니다."]);
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["시작하기"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["프로그램 검토"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["여정 세부 정보"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["여정 계속"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["등록"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["프로그램 시작"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["프로그램 열기"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["프로그램 계속"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["등록됨"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["프로그램 세부 정보"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["완료로 표시"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["나중에 다시 알림"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["웨비나 시작"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["모든 프로그램 살펴보기"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["모든 학습자 여정 살펴보기"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["자료 라이브러리"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["커뮤니티 열기"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["커뮤니티 가입"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["이미 시작되었습니다."]), t(["이미 시작되었습니다."])]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t([n(r("name")), "을(를) 완료했습니다."]), t([n(r("name")), "을(를) 완료했습니다."])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "에 등록되었습니다."]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["이 학습자 여정에 참여하도록 초대되었습니다."]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["이 학습자 여정은 곧 종료됩니다", n(r("name")), " "]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["이 학습자 여정을 마쳤습니다."]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t([n(r("name")), "을(를) 시작했습니다"]), t([n(r("name")), "을(를) 시작했습니다."])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["이 학습자 여정에서 진행하고 있습니다"]), t(["이 학습자 여정에서 진행하고 있습니다"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "을(를) 했습니다."]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "에 등록했습니다."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "을(를) 완료했습니다."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["단계를 완료했습니다."]), t(["단계를 완료했습니다."])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["커뮤니티에 게시했습니다"]), t(["커뮤니티에 게시했습니다."])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "에서 지금 일어나고 있는 일"]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["프로그램을 완료하고 인증서를 받았습니다."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "에 등록했습니다"]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["팀의 이(가) 이미 시작되었습니다."]), t(["팀의 이(가) 이미 시작되었습니다."])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["새 프로그램에 추가되었습니다: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "에서 이 설문조사 질문에 답변했습니다"]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['이 동영상을 시청했습니다 - <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["이 섹션을 읽었습니다"]);
      }
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["자료에서 지금 일어나고 있는 일"]);
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["지금 진행 중"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["리더보드"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["귀하의 팀은 이 프로그램의 토론에서 의견을 제시하고 있습니다. 한 번 살펴보고 여러분의 생각을 대화에 추가하세요."]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["귀하의 팀은 이 프로그램에서 여러 가지 토론을 진행하고 있습니다. 한 번 살펴보고 여러분의 생각을 대화에 추가하세요."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["귀하의 팀은 진행해 나가고 있으며 포인트를 적립하고 있습니다. 프로그램 리더보드의 현재 상단은 다음과 같습니다. 10위권에 변동이 있습니까? 리더보드를 확인하여 현재 위치를 확인하세요."]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["마지막 중단 지점에서 계속 읽습니다."]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["프로그램에서 완료해야 할 다음 섹션은 설문조사입니다."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["다음은 팀의 평균 진행 상황과 여러분의 진행 상황을 비교한 것입니다."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["프로그램은 오늘 ", n(r("time")), "에 시작됩니다."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["프로그램은 ", n(r("days")), "일 후에 시작됩니다."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["프로그램은 오늘 ", n(r("time")), "에 종료됩니다."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["프로그램은 ", n(r("days")), "일 후에 종료됩니다."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["오늘 프로그램이 시작되었습니다."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["프로그램이 ", n(r("days")), "일 전에 시작되었습니다."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t([" 시작하도록 설정되면 알림 이메일을 보내드립니다."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), "% 완료"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " / ", n(r("maxSteps")), "단계 완료"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " / ", n(r("required")), "커뮤니티 게시물 완료"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["프로그램 종료됨"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " 의견"]), t([n(r("count")), "의견"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " 반응"]), t([n(r("count")), "반응"])]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["귀하의 진행 상황"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["팀 평균"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% 완료"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["자세히 알아보기"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["지금 시작"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " / ", n(r(1)), " 자료 완료"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["모든 여정 단계 보기"]);
    }
  } },
  { pt: {
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["usuários pendentes"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["buscar"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["Digite um endereço de email..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["Buscar usuário por endereço de email"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["Um convite foi enviado para os seguintes endereços de email. Quando eles se inscreverem com sucesso, uma licença será consumida. Você pode reenviar o convite, cancelá-lo ou enviar um ", n(r(0)), "."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["link de inscrição"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["Anonymize names and email - Anonimizar nomes e email"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["Excluir comentários de recursos"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["Excluir postagens da comunidade"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["Anonimizar menções"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["Excluir campos do perfil"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["Excluir reflexões de RSC"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["Excluir comentários da comunidade"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["Preservar campo do perfil"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["Excluir comentários do Manual de Campo"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(['"Excluir notas privadas do Manual de Campo"']);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["Excluir conversas do programa"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["usuário"]), t(["usuários"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["foi"]), t(["foram"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["linha: ", n(r("rowList"))]), t(["linhas: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["Arquivo carregado com sucesso, uma linha válida detectada"]), t(["Arquivo carregado com sucesso, ", n(r("n")), " linhas válidas detectadas"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["Erro no upload."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Estrutura do arquivo: 1 coluna deve ter “Email” no cabeçalho"]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Estrutura do arquivo: 1 coluna deve ter “Email” no cabeçalho. Uma coluna opcional “SSO ID” pode ser fornecida."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["Arquivo carregado ausente"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["Arquivo não está no formato .xlsx."]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(['O arquivo não contém uma coluna com "email" no cabeçalho']);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["Nenhum usuário encontrado no arquivo carregado"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["Um ou mais usuários já estão conectados ao SSO"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["Uma ou mais linhas contêm endereços de email inválidos"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["Uma ou mais linhas contêm IDs de SSO inválidos"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["Uma ou mais linhas não contêm um endereço de email"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["Um ou mais usuários têm vários provedores de SSO"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["Um ou mais usuários não têm um ID SSO."]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["Um ou mais usuários não têm um provedor de SSO"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["Um ou mais endereços de email não correspondem a um usuário existente"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["Recursos"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["Programas"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["Manuais de Campo"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["Jornadas de Aprendizagem"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["Etapas das Jornadas de Aprendizagem"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["Copiar Programas (e suas tags e tipos)"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["Copiar nome do cabeçalho da tag do Programa (por exemplo, Power Skills na Nomadic Academy)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["Copiar tipos de marcadores da Biblioteca de Recursos"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["Copiar todos os Recursos e tags de tópico"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["Copiar tags da Comunidade"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["Perfil"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["Dashboard Administrativo"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["De volta à Academia"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Minimum image dimensions: ", n(r("width")), " x ", n(r("height")), `
Dimensões mínimas da imagem: `, n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Máximas dimensões da imagem: ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(['"', n(r("n")), " dia restante"]), t([n(r("n")), ' dias restantes"'])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["hoje"]), t(["em ", n(r("n")), " dia"]), t(["em ", n(r("n")), " dias"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["menos de um dia"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " dia restante para completar ", n(r("name"))]), t([n(r("n")), " dias restantes para completar ", n(r("name"))])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["Seu programa está começando em breve"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["Atualização do Programa"]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["Complete a próxima etapa da sua Jornada"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["Próximas Etapas na sua Jornada: Inscreva-se neste Programa"]);
    },
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["Complete esta etapa da sua Jornada"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " acabou"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " está terminando em breve"]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Inscreva-se para a próxima sessão de ", n(r("name"))]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Você está convidado para uma Jornada de Aprendizagem: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Esta Jornada de Aprendizagem está terminando em breve: ", n(r("name"))]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Parabéns! Você completou esta Jornada, ", n(r("name"))]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Você completou seu Programa: ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Você se inscreveu em ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Seu Programa começou: ", n(r("name"))]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Seu Programa começou: ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Você foi adicionado a um novo Programa: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["Continue progredindo no seu Programa"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["Explore Recursos sob Demanda"]);
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["Acontecendo agora em Recursos"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["Encontre um Programa para você"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Explore Jornadas de Aprendizado"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["Acontecendo agora na Comunidade"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["Junte-se à Comunidade"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["Anúncio da Comunidade"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t([`Aqui está a tradução:

Aqui está uma etapa incompleta da sua Jornada de Aprendizado ativa. Você também pode <link>ver todas as etapas</link> desta Jornada.`]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Concluir este Programa é um passo na sua Jornada de Aprendizado. Você sempre pode <link>ver todas as etapas</link> desta Jornada."]);
    },
    "homepage-tile-description": {
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["A comunidade permite que todos compartilhem ideias, conteúdos e conhecimentos; mostrem talentos e conquistas; façam perguntas; e obtenham ajuda prática de colegas e especialistas."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Reunimos as discussões mais ativas do dia em toda a Comunidade. Você também pode navegar por todas as postagens recentes na <link>página da Comunidade</link>."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Recursos são pedaços de aprendizado que você pode acessar a qualquer momento. Eles cobrem ferramentas e estruturas que você pode entender e aplicar em minutos."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Aqui estão os Recursos mais lidos e discutidos de hoje. Você também pode navegar por todo o nosso aprendizado em pedaços na <link>Biblioteca de Recursos</link>."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["Jornadas de Aprendizado são guias curados para nossas experiências de aprendizado. Elas agrupam Programas com duração definida e Recursos sob demanda sobre os tópicos mais críticos da atualidade."]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["Explore nossa biblioteca de Programas, inscreva-se nas próximas sessões ou encontre Programas prontos para participar. Quando começar, você poderá conhecer sua equipe, subir no ranking e ganhar seu certificado de conclusão."]);
        }
      },
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Você completou esta jornada de aprendizado, ", n(r("name")), ". Um registro de conclusão agora está visível em <link>seu perfil</link>."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Esta Jornada de Aprendizado, ", n(r("title")), ", termina ", n(r("em_x_dias")), ". Finalize as últimas etapas."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Esta Jornada de Aprendizado, ", n(r("title")), " terminou."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["Você foi convidado a participar desta Jornada de Aprendizado. Você pode sempre <link>ver todas as etapas</link> desta Jornada."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["Explore todas as Jornadas de Aprendizagem disponíveis para você."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["Isto é para a comunidade de etapas da jornada."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["Há novos comentários em uma discussão em que você participou. Dê uma olhada e entre na conversa."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Como lembrete, o Programa se encerra em ", n(r("daysRemaining")), " e a média de conclusão da sua equipe é de ", n(r("teamProgress")), "%."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["Confira a atividade mais recente da sua equipe e volte para a conversa."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Participe do nosso webinar ao vivo hoje. Discutiremos o futuro do trabalho híbrido. Também planejamos uma sessão de perguntas e respostas no final do webinar. <br /><br /><strong>Data:</strong> ", n(r("date")), " <br /><strong>Hora:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["Conecte-se com a comunidade global Nômade e compartilhe o que você aprendeu até agora sobre o trabalho híbrido e para onde você acha que está indo."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["Este Recurso está acontecendo hoje. Você pode sempre <link>ver todas as etapas</link> deste Recurso."]);
        }
      }
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["Começar"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["Continuar Programa"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["Iniciar Programa"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["Revisar Programa"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["Detalhes do Programa"]);
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["Junte-se à Jornada"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["Detalhes da Jornada"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["Continuar Jornada"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["Iniciar Jornada"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["Iniciar Webinar"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["Comunidade Aberta"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["Compartilhar Recurso"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["Lembrar-me mais tarde"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["Explore Todos os Programas"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Explore todas as Jornadas"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["Biblioteca de Recursos"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["Juntar-se à Comunidade"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["Inscreva-se"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["<strong>Abrir Programa</strong>"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["Inscrito"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["Marcar como Concluído"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["já começou."]), t(["já começamos."])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["inscreveu-se no curso ", n(r("name")), "."]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(['"foi concluído ', n(r("name")), "."]), t(["concluímos ", n(r("name")), '."'])]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["foram convidados a participar desta Jornada de Aprendizagem"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"Esta Jornada de Aprendizagem está terminando em breve ', n(r("name")), '"']);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["terminaram esta Jornada de Aprendizagem"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t([n(r("name")), " começou"]), t(["nós começamos ", n(r("name")), "."])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["está progredindo nesta Jornada de Aprendizagem"]), t(["estão progredindo nesta Jornada de Aprendizagem"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["começaram a ", n(r("name")), "."]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["inscreveram-se em ", n(r("name")), "."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["concluíram ", n(r("nome")), "."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["completou a etapa."]), t(["completamos a etapa."])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["has posted in the community"]), t(["have posted in the community. - postou na comunidade"]), t(["postaram na comunidade."])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Acontecendo agora em ", n(r("name"))]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["Acabaram de concluir o Programa e receberam seus certificados."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"têm se inscrito em ', n(r("name")), '"']);
      },
      "program-started": (e) => {
        const { normalize: t } = e;
        return t([`"sua equipe já começou."
"membros da sua equipe já começaram."`]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["foi adicionado a um novo Programa: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["responderam a esta pergunta da enquete em ", n(r("name"))]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['assisti a este vídeo - <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["tenham lido esta seção"]);
      }
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["Acontecendo agora"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["Tabela de Líderes"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["Sua equipe está comentando em uma discussão neste Programa. Dê uma olhada e adicione seus pensamentos à conversa."]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["Sua equipe está ativa em várias discussões neste Programa. Dê uma olhada e adicione seus pensamentos à conversa."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["Sua equipe está fazendo progressos e ganhando pontos. Aqui está o topo atual do Placar do Programa. Você entrou no top 10? Verifique o Placar para ver sua posição atual."]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["Your team is participating in a poll as part of this Program. Make sure to cast your vote and see how your input compares with others. - Sua equipe está participando de uma pesquisa como parte deste Programa. Certifique-se de votar e veja como sua opinião se compara com a dos outros."]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["A próxima seção a ser concluída em seu Programa é uma enquete."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["Aqui está como o progresso médio da sua equipe compara com o seu."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["O programa começa hoje às ", n(r("time")), "."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["O programa começa em ", n(r("days")), " dias."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["O programa termina hoje às ", n(r("time")), "."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["O programa termina em ", n(r("days")), " dias."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["Programa iniciado hoje."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program started ", n(r("days")), " days ago. - Programa iniciado há ", n(r("days")), " dias."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t(["Enviaremos um e-mail de lembrete quando estiver prestes a começar."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), "% Concluído"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " de ", n(r("maxSteps")), " etapas concluídas"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " de ", n(r("required")), " postagens da Comunidade completas"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["Programa encerrado"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " comentário"]), t([n(r("count")), " comentários"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " reação"]), t([n(r("count")), " reações"])]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["Seja o primeiro a comentar e reagir"]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["Seu Progresso"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["Média da Equipe"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% Concluído"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["Saiba Mais"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["Comece Agora"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(['"', n(r(0)), " de ", n(r(1)), ' recursos completados"']);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["Ver todas as etapas da jornada"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["Comece Hoje"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["Atualização da Jornada"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["e outros"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["Você"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["Você e"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["Resultados da Enquete"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["Ir para a questão da enquete"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " ponto"]), t([n(r("count")), " pontos"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Inscreva-se na sessão ", n(r("name"))]);
    }
  } },
  { th: {
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["ผู้ใช้ที่รออนุมัติ"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["ค้นหา"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["กรอกที่อยู่อีเมล..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["ค้นหาผู้ใช้ด้วยที่อยู่อีเมล"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["ได้ส่งคำเชิญไปยังที่อยู่อีเมลต่อไปนี้แล้ว เมื่อพวกเขาลงทะเบียนสำเร็จพวกเขาจะใช้ใบอนุญาต คุณสามารถส่งคำเชิญอีกครั้ง ยกเลิก หรือส่ง ", n(r(0)), " ให้พวกเขา"]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["ลิงก์สมัครสมาชิก"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["ทำให้ชื่อและอีเมลไม่ระบุชื่อ"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["ลบความคิดเห็น RSC"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["ลบโพสต์ชุมชน"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["ทำให้การกล่าวถึงไม่ปรากฏชื่อ"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["ลบช่องข้อมูลในโปรไฟล์"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["ลบการสะท้อน RSC"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["ลบคอมเมนต์ชุมชน"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["เก็บรักษาข้อมูลโปรไฟล์"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["ลบแสดงความคิดเห็นในคู่มือภาคสนาม"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["ลบบันทึกส่วนตัวในคู่มือ"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["ลบการสนทนาในโปรแกรมทั้งหมด"]);
    },
    user: (e) => {
      const { normalize: t } = e;
      return t(["ผู้ใช้หลายคน"]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["ถูก"]), t(["N/A"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["แถว: ", n(r("rowList"))]), t(["แถว: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["อัปโหลดไฟล์เรียบร้อยแล้ว, พบแถวที่ถูกต้อง 1 แถว"]), t(["อัปโหลดไฟล์เรียบร้อยแล้ว, พบแถวที่ถูกต้อง ", n(r("n")), " แถว"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["ข้อผิดพลาดในการอัปโหลด"]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(['โครงสร้างไฟล์: ต้องมี 1 คอลัมน์ที่มีหัวข้อว่า "อีเมล"']);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["โครงสร้างไฟล์: ต้องมี 1 คอลัมน์ที่มีหัวเรื่องว่า “Email” คอลัมน์ “SSO ID” อาจมีหรือไม่มีก็ได้"]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["ไฟล์ที่อัปโหลดหายไป"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["ไฟล์ไม่อยู่ในรูปแบบ .xlsx"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["ไฟล์ไม่มีคอลัมน์ที่มีหัวเรื่องว่า ‘อีเมล’"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["ไม่พบผู้ใช้ในไฟล์ที่อัปโหลด"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["มีผู้ใช้งานอย่างน้อยหนึ่งคนที่เชื่อมต่อกับ SSO แล้ว"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["มีหนึ่งหรือหลายรายการที่มีที่อยู่อีเมลไม่ถูกต้อง"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["หนึ่งหรือมากกว่าแถวมี SSO ID ที่ไม่ถูกต้อง"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["มีแถวหนึ่งหรือมากกว่าที่ไม่มีที่อยู่อีเมล"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(['"ผู้ใช้งานหนึ่งคนหรือมากกว่ามีผู้ให้บริการ SSO หลายราย"']);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["มีผู้ใช้งานหนึ่งคนหรือมากกว่าที่ไม่มี SSO ID"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["ผู้ใช้งานหนึ่งหรือมากกว่าไม่มีผู้ให้บริการ SSO"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["ที่อยู่อีเมลหนึ่งหรือมากกว่าไม่ตรงกับผู้ใช้งานที่มีอยู่"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["แหล่งข้อมูล"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["โปรแกรม"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["learning-exp-types.fm: คู่มือภาคสนาม"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["เส้นทางการเรียนรู้"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["ขั้นตอนบนเส้นทางการเรียนรู้"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["คัดลอกโปรแกรมทั้งหมด (รวมถึงแท็กและชนิดของโปรแกรม)"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["คัดลอกชื่อแท็กโปรแกรม (เช่น ทักษะที่สำคัญในโรงเรียน Nomadic)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["คัดลอกแท็กประเภทในห้องสมุดแหล่งข้อมูล"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["คัดลอกแหล่งข้อมูลทั้งหมดและแท็กหัวข้อเรื่อง"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["คัดลอกแท็กชุมชน"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["โปรไฟล์"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["แดชบอร์ดผู้ดูแลระบบ"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["กลับไปที่โรงเรียน"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["ขนาดภาพขั้นต่ำ: ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["ขนาดภาพสูงสุด: ", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("n")), " วันคงเหลือ"]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["วันนี้"]), t(["ในอีก 1 วัน"]), t(["ในอีก ", n(r("n")), " วัน"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["น้อยกว่าหนึ่งวัน"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " วันเหลือในการทำ ", n(r("name")), " ให้เสร็จ"]), t([n(r("n")), " วันเหลือในการทำ ", n(r("name")), " ให้เสร็จ"])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t([`โปรแกรมของคุณกำลังจะเริ่ม
`]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["อัปเดตโปรแกรม"]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["ดำเนินขั้นตอนต่อไปในเส้นทางการเรียนรู้ของคุณ"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["สิ่งที่รอคุณอยู่ในเส้นทางการเรียนรู้: ลงทะเบียนในโปรแกรมนี้"]);
    },
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["ดำเนินขั้นตอนนี้ในเส้นทางการเรียนรู้ของคุณ"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " ได้สิ้นสุดแล้ว"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " กำลังจะสิ้นสุด"]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["ลงทะเบียนสำหรับเซสชั่นถัดไปของ ", n(r("name"))]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["You're invited to a Learner Journey: ", n(r("name")), " - คุณได้รับเชิญให้เข้าร่วมเส้นทางการเรียนรู้: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["This Learner Journey is ending soon: ", n(r("name"))]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["ยินดีด้วย! คุณสำเร็จเส้นทางการเรียนรู้นี้แล้ว, ", n(r("name"))]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(['"คุณสำเร็จโปรแกรมแล้ว: ', n(r("name")), '"']);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["คุณลงทะเบียนใน ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["โปรแกรมของคุณได้เริ่มต้นแล้ว: ", n(r("name"))]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["โปรแกรมของคุณได้เริ่มต้นแล้ว: ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["คุณถูกเพิ่มเข้าในโปรแกรมใหม่: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["ทำความก้าวหน้าในโปรแกรมของคุณต่อไป"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["สำรวจแหล่งข้อมูลตามความต้องการ"]);
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["สถานการณ์ปัจจุบันในแหล่งข้อมูล"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["ค้นหาโปรแกรมสำหรับคุณ"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["สำรวจเส้นทางการเรียนรู้"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["ขณะนี้กำลังเกิดในชุมชน"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["เข้าร่วมชุมชน"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["ประกาศจากชุมชน"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["นี่คือขั้นตอนที่ยังไม่สมบูรณ์ในเส้นทางการเรียนรู้ของคุณ คุณยังสามารถ <link>ดูทุกขั้นตอน</link> ในเส้นทางนี้ได้"]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["การทำโปรแกรมนี้ให้สมบูรณ์เป็นขั้นตอนหนึ่งในเส้นทางการเรียนรู้ของคุณ คุณสามารถ <link>ดูทุกขั้นตอนได้ตลอดเวลาในเส้นทางการเรียนรู้นี้</link>"]);
    },
    "homepage-tile-description": {
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["ชุมชนเปิดโอกาสให้ทุกคนแบ่งปันแนวคิด เนื้อหา และความเชี่ยวชาญ แสดงความสามารถและความสำเร็จ ถามคำถาม และได้รับความช่วยเหลือที่เป็นประโยชน์จากเพื่อนร่วมงานและผู้เชี่ยวชาญ"]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["เราได้รวบรวมการอภิปรายที่คึกคักที่สุดของวันนี้จากทั่วทั้งชุมชน คุณยังสามารถเรียกดูโพสต์ล่าสุดทั้งหมดบนหน้า <link>ชุมชน</link> ได้เช่นกัน"]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["แหล่งข้อมูลคือชิ้นส่วนเล็กๆ ของการเรียนรู้ที่คุณสามารถเข้าถึงได้ทุกเมื่อ รวมถึงเครื่องมือและกรอบการทำงานที่คุณสามารถนำไปใช้และประยุกต์ได้ในเวลาไม่กี่นาที"]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["นี่คือแหล่งข้อมูลที่คนอ่านและพูดถึงมากที่สุดในวันนี้ คุณยังสามารถเรียกดูการเรียนรู้ขนาดพอดีคำทั้งหมดใน <link>แหล่งข้อมูล</link> ของเราได้"]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(['"เส้นทางการเรียนรู้คือคู่มือที่เราคัดสรรมาเพื่อประสบการณ์การเรียนรู้ของเรา รวมโปรแกรมที่จำกัดเวลาเข้ากับแหล่งข้อมูลตามความต้องการเกี่ยวกับหัวข้อที่สำคัญที่สุดในปัจจุบัน"']);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["สำรวจคลังโปรแกรมของเรา, ลงทะเบียนในเซสชั่นที่จะมาถึง, หรือหาดูโปรแกรมที่พร้อมเข้าร่วม เมื่อคุณเริ่ม คุณสามารถทำความรู้จักกับทีมของคุณ, ไต่อันดับในกระดานผู้นำ, และรับใบรับรองการเสร็จสิ้นของคุณ"]);
        }
      },
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["คุณได้เสร็จสิ้นเส้นทางการเรียนรู้นี้แล้ว, ", n(r("name")), ". บันทึกการเสร็จสิ้นของคุณสามารถเห็นได้ใน <link>โปรไฟล์</link>ของคุณแล้ว."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["This Learner Journey, ", n(r("title")), ", ends ", n(r("in_x_days")), `. Finish up the last few steps.
เส้นทางการเรียนรู้นี้, `, n(r("title")), ", จะสิ้นสุดในอีก ", n(r("in_x_days")), " วัน. กรุณาทำขั้นตอนสุดท้ายให้เสร็จสิ้น."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["This Learner Journey, ", n(r("title")), ` has ended.
เส้นทางการเรียนรู้นี้, `, n(r("title")), " ได้สิ้นสุดลงแล้ว."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["คุณได้รับเชิญให้เข้าร่วมเส้นทางการเรียนรู้นี้ คุณสามารถ <link>ดูทุกขั้นตอน</link> ในเส้นทางนี้ได้ตลอดเวลา"]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["สำรวจเส้นทางการเรียนรู้ทั้งหมดที่มีให้คุณ"]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["นี่คือสำหรับชุมชนเส้นทางการเรียนรู้."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["มีความคิดเห็นใหม่บางส่วนในการอภิปรายที่คุณได้เข้าร่วม ตรวจสอบและเข้าร่วมการสนทนา"]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["โปรดทราบว่า โปรแกรมจะปิดในอีก ", n(r("daysRemaining")), " วัน และค่าเฉลี่ยการเสร็จสิ้นของทีมคุณคือ ", n(r("teamProgress")), "%"]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["ดูการเคลื่อนไหวล่าสุดจากทีมของคุณแล้วกลับไปเข้าร่วมการสนทนา"]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["เข้าร่วมสัมมนาสดวันนี้ เราจะพูดคุยเกี่ยวกับอนาคตของการทำงานแบบไฮบริด นอกจากนี้เรายังวางแผนที่จะมีช่วงถามตอบตอนท้ายของสัมมนา <br /><br /><strong>วันที่:</strong> ", n(r("date")), " <br /><strong>เวลา:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["เชื่อมต่อกับชุมชน Nomadic ทั่วโลกและแบ่งปันสิ่งที่คุณได้เรียนรู้จนถึงตอนนี้เกี่ยวกับการทำงานแบบไฮบริดและที่ที่คุณคิดว่ามันกำลังมุ่งหน้าไป"]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["แหล่งข้อมูลนี้กำลังเกิดขึ้นในวันนี้ คุณสามารถ <link>ดูทุกขั้นตอน</link> ในแหล่งข้อมูลนี้ได้ตลอดเวลา"]);
        }
      }
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["เริ่มต้น"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["ดำเนินโปรแกรมต่อ"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["เริ่มโปรแกรม"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["โปรแกรมรีวิว"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["ข้อมูลโปรแกรม"]);
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["เข้าร่วมเส้นทาง"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["รายละเอียดการเดินทาง"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["ดำเนินเส้นทางต่อ"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["เริ่มการเดินทาง"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["เปิดตัวเว็บบินา"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["ชุมชนเปิด"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["แบ่งปันแหล่งข้อมูล"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["เตือนฉันทีหลัง"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["สำรวจโปรแกรมทั้งหมด"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["สำรวจเส้นทางการเรียนรู้ทั้งหมด"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["คลังแหล่งข้อมูล"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["เข้าร่วมชุมชน"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["Enroll - ลงทะเบียน"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["เปิดโปรแกรม"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["ลงทะเบียนแล้ว"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["ทำเครื่องหมายว่าเสร็จสิ้น"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["has already gotten started."]), t([`have already gotten started.
ได้เริ่มต้นแล้ว`]), t(["ได้เริ่มต้นแล้ว"])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ลงทะเบียนใน ", n(r("name")), "."]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["ได้เสร็จสิ้น ", n(r("name")), "."]), t(["ได้เสร็จสิ้น ", n(r("name")), "."])]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["ได้รับเชิญให้เข้าร่วมเส้นทางการเรียนรู้นี้"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["This Learner Journey is ending soon", n(r("name")), `  
เส้นทางการเรียนรู้นี้ใกล้จะสิ้นสุดแล้ว`, n(r("name"))]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["จบเส้นทางการเรียนรู้นี้แล้ว"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["ได้เริ่มต้นแล้ว ", n(r("name"))]), t(["ได้เริ่มต้นแล้ว ", n(r("name"))])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["กำลังมีความคืบหน้าในเส้นทางการเรียนรู้นี้"]), t(["กำลังมีความคืบหน้าในเส้นทางการเรียนรู้นี้"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), " ได้เริ่มต้นแล้ว"]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ลงทะเบียนใน ", n(r("name")), "."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"', n(r("name")), ' เสร็จแล้ว"']);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["has completed the step."]), t([`have completed the step.
ได้ทำขั้นตอนเสร็จแล้ว`]), t(["ได้ทำขั้นตอนเสร็จแล้ว"])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["has posted in the community"]), t(["have posted in the community. - ได้โพสต์ในชุมชน"]), t(["ได้โพสต์ในชุมชน"])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["กำลังเกิดขึ้นขณะนี้ที่ ", n(r("name"))]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["เพิ่งทำโปรแกรมเสร็จและได้รับใบรับรองแล้ว"]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ได้ลงทะเบียนใน ", n(r("name"))]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["รีวิว"]), t(["ทีมของคุณได้เริ่มต้นแล้ว"])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ได้ถูกเพิ่มในโปรแกรมใหม่: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["ได้ตอบคำถามแบบสำรวจนี้ใน ", n(r("name"))]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"ฉันได้ดูวิดีโอนี้แล้ว <a href="', n(r("link")), '">', n(r("name")), '</a>"']);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["have read this section - ได้อ่านส่วนนี้แล้ว"]);
      }
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["กำลังเกิดขึ้นตอนนี้"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["กระดานผู้นำ"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["ทีมของคุณกำลังแสดงความคิดเห็นในการอภิปรายในโปรแกรมนี้ ลองดูและเพิ่มความคิดของคุณในการสนทนา"]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["ทีมของคุณกำลังมีส่วนร่วมในการอภิปรายหลายเรื่องในโปรแกรมนี้ ลองดูและเพิ่มความคิดของคุณในการสนทนา"]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["ทีมของคุณกำลังมีความคืบหน้าและได้รับคะแนน นี่คืออันดับปัจจุบันของกระดานผู้นำโปรแกรม ทีมของคุณติด 10 อันดับแรกแล้วหรือยัง? ตรวจสอบกระดานผู้นำเพื่อดูตำแหน่งปัจจุบันของคุณ"]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["ทีมของคุณกำลังดำเนินการได้ดีในโปรแกรมนี้ สานต่อความพยายามเพื่อรักษาผลงานที่ดีและบรรลุเป้าหมายของคุณ"]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t([`The next section to complete in your Program is a poll.
ส่วนถัดไปที่ต้องทำในโปรแกรมของคุณคือการสำรวจ`]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["นี่คือการเปรียบเทียบความคืบหน้าเฉลี่ยของทีมคุณกับของคุณ"]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["โปรแกรมเริ่มวันนี้ตอน ", n(r("time")), "."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["โปรแกรมจะเริ่มในอีก ", n(r("days")), " วัน"]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["โปรแกรมสิ้นสุดวันนี้ตอน ", n(r("time")), "."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["โปรแกรมจะสิ้นสุดในอีก ", n(r("days")), " วัน"]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["โปรแกรมเริ่มวันนี้"]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["โปรแกรมเริ่มมาแล้ว ", n(r("days")), " วัน"]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t(["เราจะส่งอีเมลเตือนเมื่อถึงเวลาเริ่มต้น"]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), "% เสร็จสมบูรณ์"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("currentStep")), " ของ ", n(r("maxSteps")), " ขั้นตอนเสร็จสิ้นแล้ว"]);
      },
      community_posts: (e) => {
        const { normalize: t } = e;
        return t(["REVIEW ของ โพสต์ชุมชนเสร็จสิ้นแล้ว"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["โปรแกรมปิดแล้ว"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " ความคิดเห็น"]), t([n(r("count")), " ความคิดเห็น"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(['"', n(r("count")), ' ปฏิกิริยา"']);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["แสดงความคิดเห็นก่อนใคร"]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["ความก้าวหน้าของคุณ"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["ค่าเฉลี่ยทีม"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% สมบูรณ์"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["อ่านเพิ่มเติม"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["เริ่มเลย"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["เสร็จสิ้นแหล่งข้อมูล ", n(r(0)), " จาก ", n(r(1))]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["ดูขั้นตอนเส้นทางทั้งหมด"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["เริ่มวันนี้"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["อัพเดทเส้นทางการเรียนรู้"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["และอื่นๆ"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["คุณ"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["คุณกับ"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["ผลการสำรวจ"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["ไปที่คำถามโพล"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " คะแนน"]), t([n(r("count")), " คะแนน"])]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["ลงทะเบียนเซสชั่น", n(r("name"))]);
    }
  } },
  { tr: {
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["bekleyen kullanıcılar"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["ara"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["E-posta adresi girin..."]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["E-posta adresine göre kullanıcı arayın"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["Aşağıdaki e-posta adreslerine bir davet gönderildi. Başarıyla kayıt olduklarında bir lisans kullanacaklar. Davetlerini yeniden gönderebilir, iptal edebilir veya onlara bir ", n(r(0)), " gönderebilirsiniz."]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["abonelik katılma bağlantısı"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["İsimleri ve e-posta adreslerini anonimleştir"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["RSC yorumlarını sil"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["Topluluk gönderilerini kaldır"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["Bahsetmeleri anonimleştir."]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["Profil alanlarını kaldır"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["RSC yansımalarını sil"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["Topluluk yorumlarını sil"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["Profil alanını koruyun"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["FM yorumlarını sil"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["FM özel notlarını sil"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["Program görüşmelerini sil"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["kullanıcı"]), t(["kullanıcılar"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["idi"]), t(["idiler"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["satır: ", n(r("rowList"))]), t(["satırlar: ", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["Dosya başarıyla yüklendi, bir geçerli satır tespit edildi"]), t(["Dosya başarıyla yüklendi, ", n(r("n")), " geçerli satır tespit edildi"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["Yükleme hatası."]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Dosya yapısında: Bir sütunun başlığında 'Email' olmalıdır."]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["Dosya yapısı: Bir sütun başlıkta “Email” olmalıdır. İsteğe bağlı olarak “SSO ID” sütunu eklenebilir."]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["Yüklenen dosya eksik"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["Dosya .xlsx formatında değil"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["Dosyada başlıkta 'email' bulunan bir sütun yok"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["Yüklenen dosyada hiçbir kullanıcı bulunamadı."]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["SSO'ya zaten bir veya daha fazla kullanıcı bağlı."]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["Bir veya daha fazla satır geçersiz e-posta adresleri içeriyor"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["Bir veya daha fazla satır geçersiz SSO ID'leri içeriyor"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["Bir veya daha fazla satırda e-posta adresi yok."]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["Bir veya daha fazla kullanıcı birden fazla SSO sağlayıcısına sahip"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["Bir veya daha fazla kullanıcıda SSO ID yok"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["Bir veya daha fazla kullanıcıda bir SSO sağlayıcısı yok"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["Bir veya daha fazla e-posta adresi mevcut bir kullanıcıyla eşleşmiyor"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["Kaynaklar"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["Programlar"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(['"Saha Kılavuzları"']);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["Öğrenci Yolculukları"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["Öğrenci Yolculuğu Adımları"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["Tüm Programları (etiketleri ve türleriyle birlikte) kopyala."]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["Program Etiketi Başlığını Kopyala (Örn: Nomadic Akademisi'nde Güç Becerileri)"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["Kaynak Kütüphanesi tür etiketlerini kopyala"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["Tüm kaynakları ve konu etiketlerini kopyala."]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["Topluluk etiketlerini kopyala"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["Profil"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["Yönetici Paneli"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["Akademiye Dönüş"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Minimum image dimensions: ", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Maximum image dimensions: ", n(r("width")), " x ", n(r("height")), `
`]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("n")), " gün kaldı"]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(['"bugün']), t([n(r("n")), " gün"]), t([n(r("n")), ' gün içinde"'])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["bir günden az"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), "'nin tamamlanmasına ", n(r("n")), " gün kaldı"]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["Programınız yakında başlıyor"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["Program Güncellemesi"]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuğunuzun bir sonraki adımını tamamlayın"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuğunuzun Sıradaki Adımı: Bu Programa Katılın."]);
    },
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuğunuzun bu adımını tamamlayın"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " sona erdi."]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " yakında sona eriyor"]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Bir sonraki ", n(r("name")), " oturumuna kaydolun"]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Öğrenci Yolculuğu'na Davetlisiniz: ", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Bu Öğrenci Yolculuğu yakında sona eriyor: ", n(r("name"))]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Tebrikler! Bu Yolculuğu Tamamladın, ", n(r("name"))]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Programınızı Tamamladınız: ", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(['"', n(r("name")), "'e kaydoldunuz (", n(r("date")), ')"']);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Programınız başladı: ", n(r("name"))]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Programınız başladı: ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Yeni bir programa eklendiniz: ", n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["Programda ilerleme kaydetmeye devam edin"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["Talep Üzerine Kaynakları Keşfedin"]);
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["Kaynaklar'da Şu Anda Olup Bitenler"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["Sizin İçin Bir Program Bul"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Öğrenici Yolculuklarını Keşfedin"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["Şu Anda Toplulukta Olup Bitenler"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["Topluluğa Katılın"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["Topluluk Duyurusu"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["İşte aktif Öğrenici Yolculuğunuzdan eksik bir adım. Bu Yolculuktaki tüm adımları da <link>görüntüleyebilirsiniz</link>."]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["Bu Programı tamamlamak Öğrenici Yolculuğunuzda bir adımdır. Bu Yolculuktaki tüm adımları her zaman <link>görüntüleyebilirsiniz</link>."]);
    },
    "homepage-tile-description": {
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Topluluk, herkesin fikirlerini, içeriklerini ve uzmanlıklarını paylaşmalarına; yeteneklerini ve başarılarını sergilemelerine; sorular sormalarına; ve akranlarından ve uzmanlardan pratik yardım almalarına olanak tanır."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["Günün en aktif tartışmalarını topladık. Ayrıca en son gönderilere <link>Topluluk sayfası</link>ndan göz atabilirsiniz."]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["Kaynaklar, istediğiniz zaman erişebileceğiniz küçük öğrenme parçalarıdır. Araçlar ve çerçeveler hakkında bilgiler içerirler ve bunları birkaç dakika içinde anlayıp uygulayabilirsiniz."]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["İşte bugünün en çok okunan ve tartışılan Kaynakları. Ayrıca, tüm küçük boyutlu öğrenme materyallerimizi <link>Kaynak Kütüphanesi</link>'nde gezinerek bulabilirsiniz."]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["Öğrenici Yolculukları, öğrenim deneyimlerimize yönelik küratörlüğü yapılmış kılavuzlardır. Bugünün en kritik konularına dair zaman sınırlı Programları ve isteğe bağlı Kaynakları bir araya getirirler."]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["Programlar kitaplığımızı keşfedin, yaklaşan oturumlara kaydolun veya hemen katılabileceğiniz programları bulun. Bir kez başladığınızda, ekibinizi tanıyabilir, liderlik tablosunda yükselebilir ve bitirme sertifikanızı kazanabilirsiniz."]);
        }
      },
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Bu öğrenici yolculuğunu tamamladınız, ", n(r("name")), ". Tamamlanma kaydınız şimdi <link>profilinizde</link> görülebilir."]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Bu Öğrenici Yolculuğu, ", n(r("title")), ", ", n(r("in_x_days")), " içinde sona eriyor. Son birkaç adımı tamamlayın."]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Bu Öğrenici Yolculuğu, ", n(r("title")), " sona erdi."]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["Bu Öğrenici Yolculuğuna katılmaya davet edildiniz. Her zaman bu Yolculuktaki <link>tüm adımları görüntüleyebilirsiniz</link>."]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["Tüm Öğrenici Yolculuklarını keşfedin."]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["Bu, 'yolculuk adımı' topluluğu içindir."]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["Katıldığınız bir tartışmada yeni yorumlar var. İnceleyin ve sohbete katılın."]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Hatırlatma olarak, Program ", n(r("daysRemaining")), " gün içinde kapanıyor ve ekibinizin ortalama tamamlanma oranı ", n(r("teamProgress")), "."]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["Takımınızın en son etkinliklerine göz atın ve sohbete tekrar katılın."]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["Bugün canlı bir web seminerine katılın. Hibrit çalışmanın geleceğini tartışacağız. Web seminerinin sonunda bir Soru-Cevap oturumu da yapmayı planlıyoruz. <br /><br /><strong>Tarih:</strong> ", n(r("date")), " <br /><strong>Saat:</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["Küresel Göçebe topluluğuyla bağlantı kurun ve hibrit çalışma hakkında şimdiye kadar öğrendiklerinizi ve gelecekte nereye gideceğini paylaşın."]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["Bu Kaynak bugün gerçekleşiyor. Bu Kaynaktaki tüm adımları her zaman <link>görüntüleyebilirsiniz</link>."]);
        }
      }
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["Başlayın"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["Programı Sürdür"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["Programı Başlat"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["Programı Gözden Geçirme"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["Program Detayları"]);
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuğa Katıl"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuk Detayları"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuğa Devam Et"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuğa Başla"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["Webinar Başlat"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["Açık Topluluk"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["Kaynağı Paylaş"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["Daha Sonra Hatırlat"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["Tüm Programları Keşfet"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["Tüm Öğrenme Yolculuklarını Keşfet"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["Kaynak Kütüphanesi"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["Topluluğa Katıl"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["Kayıt Ol"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["Programı Aç"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["Kayıtlı"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["Tamamlandı olarak işaretle"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t } = e;
        return t([`- "Zaten başladı"
- "Zaten başladım"`]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "'e kayıt oldum."]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(['- "', n(r("name")), " tamamladı."]), t([n(r("name")), ' tamamladım."'])]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["Bu Öğrenci Yolculuğuna katılmak için davet edildiniz"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Bu Öğrenme Yolculuğu yakında sona erecek", n(r("name"))]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["Bu Öğrenme Yolculuğunu tamamladım."]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(['"O ', n(r("name")), "'e başladı."]), t(["Ben ", n(r("name")), `'e başladım."`])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["is making progress in this Learner Journey"]), t([`are making progress in this Learner Journey
Bu Öğrenci Yolculuğunda ilerleme kaydediyor`]), t(["Bu Öğrenci Yolculuğunda ilerleme kaydediyorlar"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"', n(r("name")), `'e başladım/başladık."`]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Ben ", n(r("name")), "'e kaydoldum."]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), "'i tamamladım."]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t } = e;
        return t(['"Adımı tamamladı."']);
      },
      "journey_step-posted": (e) => {
        const { normalize: t } = e;
        return t(["toplulukta paylaştı"]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Şu anda ", n(r("name")), "’de devam ediyor"]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["Programı az önce bitirdiler ve sertifikalarını aldılar."]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("name")), " için kaydoldum."]);
      },
      "program-started": (e) => {
        const { normalize: t } = e;
        return t([`For "from your team has already gotten started.": "Takımınızdan biri zaten başladı."
For "from your team have already gotten started.": "Takımınızdan bazıları zaten başladı."`]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Yeni bir programa eklendiniz: ", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['"Bu anket sorusunu ', n(r("name")), ' adıyla yanıtladı"']);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['Bu videoyu izledi: <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["Bu bölümü okudum"]);
      }
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["Şu anda oluyor"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["Lider Tablosu"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["Takımınız bu Programda bir tartışmaya yorum yapıyor. Bakın ve düşüncelerinizi sohbete ekleyin."]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["Takımınız bu Programda birkaç tartışmaya aktif olarak katılıyor. Bakın ve sohbete düşüncelerinizi ekleyin."]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["Takımınız ilerleme kaydediyor ve puan kazanıyor. İşte Program Lider Tablosunun güncel zirvesi. İlk 10’a girdiniz mi? Mevcut konumunuzu görmek için Lider Tablosuna bakın."]);
      },
      page: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["İşte takımınızla ilgili en son güncelleme! ", n(r("startDate")), ` tarihindeki etkinlikler burada.
`]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["Programınızdaki bir sonraki bölüm bir ankettir."]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["İşte takımınızın ortalama ilerlemesiyle sizinkinin karşılaştırması."]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program bugün saat ", n(r("time")), "'de başlıyor."]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program ", n(r("days")), " gün içinde başlıyor."]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program bugün saat ", n(r("time")), "'de bitiyor."]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["Program ", n(r("days")), " gün sonra bitiyor."]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["Program bugün başladı."]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("days")), " gün önce program başladı."]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t(["Size program başladığında bir hatırlatma e-postası göndereceğiz."]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("progress")), "% Tamamlandı"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["`", n(r("currentStep")), " adım ", n(r("maxSteps")), " adımdan tamamlandı`"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t([n(r("completed")), " gönderiden ", n(r("required")), " tanesi tamamlandı"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["Program kapandı"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(['"', n(r("count")), " yorum"]), t([n(r("count")), ' yorum"'])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " tepki"]), t([n(r("count")), " tepkiler"])]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["İlk yorum ve tepkiyi sen yap"]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["İlerlemeniz"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["Takım Ortalaması"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% Tamam"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["Daha Fazla Bilgi"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["Hemen Başla"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), " kaynak / ", n(r(1)), " kaynak tamamlandı"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["Tüm Yolculuk Adımlarını Görüntüle"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["Bugün Başla"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["Yolculuk Güncellemesi"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["ve diğerleri"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["Sen"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["Sen ve ..."]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["Anket Sonuçları"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["Anket sorusuna gitmek"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(['"', n(r("count")), ' puan"']);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " oturumuna kaydolun"]);
    }
  } },
  { zh: {
    "complete-this-step-in-your-journey": (e) => {
      const { normalize: t } = e;
      return t(["完成学习者之旅的这个步骤"]);
    },
    "your-program-has-started": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["Your Program has started: ", n(r("name")), `
您的计划已开始：`, n(r("name"))]);
    },
    "keep-making-progress-in-program": (e) => {
      const { normalize: t } = e;
      return t(["继续推进您的计划"]);
    },
    "explore-resources": (e) => {
      const { normalize: t } = e;
      return t(["按需查找资源"]);
    },
    "community-announcement": (e) => {
      const { normalize: t } = e;
      return t(["社区公告"]);
    },
    "homepage-tile-description": {
      journey: {
        completed: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["恭喜完成学习者之旅，", n(r("name")), "。完成记录已显示在<link>您的个人资料</link>内。"]);
        },
        ending: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["本次学习者之旅 ", n(r("title")), " 将在 ", n(r("daysRemaining")), " 天后于 ", n(r("endDate")), " 结束。请完成最后几步。"]);
        },
        ended: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["本次学习者之旅 ", n(r("title")), " 已结束。"]);
        },
        invited: (e) => {
          const { normalize: t } = e;
          return t(["您已受邀参加本次学习者之旅。您可以随时<link>查看此旅程中的所有步骤</link>。"]);
        },
        progress: (e) => {
          const { normalize: t } = e;
          return t(["探索向您提供的所有学习者之旅。"]);
        }
      },
      explore: {
        community: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["通过“社区”，大家可以分享想法、内容和专业知识；展示才华和成就；提出问题；并从同事和专家处获得切实帮助。"]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["我们收集了当天整个“社区”中最活跃的讨论。您还可以在<link>“社区”页面</link>浏览所有最新的帖子。"]);
          }
        },
        resources: {
          initial: (e) => {
            const { normalize: t } = e;
            return t(["您可以随时访问分成小段学习内容的资源。这些资源涵盖了可以在数分钟内领会和运用的方法和框架。"]);
          },
          discussions: (e) => {
            const { normalize: t } = e;
            return t(["以下是今天阅读和讨论最多的资源。您还可以在<link>资源库</link>中浏览所有分成小段的学习内容。"]);
          }
        },
        journeys: (e) => {
          const { normalize: t } = e;
          return t(["学习者之旅是根据我们的学习心得精心策划的指南，其将有时限的计划与当今最关键主题相关的按需资源组合在一起。"]);
        },
        programs: (e) => {
          const { normalize: t } = e;
          return t(["探索我们的计划库，注册参加即将到来的课程，也可以查找可随时参加的计划。开始后，您可以了解您的团队、攀登排行榜并获得结业证书。"]);
        }
      },
      journey_step: {
        community: (e) => {
          const { normalize: t } = e;
          return t(["这针对旅程步骤社区。这针对旅程步骤社区。"]);
        }
      },
      program: {
        new_comments: (e) => {
          const { normalize: t } = e;
          return t(["在您参与的讨论中有一些新评论，请查看并加入对话。"]);
        },
        program_reminder: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["温馨提醒，计划将于 ", n(r("daysRemaining")), " 天后结束，您团队的平均完成情况为 ", n(r("teamProgress")), "%。"]);
        },
        "in-progress": (e) => {
          const { normalize: t } = e;
          return t(["请查看您团队最近的活动并回到对话中。"]);
        }
      },
      resource: {
        webinar: (e) => {
          const { normalize: t, interpolate: n, named: r } = e;
          return t(["立即加入我们的现场网络研讨会，我们将讨论混合工作的未来，还计划在研讨会结束时开设问答环节。<br /><br /><strong>日期：</strong> ", n(r("date")), "<br /><strong>时间：</strong> ", n(r("time")), " ", n(r("timezone")), " <br />"]);
        },
        share: (e) => {
          const { normalize: t } = e;
          return t(["与全球 Nomadic 社区建立联系，分享截至目前您对混合工作的了解，以及您认为这种工作模式的发展方向。"]);
        },
        step: (e) => {
          const { normalize: t } = e;
          return t(["该资源今天正在进行。您可以随时<link>查看本资源中的所有步骤</link>。"]);
        }
      }
    },
    "join-journey": (e) => {
      const { normalize: t } = e;
      return t(["加入学习者之旅"]);
    },
    "start-journey": (e) => {
      const { normalize: t } = e;
      return t(["启动学习者之旅"]);
    },
    "share-resource": (e) => {
      const { normalize: t } = e;
      return t(["共享资源"]);
    },
    "be-first-comment-react": (e) => {
      const { normalize: t } = e;
      return t(["赶快来评论和互动"]);
    },
    "journey-update": (e) => {
      const { normalize: t } = e;
      return t(["旅程更新"]);
    },
    "and-others": (e) => {
      const { normalize: t } = e;
      return t(["等等"]);
    },
    you: (e) => {
      const { normalize: t } = e;
      return t(["你"]);
    },
    "you-and": (e) => {
      const { normalize: t } = e;
      return t(["你和"]);
    },
    "poll-results": (e) => {
      const { normalize: t } = e;
      return t(["投票结果"]);
    },
    "go-to-poll-question": (e) => {
      const { normalize: t } = e;
      return t(["前往投票问题页面"]);
    },
    points: (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("count")), " 分"]);
    },
    "enrol-in-session": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["注册", n(r("name")), "课程"]);
    },
    "pending-users": (e) => {
      const { normalize: t } = e;
      return t(["待定用户"]);
    },
    search: (e) => {
      const { normalize: t } = e;
      return t(["搜索"]);
    },
    "search-placeholder": (e) => {
      const { normalize: t } = e;
      return t(["输入电子邮件地址……"]);
    },
    "search-support-text": (e) => {
      const { normalize: t } = e;
      return t(["通过电子邮件地址搜索用户"]);
    },
    "pending-users-description": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["已向以下电子邮件地址发送邀请。如果这些电子邮件地址用户注册成功，他们将可以使用许可。您可以向这些电子邮件地址用户重新发送邀请、取消邀请，也可以向他们发送 ", n(r(0)), "。"]);
    },
    "subscription-join-link": (e) => {
      const { normalize: t } = e;
      return t(["订阅加入链接"]);
    },
    anonymize_names_and_email: (e) => {
      const { normalize: t } = e;
      return t(["对姓名和电子邮件进行匿名化处理"]);
    },
    delete_rsc_comments: (e) => {
      const { normalize: t } = e;
      return t(["删除 RSC 评论"]);
    },
    delete_community_posts: (e) => {
      const { normalize: t } = e;
      return t(["删除社区帖子"]);
    },
    anonymize_mentions: (e) => {
      const { normalize: t } = e;
      return t(["对所提及用户进行匿名化处理"]);
    },
    delete_profile_fields: (e) => {
      const { normalize: t } = e;
      return t(["删除个人资料字段"]);
    },
    delete_rsc_reflections: (e) => {
      const { normalize: t } = e;
      return t(["删除 RSC 反思"]);
    },
    delete_community_comments: (e) => {
      const { normalize: t } = e;
      return t(["删除社区评论"]);
    },
    preserve_profile_field: (e) => {
      const { normalize: t } = e;
      return t(["保存个人资料字段"]);
    },
    delete_fm_comments: (e) => {
      const { normalize: t } = e;
      return t(["删除 FM 评论"]);
    },
    delete_fm_private_notes: (e) => {
      const { normalize: t } = e;
      return t(["删除 FM 私人笔记"]);
    },
    delete_program_conversations: (e) => {
      const { normalize: t } = e;
      return t(["删除计划对话"]);
    },
    user: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["用户"]), t(["用户"])]);
    },
    were: (e) => {
      const { normalize: t, plural: n } = e;
      return n([t(["是"]), t(["是"])]);
    },
    "row-list": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["行：", n(r("rowList"))]), t(["行：", n(r("rowList"))])]);
    },
    "upload-success": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["文件上传成功，已检测到一个有效行"]), t(["文件上传成功，已检测到 ", n(r("n")), " 个有效行"])]);
    },
    "generic-upload-error": (e) => {
      const { normalize: t } = e;
      return t(["上传错误。"]);
    },
    "bulk-delete-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["文件结构：1 列的标题中必须有“电子邮件”"]);
    },
    "bulk-connect-sso-upload-hint": (e) => {
      const { normalize: t } = e;
      return t(["文件结构：1 列的标题中必须有“电子邮件”。可能会提供可选的“SSO ID”列。"]);
    },
    error: {
      MissingFile: (e) => {
        const { normalize: t } = e;
        return t(["上传文件缺失"]);
      },
      InvalidFile: (e) => {
        const { normalize: t } = e;
        return t(["文件不是 .xlsx 格式"]);
      },
      MissingColumns: (e) => {
        const { normalize: t } = e;
        return t(["文件不包含在标题含“电子邮件”的列"]);
      },
      NoUsersFound: (e) => {
        const { normalize: t } = e;
        return t(["在上传文件中未找到任何用户"]);
      },
      AlreadyConnected: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个用户已连接到 SSO"]);
      },
      InvalidEmail: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个行包含的电子邮件地址无效"]);
      },
      InvalidSsoId: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个行包含的 SSO ID 无效"]);
      },
      MissingEmail: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个行不包含电子邮件地址"]);
      },
      MultipleProviders: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个用户有多个 SSO 提供商"]);
      },
      NoProfileFieldValue: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个用户没有 SSO ID"]);
      },
      NoProviders: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个用户没有 SSO 提供商"]);
      },
      UnrecognisedEmail: (e) => {
        const { normalize: t } = e;
        return t(["一个或多个电子邮件地址与现有用户不匹配"]);
      }
    },
    "learning-exp-types": {
      resource: (e) => {
        const { normalize: t } = e;
        return t(["资源"]);
      },
      program: (e) => {
        const { normalize: t } = e;
        return t(["计划"]);
      },
      fm: (e) => {
        const { normalize: t } = e;
        return t(["指导手册"]);
      },
      journey: (e) => {
        const { normalize: t } = e;
        return t(["学习者之旅"]);
      },
      journey_step: (e) => {
        const { normalize: t } = e;
        return t(["学习者之旅步骤"]);
      }
    },
    "edition-creation": {
      attributes: {
        copy_programs: (e) => {
          const { normalize: t } = e;
          return t(["复制所有计划（及其标签和类型）"]);
        },
        copy_program_tag_heading: (e) => {
          const { normalize: t } = e;
          return t(["复制计划标签标题名称（例如，通过 Nomadic 学院提升技能）"]);
        },
        copy_resource_types: (e) => {
          const { normalize: t } = e;
          return t(["复制资源库类型标签"]);
        },
        copy_resources: (e) => {
          const { normalize: t } = e;
          return t(["复制所有资源和主题标签"]);
        },
        copy_community_tags: (e) => {
          const { normalize: t } = e;
          return t(["复制社区标签"]);
        }
      }
    },
    profile: (e) => {
      const { normalize: t } = e;
      return t(["个人资料"]);
    },
    "admin-dashboard": (e) => {
      const { normalize: t } = e;
      return t(["管理员仪表板"]);
    },
    "back-to-academy": (e) => {
      const { normalize: t } = e;
      return t(["返回到学院"]);
    },
    "min-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["最小图像尺寸：", n(r("width")), " x ", n(r("height"))]);
    },
    "max-image-dimensions": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["最大图像尺寸：", n(r("width")), " x ", n(r("height"))]);
    },
    days_remaining: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["剩余 ", n(r("n")), " 天"]), t(["剩余 ", n(r("n")), " 天"])]);
    },
    in_x_days: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("n")), " 天"]), t([n(r("n")), " 天"])]);
    },
    less_than_a_day: (e) => {
      const { normalize: t } = e;
      return t(["不到一天"]);
    },
    "x-days-to-complete-y": (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t(["完成 ", n(r("name")), " 还剩 ", n(r("n")), " 天"]), t(["完成 ", n(r("name")), " 还剩 ", n(r("n")), " 天"])]);
    },
    "your-program-is-starting-soon": (e) => {
      const { normalize: t } = e;
      return t(["您的计划即将开始"]);
    },
    "start-today": (e) => {
      const { normalize: t } = e;
      return t(["立即开始"]);
    },
    "program-update": (e) => {
      const { normalize: t } = e;
      return t(["计划更新"]);
    },
    "journey-invited": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["您受邀请参加学习者之旅：", n(r("name"))]);
    },
    "journey-ending": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["本次学习者之旅即将结束：", n(r("name"))]);
    },
    "journey-completed": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["祝贺！您已完成本次学习者之旅 ", n(r("name"))]);
    },
    "complete-next-step-in-journey": (e) => {
      const { normalize: t } = e;
      return t(["完成学习者之旅的下一步"]);
    },
    "coming-up-in-journey-enroll-program": (e) => {
      const { normalize: t } = e;
      return t(["接下来的学习者之旅是：注册参加此计划"]);
    },
    "x-has-ended": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " 已结束"]);
    },
    "x-is-ending-soon": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t([n(r("name")), " 即将结束"]);
    },
    "completed-your-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["您已完成计划：", n(r("name"))]);
    },
    "you-enrolled-in-x-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["您已注册参加 ", n(r("name")), " (", n(r("date")), ")"]);
    },
    "your-program-has-started-when": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["您的计划已开始：", n(r("name")), " (", n(r("date")), ")"]);
    },
    "added-to-new-program": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["已将您添加到新计划：", n(r("name"))]);
    },
    "enroll-for-the-next-session-of-x": (e) => {
      const { normalize: t, interpolate: n, named: r } = e;
      return t(["注册参加接下来的 ", n(r("name")), " 课程"]);
    },
    "explore-programs": (e) => {
      const { normalize: t } = e;
      return t(["查找适合您的计划"]);
    },
    "explore-journeys": (e) => {
      const { normalize: t } = e;
      return t(["探索学习者之旅"]);
    },
    "join-the-community": (e) => {
      const { normalize: t } = e;
      return t(["加入“社区”"]);
    },
    "happening-now-community": (e) => {
      const { normalize: t } = e;
      return t(["正在“社区”中进行"]);
    },
    "incomplete-step-message": (e) => {
      const { normalize: t } = e;
      return t(["以下是您参加的学习者之旅的不完整步骤。您还可以<link>查看此旅程中的所有步骤</link>。"]);
    },
    "incomplete-program-step-message": (e) => {
      const { normalize: t } = e;
      return t(["完成本计划是您学习者之旅中的一个步骤。您可以随时<link>查看此旅程中的所有步骤</link>。"]);
    },
    "get-started": (e) => {
      const { normalize: t } = e;
      return t(["开始"]);
    },
    "review-program": (e) => {
      const { normalize: t } = e;
      return t(["回顾计划"]);
    },
    "journey-details": (e) => {
      const { normalize: t } = e;
      return t(["学习者之旅详情"]);
    },
    "continue-journey": (e) => {
      const { normalize: t } = e;
      return t(["继续学习者之旅"]);
    },
    enroll: (e) => {
      const { normalize: t } = e;
      return t(["注册"]);
    },
    "start-program": (e) => {
      const { normalize: t } = e;
      return t(["开始计划"]);
    },
    "open-program": (e) => {
      const { normalize: t } = e;
      return t(["打开计划"]);
    },
    "continue-program": (e) => {
      const { normalize: t } = e;
      return t(["继续计划"]);
    },
    enrolled: (e) => {
      const { normalize: t } = e;
      return t(["已注册参加"]);
    },
    "program-details": (e) => {
      const { normalize: t } = e;
      return t(["计划详情"]);
    },
    "mark-as-complete": (e) => {
      const { normalize: t } = e;
      return t(["标记为“已完成”"]);
    },
    "remind-me-later": (e) => {
      const { normalize: t } = e;
      return t(["稍后提醒"]);
    },
    "launch-webinar": (e) => {
      const { normalize: t } = e;
      return t(["启动网络研讨会"]);
    },
    "explore-all-programs": (e) => {
      const { normalize: t } = e;
      return t(["探索所有计划"]);
    },
    "explore-all-journeys": (e) => {
      const { normalize: t } = e;
      return t(["探索所有学习者之旅"]);
    },
    "resource-library": (e) => {
      const { normalize: t } = e;
      return t(["资源库"]);
    },
    "open-community": (e) => {
      const { normalize: t } = e;
      return t(["打开社区"]);
    },
    "join-community": (e) => {
      const { normalize: t } = e;
      return t(["加入社区"]);
    },
    "homepage-group-activity": {
      started: (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["已开始。"]), t(["已开始。"])]);
      },
      completed: (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["已完成 ", n(r("name")), "。"]), t(["已完成 ", n(r("name")), "。"])]);
      },
      enrolled: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已注册参加 ", n(r("name")), "。"]);
      },
      "journey-invited": (e) => {
        const { normalize: t } = e;
        return t(["已受邀参加本次学习者之旅"]);
      },
      "journey-ending": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["本次学习者之旅即将结束，", n(r("name"))]);
      },
      "journey-completed": (e) => {
        const { normalize: t } = e;
        return t(["已完成本次学习者之旅"]);
      },
      "journey-started": (e) => {
        const { normalize: t, interpolate: n, named: r, plural: o } = e;
        return o([t(["已开始 ", n(r("name"))]), t(["已开始 ", n(r("name")), "。"])]);
      },
      "journey-progress": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["正在通过本次学习者之旅取得进步"]), t(["正在通过本次学习者之旅取得进步"])]);
      },
      "journey_step-started_resources": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已开始 ", n(r("name")), "。"]);
      },
      "journey_step-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已注册参加 ", n(r("name")), "。"]);
      },
      "journey_step-completed": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已完成 ", n(r("name")), "。"]);
      },
      "journey_step-completed_step": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["已完成此步骤。"]), t(["已完成此步骤。"])]);
      },
      "journey_step-posted": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["已在社区发布"]), t(["已在社区发布。"])]);
      },
      "program-happening-now": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["正在 ", n(r("name")), " 中进行"]);
      },
      "program-completed": (e) => {
        const { normalize: t } = e;
        return t(["刚刚完成了计划并获得了证书。"]);
      },
      "program-enrolled": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已注册参加 ", n(r("name"))]);
      },
      "program-started": (e) => {
        const { normalize: t, plural: n } = e;
        return n([t(["（来自您的团队）已开始。"]), t(["（来自您的团队）已开始。"])]);
      },
      "program-added": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已添加到新计划：", n(r("name"))]);
      },
      "program-answered-poll": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已在 ", n(r("name")), " 中回答了此调查问题"]);
      },
      "program-watched": (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(['已观看本视频 - <a href="', n(r("link")), '">', n(r("name")), "</a>"]);
      },
      "program-read-section": (e) => {
        const { normalize: t } = e;
        return t(["已阅读此部分"]);
      }
    },
    "happening-now-resources": (e) => {
      const { normalize: t } = e;
      return t(["正在“资源”中进行"]);
    },
    "happening-now": (e) => {
      const { normalize: t } = e;
      return t(["正在进行"]);
    },
    leaderboard: (e) => {
      const { normalize: t } = e;
      return t(["排行榜"]);
    },
    "homepage-tile-program_in_progress_description": {
      commenting: (e) => {
        const { normalize: t } = e;
        return t(["您的团队正在该计划的讨论中发表评论。请查看并在对话中添加您的想法。"]);
      },
      discussions: (e) => {
        const { normalize: t } = e;
        return t(["您的团队在该计划的几个讨论中很活跃。请查看并在对话中添加您的想法。"]);
      },
      leaderboard: (e) => {
        const { normalize: t } = e;
        return t(["您的团队正在取得进步并获得积分。这是当前位于计划排行榜前列的人员。您是否进入了前 10？ 检查排行榜，了解您目前的排名。"]);
      },
      page: (e) => {
        const { normalize: t } = e;
        return t(["从您最后的停止点开始继续阅读。"]);
      },
      new_poll: (e) => {
        const { normalize: t } = e;
        return t(["计划中要完成的下一个部分是调查。"]);
      },
      progress: (e) => {
        const { normalize: t } = e;
        return t(["以下是您团队和您的平均进步情况比较。"]);
      }
    },
    "homepage-program-not-started": {
      program_starts_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["计划于今天 ", n(r("time")), " 开始。"]);
      },
      program_starts_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["计划于 ", n(r("days")), " 后开始。"]);
      },
      program_ends_today: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["计划于今天 ", n(r("time")), " 结束。"]);
      },
      program_ends_in_days: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["计划于 ", n(r("days")), " 后结束。"]);
      },
      program_started_today: (e) => {
        const { normalize: t } = e;
        return t(["计划已于今天开始。"]);
      },
      program_started_days_ago: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["计划已于 ", n(r("days")), " 天前开始。"]);
      },
      program_reminder: (e) => {
        const { normalize: t } = e;
        return t([" 计划开始后，我们会向您发送电子邮件提醒。"]);
      }
    },
    "homepage-progress": {
      standard: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["完成 ", n(r("progress")), "%"]);
      },
      steps: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已完成 ", n(r("currentStep")), " 个步骤（共 ", n(r("maxSteps")), " 个步骤）"]);
      },
      community_posts: (e) => {
        const { normalize: t, interpolate: n, named: r } = e;
        return t(["已完成 ", n(r("completed")), " 个社区帖子（共 ", n(r("required")), " 个社区帖子）"]);
      },
      program_closed: (e) => {
        const { normalize: t } = e;
        return t(["计划已关闭"]);
      }
    },
    comment: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " 个评论"]), t([n(r("count")), " 个评论"])]);
    },
    reaction: (e) => {
      const { normalize: t, interpolate: n, named: r, plural: o } = e;
      return o([t([n(r("count")), " 个回应"]), t([n(r("count")), " 个回应"])]);
    },
    "your-progress": (e) => {
      const { normalize: t } = e;
      return t(["您的进度"]);
    },
    "team-average": (e) => {
      const { normalize: t } = e;
      return t(["团队平均"]);
    },
    "x-percent-complete": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t([n(r(0)), "% 完成"]);
    },
    "learn-more": (e) => {
      const { normalize: t } = e;
      return t(["了解更多"]);
    },
    "start-now": (e) => {
      const { normalize: t } = e;
      return t(["立即开始"]);
    },
    "x-of-y-resources-completed": (e) => {
      const { normalize: t, interpolate: n, list: r } = e;
      return t(["已完成 ", n(r(0)), " 个资源中的 ", n(r(1)), " 个"]);
    },
    "view-all-journey-steps": (e) => {
      const { normalize: t } = e;
      return t(["查看所有学习者之旅步骤"]);
    }
  } }
), qT = document.cookie.replace(
  /(?:(?:^|.*;\s*)_LOCALE_\s*=\s*([^;]*).*$)|^.*$/,
  "$1"
) || "en", HT = c0({
  globalInjection: !0,
  locale: qT,
  // set locale
  fallbackLocale: "en",
  // set fallback locale
  messages: VT
  // set locale messages
});
Md(Ry);
const BT = ve;
ve = function(...e) {
  const t = ur();
  return t !== null && (t.isCE = !0), BT(...e);
};
const JT = /* @__PURE__ */ Q({
  props: {
    edition: {
      type: Number,
      required: !0
    },
    welcome: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    return tr(UT, e.edition), tr(hp, HT), () => pt(wm, {
      initialWelcomeOpen: e.welcome
    });
  },
  styles: wm.styles
});
customElements.define(
  "home-page-preview",
  /* @__PURE__ */ Pv(JT)
);
const WT = { key: 0 }, YT = ["innerHTML"], GT = /* @__PURE__ */ Q({
  __name: "ExploreCommunity",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const { t } = ve(), n = li(
      t("homepage-tile-description.explore.community.discussions"),
      "/community?hp_src_xc=text"
    );
    return (r, o) => r.tile.initial ? (w(), P("p", WT, D(X(t)("homepage-tile-description.explore.community.initial")), 1)) : (w(), P("p", {
      key: 1,
      innerHTML: X(n)
    }, null, 8, YT));
  }
}), KT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: GT
}, Symbol.toStringTag, { value: "Module" })), QT = /* @__PURE__ */ Q({
  __name: "ExploreJourneys",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("p", null, D(X(t)("homepage-tile-description.explore.journeys")), 1));
  }
}), XT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: QT
}, Symbol.toStringTag, { value: "Module" })), ZT = /* @__PURE__ */ Q({
  __name: "ExplorePrograms",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("p", null, D(X(t)("homepage-tile-description.explore.programs")), 1));
  }
}), eC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ZT
}, Symbol.toStringTag, { value: "Module" })), tC = { key: 0 }, nC = ["innerHTML"], rC = /* @__PURE__ */ Q({
  __name: "ExploreResources",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const { t } = ve(), n = li(
      t("homepage-tile-description.explore.resources.discussions"),
      "/resource-library?hp_src_xr=text"
    );
    return (r, o) => r.tile.initial ? (w(), P("p", tC, D(X(t)("homepage-tile-description.explore.resources.initial")), 1)) : (w(), P("p", {
      key: 1,
      innerHTML: X(n)
    }, null, 8, nC));
  }
}), oC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rC
}, Symbol.toStringTag, { value: "Module" })), aC = ["innerHTML"], iC = /* @__PURE__ */ Q({
  __name: "JourneyCompleted",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve(), r = li(
      t("homepage-tile-description.journey.completed", {
        name: e.tile.journey.title
      }),
      "/profile"
    );
    return (o, a) => (w(), P("p", { innerHTML: X(r) }, null, 8, aC));
  }
}), sC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: iC
}, Symbol.toStringTag, { value: "Module" })), lC = ["innerHTML"], cC = /* @__PURE__ */ Q({
  __name: "JourneyEnding",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const { t } = ve(), n = e, r = dn(n.tile.journey.endDate) < 0 ? "ended" : "ending", o = t(`homepage-tile-description.journey.${r}`, {
      title: n.tile.journey.title,
      in_x_days: t("in_x_days", {
        n: dn(n.tile.journey.endDate)
      }),
      endDate: Et(n.tile.journey.endDate, "LL")
    });
    return (a, i) => (w(), P("p", { innerHTML: X(o) }, null, 8, lC));
  }
}), uC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cC
}, Symbol.toStringTag, { value: "Module" })), mC = ["innerHTML"], dC = /* @__PURE__ */ Q({
  __name: "JourneyInvited",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (w(), P("p", {
      innerHTML: e.tile.journey.description
    }, null, 8, mC));
  }
}), pC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: dC
}, Symbol.toStringTag, { value: "Module" })), fC = /* @__PURE__ */ Q({
  __name: "JourneyProgress",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("p", null, D(X(t)("homepage-tile-description.journey.progress")), 1));
  }
}), _C = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fC
}, Symbol.toStringTag, { value: "Module" })), gC = /* @__PURE__ */ Q({
  __name: "JourneyStepCommunity",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("p", null, D(X(t)("homepage-tile-description.journey_step.community")), 1));
  }
}), hC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gC
}, Symbol.toStringTag, { value: "Module" })), vC = /* @__PURE__ */ Q({
  __name: "JourneyStepResourceList",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (w(), P("p"));
  }
}), yC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vC
}, Symbol.toStringTag, { value: "Module" })), bC = ["innerHTML"], zC = /* @__PURE__ */ Q({
  __name: "JourneyStepWebinar",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (w(), P("div", {
      innerHTML: e.tile.description
    }, null, 8, bC));
  }
}), jC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: zC
}, Symbol.toStringTag, { value: "Module" })), wC = /* @__PURE__ */ Q({
  __name: "ProgramHappeningNow",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P(se, null, [
      x("p", null, D(X(t)("homepage-tile-description.program.new_comments")), 1),
      x("p", null, [
        e.tile.program?.endDate ? (w(), P(se, { key: 0 }, [
          Ee(D(X(t)("homepage-tile-description.program.program_reminder", {
            daysRemaining: X(dn)(e.tile.program?.endDate) > 0 ? X(t)("in_x_days", { n: X(dn)(e.tile.program?.endDate) }) : X(t)("less_than_a_day"),
            teamProgress: e.tile.progress.teamProgress
          })), 1)
        ], 64)) : re("", !0)
      ])
    ], 64));
  }
}), xC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: wC
}, Symbol.toStringTag, { value: "Module" })), kC = /* @__PURE__ */ Q({
  __name: "ProgramInProgress",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("p", null, D(X(t)("homepage-tile-description.program.in-progress")), 1));
  }
}), SC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kC
}, Symbol.toStringTag, { value: "Module" })), EC = ["innerHTML"], PC = /* @__PURE__ */ Q({
  __name: "ResourceHappeningToday",
  props: {
    tile: { type: null }
  },
  setup(e) {
    const { t } = ve(), n = e, r = t("homepage-tile-description.resource.webinar", {
      date: Et(n.tile.resource.startDate, "PPP"),
      time: Et(n.tile.resource.startDate, "p"),
      timezone: "UTC"
    });
    return (o, a) => (w(), P("p", { innerHTML: X(r) }, null, 8, EC));
  }
}), TC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: PC
}, Symbol.toStringTag, { value: "Module" })), CC = /* @__PURE__ */ Q({
  __name: "ResourceShare",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("p", null, D(X(t)("homepage-tile-description.resource.share")), 1));
  }
}), AC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CC
}, Symbol.toStringTag, { value: "Module" })), OC = ["innerHTML"], IC = /* @__PURE__ */ Q({
  __name: "ResourceStep",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (w(), P("p", {
      innerHTML: e.tile.resource.description
    }, null, 8, OC));
  }
}), LC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: IC
}, Symbol.toStringTag, { value: "Module" })), NC = { class: "card" }, MC = { class: "card-text" }, RC = { class: "title-domain-container" }, $C = ["href"], DC = { class: "card-title" }, FC = {
  key: 0,
  class: "card-domain"
}, UC = { class: "card-description" }, VC = /* @__PURE__ */ Q({
  __name: "AttachmentItem",
  props: {
    card: { type: Object }
  },
  setup(e) {
    const t = e, n = ee(() => t.card.image.search("AWSAccessKeyId") > -1 ? t.card.image : `https://res.cloudinary.com/nomadic/image/fetch/w_100,h_100,c_fill,f_auto,q_60/${encodeURIComponent(
      t.card.image
    )}`);
    return (r, o) => (w(), P("div", NC, [
      r.card.image ? (w(), ge(st, {
        key: 0,
        class: "card-image",
        src: n.value,
        alt: r.card.title
      }, null, 8, ["src", "alt"])) : re("", !0),
      x("div", MC, [
        x("div", RC, [
          x("a", {
            href: r.card.url,
            target: "_blank",
            rel: "noopener noreferrer",
            class: "card-link"
          }, [
            x("span", DC, D(r.card.title), 1)
          ], 8, $C),
          r.card.domain ? (w(), P("span", FC, D(r.card.domain), 1)) : re("", !0)
        ]),
        x("div", UC, D(r.card.description), 1)
      ])
    ]));
  }
}), qC = ".card[data-v-f2e4ed09]{min-height:150px;background:#f2f2f2;border-radius:8px;display:flex;flex-direction:row;border:none;align-items:center}.card.card-type-attachment .card-title[data-v-f2e4ed09]{font-weight:400}.card.card-type-link .card-title[data-v-f2e4ed09]{font-weight:700}.card .card-image[data-v-f2e4ed09]{overflow:hidden;border-radius:8px 0 0 8px;object-position:center;object-fit:cover;align-self:stretch;width:150px;flex-shrink:0}.card .card-text[data-v-f2e4ed09]{overflow:hidden;padding:1em}.card .card-text .card-link[data-v-f2e4ed09]{text-decoration:none}.card .card-text .card-title[data-v-f2e4ed09]{color:#000;display:-webkit-box;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;-webkit-box-orient:vertical;text-decoration:none;font-weight:700;margin-bottom:.5em}.card .card-text .card-domain[data-v-f2e4ed09]{display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:1em;text-decoration:underline}.card .card-text .card-description[data-v-f2e4ed09]{display:-webkit-box;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;-webkit-box-orient:vertical}@media all and (-ms-high-contrast: none),(-ms-high-contrast: active){.card .card-text .card-description[data-v-f2e4ed09]{display:none}}.line-clamp[data-v-f2e4ed09]{display:-webkit-box;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;-webkit-box-orient:vertical}@media (max-width: 540px){.card[data-v-f2e4ed09]{flex-direction:column}.card .card-image[data-v-f2e4ed09]{width:100%;border-radius:8px 8px 0 0;height:150px}}", n_ = /* @__PURE__ */ ae(VC, [["styles", [qC]], ["__scopeId", "data-v-f2e4ed09"]]), HC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n_
}, Symbol.toStringTag, { value: "Module" })), BC = { key: 0 }, JC = /* @__PURE__ */ Q({
  __name: "AttachmentLoader",
  props: {
    attachments: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => e.attachments?.length ? (w(), P("div", BC, [
      (w(!0), P(se, null, De(e.attachments, (r) => (w(), ge(n_, {
        key: r.id,
        card: r
      }, null, 8, ["card"]))), 128))
    ])) : re("", !0);
  }
}), WC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: JC
}, Symbol.toStringTag, { value: "Module" })), YC = { class: "multiple-profiles" }, GC = { class: "profile-list" }, KC = {
  key: 0,
  class: "profile-count"
}, QC = /* @__PURE__ */ Q({
  __name: "MultipleProfiles",
  props: {
    profiles: { type: Array },
    max: { default: 5, type: Number },
    showRemainder: { type: Boolean, default: !0 },
    total: { default: 0, type: Number }
  },
  setup(e) {
    const t = e, n = ee(() => t.profiles?.slice(0, t.max)), r = ee(() => (t.total ?? t.profiles.length) - t.max);
    return (o, a) => (w(), P("div", YC, [
      x("div", GC, [
        (w(!0), P(se, null, De(n.value, (i) => (w(), ge(Qt, {
          key: "profile" + i.id,
          imgURL: i.picture,
          name: i.name,
          size: "mini",
          class: "profile-avatar"
        }, null, 8, ["imgURL", "name"]))), 128))
      ]),
      r.value > 0 && o.showRemainder ? (w(), P("div", KC, " +" + D(r.value), 1)) : re("", !0)
    ]));
  }
}), XC = ".multiple-profiles[data-v-b77ca44a]{display:flex;width:fit-content;padding-right:.5rem}.profile-list[data-v-b77ca44a]{display:flex}.profile-list .profile-avatar[data-v-b77ca44a]{margin-right:-.5rem}.profile-count[data-v-b77ca44a]{display:flex;align-items:center;justify-content:center;height:2.15rem;font-weight:650;margin-left:.75rem}", Bl = /* @__PURE__ */ ae(QC, [["styles", [XC]], ["__scopeId", "data-v-b77ca44a"]]), ZC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Bl
}, Symbol.toStringTag, { value: "Module" })), e2 = { class: "comment-group" }, t2 = { class: "content" }, n2 = {
  key: 0,
  class: "reactions"
}, r2 = { class: "meta" }, o2 = { key: 0 }, a2 = {
  key: 1,
  class: "comment-tile__comment-count"
}, i2 = { key: 2 }, s2 = {
  key: 3,
  class: "unread-indicator"
}, l2 = /* @__PURE__ */ Q({
  __name: "CommentGroup",
  props: {
    authors: { type: Array },
    reactions: { default: () => [], type: Array },
    comment_count: { type: Number },
    reaction_count: { type: Number },
    unread: { type: Boolean, default: !1 },
    short: { type: Boolean, default: !1 }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ee(() => n.comment_count == 0 && n.reaction_count == 0), o = {
      clap: "👏",
      thumbsup: "👍",
      bulb: "💡",
      boom: "💥",
      100: "💯",
      // Note: Numeric keys are valid, but they will be coerced to a string.
      rocket: "🚀",
      muscle: "💪",
      tada: "🎉",
      exploding_head: "🤯"
    };
    function a(i) {
      return o[i] || i;
    }
    return (i, s) => (w(), P("div", e2, [
      x("div", t2, [
        B(Bl, {
          profiles: i.authors,
          max: i.short == !0 ? 3 : 4,
          "show-remainder": i.short != !0
        }, null, 8, ["profiles", "max", "show-remainder"]),
        i.reactions?.length > 0 && !i.short ? (w(), P("div", n2, [
          (w(!0), P(se, null, De(i.reactions, (l) => (w(), P("span", {
            key: l,
            class: "reaction"
          }, D(a(l)), 1))), 128))
        ])) : re("", !0)
      ]),
      x("div", r2, [
        r.value ? (w(), P("span", o2, D(X(t)("be-first-comment-react")), 1)) : !i.reactions || i.reactions.length == 0 ? (w(), P("span", a2, D(X(t)("comment", { count: i.comment_count })), 1)) : (w(), P("div", i2, D(X(t)("comment", { count: i.comment_count })) + ", " + D(X(t)("reaction", { count: i.reaction_count })), 1)),
        i.unread ? (w(), P("div", s2)) : re("", !0)
      ])
    ]));
  }
}), c2 = ".comment-group[data-v-4a587111]{display:flex;gap:.5rem;align-items:center;margin-bottom:.5rem;max-width:15rem;flex-wrap:wrap}.comment-group .content[data-v-4a587111]{display:flex}.unread-indicator[data-v-4a587111]{width:10px;height:10px;border-radius:50%;background:#e90000}.reactions[data-v-4a587111]{display:flex;gap:.2rem;background:#fff;border:1px solid #ffffffba;padding:.175rem .65rem .175rem .5rem;border-radius:10rem;margin-left:-.75rem;z-index:1}.reaction[data-v-4a587111]{font-size:1.2rem;transition:all .2s ease-in-out;cursor:pointer}.reaction[data-v-4a587111]:hover{transform:translateY(-3px)}.meta[data-v-4a587111]{display:flex;align-items:center;gap:.5rem;flex-wrap:nowrap}", Mo = /* @__PURE__ */ ae(l2, [["styles", [c2]], ["__scopeId", "data-v-4a587111"]]), u2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Mo
}, Symbol.toStringTag, { value: "Module" })), m2 = {
  class: "comment-tile",
  tabindex: "0"
}, d2 = {
  key: 0,
  class: "comment-tile__author"
}, p2 = { class: "comment-tile__content" }, f2 = { class: "comment-tile__author-meta" }, _2 = { class: "comment-tile__author-name" }, g2 = {
  key: 0,
  class: "comment-tile__date"
}, h2 = {
  key: 0,
  class: "comment-tile__title"
}, v2 = ["innerHTML"], y2 = {
  key: 1,
  class: "profiles"
}, b2 = /* @__PURE__ */ Q({
  __name: "CommentTile",
  props: {
    author: { type: null },
    date: { type: String },
    link: { type: String },
    title: { type: String },
    text: { type: String },
    comment_count: { type: Number },
    commentators: { type: Array },
    unread: { type: Boolean }
  },
  setup(e) {
    const t = e;
    function n() {
      t.link && (window.location.href = t.link);
    }
    return (r, o) => (w(), P("div", m2, [
      x("div", { class: "link" }, [
        x("button", {
          role: "link",
          onClick: n
        }, "View comment")
      ]),
      r.author ? (w(), P("div", d2, [
        B(Qt, {
          "img-url": r.author.image,
          name: r.author.name,
          profile: r.author.profile,
          id: r.author.id
        }, null, 8, ["img-url", "name", "profile", "id"]),
        x("div", p2, [
          x("div", f2, [
            x("span", _2, D(r.author.name), 1),
            r.date ? (w(), P("span", g2, D(X(jl)(r.date, { addSuffix: !0 })), 1)) : re("", !0)
          ]),
          r.title ? (w(), P("h4", h2, D(r.title), 1)) : re("", !0),
          x("div", {
            class: "comment-tile__text",
            innerHTML: r.text
          }, null, 8, v2),
          r.commentators && r.commentators.length ? (w(), P("div", y2, [
            B(Mo, {
              authors: r.commentators,
              comment_count: r.comment_count,
              unread: r.unread
            }, null, 8, ["authors", "comment_count", "unread"])
          ])) : re("", !0)
        ])
      ])) : re("", !0)
    ]));
  }
}), z2 = ".comment-tile[data-v-e45cf683]{position:relative;padding:1.4rem 1.2rem 2.5rem;color:#000;display:flex;flex-direction:column;border-radius:10px;background:#fff;box-shadow:0 2px 21px #0000001a;outline:2px solid transparent;transition:all .2s ease-in-out}.comment-tile[data-v-e45cf683]:focus,.comment-tile[data-v-e45cf683]:hover{outline:2px solid #0072ef}.comment-tile .link[data-v-e45cf683]{position:absolute;bottom:1rem;right:1rem;visibility:hidden;opacity:0;transition:all .2s ease-in-out}.comment-tile .link button[data-v-e45cf683]{background:none;border:none;padding:.5rem;margin:0;color:#0072ef;cursor:pointer;border-radius:.5rem}.comment-tile .link button[data-v-e45cf683]:hover,.comment-tile .link button[data-v-e45cf683]:focus{text-decoration:underline}.comment-tile:hover .link[data-v-e45cf683],.comment-tile:focus .link[data-v-e45cf683]{visibility:visible;opacity:1}.comment-tile__author[data-v-e45cf683]{display:flex;gap:1rem}.comment-tile__author-meta[data-v-e45cf683]{display:flex;gap:.5rem;height:fit-content;margin:auto 0}.comment-tile__author-meta .comment-tile__date[data-v-e45cf683]{font-weight:400}.comment-tile__author-name[data-v-e45cf683]{font-weight:700}.comment-tile__title[data-v-e45cf683]{color:inherit;text-transform:none;font-weight:700}.comment-tile__content[data-v-e45cf683]{display:flex;flex-direction:column;gap:.5rem;flex:1}.comment-tile__content .comment-tile__text[data-v-e45cf683]{line-height:1.25rem;word-break:break-word}.profiles[data-v-e45cf683]{display:flex;align-items:center;gap:.75rem;margin-top:.75rem}", Jl = /* @__PURE__ */ ae(b2, [["styles", [z2]], ["__scopeId", "data-v-e45cf683"]]), j2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Jl
}, Symbol.toStringTag, { value: "Module" })), w2 = { class: "author" }, x2 = { class: "author-meta" }, k2 = ["href"], S2 = { class: "date" }, E2 = { class: "topic" }, P2 = { class: "title" }, T2 = ["innerHTML"], C2 = {
  key: 0,
  class: "commentators"
}, A2 = {
  key: 1,
  class: "comments"
}, O2 = /* @__PURE__ */ Q({
  __name: "CommunityPost",
  props: {
    communityPost: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ue(t.communityPost.author), r = ue(t.communityPost.title), o = ue(t.communityPost.text), a = ue(t.communityPost.discussion), i = ue(t.communityPost.replySummary), s = ue(t.communityPost.posted);
    function l() {
      document.getSelection()?.type !== "Range" && window.homeActionHandler(
        "route",
        `/community/post/${t.communityPost?.id}`
      );
    }
    function c(u) {
      u.stopPropagation(), window.homeActionHandler("route", `/profile/${n.value.id}`);
    }
    return (u, d) => (w(), P("div", {
      class: Ce(["community-post", { "without-discussion": a.value == null }]),
      tabindex: "0",
      onClick: l
    }, [
      x("div", w2, [
        B(Qt, {
          "img-url": n.value.picture,
          name: n.value.name,
          profile: n.value.profile,
          id: n.value.id
        }, null, 8, ["img-url", "name", "profile", "id"]),
        x("div", x2, [
          x("a", {
            onClick: Or(c, ["prevent"]),
            href: `/profile/${n.value.id}`,
            class: "author-name"
          }, D(n.value.name), 9, k2),
          x("span", S2, D(X(jl)(s.value, { addSuffix: !0 })), 1)
        ])
      ]),
      x("div", E2, [
        x("h3", P2, D(r.value), 1),
        x("div", {
          class: "text",
          innerHTML: o.value
        }, null, 8, T2)
      ]),
      i.value && i.value?.authors?.length > 0 ? (w(), P("div", C2, [
        B(Mo, {
          authors: i.value?.authors,
          comment_count: i.value?.count,
          unread: i.value?.unread
        }, null, 8, ["authors", "comment_count", "unread"])
      ])) : re("", !0),
      a.value ? (w(), P("div", A2, [
        (w(!0), P(se, null, De(a.value.comments, (p) => (w(), ge(Jl, {
          key: p.id,
          author: p.author,
          date: p.posted,
          text: p.text,
          commentators: p.replySummary?.authors,
          comment_count: p.replySummary?.count,
          title: p.title,
          unread: p.replySummary.unread
        }, null, 8, ["author", "date", "text", "commentators", "comment_count", "title", "unread"]))), 128))
      ])) : re("", !0)
    ], 2));
  }
}), I2 = ".community-post[data-v-5c8f260a]{display:flex;flex-direction:column;gap:1rem;cursor:pointer;transition:all .2s ease-in-out}.community-post.without-discussion[data-v-5c8f260a]{padding:1.25rem 1.5rem;border-radius:10px;background:#fff;border:1px solid #eaeaea;box-shadow:0 2px 6px #00000030}.community-post.without-discussion[data-v-5c8f260a]:hover{background:#f5f5f5}.community-post.without-discussion .text[data-v-5c8f260a]{max-width:90%;color:#000;font-style:normal;font-weight:400}.community-post .author[data-v-5c8f260a]{display:flex;gap:1rem;align-items:center}.community-post .author .author-meta[data-v-5c8f260a]{display:flex;flex-direction:column;gap:.2rem;height:fit-content}.community-post .author .author-meta .author-name[data-v-5c8f260a]{font-weight:600;cursor:pointer;color:unset;text-decoration:none;text-underline-offset:.1rem}.community-post .author .author-meta .author-name[data-v-5c8f260a]:hover{text-decoration:underline}.community-post .author .author-meta .date[data-v-5c8f260a]{color:#999}.community-post .topic[data-v-5c8f260a]{display:flex;flex-direction:column;gap:15px}.community-post .topic .title[data-v-5c8f260a]{font-size:1.2rem;font-weight:600;margin:0}.community-post .topic .text[data-v-5c8f260a]{margin:0;word-break:break-word}.community-post .comments[data-v-5c8f260a]{display:flex;flex-direction:column;gap:.5rem}", r_ = /* @__PURE__ */ ae(O2, [["styles", [I2]], ["__scopeId", "data-v-5c8f260a"]]), L2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r_
}, Symbol.toStringTag, { value: "Module" })), N2 = { class: "community_posts_progress" }, M2 = /* @__PURE__ */ Q({
  __name: "CommunityPostsProgress",
  props: {
    community_posts_progress: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ee(() => t.community_posts_progress.completed / t.community_posts_progress.required * 100);
    function r() {
      window.homeActionHandler("route", "/community");
    }
    const { t: o } = ve();
    return (a, i) => (w(), P("div", N2, [
      B(Cn, { progress: n.value }, {
        default: Oe(() => [
          Ee(D(X(o)("homepage-progress.community_posts", {
            completed: t.community_posts_progress.completed,
            required: t.community_posts_progress.required
          })), 1)
        ]),
        _: 1
      }, 8, ["progress"]),
      B(bt, {
        onClick: r,
        class: "button"
      }, {
        default: Oe(() => [
          Ee(D(X(o)("open-community")), 1)
        ]),
        _: 1
      })
    ]));
  }
}), R2 = ".community_posts_progress[data-v-d497a209]{display:flex;flex-direction:column;gap:1.25rem;border-radius:1rem;padding:2rem 1.5rem 1.5rem;background:#e4ecf4}.community_posts_progress .info[data-v-d497a209]{display:flex;flex-direction:column;gap:.5rem}.community_posts_progress .info h4[data-v-d497a209]{font-size:1rem;font-weight:700;margin:0}.community_posts_progress .info p[data-v-d497a209]{font-weight:400;margin:0}.community_posts_progress .button[data-v-d497a209]{width:fit-content}", $2 = /* @__PURE__ */ ae(M2, [["styles", [R2]], ["__scopeId", "data-v-d497a209"]]), D2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: $2
}, Symbol.toStringTag, { value: "Module" })), F2 = { class: "explore-community" }, U2 = /* @__PURE__ */ Q({
  __name: "ExploreCommunity",
  props: {
    posts: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (w(), P("div", F2, [
      (w(!0), P(se, null, De(e.posts, (r) => (w(), P("div", {
        key: r.id,
        class: "community"
      }, [
        B(r_, {
          class: "post",
          "community-post": r
        }, null, 8, ["community-post"])
      ]))), 128))
    ]));
  }
}), V2 = '.explore-community[data-v-36c18c5a]{display:flex;gap:1rem;width:100%;box-sizing:border-box}.explore-community .community[data-v-36c18c5a]{display:flex;flex-direction:column;gap:.75rem;outline-offset:.5rem;text-decoration:none;color:#000;min-width:150px;flex:1}.explore-community .community .artwork[data-v-36c18c5a]{height:280px;width:230px;overflow:hidden;transition:all .2s ease-in-out}.explore-community .community .artwork img[data-v-36c18c5a]{width:100%;height:100%;object-fit:cover}.explore-community .community:hover .artwork[data-v-36c18c5a],.explore-community .community:focus .artwork[data-v-36c18c5a]{transition:all .2s ease-in-out;filter:brightness(1.1) contrast(1.1)}.explore-community .community:hover .community-info[data-v-36c18c5a]:before,.explore-community .community:focus .community-info[data-v-36c18c5a]:before{transform:scale(0);width:0;margin-left:-.3rem}.explore-community .community .community-info[data-v-36c18c5a]{display:flex;align-items:center;gap:.3rem;transition:all .2s ease-in-out}.explore-community .community .community-info[data-v-36c18c5a]:before{content:"";width:7px;height:7px;background:#4fb4ff;border-radius:50%;transition:all .2s ease-in-out}@media (max-width: 1127px){.explore-community[data-v-36c18c5a]{display:flex;flex-direction:column}}@media screen and (max-width: 600px){.explore-community .community[data-v-36c18c5a]{max-width:608px;width:100%}}', q2 = /* @__PURE__ */ ae(U2, [["styles", [V2]], ["__scopeId", "data-v-36c18c5a"]]), H2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: q2
}, Symbol.toStringTag, { value: "Module" })), B2 = { class: "star-text" }, J2 = { class: "star-icon" }, W2 = /* @__PURE__ */ Q({
  __name: "StarText",
  setup(e) {
    return (t, n) => (w(), P("div", B2, [
      Ha(t.$slots, "default", {}, void 0),
      x("div", J2, [
        B(X(dl), { icon: "nmd:journey-filled" })
      ])
    ]));
  }
}), Y2 = ".star-text[data-v-28fa70d7]{font-size:1rem;font-weight:700;position:relative;display:inline-block;gap:.25rem}.star-text .star-icon[data-v-28fa70d7]{display:inline;vertical-align:middle;margin-left:.25rem;color:#0072ef}", G2 = /* @__PURE__ */ ae(W2, [["styles", [Y2]], ["__scopeId", "data-v-28fa70d7"]]), K2 = ["onClick"], Q2 = /* @__PURE__ */ Q({
  __name: "ExploreJourneys",
  props: {
    journeys: { type: Array }
  },
  setup(e) {
    const { t } = ve(), n = e;
    function r(a) {
      window.homeActionHandler("openJourneyPanel", a);
    }
    const o = ee(() => n.journeys.length === 1);
    return (a, i) => (w(), P("div", {
      class: Ce(["explore-journeys", { "single-journey": o.value }])
    }, [
      (w(!0), P(se, null, De(a.journeys, (s) => (w(), P("div", {
        onClick: (l) => r(s.id),
        key: s.id,
        class: "journey-card"
      }, [
        B(G2, { class: "title" }, {
          default: Oe(() => [
            Ee(D(s.title), 1)
          ]),
          _: 2
        }, 1024),
        B(bt, {
          onClick: (l) => r(s.id),
          variant: "dark"
        }, {
          default: Oe(() => [
            Ee(D(X(t)("journey-details")), 1)
          ]),
          _: 2
        }, 1032, ["onClick"])
      ], 8, K2))), 128))
    ], 2));
  }
}), X2 = ".explore-journeys[data-v-2e1ff843]{position:relative;display:grid;grid-template-columns:repeat(auto-fill,minmax(500px,1fr));row-gap:.5rem;column-gap:.75rem}.explore-journeys.single-journey[data-v-2e1ff843]{grid-template-columns:auto}.explore-journeys .journey-card[data-v-2e1ff843]{display:flex;flex-direction:column;justify-content:space-between;border-radius:11px;background:#222;min-height:120px;padding:1.3rem 1.25rem;box-sizing:border-box;gap:1rem}.explore-journeys .journey-card .title[data-v-2e1ff843]{font-size:15px;font-style:normal;font-weight:700}", Z2 = /* @__PURE__ */ ae(Q2, [["styles", [X2]], ["__scopeId", "data-v-2e1ff843"]]), eA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Z2
}, Symbol.toStringTag, { value: "Module" })), tA = { class: "explore-programs" }, nA = ["href", "onClick"], rA = { class: "artwork" }, oA = { class: "program-info" }, aA = /* @__PURE__ */ Q({
  __name: "ExplorePrograms",
  props: {
    programs: { type: Array }
  },
  setup(e) {
    const { t } = ve(), n = (r) => {
      window.homeActionHandler("route", `/programs/${r.id}`);
    };
    return (r, o) => (w(), P("div", tA, [
      (w(!0), P(se, null, De(r.programs, (a) => (w(), P("a", {
        href: `/programs/${a.id}`,
        key: a.id,
        class: "program",
        onClick: Or((i) => n(a), ["prevent"])
      }, [
        x("div", rA, [
          B(st, {
            src: a.image,
            alt: "program artwork"
          }, null, 8, ["src"])
        ]),
        x("h3", null, D(a.title), 1),
        x("div", oA, [
          a.session?.start_date ? (w(), P(se, { key: 0 }, [
            Ee(D(X(t)("enrol-in-session", {
              name: X(Et)(a.session.start_date, "MMMM do")
            })), 1)
          ], 64)) : (w(), P(se, { key: 1 }, [
            Ee(D(X(t)("start-now")), 1)
          ], 64))
        ])
      ], 8, nA))), 128))
    ]));
  }
}), iA = '.explore-programs[data-v-ade409f6]{gap:1.5rem;width:100%;display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr))}.explore-programs .program[data-v-ade409f6]{display:flex;flex-direction:column;gap:.25em;outline-offset:.5rem;text-decoration:none;color:#000}.explore-programs .program .artwork[data-v-ade409f6]{max-height:366px;max-width:268.4px;aspect-ratio:23 / 28;overflow:hidden;transition:all .2s ease-out;border-radius:.75rem}.explore-programs .program .artwork img[data-v-ade409f6]{width:100%;height:100%;object-fit:cover}.explore-programs .program h3[data-v-ade409f6]{margin:.5em 0 0;font-weight:700;font-size:1rem}.explore-programs .program:hover .artwork[data-v-ade409f6],.explore-programs .program:focus .artwork[data-v-ade409f6]{transform:scale(1.05)}.explore-programs .program .program-info[data-v-ade409f6]{display:flex;align-items:center;gap:.3rem}.explore-programs .program .program-info[data-v-ade409f6]:before{content:"";width:7px;height:7px;background:#4fb4ff;border-radius:50%}', sA = /* @__PURE__ */ ae(aA, [["styles", [iA]], ["__scopeId", "data-v-ade409f6"]]), lA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: sA
}, Symbol.toStringTag, { value: "Module" })), cA = { class: "explore-resources" }, uA = { class: "content" }, mA = { class: "artwork" }, dA = /* @__PURE__ */ Q({
  __name: "ExploreResources",
  props: {
    resources: { type: Array }
  },
  setup(e) {
    return (t, n) => (w(), P("div", cA, [
      (w(!0), P(se, null, De(t.resources, (r) => (w(), P("div", {
        key: r.id,
        class: "resource"
      }, [
        x("div", uA, [
          x("h3", null, D(r.title), 1),
          x("p", null, D(r.description) + " – " + D(r.duration) + " mins", 1),
          x("label", null, D(r.primary_tag.name), 1),
          B(bt, { variant: "row" }, {
            default: Oe(() => [
              Ee("Read now")
            ]),
            _: 1
          })
        ]),
        x("div", mA, [
          B(st, {
            src: r.image,
            alt: "resource artwork"
          }, null, 8, ["src"])
        ])
      ]))), 128))
    ]));
  }
}), pA = '.explore-resources[data-v-f2ff9c32]{display:flex;flex-direction:column;gap:1rem}.explore-resources .resource[data-v-f2ff9c32]{display:flex;gap:.75rem;outline-offset:.5rem;text-decoration:none;color:#000;border-radius:18px;box-shadow:0 2px 13px #00000014;padding:1.75rem 1.5rem;width:100%;transition:all .2s ease-in-out;box-sizing:border-box;justify-content:space-between}.explore-resources .resource .content[data-v-f2ff9c32]{max-width:400px;display:flex;flex-direction:column;gap:.75rem}.explore-resources .resource h3[data-v-f2ff9c32]{margin:0;color:#000;font-size:1.5rem;font-style:normal;font-weight:700;line-height:normal}.explore-resources .resource p[data-v-f2ff9c32]{color:#000;font-style:normal;font-weight:400;line-height:22px}.explore-resources .resource label[data-v-f2ff9c32]{color:#000;font-style:italic;font-weight:400;line-height:22px;opacity:.8}.explore-resources .resource .artwork[data-v-f2ff9c32]{max-height:224px;width:100%;max-width:374px;overflow:hidden;transition:all .2s ease-in-out;border-radius:8px}.explore-resources .resource .artwork img[data-v-f2ff9c32]{width:100%;height:100%;object-fit:cover}.explore-resources .resource .resource-info[data-v-f2ff9c32]{display:flex;align-items:center;gap:.3rem;transition:all .2s ease-in-out}.explore-resources .resource .resource-info[data-v-f2ff9c32]:before{content:"";width:7px;height:7px;background:#4fb4ff;border-radius:50%;transition:all .2s ease-in-out}.explore-resources button[data-v-f2ff9c32]{box-shadow:none;width:fit-content}', fA = /* @__PURE__ */ ae(dA, [["styles", [pA]], ["__scopeId", "data-v-f2ff9c32"]]), _A = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fA
}, Symbol.toStringTag, { value: "Module" })), gA = { key: 0 }, hA = ["innerHTML"], vA = /* @__PURE__ */ Q({
  __name: "GroupActivity",
  props: {
    profiles: { type: Array },
    action: { type: String },
    context: { type: String },
    contextLink: { type: String },
    flipped: { type: Boolean },
    excludeYou: { type: Boolean },
    profile_count: { type: Number }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ee(() => n.profiles?.slice(0, 3)), o = ee(() => r.value ? r.value.length == 1 ? `${n.excludeYou ? "" : t("you-and") + " "}${r.value[0].name}` : `${n.excludeYou ? "" : t("you") + ", "}${r.value.map((i) => i.name).join(", ")}` : ""), a = ee(() => n.profile_count ?? n.profiles?.length ?? 0);
    return (i, s) => (w(), P("div", {
      class: Ce(["group-activity", { flipped: i.flipped }])
    }, [
      B(Bl, {
        profiles: i.profiles,
        total: a.value
      }, null, 8, ["profiles", "total"]),
      x("p", null, [
        x("strong", null, D(o.value) + D(" "), 1),
        a.value > r.value?.length ? (w(), P("span", gA, D(X(t)("and-others")) + D(" "), 1)) : re("", !0),
        x("span", {
          innerHTML: X(t)(`homepage-group-activity.${i.action}`, {
            name: i.context,
            n: a.value,
            link: i.contextLink
          })
        }, null, 8, hA)
      ])
    ], 2));
  }
}), yA = ".group-activity[data-v-c6f5f89c]{display:flex;flex-direction:column;gap:.75rem}.group-activity.flipped[data-v-c6f5f89c]{flex-direction:column-reverse}.group-activity p[data-v-c6f5f89c]{margin:0;line-height:1.3rem}.group-activity[data-v-c6f5f89c] a{color:inherit}", o_ = /* @__PURE__ */ ae(vA, [["styles", [yA]], ["__scopeId", "data-v-c6f5f89c"]]), bA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: o_
}, Symbol.toStringTag, { value: "Module" })), zA = ".journey-event-preview[data-v-b6a39d99]{display:flex;min-height:10rem;height:100%;width:100%;background-size:auto 100%;background-position:center;background-repeat:no-repeat;background-color:#8099c9;border-radius:.5rem;overflow:hidden}.journey-event-preview img[data-v-b6a39d99]{width:100%;height:100%;object-fit:cover}", jA = {}, wA = { class: "journey-event-preview" };
function xA(e, t) {
  const n = ih("NomadicImage");
  return w(), P("div", wA, [
    B(n, {
      src: "https://media-live.nomadic.fm/assets/homepage/img/journey-art.png",
      alt: "Calendar and alarm clock"
    })
  ]);
}
const a_ = /* @__PURE__ */ ae(jA, [["render", xA], ["styles", [zA]], ["__scopeId", "data-v-b6a39d99"]]), kA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: a_
}, Symbol.toStringTag, { value: "Module" })), SA = { class: "journey-event" }, EA = /* @__PURE__ */ Q({
  __name: "JourneyEvent",
  props: {
    event: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ee(() => `${Et(t.event.time, "MMMM do, YYYY - h:mm a")}`);
    return (r, o) => (w(), P(se, null, [
      x("div", SA, [
        x("h4", null, D(e.event.title), 1),
        x("p", null, D(n.value), 1)
      ]),
      e.event.showImage ? (w(), ge(a_, { key: 0 })) : re("", !0)
    ], 64));
  }
}), PA = ".journey-event[data-v-4bf13dac]{display:flex;flex-direction:column;gap:.3rem;border-radius:10px;padding:1.4rem 1.2rem;background:#eaedef}.journey-event h4[data-v-4bf13dac]{font-size:1rem;font-weight:700;margin:0}.journey-event p[data-v-4bf13dac]{font-weight:400;margin:0}", TA = /* @__PURE__ */ ae(EA, [["styles", [PA]], ["__scopeId", "data-v-4bf13dac"]]), CA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: TA
}, Symbol.toStringTag, { value: "Module" })), AA = { class: "journey-enrollment-preview" }, OA = { class: "artwork" }, IA = { class: "journey-event" }, LA = { class: "header" }, NA = { class: "session" }, MA = {
  key: 0,
  class: "group"
}, RA = ["innerHTML"], $A = /* @__PURE__ */ Q({
  __name: "ProgramCard",
  props: {
    tile: {
      type: Object,
      required: !1,
      default: () => ({})
    },
    program: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ee(() => {
      if (n.program.session) {
        const s = Et(n.program.session.startDate, "MMMM do"), l = Et(n.program.session.endDate, "MMMM do");
        return `${s} – ${l}`;
      }
      return "";
    }), o = ee(() => n.program.always_on || n.program.session && so(n.program.session.startDate) ? t("start-now") : t("enroll")), a = ee(() => !(n.program.always_on || n.program.session));
    function i() {
      window.homeActionHandler("showProgram", n.program.id);
    }
    return (s, l) => (w(), P("div", AA, [
      x("div", OA, [
        B(st, {
          src: e.program.image,
          alt: "journey artwork"
        }, null, 8, ["src"])
      ]),
      x("div", IA, [
        x("h3", null, D(e.program.title), 1),
        x("div", LA, [
          x("div", NA, [
            x("p", null, [
              x("strong", null, D(e.program.session?.name || e.program.title), 1),
              r.value?.length > 0 ? (w(), P(se, { key: 0 }, [
                Ee(" (" + D(r.value || "No upcoming sessions") + ") ", 1)
              ], 64)) : re("", !0)
            ]),
            B(bt, {
              variant: "primary",
              onClick: i,
              disabled: a.value
            }, {
              default: Oe(() => [
                Ee(D(o.value), 1)
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          e.tile.group_activity && (e.tile.group_activity.profiles?.length > 0 || !e.tile.group_activity.exclude_you) ? (w(), P("div", MA, [
            B(o_, {
              action: e.tile.group_activity.action || "program-enroll",
              profiles: e.tile.group_activity.profiles,
              context: e.tile.session?.name || e.program.title,
              "exclude-you": e.tile.group_activity.exclude_you,
              profile_count: e.tile.group_activity.profile_count,
              flipped: ""
            }, null, 8, ["action", "profiles", "context", "exclude-you", "profile_count"])
          ])) : re("", !0)
        ]),
        x("div", {
          class: "description",
          innerHTML: e.tile.description
        }, null, 8, RA),
        B(bt, {
          variant: "secondary",
          onClick: i
        }, {
          default: Oe(() => [
            Ee(D(X(t)("program-details")), 1)
          ]),
          _: 1
        })
      ])
    ]));
  }
}), DA = ".journey-enrollment-preview[data-v-fdaf5a66]{display:flex;flex-wrap:wrap;gap:1.25rem;align-items:center}.journey-enrollment-preview .artwork[data-v-fdaf5a66]{overflow:hidden;display:flex;border-radius:10px;align-self:flex-start;flex:1;aspect-ratio:1 / 1.3;max-width:280px}.journey-enrollment-preview .artwork img[data-v-fdaf5a66]{width:100%;border-radius:10px;object-fit:cover;height:100%}.journey-enrollment-preview .journey-event[data-v-fdaf5a66]{display:flex;flex-direction:column;gap:.75rem;flex:2;height:100%;align-self:flex-start;min-width:300px}.journey-enrollment-preview .journey-event h3[data-v-fdaf5a66]{font-size:1.35rem;margin:0;padding:0}.journey-enrollment-preview .journey-event .header[data-v-fdaf5a66]{display:flex;flex-direction:column;gap:1rem;background:#e4ecf4;padding:1rem;border-radius:1rem}.journey-enrollment-preview .journey-event .header .session[data-v-fdaf5a66]{display:flex;gap:1rem;align-items:center;justify-content:space-between}.journey-enrollment-preview .journey-event .header .session p[data-v-fdaf5a66]{margin:0;padding:0;flex:1}.journey-enrollment-preview .journey-event .header .session .tile-actions[data-v-fdaf5a66]{max-width:fit-content;flex:1}.journey-enrollment-preview .journey-event .header .session button[data-v-fdaf5a66]{width:fit-content!important}.journey-enrollment-preview .journey-event .header .group[data-v-fdaf5a66]{display:flex;border-top:1px solid rgba(0,0,0,.2);padding-top:1rem}.journey-enrollment-preview .journey-event .description[data-v-fdaf5a66]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:7;-webkit-box-orient:vertical;margin:0;padding:0;color:#222;font-size:15px;font-style:normal;font-weight:400;line-height:22px}.journey-enrollment-preview .journey-event .description p[data-v-fdaf5a66]{margin:0;padding:0}@media (max-width: 750px){.journey-enrollment-preview[data-v-fdaf5a66]{flex-direction:column}}", FA = /* @__PURE__ */ ae($A, [["styles", [DA]], ["__scopeId", "data-v-fdaf5a66"]]), UA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: FA
}, Symbol.toStringTag, { value: "Module" })), VA = { class: "certificate-wrapper" }, qA = { class: "cert-image" }, HA = { class: "issuer" }, BA = ["innerHTML"], JA = { class: "issued" }, WA = /* @__PURE__ */ Q({
  __name: "ProgramCertificate",
  props: {
    certificate: {
      type: Object,
      required: !0
    },
    downloadText: {
      type: String
    }
  },
  setup(e) {
    const t = e, n = ee(() => `--issuer-color: ${t.certificate?.color}`), r = () => {
      window.location.href = `/api/v1/programs/${t.certificate.id}/certificate.png`;
    };
    return (o, a) => (w(), P("div", VA, [
      x("div", {
        class: "certificate",
        style: Ut(n.value)
      }, [
        x("div", qA, [
          B(st, {
            src: e.certificate?.image
          }, null, 8, ["src"])
        ]),
        x("h4", null, D(e.certificate?.title), 1),
        x("span", HA, D(e.certificate?.issuer), 1),
        x("p", {
          innerHTML: e.certificate?.description
        }, null, 8, BA),
        B(st, {
          class: "sig-image",
          src: e.certificate?.signature
        }, null, 8, ["src"]),
        x("span", JA, D(e.certificate?.issued), 1)
      ], 4),
      B(bt, {
        id: "share-button",
        variant: "row",
        onClick: r
      }, {
        default: Oe(() => [
          Ee(D(e.downloadText ? e.downloadText : "Share your certificate"), 1)
        ]),
        _: 1
      })
    ]));
  }
}), YA = ".certificate-wrapper[data-v-8697055a]{display:flex;flex-direction:column;gap:1rem}.certificate-wrapper #share-button[data-v-8697055a]{width:fit-content;text-align:left}.certificate[data-v-8697055a]{background-color:#fff;-webkit-box-shadow:0px 1px 10px rgba(0,0,0,.1);box-shadow:0 1px 10px #0000001a;width:49%;padding:20px;-webkit-transition:background-color .2s ease-out;transition:background-color .2s ease-out;border-radius:4px;margin-bottom:20px;width:100%;box-sizing:border-box;height:fit-content}.certificate h4[data-v-8697055a]{color:#000;text-transform:none;font-size:1.5em;line-height:120%;margin-bottom:.25em}.certificate .issuer[data-v-8697055a]{opacity:.5;padding-bottom:3em;display:inline-block;color:#000}.certificate p[data-v-8697055a]{color:#000;padding-bottom:.8em;display:inline-block;max-width:80%}.certificate .issued[data-v-8697055a]{opacity:.5;color:#000}.certificate .cert-image[data-v-8697055a]{display:block;float:right;height:120px;width:100px;margin-top:-20px;background:var(--issuer-color);vertical-align:bottom;margin-left:20px;margin-bottom:20px;overflow:hidden}.certificate .cert-image img[data-v-8697055a]{width:100%;height:auto}.certificate img.sig-image[data-v-8697055a]{display:block;height:50px}", GA = /* @__PURE__ */ ae(WA, [["styles", [YA]], ["__scopeId", "data-v-8697055a"]]), KA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: GA
}, Symbol.toStringTag, { value: "Module" })), QA = { class: "journey-enrollment-preview" }, XA = { class: "artwork" }, ZA = { class: "journey-event" }, eO = { class: "header" }, tO = { class: "description" }, nO = /* @__PURE__ */ Q({
  __name: "ProgramDetails",
  props: {
    program: {
      type: Object,
      required: !1,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e;
    function n() {
      window.homeActionHandler("route", `/programs/${t.program.id}`);
    }
    return (r, o) => (w(), P("div", QA, [
      x("div", XA, [
        B(st, {
          src: e.program.image,
          alt: "journey artwork"
        }, null, 8, ["src"])
      ]),
      x("div", ZA, [
        x("div", eO, [
          x("p", null, [
            x("strong", null, D(e.program.session?.name || e.program.title), 1)
          ])
        ]),
        x("div", tO, [
          x("p", null, D(e.program.description), 1)
        ]),
        B(bt, {
          onClick: n,
          class: "details-button",
          variant: "row"
        }, {
          default: Oe(() => [
            Ee(" Program Details ")
          ]),
          _: 1
        })
      ])
    ]));
  }
}), rO = ".journey-enrollment-preview[data-v-9696c6d1]{display:flex;gap:1rem;align-items:center}.journey-enrollment-preview .artwork[data-v-9696c6d1]{width:100%;height:100%;overflow:hidden;max-height:210px;max-width:162px;aspect-ratio:1 / 4;display:flex;border-radius:10px}.journey-enrollment-preview .artwork img[data-v-9696c6d1]{width:100%;border-radius:10px;object-fit:cover;height:100%}.journey-enrollment-preview .journey-event[data-v-9696c6d1]{display:flex;flex-direction:column;gap:.1rem;flex:2;height:100%}.journey-enrollment-preview .journey-event .header[data-v-9696c6d1]{display:flex;justify-content:space-between;align-items:center;gap:.5rem}.journey-enrollment-preview .journey-event p[data-v-9696c6d1]{padding:0;margin:0;margin-top:.25rem;margin-bottom:.5rem}.journey-enrollment-preview .journey-event .description[data-v-9696c6d1]{overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;max-width:80%}.details-button[data-v-9696c6d1]{width:fit-content;text-align:left;background:none;margin-top:1rem;box-shadow:none}", oO = /* @__PURE__ */ ae(nO, [["styles", [rO]], ["__scopeId", "data-v-9696c6d1"]]), aO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: oO
}, Symbol.toStringTag, { value: "Module" })), iO = { class: "context" }, sO = { class: "title" }, lO = ["innerHTML"], cO = {
  key: 1,
  class: "single-comment"
}, uO = {
  key: 2,
  class: "comments"
}, mO = /* @__PURE__ */ Q({
  __name: "ProgramDiscussion",
  props: {
    discussions: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ee(() => t.discussions.length > 1), r = ee(() => t.discussions[0]?.comments?.[0]), o = ee(() => r.value?.author);
    return (a, i) => (w(!0), P(se, null, De(e.discussions, (s) => (w(), P("div", {
      class: Ce(["program-discussion", { "single-comment-card": n.value }]),
      key: s.title
    }, [
      x("span", iO, D(s.context), 1),
      x("h2", sO, D(s.title), 1),
      n.value ? re("", !0) : (w(), P("p", {
        key: 0,
        class: "description",
        innerHTML: s.description
      }, null, 8, lO)),
      n.value ? (w(), P("div", cO, [
        x("span", null, [
          B(Qt, {
            profile: o.value?.profile,
            name: o.value?.name,
            size: "mini",
            imgURL: o.value?.picture,
            id: o.value?.id
          }, null, 8, ["profile", "name", "imgURL", "id"]),
          x("p", null, [
            x("strong", null, D(o.value?.name), 1),
            Ee(": " + D(r.value?.text), 1)
          ])
        ])
      ])) : (w(), P("div", uO, [
        (w(!0), P(se, null, De(s.comments, (l) => (w(), ge(Jl, {
          key: l.text,
          author: l.author,
          date: l.posted,
          text: l.text,
          link: l.link,
          commentators: l.replySummary?.authors,
          comment_count: l.replySummary?.count ?? 0,
          unread: l.replySummary?.unread ?? !1
        }, null, 8, ["author", "date", "text", "link", "commentators", "comment_count", "unread"]))), 128))
      ]))
    ], 2))), 128));
  }
}), dO = ".program-discussion[data-v-435b4aa4]{display:flex;flex-direction:column;gap:.5rem}.program-discussion.single-comment-card[data-v-435b4aa4]{background:#fff;padding:1rem;border-radius:.75rem}.program-discussion .context[data-v-435b4aa4]{color:#666;font-weight:400}.program-discussion .title[data-v-435b4aa4]{font-size:1rem;font-weight:700;margin:0}.program-discussion .comments[data-v-435b4aa4]{display:flex;flex-direction:column;gap:.5rem}.single-comment span[data-v-435b4aa4]{display:flex;gap:.5rem;align-items:center}.single-comment p[data-v-435b4aa4]{margin:0;font-weight:400;max-width:60ch;width:90%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}", pO = /* @__PURE__ */ ae(mO, [["styles", [dO]], ["__scopeId", "data-v-435b4aa4"]]), fO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: pO
}, Symbol.toStringTag, { value: "Module" })), _O = ["onClick"], gO = { class: "context" }, hO = { class: "title" }, vO = ["innerHTML"], yO = {
  key: 1,
  class: "single-comment"
}, bO = {
  key: 2,
  class: "comments"
}, zO = {
  key: 0,
  class: "comment-tile__author"
}, jO = { class: "comment-tile__content" }, wO = { class: "comment-tile__author-meta" }, xO = { class: "comment-tile__author-name" }, kO = {
  key: 0,
  class: "comment-tile__date"
}, SO = {
  key: 0,
  class: "comment-tile__title"
}, EO = ["innerHTML"], PO = {
  key: 0,
  class: "profiles"
}, TO = /* @__PURE__ */ Q({
  __name: "ProgramInProgressDiscussion",
  props: {
    discussions: { type: Array }
  },
  setup(e) {
    const t = e, n = ee(() => t.discussions.length > 1);
    function r(o) {
      window.location.assign(o);
    }
    return (o, a) => (w(!0), P(se, null, De(o.discussions, (i) => (w(), P("div", {
      class: Ce(["program-discussion", { "single-comment-card": n.value }]),
      key: i.id,
      onClick: (s) => r(i.comments[0].link)
    }, [
      x("span", gO, D(i.context), 1),
      x("span", hO, D(i.title), 1),
      !n.value && i.description ? (w(), P("p", {
        key: 0,
        class: "description",
        innerHTML: i.description
      }, null, 8, vO)) : re("", !0),
      n.value ? (w(), P("div", yO, [
        x("span", null, [
          B(Qt, {
            profile: i.comments[0].author.profile,
            name: i.comments[0].author.name,
            size: "mini",
            imgURL: i.comments[0].author.picture,
            id: i.comments[0].author.id
          }, null, 8, ["profile", "name", "imgURL", "id"]),
          x("p", null, [
            x("strong", null, D(i.comments[0].author.name), 1),
            Ee(": " + D(i.comments[0].text), 1)
          ])
        ])
      ])) : (w(), P("div", bO, [
        (w(!0), P(se, null, De(i.comments, (s) => (w(), P("div", {
          class: "comment-tile",
          tabindex: "0",
          key: s.id
        }, [
          s.author ? (w(), P("div", zO, [
            B(Qt, {
              "img-url": s.author.picture,
              name: s.author.name,
              profile: s.author.profile,
              id: s.author.id
            }, null, 8, ["img-url", "name", "profile", "id"]),
            x("div", jO, [
              x("div", wO, [
                x("span", xO, D(s.author.name), 1),
                s.posted ? (w(), P("span", kO, D(X(jl)(s.posted, { addSuffix: !0 })), 1)) : re("", !0)
              ]),
              s.title ? (w(), P("h4", SO, D(s.title), 1)) : re("", !0)
            ])
          ])) : re("", !0),
          x("div", null, [
            x("div", {
              class: "comment-tile__text",
              innerHTML: s.text
            }, null, 8, EO),
            s.replySummary?.authors && s.replySummary.authors.length ? (w(), P("div", PO, [
              B(Mo, {
                authors: s.replySummary.authors,
                comment_count: s.replySummary.count,
                unread: s.replySummary.unread
              }, null, 8, ["authors", "comment_count", "unread"])
            ])) : re("", !0)
          ])
        ]))), 128))
      ]))
    ], 10, _O))), 128));
  }
}), CO = ".program-discussion[data-v-9c966a3f]{display:flex;flex-direction:column;gap:.5rem}.program-discussion.single-comment-card[data-v-9c966a3f]{background:#e4ecf4;padding:1rem;border-radius:.75rem}.program-discussion.single-comment-card[data-v-9c966a3f]:hover{background:#dae3ed;cursor:pointer}.program-discussion .context[data-v-9c966a3f]{color:#666;font-weight:400}.program-discussion .title[data-v-9c966a3f]{font-size:1rem;font-weight:700;margin:0}.program-discussion .comments[data-v-9c966a3f]{display:flex;flex-direction:column;gap:.5rem}.single-comment span[data-v-9c966a3f]{display:flex;gap:.5rem;align-items:center}.single-comment p[data-v-9c966a3f]{margin:0;font-weight:400;width:90%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.comment-tile[data-v-9c966a3f]{display:flex;gap:1rem;align-items:flex-start;flex-direction:column;margin-top:1rem}.comment-tile[data-v-9c966a3f]:focus{outline:none;box-shadow:0 0 0 3px #f9f9f9}.comment-tile .comment-tile__author[data-v-9c966a3f]{display:flex;gap:.75rem;align-items:center;flex:1}.comment-tile .comment-tile__author .comment-tile__content[data-v-9c966a3f]{display:flex;flex-direction:column;gap:.5rem;flex:1}.comment-tile .comment-tile__author .comment-tile__content .comment-tile__author-meta[data-v-9c966a3f]{display:flex;flex-direction:column;gap:.25rem;font-weight:600}.comment-tile .comment-tile__author .comment-tile__content .comment-tile__author-meta .comment-tile__author-name[data-v-9c966a3f]{font-weight:700}.comment-tile .comment-tile__author .comment-tile__content .comment-tile__author-meta .comment-tile__date[data-v-9c966a3f]{font-weight:400;color:#666}.comment-tile .comment-tile__title[data-v-9c966a3f]{font-size:1rem;font-weight:700;margin:0}.comment-tile .comment-tile__text[data-v-9c966a3f]{line-height:1.2rem;font-weight:400;margin:0;width:100%;overflow:hidden;text-overflow:ellipsis;word-break:break-word}.comment-tile .profiles[data-v-9c966a3f]{display:flex;gap:.5rem;align-items:center;margin-top:1rem}", AO = /* @__PURE__ */ ae(TO, [["styles", [CO]], ["__scopeId", "data-v-9c966a3f"]]), OO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: AO
}, Symbol.toStringTag, { value: "Module" })), IO = { class: "progress-breakdown" }, LO = ["href"], NO = /* @__PURE__ */ Q({
  __name: "ProgressBreakdown",
  props: {
    breakdown: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    return (t, n) => (w(), P("div", IO, [
      x("ul", null, [
        (w(!0), P(se, null, De(e.breakdown, (r) => (w(), P("li", {
          key: r.id
        }, [
          x("a", {
            href: r.link
          }, D(r.title), 9, LO),
          x("div", {
            class: Ce(["check", { checked: r.completed }])
          }, null, 2)
        ]))), 128))
      ])
    ]));
  }
}), MO = `.progress-breakdown ul[data-v-76d5dc13]{list-style:none;padding:0;margin:0;display:flex;flex-direction:column;align-items:flex-start;justify-content:flex-start;width:100%;height:100%}.progress-breakdown ul li[data-v-76d5dc13]{display:flex;align-items:center;justify-content:space-between;width:100%;height:100%;padding:.5rem 0}.progress-breakdown ul li[data-v-76d5dc13]:last-child{border-bottom:none}.progress-breakdown ul li a[data-v-76d5dc13]{color:#000;text-decoration:underline}.progress-breakdown ul li a[data-v-76d5dc13]:hover{cursor:pointer}.progress-breakdown ul li .check[data-v-76d5dc13]{width:1.75rem;height:1.75rem;border-radius:50%;background:#d6e4f2;outline:1px solid transparent}.progress-breakdown ul li .check.checked[data-v-76d5dc13]{position:relative;background:#0072ef;display:flex;align-items:center;justify-content:center}.progress-breakdown ul li .check.checked[data-v-76d5dc13]:after{content:url("data:image/svg+xml,%3Csvg width='15' height='11' viewBox='0 0 15 11' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 5.5L5.81696 10L14 1' stroke='white'/%3E%3C/svg%3E%0A");top:0;left:0}`, i_ = /* @__PURE__ */ ae(NO, [["styles", [MO]], ["__scopeId", "data-v-76d5dc13"]]), RO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: i_
}, Symbol.toStringTag, { value: "Module" })), $O = { class: "resource-progress" }, DO = /* @__PURE__ */ Q({
  __name: "ResourceProgress",
  props: {
    label: {
      type: String,
      required: !1
    },
    breakdown: {
      type: Array,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ee(() => n.breakdown?.filter((i) => i.completed)?.length / n.breakdown?.length * 100), o = ee(() => {
      const a = n.breakdown?.filter((i) => i.completed);
      return t("x-of-y-resources-completed", [
        a?.length,
        n.breakdown?.length
      ]);
    });
    return (a, i) => (w(), P("div", $O, [
      B(Cn, {
        label: e.label || "",
        progress: r.value
      }, {
        default: Oe(() => [
          Ee(D(o.value), 1)
        ]),
        _: 1
      }, 8, ["label", "progress"]),
      B(i_, {
        breakdown: e.breakdown,
        class: "resource-breakdown"
      }, null, 8, ["breakdown"])
    ]));
  }
}), FO = ".resource-progress[data-v-77e96cf8]{background:#e4ecf4;padding:2rem 1.5rem;border-radius:.5rem;display:flex;flex-direction:column;gap:.5rem}.resource-progress span[data-v-77e96cf8]{font-weight:400}.resource-progress .resource-breakdown[data-v-77e96cf8]{margin-top:1rem;margin-right:1rem}", UO = /* @__PURE__ */ ae(DO, [["styles", [FO]], ["__scopeId", "data-v-77e96cf8"]]), VO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: UO
}, Symbol.toStringTag, { value: "Module" })), qO = { class: "people" }, HO = { class: "person-details" }, BO = /* @__PURE__ */ Q({
  __name: "SummaryLeaderboard",
  props: {
    summaryLeaderboard: { type: Array },
    link: { type: String }
  },
  setup(e) {
    const { t } = ve(), n = e;
    function r() {
      window.location.assign(n.link);
    }
    return (o, a) => (w(), P("div", {
      class: "summary-leaderboard",
      onClick: r
    }, [
      x("table", qO, [
        x("tbody", null, [
          (w(!0), P(se, null, De(o.summaryLeaderboard, (i) => (w(), P("tr", {
            key: i.id
          }, [
            x("td", null, D(i.position) + ".", 1),
            x("td", HO, [
              B(Qt, {
                name: i.profile.name,
                imgURL: i.profile.avatar
              }, null, 8, ["name", "imgURL"]),
              x("strong", null, D(i.profile.name), 1)
            ]),
            x("td", null, D(X(t)("points", { count: i.score })), 1)
          ]))), 128))
        ])
      ])
    ]));
  }
}), JO = ".summary-leaderboard .people[data-v-0e1423bb]{border-collapse:collapse}.summary-leaderboard .people th[data-v-0e1423bb],.summary-leaderboard .people td[data-v-0e1423bb]{padding:.5rem;text-align:left}.summary-leaderboard .people thead tr th[data-v-0e1423bb]{font-size:1rem}.summary-leaderboard .people tbody tr .person-details[data-v-0e1423bb]{display:flex;align-items:center;width:fit-content}.summary-leaderboard .people tbody tr .person-details strong[data-v-0e1423bb]{margin-left:1rem}", WO = /* @__PURE__ */ ae(BO, [["styles", [JO]], ["__scopeId", "data-v-0e1423bb"]]), YO = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WO
}, Symbol.toStringTag, { value: "Module" })), GO = ["href"], KO = { class: "visually-hidden" }, QO = ["innerHTML"], XO = /* @__PURE__ */ Q({
  __name: "SummaryNewPoll",
  props: {
    summaryNewPoll: { type: null },
    link: { type: String }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ee(() => n.summaryNewPoll.pollstyle === "rating" ? {
      "aria-hidden": !0
    } : {});
    return (o, a) => (w(), P("a", {
      class: "summary-new-poll",
      href: n.link
    }, [
      x("span", KO, D(X(t)("go-to-poll-question")), 1),
      x("span", {
        class: "question",
        innerHTML: o.summaryNewPoll.title
      }, null, 8, QO),
      x("ol", Er({
        class: ["options", o.summaryNewPoll.pollstyle]
      }, r.value), [
        (w(!0), P(se, null, De(o.summaryNewPoll.options, (i) => (w(), P("li", {
          class: "option",
          key: i.id
        }, [
          x("p", null, D(i.text), 1)
        ]))), 128))
      ], 16)
    ], 8, GO));
  }
}), ZO = '.summary-new-poll[data-v-bea577de]{color:inherit;text-decoration:none;position:relative;display:flex;flex-direction:column;gap:.75rem;cursor:pointer}.summary-new-poll h3[data-v-bea577de]{font-size:1rem;font-weight:600;margin:0;padding:0}.summary-new-poll h3[data-v-bea577de] p{margin:0;padding:0}.question[data-v-bea577de]{font-weight:700}.options.rating[data-v-bea577de]{position:relative;display:flex;gap:.5rem;margin-top:.5rem;justify-content:space-between;padding:0}.options.rating .option[data-v-bea577de]{display:flex;flex-direction:column;background:#fff;width:2.25rem;height:2.25rem;justify-content:center;border-radius:.25rem;border:1px solid #000000;z-index:1}.options.rating .option p[data-v-bea577de]{margin:auto;padding:0}.options.list[data-v-bea577de]{display:flex;flex-direction:column;gap:.5rem}.options.list .option[data-v-bea577de]{display:flex;flex-direction:column;background:#fff;padding:.5rem .5rem .5rem 1rem;justify-content:center;border-radius:.25rem;border:1px solid #000000;max-width:40ch}.options.list .option p[data-v-bea577de]{margin:0;padding:0}.rating[data-v-bea577de]:after{position:absolute;content:"";display:block;width:100%;height:.75rem;background:#e0e7ee;mix-blend-mode:multiply;z-index:0;margin:auto;top:calc(50% - .375rem)}', e5 = /* @__PURE__ */ ae(XO, [["styles", [ZO]], ["__scopeId", "data-v-bea577de"]]), t5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: e5
}, Symbol.toStringTag, { value: "Module" })), n5 = (e) => (xo("data-v-6b5fcbce"), e = e(), ko(), e), r5 = ["href"], o5 = { class: "preview-image" }, a5 = { class: "page-info" }, i5 = /* @__PURE__ */ n5(() => /* @__PURE__ */ x("br", null, null, -1)), s5 = { key: 0 }, l5 = /* @__PURE__ */ Q({
  __name: "SummaryPage",
  props: {
    page: { type: null },
    link: { type: String }
  },
  setup(e) {
    return (t, n) => (w(), P("a", {
      href: t.link,
      class: "summary-page"
    }, [
      x("div", o5, [
        B(st, {
          src: `https://res.cloudinary.com/nomadic/image/fetch/w_890,f_auto,q_60/${t.page.image}`,
          alt: ""
        }, null, 8, ["src"])
      ]),
      x("div", a5, [
        x("p", null, [
          Ee(D(t.page.fm_title) + " – " + D(t.page.page_title) + " ", 1),
          i5,
          t.page.section_title ? (w(), P("strong", s5, D(t.page.section_title), 1)) : re("", !0)
        ])
      ])
    ], 8, r5));
  }
}), c5 = ".summary-page[data-v-6b5fcbce]{position:relative;display:flex;gap:1rem;align-items:center;margin-top:1.5rem;margin-left:1rem;margin-bottom:1rem;cursor:pointer}.summary-page .preview-image[data-v-6b5fcbce]{width:100%;height:100%;overflow:hidden;height:333px;display:flex;border-radius:10px;background-color:#eee}.summary-page .preview-image img[data-v-6b5fcbce]{width:100%;height:100%;object-fit:cover}.summary-page .page-info[data-v-6b5fcbce]{position:absolute;display:flex;flex-direction:column;gap:.5rem;border-radius:.5rem;background:#000000d9;color:#fff;top:-1rem;left:-1rem}.summary-page .page-info p[data-v-6b5fcbce]{margin:0;padding:.75rem .75rem .75rem 1rem;display:flex;flex-direction:column;gap:.25rem;min-width:13rem}", u5 = /* @__PURE__ */ ae(l5, [["styles", [c5]], ["__scopeId", "data-v-6b5fcbce"]]), m5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: u5
}, Symbol.toStringTag, { value: "Module" })), d5 = ["href"], p5 = { class: "visually-hidden" }, f5 = ["innerHTML"], _5 = { class: "poll-results-label" }, g5 = { class: "results" }, h5 = { class: "option" }, v5 = { class: "progress" }, y5 = /* @__PURE__ */ Q({
  __name: "SummaryPollResults",
  props: {
    summaryPollResults: { type: null },
    link: { type: String }
  },
  setup(e) {
    const { t } = ve(), n = e;
    return (r, o) => (w(), P("a", {
      class: "summary-poll-results",
      href: n.link
    }, [
      x("span", p5, D(X(t)("go-to-poll-question")), 1),
      x("span", {
        class: "question",
        innerHTML: r.summaryPollResults.title
      }, null, 8, f5),
      x("div", _5, D(X(t)("poll-results")), 1),
      x("div", g5, [
        x("ul", null, [
          (w(!0), P(se, null, De(r.summaryPollResults.options, (a) => (w(), P("li", {
            key: a.id
          }, [
            x("div", h5, [
              x("p", null, D(a.text), 1),
              x("div", v5, [
                x("div", {
                  class: "bar",
                  style: Ut({ width: `${a.percentage}%` })
                }, null, 4)
              ])
            ])
          ]))), 128))
        ])
      ])
    ], 8, d5));
  }
}), b5 = ".summary-poll-results[data-v-de3443df]{color:inherit;text-decoration:none;display:flex;flex-direction:column;gap:.75rem}.summary-poll-results .question[data-v-de3443df]{font-size:1rem;font-weight:600;margin:0;padding:0}.summary-poll-results .question[data-v-de3443df] p{margin:0;padding:0}.summary-poll-results .poll-results-label[data-v-de3443df]{font-weight:500;margin-bottom:.5rem;background:#141414;color:#fff;padding:.4rem .65rem;border-radius:.3rem;display:inline-block;width:fit-content}.summary-poll-results .results ul[data-v-de3443df]{list-style:none;padding:0;margin:0}.summary-poll-results .results ul li[data-v-de3443df]{margin-bottom:1.25rem}.summary-poll-results .results ul li .option[data-v-de3443df]{display:flex;flex-direction:column;gap:.5rem}.summary-poll-results .results ul li .option p[data-v-de3443df]{font-weight:400;margin:0;padding:0}.summary-poll-results .results ul li .option .progress[data-v-de3443df]{background:#55555524;border-radius:.2rem;height:1.3rem}.summary-poll-results .results ul li .option .progress .bar[data-v-de3443df]{background:#90949a;height:100%;border-radius:.2rem}.summary-poll-results .results ul li .option .progress .bar span[data-v-de3443df]{color:#fff;font-weight:500}", z5 = /* @__PURE__ */ ae(y5, [["styles", [b5]], ["__scopeId", "data-v-de3443df"]]), j5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z5
}, Symbol.toStringTag, { value: "Module" })), w5 = {
  key: 0,
  class: "team-icon__initials"
}, x5 = /* @__PURE__ */ Q({
  __name: "TeamIcon",
  props: {
    team: { type: Object },
    size: { default: "medium", type: String }
  },
  setup(e) {
    const t = e, n = ee(() => t.team.symbol && t.team.symbol.startsWith("_") ? t.team.symbol.substr(1) : "");
    return (r, o) => (w(), P("div", {
      class: Ce(["team-icon", r.size]),
      style: Ut({ backgroundColor: "#" + r.team.color })
    }, [
      n.value ? (w(), P("span", w5, D(n.value), 1)) : (w(), ge(st, {
        key: 1,
        class: "team-icon__image",
        src: `https://media-live.nomadic.fm/team-symbols/${r.team.symbol}.png`,
        alt: r.team.symbol
      }, null, 8, ["src", "alt"]))
    ], 6));
  }
}), k5 = ".team-icon[data-v-8f710f08]{border-radius:9999px;position:relative;display:flex;align-items:center;overflow:hidden;margin-bottom:5px;flex-shrink:0;background:#333}.team-icon.mini[data-v-8f710f08]{width:2.15rem;height:2.15rem}.team-icon.small[data-v-8f710f08]{width:2.5rem;height:2.5rem}.team-icon.medium[data-v-8f710f08]{width:3.15rem;height:3.15rem}.team-icon__initials[data-v-8f710f08]{font-weight:700;font-size:1.3em;width:100%;display:block;text-align:center;color:#fff}img.team-icon__image[data-v-8f710f08]{width:100%;position:absolute}", S5 = /* @__PURE__ */ ae(x5, [["styles", [k5]], ["__scopeId", "data-v-8f710f08"]]), E5 = { class: "summary-progress" }, P5 = { class: "progress-item" }, T5 = { class: "details" }, C5 = { class: "progress-item" }, A5 = { class: "details" }, O5 = /* @__PURE__ */ Q({
  __name: "SummaryProgress",
  props: {
    summaryProgress: { type: null }
  },
  setup(e) {
    const { t } = ve();
    return (n, r) => (w(), P("div", E5, [
      x("div", P5, [
        B(Qt, {
          name: n.summaryProgress.profile.name,
          imgURL: n.summaryProgress.profile.avatar
        }, null, 8, ["name", "imgURL"]),
        x("div", T5, [
          x("h3", null, D(X(t)("your-progress")), 1),
          B(Cn, {
            progress: n.summaryProgress.progress.your_progress
          }, null, 8, ["progress"]),
          x("p", null, D(X(t)("x-percent-complete", [
            n.summaryProgress.progress.your_progress.toFixed(0)
          ])), 1)
        ])
      ]),
      x("div", C5, [
        B(S5, {
          team: n.summaryProgress.team
        }, null, 8, ["team"]),
        x("div", A5, [
          x("h3", null, D(X(t)("team-average")), 1),
          B(Cn, {
            progress: n.summaryProgress.progress.team_average
          }, null, 8, ["progress"]),
          x("p", null, D(X(t)("x-percent-complete", [
            n.summaryProgress.progress.team_average.toFixed(0)
          ])), 1)
        ])
      ])
    ]));
  }
}), I5 = ".summary-progress[data-v-91bc6f55]{display:flex;flex-direction:column;gap:1.75rem}.summary-progress .progress-item[data-v-91bc6f55]{display:flex;gap:1rem;align-items:center;gap:.75rem}.summary-progress .progress-item .details[data-v-91bc6f55]{display:flex;flex-direction:column;width:100%;flex:1;gap:.25rem}.summary-progress .progress-item .details h3[data-v-91bc6f55]{font-size:1rem;font-weight:550;margin:0;padding-bottom:.25rem}.summary-progress .progress-item p[data-v-91bc6f55]{font-weight:400;margin:0;padding:0}", L5 = /* @__PURE__ */ ae(O5, [["styles", [I5]], ["__scopeId", "data-v-91bc6f55"]]), N5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: L5
}, Symbol.toStringTag, { value: "Module" })), M5 = { class: "webinar-card" }, R5 = { class: "info" }, $5 = /* @__PURE__ */ Q({
  __name: "TheWebinar",
  props: {
    event: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const t = e, n = ee(() => `${Et(t.event?.date, "MMMM do, yyyy - h:mm a")}`), { t: r } = ve();
    return (o, a) => (w(), P("div", M5, [
      x("div", R5, [
        x("h4", null, D(e.event.title), 1),
        x("p", null, D(n.value), 1)
      ]),
      B(bt, { class: "webinar-button" }, {
        default: Oe(() => [
          Ee(D(X(r)("homepage-tile-actions.actions.journey_step.webinar")), 1)
        ]),
        _: 1
      })
    ]));
  }
}), D5 = ".webinar-card[data-v-9470bd37]{display:flex;flex-direction:column;gap:1.25rem;border-radius:1rem;padding:2rem 1.5rem 1.5rem;background:#e4ecf4}.webinar-card .info[data-v-9470bd37]{display:flex;flex-direction:column;gap:.5rem}.webinar-card .info h4[data-v-9470bd37]{font-size:1rem;font-weight:700;margin:0}.webinar-card .info p[data-v-9470bd37]{font-weight:400;margin:0}.webinar-card .webinar-button[data-v-9470bd37]{width:fit-content}", F5 = /* @__PURE__ */ ae($5, [["styles", [D5]], ["__scopeId", "data-v-9470bd37"]]), U5 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: F5
}, Symbol.toStringTag, { value: "Module" })), Lt = (e) => (xo("data-v-e381841f"), e = e(), ko(), e), V5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), q5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), H5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), B5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), J5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), W5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), Y5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), G5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), K5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), Q5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), X5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), Z5 = /* @__PURE__ */ Lt(() => /* @__PURE__ */ x("div", null, null, -1)), eI = [
  V5,
  q5,
  H5,
  B5,
  J5,
  W5,
  Y5,
  G5,
  K5,
  Q5,
  X5,
  Z5
], tI = /* @__PURE__ */ Q({
  __name: "SpinnerLoader",
  props: {
    color: { type: String }
  },
  setup(e) {
    const t = e, n = ee(() => ({
      "--spinner-color": t.color
    }));
    return (r, o) => (w(), P("div", {
      class: "lds-spinner",
      style: Ut(n.value)
    }, eI, 4));
  }
}), nI = '.lds-spinner[data-v-e381841f]{color:official;display:inline-block;position:relative;width:80px;height:80px}.lds-spinner div[data-v-e381841f]{transform-origin:40px 40px;animation:lds-spinner-e381841f 1.2s linear infinite}.lds-spinner div[data-v-e381841f]:after{content:" ";display:block;position:absolute;top:3px;left:37px;width:6px;height:18px;border-radius:20%;background:var(--spinner-color, #fff)}.lds-spinner div[data-v-e381841f]:nth-child(1){transform:rotate(0);animation-delay:-1.1s}.lds-spinner div[data-v-e381841f]:nth-child(2){transform:rotate(30deg);animation-delay:-1s}.lds-spinner div[data-v-e381841f]:nth-child(3){transform:rotate(60deg);animation-delay:-.9s}.lds-spinner div[data-v-e381841f]:nth-child(4){transform:rotate(90deg);animation-delay:-.8s}.lds-spinner div[data-v-e381841f]:nth-child(5){transform:rotate(120deg);animation-delay:-.7s}.lds-spinner div[data-v-e381841f]:nth-child(6){transform:rotate(150deg);animation-delay:-.6s}.lds-spinner div[data-v-e381841f]:nth-child(7){transform:rotate(180deg);animation-delay:-.5s}.lds-spinner div[data-v-e381841f]:nth-child(8){transform:rotate(210deg);animation-delay:-.4s}.lds-spinner div[data-v-e381841f]:nth-child(9){transform:rotate(240deg);animation-delay:-.3s}.lds-spinner div[data-v-e381841f]:nth-child(10){transform:rotate(270deg);animation-delay:-.2s}.lds-spinner div[data-v-e381841f]:nth-child(11){transform:rotate(300deg);animation-delay:-.1s}.lds-spinner div[data-v-e381841f]:nth-child(12){transform:rotate(330deg);animation-delay:0s}@keyframes lds-spinner-e381841f{0%{opacity:1}to{opacity:0}}', rI = /* @__PURE__ */ ae(tI, [["styles", [nI]], ["__scopeId", "data-v-e381841f"]]), oI = { class: "tile-image" }, aI = { class: "image placeholder" }, iI = { class: "visually-hidden" }, sI = /* @__PURE__ */ Q({
  __name: "TileImage",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ee(() => n.tile?.image?.src || n.tile?.image), o = ee(() => n.tile?.image?.alt || n.tile?.title), a = ue(!1);
    function i() {
      a.value = !0;
    }
    return (s, l) => (w(), P("div", oI, [
      a.value ? re("", !0) : (w(), ge(st, {
        key: 0,
        class: "image",
        src: r.value,
        alt: o.value,
        onError: i
      }, null, 8, ["src", "alt"])),
      x("div", aI, [
        B(rI, { color: "#666" }),
        x("span", iI, D(X(t)("image-loading")), 1)
      ])
    ]));
  }
}), lI = ".tile-image[data-v-8c97a8c7]{width:100%;height:100%;border-radius:.5rem;overflow:hidden;max-height:300px}.tile-image .image[data-v-8c97a8c7]{width:100%;height:100%;object-fit:cover;min-width:100%;min-height:15rem}.tile-image .placeholder[data-v-8c97a8c7]{background-color:#ccc;display:flex;align-items:center;justify-content:center}", cI = /* @__PURE__ */ ae(sI, [["styles", [lI]], ["__scopeId", "data-v-8c97a8c7"]]), uI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: cI
}, Symbol.toStringTag, { value: "Module" })), mI = { key: 0 }, dI = { key: 0 }, pI = { key: 0 }, fI = { key: 1 }, _I = { key: 1 }, gI = /* @__PURE__ */ Q({
  __name: "TileProgress",
  props: {
    tile: {
      type: Object,
      required: !0
    }
  },
  setup(e) {
    const { t } = ve(), n = e, r = ee(() => n.tile?.program?.endDate || n.tile?.journey?.endDate);
    return (o, a) => e.tile.progress ? (w(), P("div", mI, [
      B(Cn, {
        progress: e.tile.progress.myProgress,
        steps: e.tile.progress?.steps
      }, {
        default: Oe(() => [
          e.tile[e.tile.type]?.endDate ? (w(), P("span", dI, [
            x("span", null, D(X(t)(
              `homepage-progress.${e.tile.progress.steps ? "steps" : "standard"}`,
              {
                progress: e.tile.progress?.myProgress?.toFixed(0),
                maxSteps: e.tile.progress.steps?.length,
                currentStep: e.tile.progress.steps?.filter(
                  (i) => i.progress == 100
                ).length
              }
            )), 1),
            X(dn)(e.tile[e.tile.type]?.endDate) < 0 ? (w(), P("span", pI, " - " + D(X(t)("homepage-progress.program_closed")), 1)) : (w(), P("span", fI, " - " + D(X(t)("days_remaining", {
              n: X(dn)(r.value)
            })), 1))
          ])) : (w(), P("span", _I, D(X(t)(`homepage-progress.${e.tile.progress.steps ? "steps" : "standard"}`, {
            progress: e.tile.progress?.myProgress?.toFixed(0),
            maxSteps: e.tile.progress.steps?.length,
            currentStep: e.tile.progress.steps?.filter(
              (i) => i.progress == 100
            ).length
          })), 1))
        ]),
        _: 1
      }, 8, ["progress", "steps"])
    ])) : re("", !0);
  }
}), hI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gI
}, Symbol.toStringTag, { value: "Module" })), vI = { class: "resource-list" }, yI = ["topic", "onClick"], bI = { class: "resource-card-content" }, zI = ["onClick", "href"], jI = { class: "description" }, wI = /* @__PURE__ */ Q({
  __name: "TopicSnapshot",
  props: {
    topics: {
      type: Object,
      required: !1
    }
  },
  setup(e) {
    function t(r) {
      return `/resource-library/${r.ref}`;
    }
    const n = (r) => {
      window.homeActionHandler("route", t(r));
    };
    return (r, o) => (w(), P("div", vI, [
      (w(!0), P(se, null, De(e.topics, (a) => (w(), P("div", {
        class: "resource-card",
        key: a.id,
        topic: a,
        onClick: (i) => n(a)
      }, [
        B(st, {
          src: a.image
        }, null, 8, ["src"]),
        x("div", bI, [
          x("a", {
            onClick: Or((i) => n(a), ["prevent"]),
            href: t(a),
            class: "title"
          }, D(a.title), 9, zI),
          x("div", jI, D(a.description), 1),
          a.replySummary.authors.length > 0 ? (w(), ge(Mo, {
            key: 0,
            authors: a.replySummary?.authors,
            comment_count: a.replySummary?.count,
            unread: a.replySummary?.unread,
            short: !0
          }, null, 8, ["authors", "comment_count", "unread"])) : re("", !0)
        ])
      ], 8, yI))), 128))
    ]));
  }
}), xI = ".resource-list[data-v-25bf8353]{gap:1rem;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));display:grid}.resource-list[data-v-25bf8353]{display:grid;width:100%}.resource-card[data-v-25bf8353]{border-radius:10px;background:#fff;border:1px solid #eaeaea}.resource-card[data-v-25bf8353]:hover{background:#f5f5f5}.resource-card .text[data-v-25bf8353]{max-width:90%;color:#000;font-style:normal;font-weight:400}.resource-card-content[data-v-25bf8353]{padding:1.25rem}img[data-v-25bf8353]{max-height:220px}.title[data-v-25bf8353]{font-size:1rem;font-weight:700;margin-bottom:.25rem;text-decoration:none;color:unset;text-underline-offset:.1rem}img[data-v-25bf8353]{height:100%;width:100%;border-radius:10px 10px 0 0;margin-left:auto;object-fit:cover}.description[data-v-25bf8353]{font-weight:400;margin-bottom:.5rem;line-height:1.25rem}.resource-card[data-v-25bf8353]{box-shadow:0 2px 6px #00000030;cursor:pointer}.resource-card-content[data-v-25bf8353]{display:flex;flex-direction:column;gap:.5rem;flex:1}@media (max-width: 1127px) and (min-width: 481px){.resource-list[data-v-25bf8353]{display:flex;flex-direction:column}.resource-card[data-v-25bf8353]{display:flex;gap:1.25rem;overflow:hidden;border-radius:.75rem;padding:1.25rem;box-sizing:border-box;cursor:pointer}.resource-card[data-v-25bf8353]:hover{background:#d2dfed}.resource-card .resource-card-content[data-v-25bf8353]{padding:0}.resource-card img[data-v-25bf8353]{border-radius:10px}img[data-v-25bf8353]{max-width:200px;max-height:120px}}", kI = /* @__PURE__ */ ae(wI, [["styles", [xI]], ["__scopeId", "data-v-25bf8353"]]), SI = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: kI
}, Symbol.toStringTag, { value: "Module" }));
